// ═══ SVG PREVIEW ENGINE ══════════════════════════════════════════════
// image_seperate(6).svg 기반: 양끝 스프링 상/하 레이어 분리, 홀은 검정 테두리 + 흰 내부 고정

// @@ENGINE-BEGIN — «@@ENGINE» 표시 사이는 매장 QR 설명 페이지(page.note-info.liquid)도 같이 쓴다(2026-10-01).
//   build-customizer.sh 가 이 구간들만 뽑아 theme/assets/paperme-note-engine.js 를 만든다 — 원본은 여기 하나.
//   🔴 구간 안에서 커스터마이저 전용 전역(COVS·SC·BC 등)을 새로 쓰면 설명 페이지가 깨진다. 쓰는 전역은 S(size·dir) 와 SIZES 뿐.
var PM_VIEWBOXES = {"portrait": {"x0": 0.0, "y0": 0.0, "w": 80.3, "h": 73.23}, "landscape": {"x0": 0.0, "y0": 0.0, "w": 80.3, "h": 73.23}};
var PM_NOTE_RECTS = {"portrait": {"x": 14.33, "y": 0.19, "w": 51.59, "h": 72.85}, "landscape": {"x": 3.71, "y": 10.82, "w": 72.85, "h": 51.59}};
var PM_PARTS = {
  "portrait-note": `<rect x="14.33" y=".19" width="51.59" height="72.85" fill="none" stroke="#231f20" stroke-width=".3" stroke-miterlimit="10" />
  `,
  "portrait-front-spring-split-top": `<g>
      <path d="M14.33,6.1c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,6.93c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,10.07c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,10.9c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,14.05c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,14.87c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,18.02c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,18.84c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "portrait-front-spring-split-bottom": `<g>
      <path d="M14.33,57.31c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,58.13c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,61.28c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,62.1c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,65.25c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,66.08c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,69.22c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,70.05c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "portrait-front-spring-full": `<g>
      <path d="M14.27,4.57c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,5.35c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,8.37c-1.67,0-3.39-.4-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,9.16c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,12.18c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,12.96c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,15.98c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,16.77c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,19.79c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,20.57c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,23.59c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,24.38c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,27.4c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,28.18c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,31.2c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,31.99c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,35c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,35.79c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,38.81c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,39.6c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,42.61c-1.67,0-3.39-.4-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,43.4c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,46.42c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,47.21c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,50.22c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,51.01c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,54.03c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,54.82c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,57.83c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,58.62c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,61.64c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,62.43c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,65.44c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,66.23c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,69.25c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,70.04c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "portrait-front-hole-split": `<g>
      <path d="M19.15,6.39h-1.66v-1.66h1.66v1.66ZM17.79,6.09h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M19.15,10.36h-1.66v-1.66h1.66v1.66ZM17.79,10.06h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M19.15,14.33h-1.66v-1.66h1.66v1.66ZM17.79,14.03h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M19.15,18.31h-1.66v-1.66h1.66v1.66ZM17.79,18h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
    </g>
    <g>
      <path d="M19.15,57.72h-1.66v-1.66h1.66v1.66ZM17.79,57.42h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M19.15,61.69h-1.66v-1.66h1.66v1.66ZM17.79,61.39h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M19.15,65.67h-1.66v-1.66h1.66v1.66ZM17.79,65.36h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M19.15,69.64h-1.66v-1.66h1.66v1.66ZM17.79,69.34h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "portrait-front-hole-full": `<g>
      <path d="M18.82,4.87h-1.45v-1.45h1.45v1.45ZM17.52,4.72h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,8.68h-1.45v-1.45h1.45v1.45ZM17.52,8.53h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,12.48h-1.45v-1.45h1.45v1.45ZM17.52,12.33h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,16.28h-1.45v-1.45h1.45v1.45ZM17.52,16.14h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,20.09h-1.45v-1.45h1.45v1.45ZM17.52,19.94h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,23.89h-1.45v-1.45h1.45v1.45ZM17.52,23.75h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,27.7h-1.45v-1.45h1.45v1.45ZM17.52,27.55h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,31.5h-1.45v-1.45h1.45v1.45ZM17.52,31.35h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,35.31h-1.45v-1.45h1.45v1.45ZM17.52,35.16h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,39.11h-1.45v-1.45h1.45v1.45ZM17.52,38.96h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,42.92h-1.45v-1.45h1.45v1.45ZM17.52,42.77h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,46.72h-1.45v-1.45h1.45v1.45ZM17.52,46.57h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,50.53h-1.45v-1.45h1.45v1.45ZM17.52,50.38h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,54.33h-1.45v-1.45h1.45v1.45ZM17.52,54.18h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,58.14h-1.45v-1.45h1.45v1.45ZM17.52,57.99h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,61.94h-1.45v-1.45h1.45v1.45ZM17.52,61.79h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,65.75h-1.45v-1.45h1.45v1.45ZM17.52,65.6h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,69.55h-1.45v-1.45h1.45v1.45ZM17.52,69.4h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "portrait-back-spring-split-top": `<g>
      <path d="M66.08,6.1c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.08,6.93c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.08,10.07c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.08,10.9c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.08,14.05c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.08,14.87c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.08,18.02c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.08,18.84c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "portrait-back-spring-split-bottom": `<g>
      <path d="M66.08,57.31c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.08,58.13c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.08,61.28c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.08,62.1c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.08,65.25c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.08,66.08c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.08,69.22c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.08,70.05c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "portrait-back-spring-full": `<g>
      <path d="M66.11,4.57c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,5.35c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,8.37c1.67,0,3.39-.4,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,9.16c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,12.18c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,12.96c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,15.98c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,16.77c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,19.79c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,20.57c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,23.59c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,24.38c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,27.4c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,28.18c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,31.2c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,31.99c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,35c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,35.79c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,38.81c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,39.6c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,42.61c1.67,0,3.39-.4,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,43.4c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,46.42c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,47.21c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,50.22c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,51.01c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,54.03c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,54.82c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,57.83c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,58.62c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,61.64c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,62.43c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,65.44c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,66.23c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,69.25c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M66.11,70.04c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "portrait-back-hole-split": `<g>
      <path d="M62.92,6.39h-1.66v-1.66h1.66v1.66ZM61.56,6.09h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M62.92,10.36h-1.66v-1.66h1.66v1.66ZM61.56,10.06h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M62.92,14.33h-1.66v-1.66h1.66v1.66ZM61.56,14.03h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M62.92,18.31h-1.66v-1.66h1.66v1.66ZM61.56,18h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
    </g>
    <g>
      <path d="M62.92,57.72h-1.66v-1.66h1.66v1.66ZM61.56,57.42h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M62.92,61.69h-1.66v-1.66h1.66v1.66ZM61.56,61.39h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M62.92,65.67h-1.66v-1.66h1.66v1.66ZM61.56,65.36h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M62.92,69.64h-1.66v-1.66h1.66v1.66ZM61.56,69.34h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "portrait-back-hole-full": `<g>
      <path d="M63.04,4.87h-1.45v-1.45h1.45v1.45ZM61.73,4.72h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M63.04,8.68h-1.45v-1.45h1.45v1.45ZM61.73,8.53h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M63.04,12.48h-1.45v-1.45h1.45v1.45ZM61.73,12.33h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M63.04,16.28h-1.45v-1.45h1.45v1.45ZM61.73,16.14h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M63.04,20.09h-1.45v-1.45h1.45v1.45ZM61.73,19.94h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M63.04,23.89h-1.45v-1.45h1.45v1.45ZM61.73,23.75h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M63.04,27.7h-1.45v-1.45h1.45v1.45ZM61.73,27.55h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M63.04,31.5h-1.45v-1.45h1.45v1.45ZM61.73,31.35h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M63.04,35.31h-1.45v-1.45h1.45v1.45ZM61.73,35.16h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M63.04,39.11h-1.45v-1.45h1.45v1.45ZM61.73,38.96h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M63.04,42.92h-1.45v-1.45h1.45v1.45ZM61.73,42.77h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M63.04,46.72h-1.45v-1.45h1.45v1.45ZM61.73,46.57h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M63.04,50.53h-1.45v-1.45h1.45v1.45ZM61.73,50.38h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M63.04,54.33h-1.45v-1.45h1.45v1.45ZM61.73,54.18h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M63.04,58.14h-1.45v-1.45h1.45v1.45ZM61.73,57.99h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M63.04,61.94h-1.45v-1.45h1.45v1.45ZM61.73,61.79h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M63.04,65.75h-1.45v-1.45h1.45v1.45ZM61.73,65.6h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M63.04,69.55h-1.45v-1.45h1.45v1.45ZM61.73,69.4h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "portrait-front-band-basic": `<rect x="55.22" y=".06" width="2.07" height="73.12" fill="currentColor" />
  `,
  "portrait-front-band-corner": `<polygon points="66.06 16.2 47.78 .04 50.93 .04 66.06 13.45 66.06 16.2" fill="currentColor" />
    <polygon points="66.1 57.02 47.82 73.18 50.97 73.18 66.1 59.77 66.1 57.02" fill="currentColor" />
  `,
  "portrait-front-band-double-1": `<rect x="53.51" y=".06" width="2.07" height="73.12" fill="currentColor" />
  `,
  "portrait-front-band-double-2": `<rect x="56.94" y=".06" width="2.07" height="73.12" fill="currentColor" />
  `,
  "portrait-back-band-basic": `<rect x="22.86" y=".01" width="2.07" height="8.09" transform="translate(47.79 8.12) rotate(180)" fill="currentColor" />
    <rect x="22.86" y="65.17" width="2.07" height="8.06" fill="currentColor" />
  `,
  "portrait-back-eyelet-basic": `<g>
      <circle cx="23.89" cy="8.69" r="1.22" fill="currentColor" />
      <path d="M23.89,10.03c-.74,0-1.34-.6-1.34-1.34s.6-1.34,1.34-1.34,1.34.6,1.34,1.34-.6,1.34-1.34,1.34ZM23.89,7.6c-.6,0-1.09.49-1.09,1.09s.49,1.09,1.09,1.09,1.09-.49,1.09-1.09-.49-1.09-1.09-1.09Z" fill="currentColor" />
    </g>
    <g>
      <circle cx="23.89" cy="8.69" r=".9" fill="currentColor" />
      <path d="M23.89,9.69c-.55,0-1-.45-1-1s.45-1,1-1,1,.45,1,1-.45,1-1,1ZM23.89,7.89c-.44,0-.8.36-.8.8s.36.8.8.8.8-.36.8-.8-.36-.8-.8-.8Z" fill="currentColor" />
    </g>
    <g>
      <circle cx="23.89" cy="64.58" r="1.22" fill="currentColor" />
      <path d="M23.89,65.92c-.74,0-1.34-.6-1.34-1.34s.6-1.34,1.34-1.34,1.34.6,1.34,1.34-.6,1.34-1.34,1.34ZM23.89,63.49c-.6,0-1.09.49-1.09,1.09s.49,1.09,1.09,1.09,1.09-.49,1.09-1.09-.49-1.09-1.09-1.09Z" fill="currentColor" />
    </g>
    <g>
      <circle cx="23.89" cy="64.58" r=".9" fill="currentColor" />
      <path d="M23.89,65.58c-.55,0-1-.45-1-1s.45-1,1-1,1,.45,1,1-.45,1-1,1ZM23.89,63.78c-.44,0-.8.36-.8.8s.36.8.8.8.8-.36.8-.8-.36-.8-.8-.8Z" fill="currentColor" />
    </g>
  `,
  "portrait-back-band-corner": `<polygon points="25.26 69.37 26.57 67.85 32.72 73.17 29.88 73.17 25.26 69.37" fill="currentColor" />
    <polygon points="18.73 63.57 20 62.1 14.23 56.84 14.24 59.46 18.73 63.57" fill="currentColor" />
    <polygon points="18.06 11.05 19.57 12.36 14.25 18.51 14.25 15.66 18.06 11.05" fill="currentColor" />
    <polygon points="23.86 4.52 25.32 5.79 30.58 .02 27.97 .02 23.86 4.52" fill="currentColor" />
  `,
  "portrait-back-eyelet-corner": `<g>
      <g>
        <circle cx="25.5" cy="68.2" r="1.22" fill="currentColor" />
        <path d="M25.5,69.52c-.31,0-.61-.1-.86-.32h0c-.55-.47-.61-1.31-.13-1.86.48-.55,1.31-.61,1.86-.13s.61,1.31.13,1.86c-.26.3-.63.45-1,.45ZM24.77,69.05c.23.2.52.29.81.27.3-.02.57-.16.76-.38.4-.47.35-1.17-.11-1.58-.47-.4-1.17-.35-1.57.11-.4.46-.35,1.17.11,1.58h0Z" fill="currentColor" />
      </g>
      <g>
        <circle cx="25.5" cy="68.2" r=".9" fill="currentColor" />
        <path d="M25.49,69.21c-.24,0-.47-.08-.65-.24-.2-.17-.32-.42-.34-.68-.02-.27.07-.52.24-.73.36-.42.99-.46,1.41-.1.42.36.46.99.1,1.41-.17.2-.42.32-.68.34-.02,0-.05,0-.07,0ZM25.5,67.4c-.22,0-.45.09-.61.28-.29.33-.25.84.08,1.13.16.14.37.21.58.19.21-.02.41-.11.55-.27.29-.33.25-.84-.08-1.13-.15-.13-.34-.19-.52-.19Z" fill="currentColor" />
      </g>
    </g>
    <g>
      <g>
        <circle cx="19.73" cy="63.26" r="1.22" fill="currentColor" />
        <path d="M19.73,64.58c-.33,0-.65-.12-.89-.35-.53-.49-.57-1.33-.07-1.86.49-.53,1.33-.57,1.86-.07.53.49.57,1.33.07,1.86-.24.26-.56.41-.91.42-.02,0-.04,0-.05,0ZM19.73,62.15c-.3,0-.6.12-.82.36-.42.45-.39,1.16.06,1.58.22.2.5.3.8.3.3-.01.57-.14.78-.36.42-.45.39-1.16-.06-1.58-.21-.2-.49-.29-.76-.29Z" fill="currentColor" />
      </g>
      <g>
        <circle cx="19.73" cy="63.26" r=".9" fill="currentColor" />
        <path d="M19.73,64.26c-.24,0-.49-.09-.68-.26h0c-.41-.38-.43-1.01-.06-1.41.18-.2.43-.31.7-.32.26-.02.52.08.72.26.41.37.43,1.01.06,1.41-.2.21-.47.32-.74.32ZM19.19,63.85c.33.3.83.28,1.13-.04.3-.32.28-.83-.05-1.13-.16-.15-.36-.21-.57-.21-.21,0-.41.1-.56.26-.3.32-.28.83.05,1.13h0Z" fill="currentColor" />
      </g>
    </g>
    <g>
      <g>
        <circle cx="19.22" cy="11.28" r="1.22" fill="currentColor" />
        <path d="M19.22,12.6c-.32,0-.62-.11-.86-.32-.55-.48-.61-1.31-.13-1.86h0c.48-.55,1.31-.61,1.86-.13.27.23.43.55.45.9.02.35-.09.69-.32.96-.23.27-.55.43-.9.45-.03,0-.06,0-.1,0ZM18.38,10.55h0c-.4.47-.35,1.17.11,1.57.23.2.52.29.81.27.3-.02.57-.16.76-.38.2-.23.29-.51.27-.81s-.16-.57-.38-.76c-.46-.4-1.17-.35-1.57.11Z" fill="currentColor" />
      </g>
      <g>
        <circle cx="19.22" cy="11.28" r=".9" fill="currentColor" />
        <path d="M19.22,12.28c-.23,0-.46-.08-.65-.24-.42-.36-.46-.99-.1-1.41h0c.36-.42.99-.46,1.41-.1.2.17.32.42.34.68.02.27-.07.52-.24.73-.2.23-.48.35-.76.35ZM18.62,10.76c-.29.33-.25.84.08,1.13.16.14.37.21.58.19.21-.02.41-.11.55-.27.14-.16.21-.37.19-.58-.02-.21-.11-.41-.27-.55-.33-.29-.84-.25-1.13.08h0Z" fill="currentColor" />
      </g>
    </g>
    <g>
      <g>
        <circle cx="24.17" cy="5.51" r="1.22" fill="currentColor" />
        <path d="M24.17,6.83c-.32,0-.64-.12-.89-.35-.26-.24-.41-.56-.42-.91-.01-.35.11-.69.35-.95.24-.26.56-.41.91-.42.35-.02.69.11.95.35.53.49.57,1.33.07,1.86-.26.28-.61.42-.97.42ZM24.17,4.4s-.03,0-.05,0c-.3.01-.57.14-.78.36h0c-.2.22-.31.5-.3.8.01.3.14.57.36.78.45.42,1.16.39,1.58-.06.42-.45.39-1.16-.06-1.58-.21-.19-.48-.3-.76-.3Z" fill="currentColor" />
      </g>
      <g>
        <circle cx="24.17" cy="5.51" r=".9" fill="currentColor" />
        <path d="M24.17,6.51c-.24,0-.49-.09-.68-.26-.41-.37-.43-1.01-.06-1.41h0c.18-.2.43-.31.69-.32.27,0,.52.08.72.27.41.37.43,1.01.06,1.41-.2.21-.47.32-.74.32ZM24.17,4.71s-.02,0-.03,0c-.21,0-.41.1-.56.26h0c-.3.32-.28.83.04,1.13.32.3.83.28,1.13-.05.3-.32.28-.83-.04-1.13-.15-.14-.34-.21-.54-.21Z" fill="currentColor" />
      </g>
    </g>
  `,
  "portrait-back-band-double-1": `<rect x="26.42" width="2.07" height="8.1" transform="translate(54.91 8.1) rotate(180)" fill="currentColor" />
    <rect x="26.42" y="65.16" width="2.07" height="8.01" fill="currentColor" />
  `,
  "portrait-back-band-double-2": `<rect x="22.96" width="2.07" height="8.1" transform="translate(47.98 8.1) rotate(180)" fill="currentColor" />
    <rect x="22.96" y="65.16" width="2.07" height="8.01" fill="currentColor" />
  `,
  "portrait-back-eyelet-double-1": `<g>
      <circle cx="23.99" cy="8.68" r="1.22" fill="currentColor" />
      <path d="M23.99,10c-.73,0-1.32-.59-1.32-1.32s.59-1.32,1.32-1.32,1.32.59,1.32,1.32-.59,1.32-1.32,1.32ZM23.99,7.56c-.62,0-1.12.5-1.12,1.12s.5,1.12,1.12,1.12,1.12-.5,1.12-1.12-.5-1.12-1.12-1.12Z" fill="currentColor" />
    </g>
    <g>
      <circle cx="23.99" cy="8.68" r=".9" fill="currentColor" />
      <path d="M23.99,9.68c-.55,0-1-.45-1-1s.45-1,1-1,1,.45,1,1-.45,1-1,1ZM23.99,7.88c-.44,0-.8.36-.8.8s.36.8.8.8.8-.36.8-.8-.36-.8-.8-.8Z" fill="currentColor" />
    </g>
    <g>
      <circle cx="23.99" cy="64.57" r="1.22" fill="currentColor" />
      <path d="M23.99,65.89c-.73,0-1.32-.59-1.32-1.32s.59-1.32,1.32-1.32,1.32.59,1.32,1.32-.59,1.32-1.32,1.32ZM23.99,63.46c-.62,0-1.12.5-1.12,1.12s.5,1.12,1.12,1.12,1.12-.5,1.12-1.12-.5-1.12-1.12-1.12Z" fill="currentColor" />
    </g>
    <g>
      <circle cx="23.99" cy="64.57" r=".9" fill="currentColor" />
      <path d="M23.99,65.57c-.55,0-1-.45-1-1s.45-1,1-1,1,.45,1,1-.45,1-1,1ZM23.99,63.77c-.44,0-.8.36-.8.8s.36.8.8.8.8-.36.8-.8-.36-.8-.8-.8Z" fill="currentColor" />
    </g>
  `,
  "portrait-back-eyelet-double-2": `<g>
      <circle cx="27.45" cy="8.68" r="1.22" fill="currentColor" />
      <path d="M27.45,10c-.73,0-1.32-.59-1.32-1.32s.59-1.32,1.32-1.32,1.32.59,1.32,1.32-.59,1.32-1.32,1.32ZM27.45,7.56c-.62,0-1.12.5-1.12,1.12s.5,1.12,1.12,1.12,1.12-.5,1.12-1.12-.5-1.12-1.12-1.12Z" fill="currentColor" />
    </g>
    <g>
      <circle cx="27.45" cy="8.68" r=".9" fill="currentColor" />
      <path d="M27.45,9.68c-.55,0-1-.45-1-1s.45-1,1-1,1,.45,1,1-.45,1-1,1ZM27.45,7.88c-.44,0-.8.36-.8.8s.36.8.8.8.8-.36.8-.8-.36-.8-.8-.8Z" fill="currentColor" />
    </g>
    <g>
      <circle cx="27.45" cy="64.57" r="1.22" fill="currentColor" />
      <path d="M27.45,65.89c-.73,0-1.32-.59-1.32-1.32s.59-1.32,1.32-1.32,1.32.59,1.32,1.32-.59,1.32-1.32,1.32ZM27.45,63.46c-.62,0-1.12.5-1.12,1.12s.5,1.12,1.12,1.12,1.12-.5,1.12-1.12-.5-1.12-1.12-1.12Z" fill="currentColor" />
    </g>
    <g>
      <circle cx="27.45" cy="64.57" r=".9" fill="currentColor" />
      <path d="M27.45,65.57c-.55,0-1-.45-1-1s.45-1,1-1,1,.45,1,1-.45,1-1,1ZM27.45,63.77c-.44,0-.8.36-.8.8s.36.8.8.8.8-.36.8-.8-.36-.8-.8-.8Z" fill="currentColor" />
    </g>
  `,
  "landscape-note": `<rect x="14.33" y=".19" width="51.59" height="72.85" transform="translate(3.52 76.74) rotate(-90)" fill="none" stroke="#231f20" stroke-width=".3" stroke-miterlimit="10" />
  `,
  "landscape-front-spring-split-top": `<g>
      <path d="M3.61,15.71c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,16.53c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,19.68c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,20.5c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,23.65c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,24.47c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,27.62c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,28.44c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "landscape-front-spring-split-bottom": `<g>
      <path d="M3.61,46.57c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,47.4c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,50.54c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,51.37c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,54.52c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,55.34c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,58.49c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,59.31c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "landscape-front-spring-full": `<g>
      <path d="M3.54,14.47c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,15.26c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,18.27c-1.67,0-3.39-.4-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,19.06c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,22.08c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,22.86c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,25.88c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,26.67c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,29.69c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,30.47c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,33.49c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,34.28c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,37.3c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,38.08c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,41.1c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,41.89c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,44.9c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,45.69c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,48.71c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,49.5c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,52.51c-1.67,0-3.39-.4-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,53.3c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,56.32c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,57.11c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,60.12c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,60.91c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "landscape-front-hole-split": `<g>
      <path d="M8.43,16h-1.66v-1.66h1.66v1.66ZM7.07,15.7h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.43,19.97h-1.66v-1.66h1.66v1.66ZM7.07,19.67h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.43,23.94h-1.66v-1.66h1.66v1.66ZM7.07,23.64h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.43,27.91h-1.66v-1.66h1.66v1.66ZM7.07,27.61h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
    </g>
    <g>
      <path d="M8.43,46.99h-1.66v-1.66h1.66v1.66ZM7.07,46.69h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.43,50.96h-1.66v-1.66h1.66v1.66ZM7.07,50.66h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.43,54.93h-1.66v-1.66h1.66v1.66ZM7.07,54.63h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.43,58.9h-1.66v-1.66h1.66v1.66ZM7.07,58.6h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "landscape-front-hole-full": `<g>
      <path d="M8.08,14.77h-1.45v-1.45h1.45v1.45ZM6.78,14.62h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,18.58h-1.45v-1.45h1.45v1.45ZM6.78,18.43h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,22.38h-1.45v-1.45h1.45v1.45ZM6.78,22.23h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,26.19h-1.45v-1.45h1.45v1.45ZM6.78,26.04h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,29.99h-1.45v-1.45h1.45v1.45ZM6.78,29.84h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,33.79h-1.45v-1.45h1.45v1.45ZM6.78,33.65h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,37.6h-1.45v-1.45h1.45v1.45ZM6.78,37.45h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,41.4h-1.45v-1.45h1.45v1.45ZM6.78,41.25h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,45.21h-1.45v-1.45h1.45v1.45ZM6.78,45.06h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,49.01h-1.45v-1.45h1.45v1.45ZM6.78,48.86h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,52.82h-1.45v-1.45h1.45v1.45ZM6.78,52.67h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,56.62h-1.45v-1.45h1.45v1.45ZM6.78,56.47h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,60.43h-1.45v-1.45h1.45v1.45ZM6.78,60.28h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "landscape-back-spring-split-top": `<g>
      <path d="M76.68,15.71c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.68,16.53c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.68,19.68c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.68,20.5c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.68,23.65c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.68,24.47c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.68,27.62c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.68,28.44c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "landscape-back-spring-split-bottom": `<g>
      <path d="M76.68,46.57c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.68,47.4c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.68,50.54c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.68,51.37c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.68,54.52c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.68,55.34c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.68,58.49c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.68,59.31c1.75,0,3.61-.42,3.61-1.2s-1.86-1.2-3.61-1.2v.3c2.05,0,3.31.53,3.31.9s-1.26.9-3.31.9-3.31-.53-3.31-.9h-.3c0,.78,1.86,1.2,3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "landscape-back-spring-full": `<g>
      <path d="M76.7,14.47c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,15.26c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,18.27c1.67,0,3.39-.4,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,19.06c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,22.08c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,22.86c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,25.88c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,26.67c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,29.69c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,30.47c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,33.49c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,34.28c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,37.3c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,38.08c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,41.1c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,41.89c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,44.9c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,45.69c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,48.71c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,49.5c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,52.51c1.67,0,3.39-.4,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,53.3c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,56.32c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,57.11c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,60.12c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M76.7,60.91c1.67,0,3.39-.41,3.39-1.08s-1.72-1.08-3.39-1.08v.15c1.94,0,3.24.48,3.24.93s-1.3.93-3.24.93-3.24-.48-3.24-.93h-.15c0,.68,1.72,1.08,3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "landscape-back-hole-split": `<g>
      <path d="M73.58,16h-1.66v-1.66h1.66v1.66ZM72.23,15.7h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M73.58,19.97h-1.66v-1.66h1.66v1.66ZM72.23,19.67h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M73.58,23.94h-1.66v-1.66h1.66v1.66ZM72.23,23.64h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M73.58,27.91h-1.66v-1.66h1.66v1.66ZM72.23,27.61h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
    </g>
    <g>
      <path d="M73.58,46.99h-1.66v-1.66h1.66v1.66ZM72.23,46.69h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M73.58,50.96h-1.66v-1.66h1.66v1.66ZM72.23,50.66h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M73.58,54.93h-1.66v-1.66h1.66v1.66ZM72.23,54.63h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M73.58,58.9h-1.66v-1.66h1.66v1.66ZM72.23,58.6h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "landscape-back-hole-full": `<g>
      <path d="M73.61,14.77h-1.45v-1.45h1.45v1.45ZM72.31,14.62h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M73.61,18.58h-1.45v-1.45h1.45v1.45ZM72.31,18.43h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M73.61,22.38h-1.45v-1.45h1.45v1.45ZM72.31,22.23h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M73.61,26.19h-1.45v-1.45h1.45v1.45ZM72.31,26.04h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M73.61,29.99h-1.45v-1.45h1.45v1.45ZM72.31,29.84h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M73.61,33.79h-1.45v-1.45h1.45v1.45ZM72.31,33.65h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M73.61,37.6h-1.45v-1.45h1.45v1.45ZM72.31,37.45h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M73.61,41.4h-1.45v-1.45h1.45v1.45ZM72.31,41.25h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M73.61,45.21h-1.45v-1.45h1.45v1.45ZM72.31,45.06h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M73.61,49.01h-1.45v-1.45h1.45v1.45ZM72.31,48.86h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M73.61,52.82h-1.45v-1.45h1.45v1.45ZM72.31,52.67h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M73.61,56.62h-1.45v-1.45h1.45v1.45ZM72.31,56.47h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M73.61,60.43h-1.45v-1.45h1.45v1.45ZM72.31,60.28h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "landscape-front-band-basic": `<rect x="65.81" y="10.72" width="2.07" height="51.8" fill="currentColor" />
  `,
  "landscape-front-band-corner": `<polygon points="76.65 26.86 58.37 10.71 61.52 10.71 76.65 24.11 76.65 26.86" fill="currentColor" />
    <polygon points="76.69 46.37 58.41 62.53 61.56 62.53 76.69 49.12 76.69 46.37" fill="currentColor" />
  `,
  "landscape-front-band-double-1": `<rect x="64.1" y="10.72" width="2.07" height="51.8" fill="currentColor" />
  `,
  "landscape-front-band-double-2": `<rect x="67.53" y="10.72" width="2.07" height="51.8" fill="currentColor" />
  `,
  "landscape-back-band-basic": `<rect x="12.19" y="10.65" width="2.07" height="8.09" transform="translate(26.45 29.39) rotate(180)" fill="currentColor" />
    <rect x="12.19" y="54.46" width="2.07" height="8.06" fill="currentColor" />
  `,
  "landscape-back-eyelet-basic": `<g>
      <circle cx="13.23" cy="19.33" r="1.22" fill="currentColor" />
      <path d="M13.23,20.67c-.74,0-1.34-.6-1.34-1.34s.6-1.34,1.34-1.34,1.34.6,1.34,1.34-.6,1.34-1.34,1.34ZM13.23,18.24c-.6,0-1.09.49-1.09,1.09s.49,1.09,1.09,1.09,1.09-.49,1.09-1.09-.49-1.09-1.09-1.09Z" fill="currentColor" />
    </g>
    <g>
      <circle cx="13.23" cy="19.33" r=".9" fill="currentColor" />
      <path d="M13.23,20.33c-.55,0-1-.45-1-1s.45-1,1-1,1,.45,1,1-.45,1-1,1ZM13.23,18.53c-.44,0-.8.36-.8.8s.36.8.8.8.8-.36.8-.8-.36-.8-.8-.8Z" fill="currentColor" />
    </g>
    <g>
      <circle cx="13.23" cy="53.88" r="1.22" fill="currentColor" />
      <path d="M13.23,55.22c-.74,0-1.34-.6-1.34-1.34s.6-1.34,1.34-1.34,1.34.6,1.34,1.34-.6,1.34-1.34,1.34ZM13.23,52.79c-.6,0-1.09.49-1.09,1.09s.49,1.09,1.09,1.09,1.09-.49,1.09-1.09-.49-1.09-1.09-1.09Z" fill="currentColor" />
    </g>
    <g>
      <circle cx="13.23" cy="53.88" r=".9" fill="currentColor" />
      <path d="M13.23,54.88c-.55,0-1-.45-1-1s.45-1,1-1,1,.45,1,1-.45,1-1,1ZM13.23,53.08c-.44,0-.8.36-.8.8s.36.8.8.8.8-.36.8-.8-.36-.8-.8-.8Z" fill="currentColor" />
    </g>
  `,
  "landscape-back-band-corner": `<polygon points="14.59 58.67 15.91 57.15 22.05 62.47 19.21 62.47 14.59 58.67" fill="currentColor" />
    <polygon points="8.07 52.86 9.33 51.4 3.57 46.14 3.57 48.76 8.07 52.86" fill="currentColor" />
    <polygon points="7.39 21.68 8.91 22.99 3.59 29.14 3.59 26.3 7.39 21.68" fill="currentColor" />
    <polygon points="13.19 15.15 14.66 16.42 19.92 10.65 17.3 10.65 13.19 15.15" fill="currentColor" />
  `,
  "landscape-back-eyelet-corner": `<g>
      <g>
        <circle cx="14.83" cy="57.5" r="1.22" fill="currentColor" />
        <path d="M14.83,58.82c-.31,0-.61-.1-.86-.32h0c-.55-.47-.61-1.31-.13-1.86.48-.55,1.31-.61,1.86-.13s.61,1.31.13,1.86c-.26.3-.63.45-1,.45ZM14.1,58.35c.23.2.52.29.81.27.3-.02.57-.16.76-.38.4-.47.35-1.17-.11-1.58-.47-.4-1.17-.35-1.57.11-.4.46-.35,1.17.11,1.58h0Z" fill="currentColor" />
      </g>
      <g>
        <circle cx="14.83" cy="57.5" r=".9" fill="currentColor" />
        <path d="M14.83,58.5c-.24,0-.47-.08-.65-.24-.2-.17-.32-.42-.34-.68-.02-.27.07-.52.24-.73.36-.42.99-.46,1.41-.1.42.36.46.99.1,1.41-.17.2-.42.32-.68.34-.02,0-.05,0-.07,0ZM14.83,56.7c-.22,0-.45.09-.61.28-.29.33-.25.84.08,1.13.16.14.37.21.58.19.21-.02.41-.11.55-.27.29-.33.25-.84-.08-1.13-.15-.13-.34-.19-.52-.19Z" fill="currentColor" />
      </g>
    </g>
    <g>
      <g>
        <circle cx="9.06" cy="52.56" r="1.22" fill="currentColor" />
        <path d="M9.06,53.88c-.33,0-.65-.12-.89-.35-.53-.49-.57-1.33-.07-1.86.49-.53,1.33-.57,1.86-.07.53.49.57,1.33.07,1.86-.24.26-.56.41-.91.42-.02,0-.04,0-.05,0ZM9.06,51.44c-.3,0-.6.12-.82.36-.42.45-.39,1.16.06,1.58.22.2.5.3.8.3.3-.01.57-.14.78-.36.42-.45.39-1.16-.06-1.58-.21-.2-.49-.29-.76-.29Z" fill="currentColor" />
      </g>
      <g>
        <circle cx="9.06" cy="52.56" r=".9" fill="currentColor" />
        <path d="M9.06,53.56c-.24,0-.49-.09-.68-.26h0c-.41-.38-.43-1.01-.06-1.41.18-.2.43-.31.7-.32.26-.02.52.08.72.26.41.37.43,1.01.06,1.41-.2.21-.47.32-.74.32ZM8.52,53.15c.33.3.83.28,1.13-.04.3-.32.28-.83-.05-1.13-.16-.15-.36-.21-.57-.21-.21,0-.41.1-.56.26-.3.32-.28.83.05,1.13h0Z" fill="currentColor" />
      </g>
    </g>
    <g>
      <g>
        <circle cx="8.55" cy="21.92" r="1.22" fill="currentColor" />
        <path d="M8.55,23.23c-.32,0-.62-.11-.86-.32-.55-.48-.61-1.31-.13-1.86h0c.48-.55,1.31-.61,1.86-.13.27.23.43.55.45.9.02.35-.09.69-.32.96-.23.27-.55.43-.9.45-.03,0-.06,0-.1,0ZM7.71,21.19h0c-.4.47-.35,1.17.11,1.57.23.2.52.29.81.27.3-.02.57-.16.76-.38.2-.23.29-.51.27-.81s-.16-.57-.38-.76c-.46-.4-1.17-.35-1.57.11Z" fill="currentColor" />
      </g>
      <g>
        <circle cx="8.55" cy="21.92" r=".9" fill="currentColor" />
        <path d="M8.55,22.92c-.23,0-.46-.08-.65-.24-.42-.36-.46-.99-.1-1.41h0c.36-.42.99-.46,1.41-.1.2.17.32.42.34.68.02.27-.07.52-.24.73-.2.23-.48.35-.76.35ZM7.95,21.39c-.29.33-.25.84.08,1.13.16.14.37.21.58.19.21-.02.41-.11.55-.27.14-.16.21-.37.19-.58-.02-.21-.11-.41-.27-.55-.33-.29-.84-.25-1.13.08h0Z" fill="currentColor" />
      </g>
    </g>
    <g>
      <g>
        <circle cx="13.5" cy="16.15" r="1.22" fill="currentColor" />
        <path d="M13.5,17.47c-.32,0-.64-.12-.89-.35-.26-.24-.41-.56-.42-.91-.01-.35.11-.69.35-.95.24-.26.56-.41.91-.42.35-.02.69.11.95.35.53.49.57,1.33.07,1.86-.26.28-.61.42-.97.42ZM13.5,15.03s-.03,0-.05,0c-.3.01-.57.14-.78.36h0c-.2.22-.31.5-.3.8.01.3.14.57.36.78.45.42,1.16.39,1.58-.06.42-.45.39-1.16-.06-1.58-.21-.19-.48-.3-.76-.3Z" fill="currentColor" />
      </g>
      <g>
        <circle cx="13.5" cy="16.15" r=".9" fill="currentColor" />
        <path d="M13.5,17.15c-.24,0-.49-.09-.68-.26-.41-.37-.43-1.01-.06-1.41h0c.18-.2.43-.31.69-.32.27,0,.52.08.72.27.41.37.43,1.01.06,1.41-.2.21-.47.32-.74.32ZM13.5,15.35s-.02,0-.03,0c-.21,0-.41.1-.56.26h0c-.3.32-.28.83.04,1.13.32.3.83.28,1.13-.05.3-.32.28-.83-.04-1.13-.15-.14-.34-.21-.54-.21Z" fill="currentColor" />
      </g>
    </g>
  `,
  "landscape-back-band-double-1": `<rect x="15.75" y="10.64" width="2.07" height="8.1" transform="translate(33.57 29.37) rotate(180)" fill="currentColor" />
    <rect x="15.75" y="54.45" width="2.07" height="8.01" fill="currentColor" />
  `,
  "landscape-back-band-double-2": `<rect x="12.29" y="10.64" width="2.07" height="8.1" transform="translate(26.65 29.37) rotate(180)" fill="currentColor" />
    <rect x="12.29" y="54.45" width="2.07" height="8.01" fill="currentColor" />
  `,
  "landscape-back-eyelet-double-1": `<g>
      <circle cx="13.32" cy="19.32" r="1.22" fill="currentColor" />
      <path d="M13.32,20.63c-.73,0-1.32-.59-1.32-1.32s.59-1.32,1.32-1.32,1.32.59,1.32,1.32-.59,1.32-1.32,1.32ZM13.32,18.2c-.62,0-1.12.5-1.12,1.12s.5,1.12,1.12,1.12,1.12-.5,1.12-1.12-.5-1.12-1.12-1.12Z" fill="currentColor" />
    </g>
    <g>
      <circle cx="13.32" cy="19.32" r=".9" fill="currentColor" />
      <path d="M13.32,20.32c-.55,0-1-.45-1-1s.45-1,1-1,1,.45,1,1-.45,1-1,1ZM13.32,18.52c-.44,0-.8.36-.8.8s.36.8.8.8.8-.36.8-.8-.36-.8-.8-.8Z" fill="currentColor" />
    </g>
    <g>
      <circle cx="13.32" cy="53.87" r="1.22" fill="currentColor" />
      <path d="M13.32,55.19c-.73,0-1.32-.59-1.32-1.32s.59-1.32,1.32-1.32,1.32.59,1.32,1.32-.59,1.32-1.32,1.32ZM13.32,52.75c-.62,0-1.12.5-1.12,1.12s.5,1.12,1.12,1.12,1.12-.5,1.12-1.12-.5-1.12-1.12-1.12Z" fill="currentColor" />
    </g>
    <g>
      <circle cx="13.32" cy="53.87" r=".9" fill="currentColor" />
      <path d="M13.32,54.87c-.55,0-1-.45-1-1s.45-1,1-1,1,.45,1,1-.45,1-1,1ZM13.32,53.07c-.44,0-.8.36-.8.8s.36.8.8.8.8-.36.8-.8-.36-.8-.8-.8Z" fill="currentColor" />
    </g>
  `,
  "landscape-back-eyelet-double-2": `<g>
      <circle cx="16.78" cy="19.32" r="1.22" fill="currentColor" />
      <path d="M16.78,20.63c-.73,0-1.32-.59-1.32-1.32s.59-1.32,1.32-1.32,1.32.59,1.32,1.32-.59,1.32-1.32,1.32ZM16.78,18.2c-.62,0-1.12.5-1.12,1.12s.5,1.12,1.12,1.12,1.12-.5,1.12-1.12-.5-1.12-1.12-1.12Z" fill="currentColor" />
    </g>
    <g>
      <circle cx="16.78" cy="19.32" r=".9" fill="currentColor" />
      <path d="M16.78,20.32c-.55,0-1-.45-1-1s.45-1,1-1,1,.45,1,1-.45,1-1,1ZM16.78,18.52c-.44,0-.8.36-.8.8s.36.8.8.8.8-.36.8-.8-.36-.8-.8-.8Z" fill="currentColor" />
    </g>
    <g>
      <circle cx="16.78" cy="53.87" r="1.22" fill="currentColor" />
      <path d="M16.78,55.19c-.73,0-1.32-.59-1.32-1.32s.59-1.32,1.32-1.32,1.32.59,1.32,1.32-.59,1.32-1.32,1.32ZM16.78,52.75c-.62,0-1.12.5-1.12,1.12s.5,1.12,1.12,1.12,1.12-.5,1.12-1.12-.5-1.12-1.12-1.12Z" fill="currentColor" />
    </g>
    <g>
      <circle cx="16.78" cy="53.87" r=".9" fill="currentColor" />
      <path d="M16.78,54.87c-.55,0-1-.45-1-1s.45-1,1-1,1,.45,1,1-.45,1-1,1ZM16.78,53.07c-.44,0-.8.36-.8.8s.36.8.8.8.8-.36.8-.8-.36-.8-.8-.8Z" fill="currentColor" />
    </g>
  `
};
// @@ENGINE-END
var PM_ICON_PARTS = {
  "portrait-icon-note-split": `<rect x="14.33" y=".19" width="51.59" height="72.85" fill="none" stroke="#231f20" stroke-width=".3" stroke-miterlimit="10" />
    `,
  "portrait-icon-split-top": `<g>
      <path d="M14.33,6.1c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,6.93c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,10.07c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,10.9c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,14.05c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,14.87c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,18.02c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,18.84c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
    </g>
    `,
  "portrait-icon-split-bottom": `<g>
      <path d="M14.33,57.31c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,58.13c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,61.28c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,62.1c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,65.25c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,66.08c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,69.22c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.33,70.05c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
    </g>
    `,
  "portrait-icon-hole-split-top": `<g>
      <path d="M19.15,6.39h-1.66v-1.66h1.66v1.66ZM17.79,6.09h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M19.15,10.36h-1.66v-1.66h1.66v1.66ZM17.79,10.06h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M19.15,14.33h-1.66v-1.66h1.66v1.66ZM17.79,14.03h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M19.15,18.31h-1.66v-1.66h1.66v1.66ZM17.79,18h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
    </g>
    `,
  "portrait-icon-hole-split-bottom": `<g>
      <path d="M19.15,57.72h-1.66v-1.66h1.66v1.66ZM17.79,57.42h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M19.15,61.69h-1.66v-1.66h1.66v1.66ZM17.79,61.39h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M19.15,65.67h-1.66v-1.66h1.66v1.66ZM17.79,65.36h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M19.15,69.64h-1.66v-1.66h1.66v1.66ZM17.79,69.34h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "portrait-icon-note-full": `<rect x="14.33" y=".19" width="51.59" height="72.85" fill="none" stroke="#231f20" stroke-width=".3" stroke-miterlimit="10" />
    `,
  "portrait-icon-full": `<g>
      <path d="M14.27,4.57c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,5.35c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,8.37c-1.67,0-3.39-.4-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,9.16c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,12.18c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,12.96c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,15.98c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,16.77c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,19.79c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,20.57c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,23.59c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,24.38c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,27.4c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,28.18c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,31.2c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,31.99c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,35c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,35.79c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,38.81c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,39.6c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,42.61c-1.67,0-3.39-.4-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,43.4c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,46.42c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,47.21c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,50.22c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,51.01c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,54.03c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,54.82c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,57.83c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,58.62c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,61.64c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,62.43c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,65.44c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,66.23c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,69.25c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M14.27,70.04c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
    </g>
    `,
  "portrait-icon-hole-full": `<g>
      <path d="M18.82,4.87h-1.45v-1.45h1.45v1.45ZM17.52,4.72h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,8.68h-1.45v-1.45h1.45v1.45ZM17.52,8.53h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,12.48h-1.45v-1.45h1.45v1.45ZM17.52,12.33h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,16.28h-1.45v-1.45h1.45v1.45ZM17.52,16.14h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,20.09h-1.45v-1.45h1.45v1.45ZM17.52,19.94h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,23.89h-1.45v-1.45h1.45v1.45ZM17.52,23.75h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,27.7h-1.45v-1.45h1.45v1.45ZM17.52,27.55h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,31.5h-1.45v-1.45h1.45v1.45ZM17.52,31.35h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,35.31h-1.45v-1.45h1.45v1.45ZM17.52,35.16h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,39.11h-1.45v-1.45h1.45v1.45ZM17.52,38.96h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,42.92h-1.45v-1.45h1.45v1.45ZM17.52,42.77h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,46.72h-1.45v-1.45h1.45v1.45ZM17.52,46.57h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,50.53h-1.45v-1.45h1.45v1.45ZM17.52,50.38h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,54.33h-1.45v-1.45h1.45v1.45ZM17.52,54.18h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,58.14h-1.45v-1.45h1.45v1.45ZM17.52,57.99h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,61.94h-1.45v-1.45h1.45v1.45ZM17.52,61.79h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,65.75h-1.45v-1.45h1.45v1.45ZM17.52,65.6h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M18.82,69.55h-1.45v-1.45h1.45v1.45ZM17.52,69.4h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "landscape-icon-note-split": `<rect x="14.33" y=".19" width="51.59" height="72.85" transform="translate(3.52 76.74) rotate(-90)" fill="none" stroke="#231f20" stroke-width=".3" stroke-miterlimit="10" />
    `,
  "landscape-icon-split-top": `<g>
      <path d="M3.61,15.71c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,16.53c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,19.68c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,20.5c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,23.65c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,24.47c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,27.62c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,28.44c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
    </g>
    `,
  "landscape-icon-split-bottom": `<g>
      <path d="M3.61,46.57c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,47.4c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,50.54c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,51.37c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,54.52c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,55.34c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,58.49c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.61,59.31c-1.75,0-3.61-.42-3.61-1.2s1.86-1.2,3.61-1.2v.3c-2.05,0-3.31.53-3.31.9s1.26.9,3.31.9,3.31-.53,3.31-.9h.3c0,.78-1.86,1.2-3.61,1.2Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
    </g>
    `,
  "landscape-icon-hole-split-top": `<g>
      <path d="M8.43,16h-1.66v-1.66h1.66v1.66ZM7.07,15.7h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.43,19.97h-1.66v-1.66h1.66v1.66ZM7.07,19.67h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.43,23.94h-1.66v-1.66h1.66v1.66ZM7.07,23.64h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.43,27.91h-1.66v-1.66h1.66v1.66ZM7.07,27.61h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
    </g>
    `,
  "landscape-icon-hole-split-bottom": `<g>
      <path d="M8.43,46.99h-1.66v-1.66h1.66v1.66ZM7.07,46.69h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.43,50.96h-1.66v-1.66h1.66v1.66ZM7.07,50.66h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.43,54.93h-1.66v-1.66h1.66v1.66ZM7.07,54.63h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.43,58.9h-1.66v-1.66h1.66v1.66ZM7.07,58.6h1.06v-1.06h-1.06v1.06Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `,
  "landscape-icon-note-full": `<rect x="14.33" y=".19" width="51.59" height="72.85" transform="translate(3.52 76.74) rotate(-90)" fill="none" stroke="#231f20" stroke-width=".3" stroke-miterlimit="10" />
    `,
  "landscape-icon-full": `<g>
      <path d="M3.54,14.47c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,15.26c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,18.27c-1.67,0-3.39-.4-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,19.06c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,22.08c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,22.86c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,25.88c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,26.67c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,29.69c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,30.47c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,33.49c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,34.28c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,37.3c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,38.08c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,41.1c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,41.89c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,44.9c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,45.69c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,48.71c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,49.5c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,52.51c-1.67,0-3.39-.4-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,53.3c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,56.32c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,57.11c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,60.12c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M3.54,60.91c-1.67,0-3.39-.41-3.39-1.08s1.72-1.08,3.39-1.08v.15c-1.94,0-3.24.48-3.24.93s1.3.93,3.24.93,3.24-.48,3.24-.93h.15c0,.68-1.72,1.08-3.39,1.08Z" fill="none" stroke="currentColor" stroke-width=".1" stroke-miterlimit="10" />
    </g>
    `,
  "landscape-icon-hole-full": `<g>
      <path d="M8.08,14.77h-1.45v-1.45h1.45v1.45ZM6.78,14.62h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,18.58h-1.45v-1.45h1.45v1.45ZM6.78,18.43h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,22.38h-1.45v-1.45h1.45v1.45ZM6.78,22.23h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,26.19h-1.45v-1.45h1.45v1.45ZM6.78,26.04h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,29.99h-1.45v-1.45h1.45v1.45ZM6.78,29.84h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,33.79h-1.45v-1.45h1.45v1.45ZM6.78,33.65h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,37.6h-1.45v-1.45h1.45v1.45ZM6.78,37.45h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,41.4h-1.45v-1.45h1.45v1.45ZM6.78,41.25h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,45.21h-1.45v-1.45h1.45v1.45ZM6.78,45.06h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,49.01h-1.45v-1.45h1.45v1.45ZM6.78,48.86h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,52.82h-1.45v-1.45h1.45v1.45ZM6.78,52.67h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,56.62h-1.45v-1.45h1.45v1.45ZM6.78,56.47h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
      <path d="M8.08,60.43h-1.45v-1.45h1.45v1.45ZM6.78,60.28h1.15v-1.15h-1.15v1.15Z" fill="#ffffff" stroke="#231f20" stroke-width=".1" stroke-miterlimit="10" />
    </g>
  `
};

// @@ENGINE-BEGIN
function fmt(v){return (Math.round(v*100)/100).toString();}

// 아일렛 도형(대표님 원본 eyelet.svg). 원본 좌표(중심 66.98,204.41 · 바깥반지름 20.31)를 그대로 두고
// transform 으로 목표 중심·크기에 맞춘다 → 원본을 다시 export 해도 좌표만 갈아끼우면 된다.
// 두 동심 링(어두움) 사이를 아일렛 색(color)으로 채우고(도넛 fill), 흰색 하이라이트를 맨 위에.
// 가운데 구멍(반지름<12.84)은 투명 — 표지가 비쳐 보인다.
var EYELET_CX=66.98, EYELET_CY=204.41, EYELET_R=20.31;   // 원본 기준값(재export 시 여기만 갱신)
function eyeletSVG(cx,cy,rOuter,color){
  var s=rOuter/EYELET_R;
  return '<g transform="translate('+fmt(cx)+' '+fmt(cy)+') scale('+s+') translate('+(-EYELET_CX)+' '+(-EYELET_CY)+')">'
    // 가운데 구멍을 #f6f5ee 로 메꿔 밴드가 비치지 않게(그룹이 밴드 위에 그려짐). 안쪽 링 아래까지 살짝 덮음.
    +'<circle cx="66.98" cy="204.41" r="13" fill="#f6f5ee"/>'
    // 두 링 사이 색 채움(바깥 20.31 ~ 구멍 12.84, evenodd 로 도넛)
    +'<path fill="'+color+'" fill-rule="evenodd" d="M46.67,204.41a20.31,20.31 0 1,0 40.62,0a20.31,20.31 0 1,0 -40.62,0ZM54.14,204.41a12.84,12.84 0 1,0 25.68,0a12.84,12.84 0 1,0 -25.68,0Z"/>'
    // 어두운 두 링(원본 cls-1)
    +'<path fill="#231f20" d="M66.98,224.72c-11.2,0-20.31-9.11-20.31-20.31s9.11-20.31,20.31-20.31,20.31,9.11,20.31,20.31-9.11,20.31-20.31,20.31ZM66.98,185.09c-10.65,0-19.31,8.66-19.31,19.31s8.66,19.31,19.31,19.31,19.31-8.66,19.31-19.31-8.66-19.31-19.31-19.31ZM66.98,218.24c-7.63,0-13.84-6.21-13.84-13.84s6.21-13.84,13.84-13.84,13.84,6.21,13.84,13.84-6.21,13.84-13.84,13.84ZM66.98,191.56c-7.08,0-12.84,5.76-12.84,12.84s5.76,12.84,12.84,12.84,12.84-5.76,12.84-12.84-5.76-12.84-12.84-12.84Z"/>'
    // 흰색 하이라이트(원본 cls-2) — 맨 위
    +'<path fill="#fff" d="M70.5,221.06l-.21-.98c2.22-.47,4.29-1.39,6.13-2.73l.59.81c-1.96,1.43-4.15,2.41-6.51,2.91Z"/>'
    +'<path fill="#fff" d="M82.07,212.28l-.89-.46c1.19-2.27,1.82-4.84,1.82-7.42,0-4.8-2.12-9.3-5.83-12.36l.64-.77c3.94,3.25,6.19,8.03,6.19,13.13,0,2.74-.67,5.47-1.93,7.88Z"/>'
    +'</g>';
}
// @@ENGINE-END

function buildNoteSVG(opts){
  var orient = opts.isLandscape ? 'landscape' : 'portrait';
  var vb = PM_VIEWBOXES[orient];
  var nr = PM_NOTE_RECTS[orient];
  var side = opts.isBack ? 'back' : 'front';
  var springKind = opts.springType === 'full' ? 'full' : 'split';
  var s = '';

  s += '<rect x="'+fmt(nr.x+1.3)+'" y="'+fmt(nr.y+1.3)+'" width="'+fmt(nr.w)+'" height="'+fmt(nr.h)+'" fill="rgba(0,0,0,0.06)"/>';
  s += '<rect x="'+fmt(nr.x)+'" y="'+fmt(nr.y)+'" width="'+fmt(nr.w)+'" height="'+fmt(nr.h)+'" fill="'+(opts.coverColor||'#F5F3EE')+'"/>';
  if(opts.coverImage){ s += '<image href="'+opts.coverImage+'" x="'+fmt(nr.x)+'" y="'+fmt(nr.y)+'" width="'+fmt(nr.w)+'" height="'+fmt(nr.h)+'" preserveAspectRatio="xMinYMid slice"/>'; }

  // 텍스처/패턴 표지 — 썸네일(drawCovThumb)과 같은 규칙으로 표지 위에 패턴 오버레이
  if(opts.coverPattern){
    var u = nr.w/80; // 썸네일 캔버스(80px) 기준 좌표 → viewBox 단위 환산
    var pid = 'pmp-'+opts.coverPattern+'-'+side+'-'+Math.round(opts.W);
    var pdef = '';
    if(opts.coverPattern==='hatch') pdef='<pattern id="'+pid+'" width="'+fmt(5*u)+'" height="'+fmt(5*u)+'" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><line x1="0" y1="0" x2="0" y2="'+fmt(5*u)+'" stroke="rgba(0,0,0,0.06)" stroke-width="'+fmt(0.5*u)+'"/></pattern>';
    else if(opts.coverPattern==='owl') pdef='<pattern id="'+pid+'" width="'+fmt(18*u)+'" height="'+fmt(18*u)+'" patternUnits="userSpaceOnUse"><ellipse cx="'+fmt(4*u)+'" cy="'+fmt(8*u)+'" rx="'+fmt(3*u)+'" ry="'+fmt(7*u)+'" transform="rotate(17 '+fmt(4*u)+' '+fmt(8*u)+')" fill="rgba(255,255,255,0.25)"/></pattern>';
    else if(opts.coverPattern==='floral') pdef='<pattern id="'+pid+'" width="'+fmt(12*u)+'" height="'+fmt(10*u)+'" patternUnits="userSpaceOnUse"><circle cx="'+fmt(6*u)+'" cy="'+fmt(5*u)+'" r="'+fmt(4*u)+'" fill="none" stroke="rgba(80,80,120,0.2)" stroke-width="'+fmt(0.5*u)+'"/></pattern>';
    else if(opts.coverPattern==='stripe') pdef='<pattern id="'+pid+'" width="'+fmt(10*u)+'" height="'+fmt(10*u)+'" patternUnits="userSpaceOnUse"><line x1="'+fmt(5*u)+'" y1="0" x2="'+fmt(5*u)+'" y2="'+fmt(10*u)+'" stroke="rgba(100,90,70,0.18)" stroke-width="'+fmt(2.5*u)+'"/></pattern>';
    else if(opts.coverPattern==='dots') pdef='<pattern id="'+pid+'" width="'+fmt(12*u)+'" height="'+fmt(12*u)+'" patternUnits="userSpaceOnUse"><circle cx="'+fmt(6*u)+'" cy="'+fmt(6*u)+'" r="'+fmt(3*u)+'" fill="rgba(255,200,160,0.3)"/></pattern>';
    if(pdef) s += '<defs>'+pdef+'</defs><rect x="'+fmt(nr.x)+'" y="'+fmt(nr.y)+'" width="'+fmt(nr.w)+'" height="'+fmt(nr.h)+'" fill="url(#'+pid+')"/>';
  }

  if(opts.showBand && opts.bandType && opts.bandType !== 'none'){
    if(side === 'front'){
      if(opts.bandType === 'basic'){
        s += '<g style="color:'+opts.bandColor+'">'+PM_PARTS[orient+'-front-band-basic']+'</g>';
      } else if(opts.bandType === 'corner'){
        s += '<g style="color:'+opts.bandColor+'">'+PM_PARTS[orient+'-front-band-corner']+'</g>';
      } else if(opts.bandType === 'double'){
        s += '<g style="color:'+opts.bandColor+'">'+PM_PARTS[orient+'-front-band-double-1']+'</g>';
        s += '<g style="color:'+opts.band2Color+'">'+PM_PARTS[orient+'-front-band-double-2']+'</g>';
      }
    } else {
      if(opts.bandType === 'basic'){
        s += '<g style="color:'+opts.bandColor+'">'+PM_PARTS[orient+'-back-band-basic']+'</g>';
        s += '<g style="color:'+opts.eyeletColor+'">'+PM_PARTS[orient+'-back-eyelet-basic']+'</g>';
      } else if(opts.bandType === 'corner'){
        s += '<g style="color:'+opts.bandColor+'">'+PM_PARTS[orient+'-back-band-corner']+'</g>';
        s += '<g style="color:'+opts.eyeletColor+'">'+PM_PARTS[orient+'-back-eyelet-corner']+'</g>';
      } else if(opts.bandType === 'double'){
        s += '<g style="color:'+opts.bandColor+'">'+PM_PARTS[orient+'-back-band-double-1']+'</g>';
        s += '<g style="color:'+opts.band2Color+'">'+PM_PARTS[orient+'-back-band-double-2']+'</g>';
        s += '<g style="color:'+opts.eyeletColor+'">'+PM_PARTS[orient+'-back-eyelet-double-1']+'</g>';
        s += '<g style="color:'+opts.eyelet2Color+'">'+PM_PARTS[orient+'-back-eyelet-double-2']+'</g>';
      }
    }
  }

  s += PM_PARTS[orient+'-note'];

  if(opts.showSpring){
    if(opts.springType === 'full'){
      s += '<g style="color:'+opts.springColor+'">'+PM_PARTS[orient+'-'+side+'-spring-full']+'</g>';
    } else {
      s += '<g style="color:'+opts.springTopColor+'">'+PM_PARTS[orient+'-'+side+'-spring-split-top']+'</g>';
      s += '<g style="color:'+opts.springBotColor+'">'+PM_PARTS[orient+'-'+side+'-spring-split-bottom']+'</g>';
    }
    s += PM_PARTS[orient+'-'+side+'-hole-'+springKind] || '';
  }

  return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="'+fmt(vb.x0)+' '+fmt(vb.y0)+' '+fmt(vb.w)+' '+fmt(vb.h)+'" width="'+opts.W+'" height="'+opts.H+'" preserveAspectRatio="xMidYMid meet">'+s+'</svg>';
}

// ── 실제 비율 프리뷰(커버는 비율대로, 스프링·구멍은 단위 모듈을 타일링) ──
// @@ENGINE-BEGIN
var PM_K=51.59/182;            // 전역 스케일(units per mm) — 코일 크기 고정
var PM_X0=4, PM_Y0=2;          // 새 커버 원점(왼쪽에 스프링 오버행 여유)
var PM_PITCH=3.80;             // 코일/구멍 1개 간격(units, 고정)
var PM_COIL_SCALE=0.5;         // 코일 축소(지름 약 12mm)
var PM_MARGIN=8*PM_K;          // 노트 끝에서 8mm 여백(상·하 동일)
var PM_TPL={portrait:{x:14.33,y:0.19,w:51.59,h:72.85},landscape:{x:3.71,y:10.82,w:72.85,h:51.59}};
var PM_UNIT_CACHE={};
function firstMY(s){var m=s.match(/M\s*-?[\d.]+[ ,]\s*(-?[\d.]+)/);return m?+m[1]:0;}
function springUnit(orient,side){
  var key=orient+'-'+side; if(PM_UNIT_CACHE[key])return PM_UNIT_CACHE[key];
  var sp=PM_PARTS[orient+'-'+side+'-spring-full']||'';
  var paths=sp.match(/<path\b[\s\S]*?\/>/g)||[];
  var coil=(paths[0]||'')+(paths[1]||'');          // 코일 1개 = path 2개
  // 스프링 선을 굵게(원래 대비 +30%): 코일 path 는 fill:none 이라 보이는 건 전적으로 stroke → stroke-width 만 ×1.3.
  coil=coil.replace(/stroke-width="([\d.]+)"/g,function(_m,w){return 'stroke-width="'+(Math.round(parseFloat(w)*1.3*1000)/1000)+'"';});
  var hl=PM_PARTS[orient+'-'+side+'-hole-full']||'';
  var hpaths=hl.match(/<path\b[\s\S]*?\/>/g)||[];
  var hole=hpaths[0]||'';                            // 구멍 1개 = path 1개
  var u={coil:coil,hole:hole,refY:firstMY(coil)};
  PM_UNIT_CACHE[key]=u; return u;
}
// 아일렛 — 각 그로밋 요소를 크기 그대로 두고, 중심 y만 캐싱해 위치만 옮긴다(크기 고정).
var PM_EYE_CACHE={};
function eyeletUnit(part){
  if(PM_EYE_CACHE[part])return PM_EYE_CACHE[part];
  var ns='http://www.w3.org/2000/svg';
  var svg=document.createElementNS(ns,'svg');
  svg.setAttribute('width',300);svg.setAttribute('height',300);
  svg.style.position='absolute';svg.style.left='-99999px';
  svg.innerHTML=PM_PARTS[part]||'';
  document.body.appendChild(svg);
  var els=[];
  Array.prototype.forEach.call(svg.childNodes,function(n){
    if(!n.getBBox)return;
    var b;try{b=n.getBBox();}catch(e){return;}
    if(!b.height&&!b.width)return;
    els.push({html:n.outerHTML, cy:b.y+b.height/2});
  });
  document.body.removeChild(svg);
  PM_EYE_CACHE[part]=els;return els;
}
// 밴드 — 가는 스트랩의 폭/중심을 캐싱. 두께는 실제 5mm로 정규화(코너처럼 넓은 랩은 제외).
var PM_BAND_TGT_MM=5;
var PM_BAND_CACHE={};
function bandMetric(part){
  if(PM_BAND_CACHE[part])return PM_BAND_CACHE[part];
  var ns='http://www.w3.org/2000/svg';
  var svg=document.createElementNS(ns,'svg');
  svg.setAttribute('width',300);svg.setAttribute('height',300);
  svg.style.position='absolute';svg.style.left='-99999px';
  svg.innerHTML='<g>'+(PM_PARTS[part]||'')+'</g>';
  document.body.appendChild(svg);
  var b=svg.firstChild.getBBox();
  document.body.removeChild(svg);
  var w=b.width, cx=b.x+b.width/2;
  var bt=(w<6)?(PM_BAND_TGT_MM*PM_K)/w:1;   // 가는 스트랩만 5mm로, 코너 랩(넓음)은 원본 유지
  var u={cx:cx,bt:bt};PM_BAND_CACHE[part]=u;return u;
}
function curNoteMM(){
  var land=S.dir==='landscape', nw,nh;
  if(S.size==='X'){var cw=S.cw||182,ch=S.ch||257; if(land){nw=Math.max(cw,ch);nh=Math.min(cw,ch);}else{nw=Math.min(cw,ch);nh=Math.max(cw,ch);}}
  else{var sz=SIZES.find(function(x){return x.id===S.size;});nw=sz.w;nh=sz.h; if(land){var t=nw;nw=nh;nh=t;}}
  return{nw:nw,nh:nh,land:land};
}
function notePreviewVB(){
  var m=curNoteMM();
  return{w:PM_X0+m.nw*PM_K+2, h:PM_Y0+m.nh*PM_K+2};
}
function fitNote(maxW,maxH){
  var vb=notePreviewVB();
  // 배율은 방향과 무관하게 고정한다(정사각 박스 + A의 긴 변 257mm 기준).
  // → A는 박스를 (긴 변 기준) 꽉 채우고, 작은 사이즈는 상대적으로 작게,
  //   그리고 가로/세로가 같은 정사각 노트는 방향을 바꿔도 크기가 동일하게 보인다.
  var ref=PM_X0+257*PM_K+2;
  var ppu=Math.min(maxW/ref, maxH/ref);
  return{W:Math.round(vb.w*ppu), H:Math.round(vb.h*ppu)};
}
function buildNotePreviewSVG(opts){
  var m=curNoteMM(),land=m.land,side=opts.isBack?'back':'front',orient=land?'landscape':'portrait';
  var springKind=opts.springType==='full'?'full':'split';
  var x0=PM_X0,y0=PM_Y0,coverW=m.nw*PM_K,coverH=m.nh*PM_K;
  var vbW=x0+coverW+2, vbH=y0+coverH+2;
  var s='';
  s+='<rect x="'+fmt(x0+1.3)+'" y="'+fmt(y0+1.3)+'" width="'+fmt(coverW)+'" height="'+fmt(coverH)+'" fill="rgba(0,0,0,0.06)"/>';
  s+='<rect x="'+fmt(x0)+'" y="'+fmt(y0)+'" width="'+fmt(coverW)+'" height="'+fmt(coverH)+'" fill="'+(opts.coverColor||'#F5F3EE')+'"/>';
  if(opts.coverImage){
    var imgX,imgY,imgW,imgH;
    if(opts.coverFitFull){
      // fit_full 표지(예: C 전용): 이미지를 그 사이즈에 맞춰 촬영했으므로 A실척 크롭을 하지 않고
      // 표지 사각형에 그대로 채운다(더 잘리지 않음). slice 라 비율이 딱 맞으면 무크롭, 살짝 다르면 최소만.
      imgX=x0; imgY=y0; imgW=coverW; imgH=coverH;
    } else {
      // 일반: A사이즈(182x257) 기준 원본을 고정 실척(mm)으로 배치 — 작은 사이즈는 축소가 아니라 크롭(무늬 크기 유지).
      // 🔴 가로형이어도 기준 틀을 돌리지 않는다(2026-10-04 대표님 지적). 사진은 «세로 A 표지 한 장»이라,
      //    틀을 257×182 로 돌리면 세로 사진이 그 폭을 채우려고 약 1.33배 확대된 뒤 잘렸다(가로 C 에서 무늬가 커 보임).
      //    세로 A 실척 그대로 두고 가로 표지 사각형만큼 잘라 낸다 — 가로 C(182×128)는 무확대.
      //    가로 B·A 는 폭(202·257)이 사진 폭(182)을 넘어 그만큼만 확대된다(돌리지 않는 한 피할 수 없다).
      var aSz=SIZES.find(function(x){return x.id==='A';});
      var imgWBase=aSz.w*PM_K, imgHBase=aSz.h*PM_K;
      var imgScale=Math.max(1, coverW/imgWBase, coverH/imgHBase); // 표지가 사진(A 실척)보다 클 때만 확대
      imgW=imgWBase*imgScale; imgH=imgHBase*imgScale;
      imgX=x0; imgY=y0+(coverH-imgH)/2;
    }
    var imgClipId='pmimgclip-'+side+'-'+Math.round(opts.W)+'-'+Math.round(coverH);
    s+='<defs><clipPath id="'+imgClipId+'"><rect x="'+fmt(x0)+'" y="'+fmt(y0)+'" width="'+fmt(coverW)+'" height="'+fmt(coverH)+'"/></clipPath></defs>';
    // 디자인 카테고리는 컬러라인이 항상 제본 쪽(앞=왼/뒤=오른)에 오도록 뒷표지에서 좌우반전
    var flipDesign=side==='back'&&opts.coverCat==='디자인';
    var imgTag='<image href="'+opts.coverImage+'" x="'+fmt(imgX)+'" y="'+fmt(imgY)+'" width="'+fmt(imgW)+'" height="'+fmt(imgH)+'" preserveAspectRatio="xMinYMid slice"/>';
    if(flipDesign){
      var flipCx=x0+coverW/2;
      s+='<g clip-path="url(#'+imgClipId+')"><g transform="translate('+fmt(2*flipCx)+',0) scale(-1,1)">'+imgTag+'</g></g>';
    } else {
      s+='<g clip-path="url(#'+imgClipId+')">'+imgTag+'</g>';
    }
  }
  if(opts.coverPattern){
    var u=coverW/80, pid='pmpv-'+opts.coverPattern+'-'+side+'-'+Math.round(opts.W)+'-'+Math.round(coverH), pdef='';
    if(opts.coverPattern==='hatch')pdef='<pattern id="'+pid+'" width="'+fmt(5*u)+'" height="'+fmt(5*u)+'" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><line x1="0" y1="0" x2="0" y2="'+fmt(5*u)+'" stroke="rgba(0,0,0,0.06)" stroke-width="'+fmt(0.5*u)+'"/></pattern>';
    else if(opts.coverPattern==='owl')pdef='<pattern id="'+pid+'" width="'+fmt(18*u)+'" height="'+fmt(18*u)+'" patternUnits="userSpaceOnUse"><ellipse cx="'+fmt(4*u)+'" cy="'+fmt(8*u)+'" rx="'+fmt(3*u)+'" ry="'+fmt(7*u)+'" transform="rotate(17 '+fmt(4*u)+' '+fmt(8*u)+')" fill="rgba(255,255,255,0.25)"/></pattern>';
    else if(opts.coverPattern==='floral')pdef='<pattern id="'+pid+'" width="'+fmt(12*u)+'" height="'+fmt(10*u)+'" patternUnits="userSpaceOnUse"><circle cx="'+fmt(6*u)+'" cy="'+fmt(5*u)+'" r="'+fmt(4*u)+'" fill="none" stroke="rgba(80,80,120,0.2)" stroke-width="'+fmt(0.5*u)+'"/></pattern>';
    else if(opts.coverPattern==='stripe')pdef='<pattern id="'+pid+'" width="'+fmt(10*u)+'" height="'+fmt(10*u)+'" patternUnits="userSpaceOnUse"><line x1="'+fmt(5*u)+'" y1="0" x2="'+fmt(5*u)+'" y2="'+fmt(10*u)+'" stroke="rgba(100,90,70,0.18)" stroke-width="'+fmt(2.5*u)+'"/></pattern>';
    else if(opts.coverPattern==='dots')pdef='<pattern id="'+pid+'" width="'+fmt(12*u)+'" height="'+fmt(12*u)+'" patternUnits="userSpaceOnUse"><circle cx="'+fmt(6*u)+'" cy="'+fmt(6*u)+'" r="'+fmt(3*u)+'" fill="rgba(255,200,160,0.3)"/></pattern>';
    if(pdef)s+='<defs>'+pdef+'</defs><rect x="'+fmt(x0)+'" y="'+fmt(y0)+'" width="'+fmt(coverW)+'" height="'+fmt(coverH)+'" fill="url(#'+pid+')"/>';
  }
  s+='<rect x="'+fmt(x0)+'" y="'+fmt(y0)+'" width="'+fmt(coverW)+'" height="'+fmt(coverH)+'" fill="none" stroke="#231f20" stroke-width=".12" stroke-miterlimit="10"/>';  // 노트 외곽선 .15→.12 (80%)
  // 밴드(잠금) — 고정 mm 위치에 직접 그린다. 앞=오른쪽 기준, 뒤=왼쪽 기준(대칭).
  var tpl=PM_TPL[orient];          // (아래 스프링 위치 계산에 사용)
  var mmU=PM_K;                    // units per mm
  var rX=x0+coverW, lX=x0, tY=y0, bY=y0+coverH, bandW=5*mmU;
  var cornerOff=(S.size==='A'?31:S.size==='B'?29:27)*mmU; // C/커스텀=27, B=29, A=31
  function vBand(cx,color){ return '<rect x="'+fmt(cx-bandW/2)+'" y="'+fmt(tY)+'" width="'+fmt(bandW)+'" height="'+fmt(coverH)+'" fill="'+color+'"/>'; }
  function diag(x1,y1,x2,y2,color){ return '<line x1="'+fmt(x1)+'" y1="'+fmt(y1)+'" x2="'+fmt(x2)+'" y2="'+fmt(y2)+'" stroke="'+color+'" stroke-width="'+fmt(bandW)+'"/>'; }
  // 대표님 원본 아일렛 도형으로 교체(2026-07-20). 바깥지름을 예전과 같은 ~2.8mm 로 맞춘다.
  function eye(cx,cy,color){ return eyeletSVG(cx,cy,2.8*mmU,color); }
  if(opts.showBand&&opts.bandType&&opts.bandType!=='none'){
    var back=(side==='back');
    var eIn=24.5*mmU;                            // 아일렛: 끝에서 24.5mm
    // 밴드 가로 위치: 가로 100mm 이상은 22mm 기준, 50mm에서 7mm로 순차 조정
    var bStart=m.nw>=100?22:(m.nw<=50?7:7+15*(m.nw-50)/50);
    var c1d=(bStart+2.5)*mmU, c2d=(bStart+8.5)*mmU; // 중심 거리(밴드폭5mm, 간격1mm)
    var c1=back?(lX+c1d):(rX-c1d);               // 밴드1 중심
    var c2=back?(lX+c2d):(rX-c2d);               // 밴드2 중심
    var o=cornerOff, bands='', eyes='';
    function stub(cx,y1,y2,col){return '<rect x="'+fmt(cx-bandW/2)+'" y="'+fmt(y1)+'" width="'+fmt(bandW)+'" height="'+fmt(y2-y1)+'" fill="'+col+'"/>';}
    if(opts.bandType==='basic'||opts.bandType==='double'){
      // c1 = 여는 변에 가장 가까운 위치(앞=오른쪽 끝, 뒤=왼쪽 끝), c2 = 그 안쪽
      // 밴드: 1번=왼쪽 / 2번=오른쪽 (뒷면은 좌우 반전이라 1번이 오른쪽으로 옴)
      //  → c1(앞 오른쪽/뒤 왼쪽)에는 밴드2, c2에는 밴드1
      // 아일렛: 왼쪽=1번 / 오른쪽=2번 (뒷면 기준 c1=왼쪽=ey1, c2=오른쪽=ey2)
      var list=(opts.bandType==='basic')
        ? [{x:c1,col:opts.bandColor,ec:opts.eyeletColor}]
        : [{x:c1,col:opts.band2Color,ec:opts.eyeletColor},{x:c2,col:opts.bandColor,ec:opts.eyelet2Color}];
      list.forEach(function(b){
        if(!back){ bands+=vBand(b.x,b.col); }      // 앞면: 전체 세로 밴드
        else {                                      // 뒷면: 양 끝에서 아일렛까지만(토막)
          bands+=stub(b.x,tY,tY+eIn,b.col);
          bands+=stub(b.x,bY-eIn,bY,b.col);
          eyes+=eye(b.x,tY+eIn,b.ec);
          eyes+=eye(b.x,bY-eIn,b.ec);
        }
      });
    } else if(opts.bandType==='corner'){
      var ext=15*mmU;   // 대각선을 변 밖으로 연장 → 클립으로 노트면과 평행하게 잘림
      // 위쪽=밴드1/아일렛1, 아래쪽=밴드2/아일렛2
      var topCol=opts.bandColor, botCol=opts.band2Color;
      function dseg(ax,ay,bx,by,col){var dx2=bx-ax,dy2=by-ay,L=Math.hypot(dx2,dy2)||1,ux=dx2/L,uy=dy2/L;return diag(ax-ux*ext,ay-uy*ext,bx+ux*ext,by+uy*ext,col);}
      if(!back){
        bands+=dseg(rX-o,tY,rX,tY+o,topCol);
        bands+=dseg(rX-o,bY,rX,bY-o,botCol);
      } else {
        bands+=dseg(lX+o,tY,lX,tY+o,topCol);
        bands+=dseg(lX+o,bY,lX,bY-o,botCol);
        eyes+=eye(lX+o/2,tY+o/2,opts.eyeletColor);  // 위쪽 아일렛
        eyes+=eye(lX+o/2,bY-o/2,opts.eyelet2Color); // 아래쪽 아일렛
      }
    }
    // 밴드는 커버 면에 맞게 클립. 외곽선(테두리) 두께만큼 살짝 넓혀 밴드 끝이 외곽선을 덮게 한다.
    var eb=0.3; // 테두리(stroke .3) 두께만큼 블리드
    var clipId='pmbclip-'+side+'-'+Math.round(opts.W)+'-'+Math.round(coverH);
    s+='<defs><clipPath id="'+clipId+'"><rect x="'+fmt(x0-eb)+'" y="'+fmt(y0-eb)+'" width="'+fmt(coverW+2*eb)+'" height="'+fmt(coverH+2*eb)+'"/></clipPath></defs>';
    s+='<g clip-path="url(#'+clipId+')">'+bands+'</g>'+eyes;
  }
  // 스프링 + 구멍 — 단위 모듈을 코일 크기(약 12mm)로 축소해 노트 길이에 맞춰 타일링
  if(opts.showSpring){
    var unit=springUnit(orient,side);
    var cs=PM_COIL_SCALE;                  // 코일 축소(지름 약 12mm)
    var effPitch=PM_PITCH*cs;              // 축소된 코일 간격
    // 바인딩 변 — 앞면은 템플릿 왼쪽, 뒷면은 오른쪽에 코일/구멍이 그려져 있다.
    var tplRight=tpl.x+tpl.w;
    var ax=side==='back'?tplRight:tpl.x;             // 코일 축소 앵커 = 바인딩 변
    var dx=side==='back'?(x0+coverW-tplRight):(x0-tpl.x); // 바인딩 변을 새 커버 가장자리에 맞춤
    var ay=unit.refY;
    var scl=' translate('+fmt(ax)+','+fmt(ay)+') scale('+fmt(cs)+') translate('+fmt(-ax)+','+fmt(-ay)+')';
    function coilG(topY,color){return '<g style="color:'+color+'" transform="translate('+fmt(dx)+','+fmt(topY-unit.refY)+')'+scl+'">'+unit.coil+'</g>';}
    function holeG(topY){return '<g transform="translate('+fmt(dx)+','+fmt(topY-unit.refY)+')'+scl+'">'+unit.hole+'</g>';}
    var usable=coverH-2*PM_MARGIN;
    var coils='',holes='',i,topY;
    if(springKind==='full'){
      // 상·하단 모두 PM_MARGIN 여백을 두고 그 사이를 균등 분할(피치 ≈ effPitch)
      var N=Math.max(2,Math.round(usable/effPitch)+1);
      var pitch=usable/(N-1);
      for(i=0;i<N;i++){topY=y0+PM_MARGIN+i*pitch; coils+=coilG(topY,opts.springColor); holes+=holeG(topY);}
    } else {
      var maxEnd=Math.max(1,Math.floor((usable/2)/effPitch)+1);
      // 양끝 스프링 개수는 **제본면 길이(mm)** 로 정한다 — 사이즈 이름으로 정하지 않는다.
      //   ~85mm = 3개 / 85mm~A미만 = 4개 / **A 세로형 제본면(257mm) 이상 = 5개**
      // 🔴 2026-08-05 수정: 기준이 202(=B의 세로)로 박혀 있어 **B 에서도 5개**가 나왔다(대표님 지적).
      //    5개는 A 부터다. 길이로 판정하므로 커스텀 사이즈도 257mm 이상이면 자동으로 5개가 된다.
      // ⚠️ m.nh 는 방향까지 반영된 제본면 길이라 getSpringFaceLen() 과 같은 값이다
      //    (세로형=높이, 가로형=눕혔을 때의 높이). 둘 중 하나를 고치면 다른 쪽도 확인할 것.
      var sfl=m.nh;
      var aRef=(SIZES.find(function(x){return x.id==='A';})||{}).h||257;
      var baseN=sfl<=85?3:(sfl>=aRef?5:4);
      var endN=Math.min(baseN, maxEnd);
      for(i=0;i<endN;i++){topY=y0+PM_MARGIN+i*effPitch; coils+=coilG(topY,opts.springTopColor); holes+=holeG(topY);}
      for(i=0;i<endN;i++){topY=y0+coverH-PM_MARGIN-i*effPitch; coils+=coilG(topY,opts.springBotColor); holes+=holeG(topY);}
    }
    s+=coils+holes;
  }
  return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 '+fmt(vbW)+' '+fmt(vbH)+'" width="'+opts.W+'" height="'+opts.H+'" preserveAspectRatio="xMidYMid meet">'+s+'</svg>';
}
// @@ENGINE-END

function bandThumbSVG2(type, bColor, b2Color, eyColor, isSelected) {
  var c1 = isSelected ? (bColor || '#1C1C1C') : '#2A2A2A';
  var c2 = isSelected ? (b2Color || c1) : '#2A2A2A';
  return buildNoteSVG({
    W:46, H:58,
    isBack:false,
    isLandscape:S.dir==='landscape',
    coverColor:'#F8F7F4',
    showSpring:S.springChosen,
    springType:'split',
    springColor:'#B0ADA8',
    springTopColor:'#B0ADA8',
    springBotColor:'#B0ADA8',
    showBand:type !== 'none',
    bandType:type,
    bandColor:c1,
    band2Color:c2,
    eyeletColor:eyColor || '#888',
    eyelet2Color:eyColor || '#888'
  });
}


// ═══ LANGUAGE ════════════════════════════════════════════════════════
// 🔴 첫 언어는 **주소에서 읽는다**(2026-08-13). 예전엔 무조건 'ko' 로 시작해서,
//    홈에서 영어로 바꾸고 노트 만들기로 들어오면 다시 한국어가 됐다 — 언어가 페이지마다 튀었다.
//    ⚠️ **`localization.language` / `request.locale` 을 믿을 수 없다.** 이 페이지는 `layout none` 이라
//       Shopify 가 현재 언어를 안 넘겨준다 — 라이브에서 `/en/pages/diy-notebook` 인데 값이 비어 있는 걸 확인했다
//       (게시된 언어 **목록**(`localization.available_languages`)은 정상으로 들어온다. 그래서 그 목록만 쓴다).
//    → 주소의 접두어(`/en`)를 목록의 root 와 맞춰 언어를 정한다. **주소는 언제나 사실이다.**
function pmLocaleFromPath(){
  var list=window.PAPERME_LOCALES||[], p=(typeof location!=='undefined'?location.pathname:'')||'/', prim='';
  for(var i=0;i<list.length;i++){
    var r=list[i].root||'/', iso=(list[i].iso||'').toLowerCase();
    if(list[i].primary)prim=iso;
    if(r!=='/'&&(p===r||p.indexOf(r+'/')===0))return iso;
  }
  return prim||(window.PAPERME_LOCALE||'').toLowerCase();   // 목록이 없으면 주입값, 그것도 없으면 빈 문자열
}
// 로케일 코드(`en`·`en-US`·`ja`·`ja-JP`…)를 우리가 쓰는 세 언어 중 하나로 줄인다.
// 🔴 예전엔 `indexOf('en')===0` 한 줄이라 **일본어가 조용히 한국어로 떨어졌다**(2026-08-14 3언어 개편).
//    모르는 언어는 한국어로 떨어뜨린다 — 원문이 기본값이다.
function pmLangFrom(iso){
  iso=(iso||'').toLowerCase();
  if(iso.indexOf('ja')===0)return 'ja';
  if(iso.indexOf('en')===0)return 'en';
  return 'ko';
}
var LANG=pmLangFrom(pmLocaleFromPath());
var TXT={
  ko:{
    'hdr-h1':'나만의 노트를 만들어보세요.',
    'size-note':'선택한 사이즈는 내지 기준입니다. 실제 완성 사이즈는 선택하신 사이즈보다 조금 더 커집니다.',
    'st-size':'사이즈 선택','st-dir':'방향 선택','st-spring':'스프링 선택',
    'size-tip-btn-txt':'SIZE TIP','sizetip-ttl':'사이즈 가이드','sizetip-loading':'불러오는 중…',
    'sizetip-scrollhint':'← 좌우로 밀어서 보실 수 있어요 →',
    /* 도해 안에 이미 "수작업 공정 특성상…" 문구가 있으므로 여기선 반복하지 않는다. */
    'sizetip-note':'표기된 치수는 내지 기준입니다. 실제 완성 사이즈는 조금 더 커집니다.',
    'st-band':'잠금 방식 선택','st-fc':'앞표지 선택','st-bc':'뒷표지 선택',
    'st-inn':'내지 선택','inn-limit-lbl':'최소 2세트 · 최대 5세트','sp-price-tag':'+1,500원',
    'lbl-w':'가로','lbl-h':'세로',
    'dir-portrait':'세로형','dir-landscape':'가로형',
    'sp-lbl-full':'풀 스프링','sp-lbl-split':'양끝 스프링',
    'sc-lbl':'스프링 컬러','sc-top-lbl':'위쪽 스프링','sc-bot-lbl':'아래쪽 스프링',
    'bc-lbl':'밴드 컬러','bc1-lbl':'밴드 1 컬러','bc2-lbl':'밴드 2 컬러',
    'bk-lbl':'버클 컬러','ey-lbl':'아일렛 컬러',
    'ey-note':'※ 뒷면 프리뷰에서 확인하세요',
    'ey1-lbl':'왼쪽 밴드 아일렛','ey2-lbl':'오른쪽 밴드 아일렛',
    'prev-lbl':'PREVIEW','ptab-front':'앞면','ptab-back':'뒷면',
    'zoombtn':'⤢ 크게보기','zoombtn-m':'⤢ 크게','ztab-front':'앞면','ztab-back':'뒷면',
    'zoom-hint':'손가락으로 오므렸다 펴서 확대 · 끌어서 이동 · 더블탭으로 확대/축소',
    'zoom-hint-mouse':'클릭하면 확대 · 다시 클릭하면 원래대로 · 끌어서 이동 · 휠로 배율 조절',
    'mobile-prev-reopen':'미리보기 펼치기 ▾',
    'navwait':'로그인 화면으로 이동 중…',
    'm-ptab-front':'앞','m-ptab-back':'뒤','mobile-add-btn':'장바구니 담기','m-reset-btn':'↺ 옵션 초기화','mobile-bottom-add':'담기',
    'sk-size':'사이즈','sk-dir':'방향','sk-sp':'스프링','sk-band':'잠금',
    'sk-fc':'앞표지','sk-bc':'뒷표지','sk-inn':'내지',
    'price-lbl':'합계','qty-lbl':'수량','reset-btn':'선택 초기화',
    'btn-add':'장바구니에 담기','btn-wish':'위시리스트에 저장','btn-checkout':'주문하기',
    // 제작 기간 표현은 leadNote()·장바구니 요약과 같은 「보통 5–7일 · 넉넉히 10일」(2026-09-22). 세 곳이 한 벌.
    // 🔴 `note-lead` 는 여기 없다 — 제작 화면과 **같은 문구**라 leadNote()·leadNoteHtml() 한 곳에서 채운다(2026-09-23).
    //    여기 다시 넣으면 메일 링크가 없는 글자로 덮인다.
    'note-local':'장바구니는 이 기기에만 저장됩니다. 선택한 내용을 나중에 다시 확인하거나 다른 기기에서도 확인하려면 로그인 후 위시리스트에 저장해 주세요.',
    'agree-lbl':'위 내용을 확인했으며, 주문제작 상품은 단순변심에 의한 취소·환불이 제한되는 것에 동의합니다.',
    'use-q':'이 노트는 누구를 위한 건가요?',
    'use-self':'제가 사용합니다',
    'use-gift':'선물용입니다 — 동봉되는 주문서에는 금액을 표기하지 않고 보내드려요',
    'use-mixed':'섞여있어요.',
    'use-mixed-hint':'선물용 품목을 선택해주세요.',
    'use-warn':'용도를 선택해 주세요.',
    'agree-warn':'주문제작 동의에 체크해주세요.',
    'nav-wish':'위시리스트','nav-cart':'장바구니',
    'dr-wish-ttl':'위시리스트','dr-cart-ttl':'장바구니',
    'wish-empty':'저장된 조합이 없어요.','cart-empty':'담긴 노트가 없어요.',
    'cart-ordered':'주문이 접수되어 장바구니를 비웠어요. 감사합니다!',
    'pop-t':'장바구니에 담았어요','pop-cn':'계속 만들기','pop-ok':'장바구니 보기',
    'inn-cart-ttl':'선택한 내지 순서',
    'inn-cart-note':'(드래그 앤 드롭으로 순서를 바꿀 수 있습니다.)',
    'band-none':'없음','band-basic':'기본형','band-corner':'코너형','band-double':'더블형',
    /* 🔴 버튼 라벨은 '바꿀 언어'가 아니라 **'지금 언어'**다(2026-08-14 목록으로 바뀌면서 뒤집혔다).
       예전엔 한국어 화면에서 'EN'(= 누르면 영어)이었는데, 목록에서는 그게 거짓말이 된다. */
    'free':'무료','lang-btn':'KO',
    'vtab-diy':'DIY NOTEBOOK','vtab-diy-short':'DIY','vtab-premade':'SIGNATURE','vtab-acc':'ACC','shop-sub-premade':'페이퍼미가 직접 고른 조합을 만나보세요.','shop-sub-acc':'액세서리·포장용품을 만나보세요.','only1-note':'unique 한 디자인이나 소재를 적용한 only 1 노트입니다.\n판매 후에는 재입고 되지 않습니다.','sig-note':'SIGNATURE는 PAPER ME가 미리 조합해 둔 구성으로, 주문을 받은 뒤 한 권씩 만듭니다.\n일정이 급하실 경우 paper.me.seoul@gmail.com으로 문의해 주세요 — 가능한 범위에서 일정을 앞당겨 드릴게요 :)','sig-note-short':'주문 후 제작이 시작됩니다. 일정이 급하실 경우 메일로 문의주세요. : )','shop-soldout':'품절','shop-coming':'준비 중입니다. 곧 만나보실 수 있어요.','shop-back':'← 목록으로','shop-add':'장바구니 담기','shop-opt':'옵션 선택','shop-qty':'수량','shop-added':'장바구니에 담았어요','shop-checkout-soon':'기성품 주문/결제는 준비 중이에요. 곧 지원됩니다.','imgzoom-hint':'🔍 이미지 위에서 마우스를 움직이면 확대돼요 · 모바일은 손가락으로 누른 채 이동',
    'cf-info':'고객안내','cf-refund':'환불 정책','cf-ship':'배송 정책','cf-privacy':'개인정보처리방침','cf-terms':'이용약관',
    // HOW TO 탭. ⚠️ 본문(`-b`)에는 `<br>` 이 들어 있어 **innerHTML 로 넣어야 한다**(applyHowtoLang).
    //    홈의 같은 섹션과 문안이 두 벌로 존재한다(DECISIONS #13) — 한쪽을 고치면 다른 쪽도 같이.
    'ht-title':'단계별로 완성되는 나만의 노트',
    'ht-sub':'표지와 내지, 제본과 잠금 방식까지 모든 스텝을 내가 원하는대로!',
    'ht-s1-t':'규격과 표지 선택',
    'ht-s1-b':'A, B, C 세 가지 규격 또는 원하는 커스텀 사이즈를<br>선택하고, 앞과 뒤 표지를 선택해 주세요.',
    'ht-s2-t':'스프링과 밴드 조율',
    // 🔴 「양끝 스프링」 — DIY 버튼(sp-lbl-split)·요약·장바구니·주문서와 같은 이름을 쓴다(2026-09-22 대표님 지적: HOW TO 만 「분리형」이었다).
    //    홈 「만드는 과정」 섹션(paperme-howto.liquid · index.json)도 같은 문장이다 — 한쪽만 고치지 말 것.
    'ht-s2-b':'스프링 타입을 풀 스프링과 양끝 스프링 중<br>선택해 주세요. 양끝 스프링은 위아래 컬러를<br>각각 선택하실 수 있어요.<br>노트를 감싸줄 밴드의 타입과 컬러,<br>밴드에 어울리는 아일렛 컬러도 선택해 주세요.',
    'ht-s3-t':'나만의 내지 레이어링',
    'ht-s3-b':'기록의 목적과 자주 쓰는 필기구에 어울리는 내지를<br>선택해 주세요. 내지는 최소 2세트에서 최대 5세트까지<br>자유롭게 구성하실 수 있어요.',
    'ht-cta':'노트 만들기 →',
    'cover-cats-ids':['solid','texture','pattern','limited'],
    // ('cover-cats' 는 지웠다 — 아무 데서도 안 쓰는데 `텍스처` 같은 옛 값이 남아 있어
    //  표지 카테고리 라벨의 출처처럼 보였다. 진짜 출처는 COV_CAT_LABEL 이다.)
    'inn-cats-ko':['라인','격자','플래너','무지','특수'],
    'inn-cats':['라인','격자','플래너','무지','특수'],
    'hint-more':function(n){return '최소 '+n+'세트 더 선택해주세요.'},
    'hint-add':function(n){return '최대 '+n+'세트 더 추가할 수 있어요.'},
    'hint-done':'내지 선택 완료.',
    'toast-max':'내지는 최대 5세트까지 담을 수 있어요.',
    'custom-info':'최소 50×50mm ~ A4(210×297mm) 이내로 입력해주세요.',
    'custom-warn':function(w,h,rotated){var base=w+'×'+h+'mm · 커스텀 +10,000원 추가'; return rotated?base+'\n※ 선택하신 사이즈는 가로형 형태입니다. 방향이 자동으로 가로형으로 설정됩니다.':base;},
    /* 🔴 2026-08-14: '카카오톡 채널'을 메일로 고쳤다. **그런 채널이 없다** — 대표님 확인.
       사이트 어디에도 카카오톡이 없고(푸터·햄버거·SIGNATURE 안내 모두 메일·전화·인스타),
       고객을 존재하지 않는 창구로 보내고 있었다. 이 문구는 사라지는 토스트가 아니라
       입력칸 아래 **계속 떠 있는 안내**라, 주소를 그대로 적어 바로 쓸 수 있게 했다. */
    'custom-err-small':'최소 50×50mm 이하 사이즈 — paper.me.seoul@gmail.com 으로 문의해주세요.',
    'custom-err-big':'A4(210×297mm) 초과 사이즈 — paper.me.seoul@gmail.com 으로 문의해주세요.',
    'custom-err':'사이즈 범위 초과 — paper.me.seoul@gmail.com 으로 문의해주세요.',
    'per-set':'원/세트','won':'원','reset-confirm':'모든 선택을 초기화할까요?'
  },
  en:{
    'hdr-h1':'Build your own notebook.',
    'size-note':'The size shown is based on the inner pages. The finished notebook is slightly larger than the selected size.',
    'st-size':'Size','st-dir':'Orientation','st-spring':'Spring',
    'size-tip-btn-txt':'SIZE TIP','sizetip-ttl':'Size Guide','sizetip-loading':'Loading…',
    'sizetip-scrollhint':'← swipe to see the full chart →',
    'sizetip-note':'Dimensions refer to the inner pages. Finished notebooks are slightly larger.',
    'st-band':'Closure','st-fc':'Front Cover','st-bc':'Back Cover',
    'st-inn':'Inner Pages','inn-limit-lbl':'Min 2 · Max 5 sets','sp-price-tag':'+1,500 KRW',
    'lbl-w':'Width','lbl-h':'Height',
    'dir-portrait':'Portrait','dir-landscape':'Landscape',
    'sp-lbl-full':'Full Spring','sp-lbl-split':'Split Spring',
    'sc-lbl':'Spring Color','sc-top-lbl':'Top Spring','sc-bot-lbl':'Bottom Spring',
    'bc-lbl':'Band Color','bc1-lbl':'Band 1 Color','bc2-lbl':'Band 2 Color',
    'bk-lbl':'Buckle Color','ey-lbl':'Eyelet Color',
    'ey-note':'※ Check in back cover preview',
    'ey1-lbl':'Left Band Eyelet','ey2-lbl':'Right Band Eyelet',
    'prev-lbl':'PREVIEW','ptab-front':'Front','ptab-back':'Back',
    'zoombtn':'⤢ Zoom','zoombtn-m':'⤢ Zoom','ztab-front':'Front','ztab-back':'Back',
    'zoom-hint':'Pinch to zoom · drag to move · double-tap to zoom in/out',
    'zoom-hint-mouse':'Click to zoom in · click again to reset · drag to move · scroll to adjust',
    'mobile-prev-reopen':'Show preview ▾',
    'navwait':'Opening sign-in…',
    'm-ptab-front':'Front','m-ptab-back':'Back','mobile-add-btn':'Add to cart','m-reset-btn':'↺ Reset','mobile-bottom-add':'Add',
    'sk-size':'Size','sk-dir':'Orientation','sk-sp':'Spring','sk-band':'Closure',
    'sk-fc':'Front Cover','sk-bc':'Back Cover','sk-inn':'Inner Pages',
    'price-lbl':'Total','qty-lbl':'Qty','reset-btn':'Reset',
    'btn-add':'Add to Cart','btn-wish':'Save to Wishlist','btn-checkout':'Checkout',
    'note-local':'Your cart is saved only on this device. If you\'d like to check your selections again later or on another device, please log in and save them to your wishlist.',
    'agree-lbl':'I have read the above and agree that cancellation or refund due to a change of mind is limited for made-to-order items.',
    'use-q':'Who is this notebook for?',
    'use-self':'For personal use',
    'use-gift':'This is a gift — we’ll send it without displaying the price on the enclosed order form.',
    'use-mixed':'Both personal use and gifts',
    'use-mixed-hint':'Please select the item(s) that are gifts.',
    'use-warn':'Please choose one.',
    'agree-warn':'Please check the made-to-order agreement.',
    'nav-wish':'Wishlist','nav-cart':'Cart',
    'dr-wish-ttl':'Wishlist','dr-cart-ttl':'Cart',
    'wish-empty':'No saved configs.','cart-empty':'Your cart is empty.',
    'cart-ordered':'Your order has been received, so we’ve emptied your cart. Thank you!',
    'pop-t':'Added to cart','pop-cn':'Keep building','pop-ok':'View cart',
    'inn-cart-ttl':'Selected inner pages',
    'inn-cart-note':'(Drag and drop to reorder.)',
    'band-none':'None','band-basic':'Basic','band-corner':'Corner','band-double':'Double',
    'free':'Free','lang-btn':'EN',
    'vtab-diy':'DIY NOTEBOOK','vtab-diy-short':'DIY','vtab-premade':'SIGNATURE','vtab-acc':'ACC','shop-sub-premade':'Paper Me’s selected combinations.','shop-sub-acc':'Accessories & packaging.','only1-note':'A one-of-a-kind note with a unique design or material.\nOnce sold, it will not be restocked.','sig-note':'SIGNATURE notebooks feature combinations selected by PAPER ME and are made one by one after your order is placed.\nIf you need yours sooner, please email us at paper.me.seoul@gmail.com — we’ll do our best to accommodate your schedule. :)','sig-note-short':'Made to order · Need it sooner? Email us : )','shop-soldout':'Sold out','shop-coming':'Coming soon.','shop-back':'← Back to list','shop-add':'Add to Cart','shop-opt':'Options','shop-qty':'Qty','shop-added':'Added to cart','shop-checkout-soon':'Checkout for shop items is coming soon.','imgzoom-hint':'🔍 Move your mouse over the image to magnify · on mobile, press and drag',
    'cf-info':'Information','cf-refund':'Refund Policy','cf-ship':'Shipping Policy','cf-privacy':'Privacy Policy','cf-terms':'Terms of Service',
    // 🔴 홈의 영문판(대표님이 Translate & Adapt 에 입력)에서 그대로 옮겼다 — 두 곳 문안을 같게 유지한다.
    //    ⚠️ 세 개는 홈에 없어서 내가 채웠다(대표님 확인 필요): 'ht-sub' · 'ht-s2-t' · 'ht-cta'.
    //       특히 홈의 02 제목이 01 과 똑같은 'Choose Your Size & Cover' 로 들어가 있다(복붙 실수) —
    //       02 는 스프링·밴드 단계라 여기서는 'Choose Your Spring & Band' 로 넣었다. 홈도 고쳐야 한다.
    'ht-title':'Create Your Own Notebook, Step by Step',
    'ht-sub':'Covers, inner pages, binding, closure — every step is yours.',
    'ht-s1-t':'Choose Your Size & Cover',
    'ht-s1-b':'Choose from three standard sizes — A, B,<br>or C — or select your preferred custom<br>size, then choose your front and back covers.',
    'ht-s2-t':'Choose Your Spring & Band',
    'ht-s2-b':'Choose between full spring binding and<br>split spring binding.<br>With split spring binding, you can select<br>different colors for the top and bottom springs.<br><br>Then choose the type and color of the band<br>that wraps around your notebook, along<br>with an eyelet color to complement it.',
    'ht-s3-t':'Layer Your Inner Pages',
    'ht-s3-b':'Choose the inner pages that best suit how<br>you plan to use your notebook and the<br>writing tools you reach for most often.<br>You can freely combine 2 to 5 sets of inner<br>pages to create your own layout.',
    'ht-cta':'Build Your Notebook →',
    'cover-cats-ids':['solid','texture','pattern','limited'],
    'inn-cats-ko':['라인','격자','플래너','무지','특수'],
    'inn-cats':['Lined','Grid','Planner','Blank','Special'],
    'hint-more':function(n){return 'Select '+n+' more set(s).'},
    'hint-add':function(n){return 'Up to '+n+' more set(s).'},
    'hint-done':'Selection complete.',
    'toast-max':'Max 5 sets allowed.',
    'custom-info':'Enter size between 50×50mm and A4 (210×297mm).',
    'custom-warn':function(w,h,rotated){var base=w+'×'+h+'mm · Custom +10,000 KRW'; return rotated?base+'\n※ This size fits in landscape orientation. Direction is set to landscape automatically.':base;},
    'custom-err-small':'Size below 50×50mm — please email paper.me.seoul@gmail.com.',
    'custom-err-big':'Size exceeds A4 (210×297mm) — please email paper.me.seoul@gmail.com.',
    'custom-err':'Size out of range — please email paper.me.seoul@gmail.com.',
    'per-set':' KRW/set','won':' KRW','reset-confirm':'Reset all selections?'
  },
  // ── 日本語 (2026-08-14) ──────────────────────────────────────────────────
  // 🔴 **톤: 본문·안내문은 정중체(です・ます), 버튼·탭 등 좁은 라벨은 명사형**(2026-08-13 대표님 결정).
  //    같은 성격끼리는 반드시 통일할 것 — 버튼 하나만 정중체면 그것만 튄다.
  // 🔴 **여기 없는 키는 영어로 나온다**(t 의 폴백). 그래서 하나씩 채워 넣어도 안전하다.
  // ⚠️ 용어는 아래로 고정한다(섞이면 같은 부품이 화면마다 다른 이름이 된다):
  //    스프링=スプリング · 풀=フルスプリング · 양끝=セパレートスプリング · 아일렛=アイレット ·
  //    내지=中紙 · 앞표지=表紙 · 뒷표지=裏表紙 · 잠금(밴드)=バンド/留め方 ·
  //    세트=セット · 장(매)=枚 · 통화=KRW(円이 아니다 — 한국 원화다).
  // 🔴 **이 용어는 대표님이 홈(Translate & Adapt)에 쓰신 것을 그대로 따른 것이다**(2026-08-14).
  //    처음엔 내가 "더 자연스러운 일본어"라며 リング·ハトメ 로 넣었는데, 브랜드는 이미 영어 단어를 쓰고 있고
  //    일러스트에도 `Choose the spring type & color` 가 영어로 박혀 있다. **홈과 다른 이름으로 부르면 안 된다.**
  //    ⚠️ 새 문구를 넣을 때 홈에 같은 말이 있는지 먼저 볼 것 — 사전보다 홈이 기준이다.
  ja:{
    'hdr-h1':'自分だけのノートをつくってみませんか。',
    'size-note':'表示のサイズは中紙を基準としています。仕上がりは選んだサイズより少し大きくなります。',
    'st-size':'サイズを選ぶ','st-dir':'向きを選ぶ','st-spring':'スプリングを選ぶ',
    'size-tip-btn-txt':'SIZE TIP','sizetip-ttl':'サイズガイド','sizetip-loading':'読み込み中…',
    'sizetip-scrollhint':'← 左右にスワイプしてご覧いただけます →',
    'sizetip-note':'記載の寸法は中紙を基準としています。仕上がりは少し大きくなります。',
    'st-band':'留め方を選ぶ','st-fc':'表紙を選ぶ','st-bc':'裏表紙を選ぶ',
    'st-inn':'中紙を選ぶ','inn-limit-lbl':'最少2セット · 最大5セット','sp-price-tag':'+1,500 KRW',
    'lbl-w':'幅','lbl-h':'高さ',
    'dir-portrait':'縦型','dir-landscape':'横型',
    // 🔴 `\n` 은 버튼 라벨에서 줄바꿈이 된다(`.sp-lbl{white-space:pre-line}`, 대표님 지적 2026-08-17).
    //    일본어는 띄어쓰기가 없어 그냥 두면 `フルスプリ / ング` 처럼 낱말 가운데서 끊긴다.
    //    セパレート 쪽은 이미 `セパレート / スプリング` 로 자연스럽게 끊겨 손대지 않았다.
    'sp-lbl-full':'フル\nスプリング','sp-lbl-split':'セパレートスプリング',
    'sc-lbl':'スプリングカラー','sc-top-lbl':'上のスプリング','sc-bot-lbl':'下のスプリング',
    'bc-lbl':'バンドカラー','bc1-lbl':'バンド1カラー','bc2-lbl':'バンド2カラー',
    'bk-lbl':'バックルカラー','ey-lbl':'アイレットカラー',
    'ey-note':'※ 裏面のプレビューでご確認ください',
    'ey1-lbl':'左バンドのアイレット','ey2-lbl':'右バンドのアイレット',
    'prev-lbl':'PREVIEW','ptab-front':'表','ptab-back':'裏',
    'zoombtn':'⤢ 拡大','zoombtn-m':'⤢ 拡大','ztab-front':'表','ztab-back':'裏',
    'zoom-hint':'ピンチで拡大 · ドラッグで移動 · ダブルタップで拡大／縮小',
    'zoom-hint-mouse':'クリックで拡大 · もう一度クリックで元に戻る · ドラッグで移動 · ホイールで倍率調整',
    'mobile-prev-reopen':'プレビューを開く ▾',
    'navwait':'ログイン画面へ移動中…',
    'm-ptab-front':'表','m-ptab-back':'裏','mobile-add-btn':'カートに追加','m-reset-btn':'↺ リセット','mobile-bottom-add':'追加',
    'sk-size':'サイズ','sk-dir':'向き','sk-sp':'スプリング','sk-band':'留め方',
    'sk-fc':'表紙','sk-bc':'裏表紙','sk-inn':'中紙',
    'price-lbl':'合計','qty-lbl':'数量','reset-btn':'選択をリセット',
    'btn-add':'カートに追加','btn-wish':'ウィッシュリストに保存','btn-checkout':'ご注文へ進む',
    'note-local':'カートの内容は、この端末にのみ保存されます。選択した内容をあとでもう一度確認したり、ほかの端末で確認したりする場合は、ログインしてウィッシュリストに保存してください。',
    'agree-lbl':'上記の内容を確認し、受注制作商品はお客様都合によるキャンセル・返金が制限されることに同意します。',
    'use-q':'このノートは、誰のためにつくりますか？',
    'use-self':'自分用です',
    // 🔴 대표님 초안은 `…お送りください`(= 가게에 부탁하는 말투)였다. 이건 **고객이 고르는 선택지 라벨**이라
    //    가게가 하는 말이어야 한다 → `お送りします`. 영문판(We will send it…)과도 이렇게 맞는다.
    'use-gift':'ギフト用です — 同封する注文書には金額を記載せずにお送りします。',
    'use-mixed':'自分用とギフト用の両方です',
    'use-mixed-hint':'ギフト用の商品を選択してください。',
    'use-warn':'ご用途をお選びください。',
    'agree-warn':'受注制作への同意にチェックしてください。',
    'nav-wish':'ウィッシュリスト','nav-cart':'カート',
    'dr-wish-ttl':'ウィッシュリスト','dr-cart-ttl':'カート',
    'wish-empty':'保存された組み合わせはありません。','cart-empty':'カートは空です。',
    'cart-ordered':'ご注文を承りましたので、カートを空にしました。ありがとうございます！',
    'pop-t':'カートに追加しました','pop-cn':'つくり続ける','pop-ok':'カートを見る',
    'inn-cart-ttl':'選んだ中紙の順番',
    'inn-cart-note':'（ドラッグ＆ドロップで順番を変えられます。）',
    'band-none':'なし','band-basic':'ベーシック','band-corner':'コーナー','band-double':'ダブル',
    'free':'無料','lang-btn':'JA',
    'vtab-diy':'DIY NOTEBOOK','vtab-diy-short':'DIY','vtab-premade':'SIGNATURE','vtab-acc':'ACC',
    'shop-sub-premade':'ペーパーミーが選んだ組み合わせをご覧ください。','shop-sub-acc':'アクセサリー・梱包用品をご覧ください。',
    'only1-note':'ユニークなデザインや素材を使った only 1 のノートです。\n販売後の再入荷はございません。',
    'sig-note':'SIGNATUREは、PAPER MEがあらかじめセレクトした組み合わせを、ご注文後に一冊ずつお作りします。\nお急ぎの場合は paper.me.seoul@gmail.com までご連絡ください — 可能な範囲で早めにお届けできるよう対応いたします :)',
    'sig-note-short':'ご注文後に制作を始めます。お急ぎの場合はメールでお問い合わせください。 : )',
    'shop-soldout':'完売','shop-coming':'準備中です。もうすぐご覧いただけます。','shop-back':'← 一覧へ戻る','shop-add':'カートに追加','shop-opt':'オプションを選ぶ','shop-qty':'数量','shop-added':'カートに追加しました','shop-checkout-soon':'既製品のご注文・お支払いは準備中です。もうすぐ対応いたします。',
    'imgzoom-hint':'🔍 画像の上でマウスを動かすと拡大されます · スマートフォンでは指で押したまま移動してください',
    'cf-info':'お客様へのご案内','cf-refund':'返品・返金ポリシー','cf-ship':'配送ポリシー','cf-privacy':'プライバシーポリシー','cf-terms':'利用規約',
    // HOW TO 탭. 🔴 **홈의 같은 섹션(대표님이 Translate & Adapt 에 입력)에서 한 글자도 바꾸지 않고 옮겼다**(2026-08-14).
    //    같은 문안이 두 벌로 존재하는 자리라(DECISIONS #13) 한쪽만 고치면 홈과 노트 만들기가 서로 다른 말을 한다.
    //    ⚠️ `<br>` 위치만 이 탭의 좁은 칸에 맞춰 다시 잡았다 — 글자는 건드리지 않았다.
    'ht-title':'ステップごとに仕上げる、自分だけのノート',
    'ht-sub':'表紙も中紙も、綴じ方も留め方も、すべて思いのままに。',
    'ht-s1-t':'サイズと表紙を選ぶ',
    'ht-s1-b':'A・B・Cの3つのサイズ、またはお好みのカスタムサイズを選び、<br>表紙と裏表紙を選んでください。',
    'ht-s2-t':'スプリングとバンドを選ぶ',
    'ht-s2-b':'スプリングは、フルスプリングとセパレートスプリングからお選びください。<br>セパレートスプリングは、上下それぞれ異なるカラーをお選びいただけます。<br><br>ノートを留めるバンドのタイプとカラー、<br>さらにバンドに合わせるアイレットのカラーもお選びください。',
    'ht-s3-t':'自分だけの中紙をレイヤリング',
    'ht-s3-b':'記録する目的や、普段よく使う筆記具に合った中紙をお選びください。<br>中紙は2セットから5セットまで、自由に組み合わせていただけます。',
    'ht-cta':'ノートをつくる →',
    'cover-cats-ids':['solid','texture','pattern','limited'],
    // 🔴 `inn-cats-ko` 는 **번역하지 않는다.** 이건 화면 문구가 아니라 메타객체의 한글 카테고리 값과 맞춰보는 열쇠다.
    'inn-cats-ko':['라인','격자','플래너','무지','특수'],
    'inn-cats':['罫線','方眼','プランナー','無地','特殊'],
    'hint-more':function(n){return 'あと'+n+'セット選んでください。'},
    'hint-add':function(n){return 'あと'+n+'セットまで追加できます。'},
    'hint-done':'中紙の選択が完了しました。',
    'toast-max':'中紙は最大5セットまでお選びいただけます。',
    'custom-info':'50×50mm 〜 A4（210×297mm）の範囲でご入力ください。',
    'custom-warn':function(w,h,rotated){var base=w+'×'+h+'mm · カスタム +10,000 KRW'; return rotated?base+'\n※ このサイズは横型になります。向きは自動的に横型に設定されます。':base;},
    'custom-err-small':'50×50mm を下回るサイズです — paper.me.seoul@gmail.com までご連絡ください。',
    'custom-err-big':'A4（210×297mm）を超えるサイズです — paper.me.seoul@gmail.com までご連絡ください。',
    'custom-err':'サイズが範囲外です — paper.me.seoul@gmail.com までご連絡ください。',
    'per-set':' KRW/セット','won':' KRW','reset-confirm':'すべての選択をリセットしますか？'
  }
};
// 🔴 **폴백 사슬: 일본어 → 영어 → 한국어 → 키 이름**(2026-08-14 3언어 개편).
//    일본어 문안을 190개 한꺼번에 넣지 않고 하나씩 채워도 화면이 안 깨지게 하려는 것이다.
//    빠진 키는 영어로 나온다 — 일본 고객에게 한국어보다 영어가 낫고, 무엇보다 **키 이름이 화면에 노출되지 않는다.**
function t(k){
  var d=TXT[LANG];
  if(d&&d[k]!==undefined)return d[k];
  if(LANG==='ja'&&TXT.en[k]!==undefined)return TXT.en[k];
  return TXT.ko[k]!==undefined?TXT.ko[k]:k;
}
// 스프링 종류 이름을 **한 줄로** 돌려준다 (2026-08-17).
// 🔴 버튼 라벨(`sp-lbl-full`)에는 줄바꿈 `\n` 이 들어 있다 — 일본어가 낱말 가운데서 끊기는 걸 막으려고 넣었다.
//    그 값을 요약 줄(`풀 스프링 · Gold`)이나 장바구니 이름에 그대로 쓰면 거기서도 줄이 갈라진다.
// 🔴 부르는 곳이 둘이라 **헬퍼로 모았다** — 한쪽만 고치면 반드시 뒤처진다(DECISIONS #13).
// 🔴 `\n` 은 **지운다. 공백으로 바꾸지 않는다.** 일본어는 낱말 사이에 공백을 쓰지 않으므로
//    `フル\nスプリング` 을 공백으로 펴면 `フル スプリング` 이라는 어색한 표기가 된다(실측으로 잡음).
//    → 규칙: `\n` 은 **글자 사이에** 넣는다(공백을 대신하는 자리가 아니다).
function spTypeName(){return t(S.sp==='full'?'sp-lbl-full':'sp-lbl-split').replace(/\n/g,'');}
// 인라인 문구용 헬퍼. TXT 키로 옮기지 않고 **그 자리에서** 세 언어를 적는다.
// 🔴 키 관리를 하지 않는 것이 요점이다 — 키를 만들면 오타로 키 이름이 화면에 찍히는 사고가 생기고,
//    한 번만 쓰이는 짧은 문구 100여 개를 위해 그 위험을 감수할 이유가 없다.
//    ja 를 생략하거나 비워두면 영어로, 영어도 없으면 한국어로 떨어진다(t 와 같은 사슬).
// 🔴 **빈 문자열('')은 '번역이 없음'이 아니라 '일부러 비운 것'으로 본다.**
//    `LANG==='ko'?'개':''` 처럼 한국어에만 조사·단위가 붙고 영어에선 비우는 자리가 실제로 있다.
//    `en||ko` 로 떨어뜨리면 그런 자리에 한국어가 되살아난다 — undefined·null 만 '없음'으로 친다.
function _lHas(v){return v!==undefined&&v!==null;}
function L(ko,en,ja){
  if(LANG==='ja')return _lHas(ja)?ja:(_lHas(en)?en:ko);
  if(LANG==='en')return _lHas(en)?en:ko;
  return ko;
}
// 카탈로그 데이터(표지·내지)의 한/영 값을 고른다.
// 🔴 **영문 값이 없으면 한글로 되돌린다.** 표지·내지 설명은 메타객체에서 오는데 거기엔 한글 필드뿐이라,
//    영문 필드를 그대로 읽으면 EN 에서 `undefined` 가 화면에 찍힌다(2026-08-13 대표님 발견).
//    번역이 없을 때 원문을 보여주는 것이 빈 칸이나 undefined 보다 낫다.
//    ⚠️ 진짜 번역은 메타객체에 영문 필드를 만들어 build 가 같이 주입해야 한다 — 이건 데이터 작업이다.
//    2026-08-14: 일본어 인수를 더했다. 메타객체의 `explain_ja` 를 읽어 넘기며, 비어 있으면 영어 → 한국어 순으로 떨어진다.
// 🔴 **L() 을 쓰지 않는다.** 여기서는 빈 문자열이 '일부러 비운 것'이 아니라 **'대표님이 아직 입력 안 한 칸'** 이다.
//    메타객체의 빈 필드는 Liquid 이 `''` 로 주입하므로, `''` 도 없는 것으로 보고 원문까지 떨어져야 한다.
//    (L 은 반대 규칙이다 — 그쪽은 `''` 를 의도된 빈칸으로 본다. 두 규칙을 한 함수에 담을 수 없어 나눠 뒀다.)
function pickLang(ko,en,ja){
  if(LANG==='ja')return (ja||en||ko||'');
  if(LANG==='en')return (en||ko||'');
  return (ko||'');
}
// ── 참고용 외화 환산 (2026-09-15) ─────────────────────────────────────────
// 원화 옆에 영어면 `(approx. $19)`, 일본어면 `(約 ¥2,983)` 을 붙인다. 한국어는 아무것도 안 붙는다.
// 모듈은 theme/assets/paperme-fx.js 하나(빌드가 엔진 앞에 주입). 환율·표기 규칙·"왜 원화를 바꾸지 않나"는 그 머리말에.
// 🔴 붙이는 자리는 **낱개 가격과 합계**뿐이다 — `+1,500` 같은 가산 내역에는 붙이지 않는다(합계에 이미 있다).
//    10열 표지 격자의 9px 가격줄에도 안 붙인다 — 칸이 좁아 줄이 깨진다. 표지를 누르면 상세 가격에 붙는다.
// 단독 열람(dev)에는 모듈이 없어 원화만 보인다 — 그게 정상이다.
function fxHtml(krw){return window.PAPERME_FX?window.PAPERME_FX.html(krw,LANG):'';}
function fxAppend(el,krw){var s=window.PAPERME_FX?window.PAPERME_FX.el(krw,LANG):null;if(el&&s)el.appendChild(s);}
function fxNote(){return window.PAPERME_FX?window.PAPERME_FX.note(LANG):'';}
// textContent 로 원화를 쓰고 환산 span 을 뒤에 단다(setText 는 자식을 지우므로 순서가 중요하다).
function setPrice(id,str,krw){var el=document.getElementById(id);if(!el)return;el.textContent=str;fxAppend(el,krw);}
// Shopify `product.price` 는 최소단위(원×100)다 — 라이브 실측 `priceCents: 2600000` = ₩26,000. 원으로 바꿀 때는 이것만 쓴다.
function pcKrw(c){return Math.round((+c||0)/100);}
// ── 배송비·제작 기간 안내 (2026-09-22, 대표님 제안) ─────────────────────────
// 전에는 제작 기간이 장바구니 동의 문구 안에만, 배송비는 결제창(주소 입력 뒤)에만 있었다.
// 한 권 2만원짜리에 결제창에서 4,000원이 붙으면 지출이 20% 뛰고, 일정이 있는 고객은 조합을 다 만든 뒤에야 기간을 알았다.
// → 제작 화면 제목 아래(기간) · 합계 아래(배송비 규칙) · 장바구니 요약(합계·배송비·기간) 세 자리에 «안내»로 둔다.
// 🔴 배송비를 합계에 **더해서 보여주지 않는다** — 주소(일반/제주/도서산간/해외)를 알아야 정해진다. 규칙만 보이고 계산은 결제창에 맡긴다.
// 🔴 숫자는 여기 한 곳. **바꿀 땐 같이:** Shopify 관리자 배송 요금 · 정책(shipping-policy) · 고객안내(page.info.json) · 여기.
var PM_SHIP={fee:4000,free:40000,jejuFee:4500,jejuFree:45000};
// 제작 기간 — 대표님(2026-09-22): "보통은 5–7일 안에 나가는데 종이가 없거나 하는 상황 대비로 안전 시간을 걸어둔다" → «넉넉히 10일».
// 정책 페이지의 「영업일 7–10일 준비기간」과 상한(10일)이 같아 어긋나지 않는다. 2주 라는 말은 쓰지 않는다 — 같은 기간이 길게 읽힌다.
// 🔴 세 줄이다(2026-09-23 대표님). 줄바꿈은 `\n` + `white-space:pre-line` — <br> 은 textContent 로 들어가 글자로 보인다(지뢰 10).
// 🔴 **해외는 숫자가 다르다.** 제작 자체는 어디서 주문하든 같지만(5–7일), 해외는 **매주 금요일 일괄 발송**이라
//    발송 준비까지 7–10일(최대 14일)로 잡는다. 그래서 영·일은 「제작이 끝난다」가 아니라 **「발송 준비가 된다」**로 쓴다 —
//    제작이 더 오래 걸린다고 말하면 사실과 다르다.
function leadNote(){
  return L('모든 노트는 주문 후 한 권씩 제작됩니다.\n작업은 보통 영업일 기준 5–7일 이내에 완료되지만, 경우에 따라 최대 10영업일까지 소요될 수 있습니다.\n일정이 급하신 경우 메일로 문의해 주세요. 가능한 범위에서 빠르게 준비해 드릴게요. :)',
           'All notebooks are made one by one after your order is placed.\nOrders are usually ready to ship within 7–10 business days, but in some cases it may take up to 14 business days.\nIf you need your order sooner, please email us. We’ll do our best to prepare it as quickly as possible. :)',
           'すべてのノートは、ご注文をいただいてから一冊ずつ制作します。\n通常は7〜10営業日以内に発送のご準備が整いますが、場合によっては最大14営業日ほどお時間をいただくことがあります。\nお急ぎの場合はメールでお問い合わせください。可能な範囲で早めにご用意いたします。 :)');
}
// 문의 메일 — 「메일로 문의해 주세요」 다음 줄에 누를 수 있는 주소를 둔다(2026-09-23 대표님).
// 🔴 주소는 여기 한 곳이 아니다 — 푸터·커스텀 사이즈 오류·SIGNATURE 안내에도 있다. 바꿀 땐 같이 찾을 것.
var PM_MAIL='paper.me.seoul@gmail.com';
// 링크가 들어가므로 이 문구만 innerHTML 로 넣는다. **본문은 반드시 escape** 하고 링크만 태그로 붙인다.
// 🔴 줄을 새로 만들지 않고 **셋째 줄 끝에 두 칸 띄워** 붙인다(대표님) — 한 줄 늘리면 그만큼 옵션 자리가 줄어든다.
//    `white-space:pre-line` 은 연속 공백을 하나로 줄이므로 눈에 보이는 간격은 마진(.lead-mail)으로 준다.
// 🔴 **아이콘만** 둔다(2026-09-23 대표님) — 주소 글자도 밑줄도 뺐다. 문장 끝에 작은 단추처럼 붙는 편이 조용하다.
//    글자가 없으므로 **무엇인지 말해줄 것이 필요하다** — title 은 마우스용, aria-label 은 화면낭독기용. 둘 다 주소를 읽어준다.
function leadNoteHtml(){
  var lbl=L('메일로 문의하기 — '+PM_MAIL, 'Email us — '+PM_MAIL, 'メールでお問い合わせ — '+PM_MAIL);
  return shopEsc(leadNote())
    +'<a class="lead-mail" href="mailto:'+PM_MAIL+'" title="'+shopEsc(lbl)+'" aria-label="'+shopEsc(lbl)+'">'
    +'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">'
    +'<rect x="2.5" y="5" width="19" height="14" rx="2.5"/><path d="M3 7l9 6 9-6"/></svg></a>';
}
// 배송비 규칙 한 줄. 국내 요율은 한국어에만 — 영어·일본어 손님은 대부분 해외라 국내 요율이 오히려 헷갈린다(해외는 결제창에서 국가·무게로 산정).
function shipNoteParts(){
  var w=function(n){return n.toLocaleString()+'원';};
  if(LANG==='ko')return ['배송비 '+w(PM_SHIP.fee)+' · '+w(PM_SHIP.free)+' 이상 무료',
                         '제주 '+w(PM_SHIP.jejuFee)+' · '+w(PM_SHIP.jejuFree)+' 이상 무료 · 도서산간·해외는 결제 시 안내'];
  return [L('','Shipping is calculated at checkout by destination and weight.','送料はお届け先と重さによりお支払い画面で計算されます。'),
          L('','Overseas orders ship every Friday.','海外発送は毎週金曜日にまとめて発送します。')];
}
function shipNote(){return shipNoteParts().join(' · ');}                 // 한 줄(장바구니·모바일 요약)
function shipNoteHtml(){return shipNoteParts().map(function(s){return s.replace(/&/g,'&amp;').replace(/</g,'&lt;');}).join('<br>');}   // 두 줄(합계 아래 — 9px 한 줄로는 안 읽힌다)
// 무료배송까지 남은 금액(한국어·국내 기준). 0 이하면 빈 문자열. 한 권 2만원 구조라 두 권째에 무료가 된다 — 안내이면서 자연스러운 두 권 유도.
function freeShipNudge(subtotal){
  if(LANG!=='ko')return '';
  var left=PM_SHIP.free-subtotal;
  if(left<=0)return '무료배송 기준을 넘었어요 (일반 지역).';
  return left.toLocaleString()+'원 더 담으면 무료배송이에요 (일반 지역).';
}
// 장바구니 상품 합계(원). 노트=담은 시점 가격×수량, 상품=variant 가격×수량. 배송비는 넣지 않는다(위 이유).
function cartSubtotal(){
  return CART.reduce(function(a,it){
    if(!it)return a;
    if(it.kind==='product')return a+pcKrw(it.priceCents)*(it.qty||1);
    return a+((it.price&&it.price.total)||0)*((it.snap&&it.snap.qty)||1);
  },0);
}
// ── 스토어 로케일(Shopify 언어) 연동 ───────────────────────────────────────
// 언어를 둘 이상 게시하면 Shopify 가 `/en/...` 같은 주소로 번역본을 서빙한다.
// 그 주소로 이동해야 **Liquid 이 번역된 값으로 다시 렌더**되어 카탈로그·상품 설명까지 영문이 된다.
// (자체 JS 토글만으로는 우리 UI 문구만 바뀌고 데이터는 한글 그대로다.)
function pmLocaleRoot(iso){
  var list=window.PAPERME_LOCALES||[];
  for(var i=0;i<list.length;i++){
    var c=(list[i].iso||'').toLowerCase();
    if(c===iso||c.indexOf(iso+'-')===0)return list[i].root||'/';
  }
  return null;   // 그 언어가 게시돼 있지 않음
}
// 지금 주소를 target 언어의 주소로 바꾼다. 로케일 접두어만 갈아끼우므로 쿼리·해시가 보존된다
// (`?tab=signature&p=...` 같은 상태를 잃지 않는다).
// 🔴 지금 주소에 이미 붙어 있는 로케일 접두어를 **주소에서 직접** 찾아낸다(2026-08-13).
//    처음엔 주입값(PAPERME_LOCALE)으로 판단했는데, 그 값이 비면 접두어가 없다고 오판해
//    `/en/pages/...` 에 `/en` 을 또 붙여 **`/en/en/...` 404** 가 났다.
//    주소는 언제나 사실이므로 주소를 기준으로 삼는다 — 주입값이 틀려도 안전하다.
function pmStripLocalePrefix(path){
  var list=window.PAPERME_LOCALES||[];
  for(var i=0;i<list.length;i++){
    var r=list[i].root||'/';
    if(r!=='/'&&(path===r||path.indexOf(r+'/')===0))return path.slice(r.length)||'/';
  }
  return path;
}
// 지금 주소에 붙어 있는 로케일 접두어(없으면 '/').
function pmCurrentLocaleRoot(){
  var list=window.PAPERME_LOCALES||[], p=location.pathname;
  for(var i=0;i<list.length;i++){
    var r=list[i].root||'/';
    if(r!=='/'&&(p===r||p.indexOf(r+'/')===0))return r;
  }
  return '/';
}
// 🔴 페이지 안의 내부 링크에 로케일 접두어를 붙인다(2026-08-13 대표님 지적).
//    이 페이지의 링크(About·Notice·로고·정책 등)는 `/pages/...` 처럼 **절대경로로 박혀 있어**,
//    영어로 보다가 그 링크를 누르면 접두어가 빠진 한국어 주소로 나가 **언어가 풀렸다.**
//    링크마다 고치면 새 링크를 추가할 때 또 빠뜨린다 — **한 곳에서 일괄로** 붙인다.
//    ⚠️ 이미 접두어가 있는 링크·외부 링크·앵커·mailto/tel 은 건드리지 않는다.
function pmLocalizeLinks(){
  var root=pmCurrentLocaleRoot(); if(root==='/')return;
  var as=document.querySelectorAll('a[href^="/"]');
  for(var i=0;i<as.length;i++){
    var h=as[i].getAttribute('href');
    if(!h||h.indexOf('//')===0)continue;                 // 프로토콜 상대 URL(외부)
    if(h===root||h.indexOf(root+'/')===0)continue;       // 이미 붙어 있음
    as[i].setAttribute('href', h==='/'?root:(root+h));
  }
}
function localeUrlFor(iso){
  var root=pmLocaleRoot(iso); if(root===null)return null;
  var p=pmStripLocalePrefix(location.pathname);
  if(root!=='/')p=root+(p==='/'?'':p);
  return p+location.search+location.hash;
}
// ── 언어 선택 목록 ─────────────────────────────────────────────────────────
// 🔴 2026-08-14: 언어가 셋이 되어 **토글로는 표현할 수 없다**(누를 때마다 원하지 않는 언어를 거쳐 간다).
//    버튼은 이제 '바꿀 언어'가 아니라 **'지금 언어'**를 보여주고, 누르면 목록이 열린다.
var LANG_MENU=[{iso:'ko',code:'KO',name:'한국어'},{iso:'en',code:'EN',name:'English'},{iso:'ja',code:'JA',name:'日本語'}];
// 🔴 **스토어에 게시된 언어만 목록에 넣는다.** 게시 전에 일본어를 띄우면 UI 만 일본어가 되고
//    About·정책·카탈로그는 한국어로 남아 반쪽짜리 화면이 고객에게 보인다.
//    → 대표님이 Shopify 에서 게시하시는 순간 저절로 나타난다. 코드를 다시 고칠 필요가 없다.
//    ⚠️ 예외: 게시 목록 자체가 없으면(로컬 단독 열람) 셋 다 넣어 JS 로만 전환한다 — 개발용.
function langChoices(){
  var list=window.PAPERME_LOCALES||[];
  if(!list.length)return LANG_MENU.slice();
  return LANG_MENU.filter(function(m){return pmLocaleRoot(m.iso)!==null;});
}
function buildLangMenu(){
  var menu=document.getElementById('lang-menu'); if(!menu)return;
  var choices=langChoices();
  menu.innerHTML='';
  choices.forEach(function(m){
    var b=document.createElement('button');
    b.type='button'; b.textContent=m.name; b.className=(m.iso===LANG?'on':'');
    b.onclick=function(e){e.stopPropagation();closeLangMenu();setLang(m.iso);};
    menu.appendChild(b);
  });
  // 고를 게 하나뿐이면 버튼을 눌러도 의미가 없다 — 목록만 감춘다(버튼은 현재 언어 표시로 남는다).
  var btn=document.getElementById('lang-btn');
  if(btn)btn.disabled=(choices.length<2);
}
// 🔴 여기 있던 `placeLangBtn()` 은 2026-08-15 에 **지웠다.** 되살리지 말 것.
//   무엇이었나: 989px 이하에서 `.lang-wrap` 노드를 오른쪽 `.nav-btns` → 왼쪽 `.nav-left` 로 옮기고
//   resize 마다 다시 판정하던 함수. 오른쪽에 언어·계정·위시·장바구니 넷을 넣으니 375px 에서
//   묶음 128.1px vs 한 칸 여유 115.6px 라 로고가 밀려서, 언어를 왼쪽으로 피신시킨 것이었다.
//   왜 지웠나: 대표님이 **계정을 햄버거 서랍으로 내리기로** 하셔서 오른쪽이 세 칸(언어·위시·장바구니
//   = 103px)이 됐다. 여유 안에 들어오므로 옮길 이유가 없다 — 마크업 그대로 오른쪽에 두면 된다.
//   덕분에 테마 쪽의 짝(언어 폼 두 벌 + CSS 로 하나씩 감추기)도 같이 사라졌다.
//   ⚠️ 오른쪽에 아이콘을 다시 늘리면 같은 문제가 돌아온다. 그때 이 함수를 되살리기 전에
//      **먼저 무엇을 서랍으로 내릴 수 있는지** 볼 것 — 옮기기보다 줄이는 쪽이 항상 낫다(DECISIONS #26).
function toggleLangMenu(e){
  if(e&&e.stopPropagation)e.stopPropagation();
  var menu=document.getElementById('lang-menu'),btn=document.getElementById('lang-btn');
  if(!menu)return;
  if(menu.hidden){buildLangMenu();menu.hidden=false;if(btn)btn.setAttribute('aria-expanded','true');}
  else closeLangMenu();
}
function closeLangMenu(){
  var menu=document.getElementById('lang-menu'),btn=document.getElementById('lang-btn');
  if(menu)menu.hidden=true;
  if(btn)btn.setAttribute('aria-expanded','false');
}
// 바깥을 누르거나 ESC 로 닫는다(드롭다운이 열린 채 남아 있으면 다른 조작을 가린다).
document.addEventListener('click',function(){closeLangMenu();});
document.addEventListener('keydown',function(e){if(e.key==='Escape')closeLangMenu();});
function setLang(next){
  if(next===LANG)return;
  // 그 언어가 스토어에 게시돼 있으면 **주소를 바꾼다** — 번역된 데이터를 받기 위해서다.
  var url=localeUrlFor(next);
  if(url&&url!==location.pathname+location.search+location.hash){
    stashDraft();   // 🔴 이동하면 메모리가 날아간다 — 만들던 조합을 먼저 챙긴다(다음 로드의 init 이 되살린다)
    location.href=url; return;
  }
  // 게시된 언어가 하나뿐이면(또는 로컬 단독 열람) 예전처럼 화면 문구만 바꾼다.
  LANG=next;
  applyLang();renderAll();refreshOpenDetails();
  if(document.body.classList.contains('tab-shop'))renderShop();
  if(_sdProd)renderShopDetail();
}
function toggleNav(open){
  var on=(open===undefined)?!document.body.classList.contains('nav-open'):open;
  document.body.classList.toggle('nav-open',on);
  var b=document.querySelector('.nav-burger');
  if(b)b.setAttribute('aria-expanded',on?'true':'false');
}
// 헤더 메뉴의 DIY NOTEBOOK · PREMADE 는 별도 페이지가 아니라 **이 페이지의 탭**이다(2026-07-31).
// 이 페이지 안에서 눌렀을 때 href 로 실제 이동하면 화면이 통째로 다시 로드돼 깜빡이므로 탭만 바꾼다.
// 🔴 href 는 진짜 주소로 남겨둔다 — 테마 페이지(홈·About)의 헤더에서 오는 링크, 새 탭으로 열기,
//    JS 가 막힌 환경이 전부 그 href 로 동작해야 한다. `?tab=premade` 는 init() 이 읽는다.
function navTab(e,tp){
  if(e&&(e.metaKey||e.ctrlKey||e.shiftKey||e.button===1))return true;  // 새 탭/새 창으로 열기는 건드리지 않는다
  if(e&&e.preventDefault)e.preventDefault();
  toggleNav(false);                                                    // 모바일 서랍에서 눌렀으면 닫는다
  switchTab(tp);
  return false;
}
// 헤더 메뉴의 현재 위치 표시(.on)를 활성 탭에 맞춘다.
// HOW TO·ACC 는 헤더 메뉴에 없는 탭이라(탭 줄에만 있음) DIY NOTEBOOK 쪽에 표시를 남긴다.
function syncNavMenu(tp){
  var isPre=(tp==='premade');
  document.querySelectorAll('.nav-lnk-diy').forEach(function(a){a.classList.toggle('on',!isPre);});
  document.querySelectorAll('.nav-lnk-premade').forEach(function(a){a.classList.toggle('on',isPre);});
}
function refreshOpenDetails(){
  ['fc','bc'].forEach(function(side){
    var el=document.getElementById(side+'-detail');
    if(el&&el.classList.contains('on')){
      var id=side==='fc'?S.fc:S.bcover, cv=COVS.find(function(x){return x.id===id;});
      if(cv)showCovDetail(side,cv);
    }
  });
  var ie=document.getElementById('in-detail');
  if(ie&&ie.classList.contains('on')&&_lastInn)showInnDetail(_lastInn);
}
// 언어를 CSS 와 브라우저에 알린다 (2026-08-16). 문구 교체(applyLang)와 **따로 둔 이유**:
// init 이 `if(LANG!=='ko')applyLang()` 로 한국어 첫 로드에서는 applyLang 을 건너뛴다.
// 안에 넣으면 한국어일 때만 클래스가 안 붙어, 나중에 `.lang-ko` 규칙을 쓰는 순간 조용히 어긋난다.
// 🔴 `<html lang>` 도 같이 고친다 — 마크업에 `lang="ko"` 가 박혀 있어 일본어 화면인데 문서는
//    한국어라고 말하고 있었다. 줄바꿈 규칙·읽어주기·검색엔진이 보는 값이다.
function applyLangAttrs(){
  document.documentElement.lang=LANG;
  ['ko','en','ja'].forEach(function(l){document.body.classList.toggle('lang-'+l,LANG===l);});
}
function applyLang(){
  applyLangAttrs();
  ['hdr-h1','size-note','st-size','st-dir','st-spring','st-band','st-fc','st-bc','st-inn',
   'inn-limit-lbl','sp-price-tag','lbl-w','lbl-h','dir-portrait','dir-landscape',
   'sp-lbl-full','sp-lbl-split','sc-lbl','sc-top-lbl','sc-bot-lbl',
   'bc-lbl','bc1-lbl','bc2-lbl','bk-lbl','ey-lbl','ey-note','ey1-lbl','ey2-lbl',
   'prev-lbl','ptab-front','ptab-back','zoombtn','zoombtn-m','ztab-front','ztab-back','zoom-hint',
   'm-ptab-front','m-ptab-back','mobile-add-btn','m-reset-btn','mobile-bottom-add','sk-size','sk-dir','sk-sp','sk-band',
   'sk-fc','sk-bc','sk-inn','price-lbl','qty-lbl','reset-btn',
   'btn-add','btn-wish','btn-checkout','nav-wish','nav-cart','note-local','agree-lbl',
   'use-q','use-self','use-gift','use-mixed','use-mixed-hint',
   'dr-wish-ttl','dr-cart-ttl','wish-empty','cart-empty',
   'pop-t','pop-cn','pop-ok','inn-cart-ttl','inn-cart-note',
   'vtab-diy','vtab-premade','vtab-acc',
   'cf-info','cf-refund','cf-ship','cf-privacy','cf-terms',
   'size-tip-btn-txt','sizetip-ttl','sizetip-note','sizetip-scrollhint','mobile-prev-reopen',
   'lang-btn'].forEach(function(id){
    var el=document.getElementById(id);
    // 🔴 `lang-btn` 도 여기서 갱신한다(2026-08-13). 예전엔 toggleLang 안에서만 바꿔서,
    //    **영어 로케일로 처음 들어오면** 화면은 영어인데 버튼만 'EN' 으로 남았다(로케일 연동 테스트에서 발견).
    //    갱신 지점이 둘이면 한쪽을 빠뜨린다 — 한 곳으로 모은다.
    // el.textContent 로 덮으면 자식 svg·배지가 통째로 지워짐.
    // 언어 버튼은 `.lang-txt`(🌐 옆 글자) — `.nb-txt` 는 모바일에서 숨겨지는 칸이라 쓰면 안 된다(2026-10-07 실제로 KO 가 사라졌다).
    if(el&&t(id)!==id)(el.querySelector('.nb-txt, .lang-txt')||el).textContent=tabLabel(id);
  });
  applyHowtoLang();
  setupHowto();     // HOW TO 일러스트도 언어별 파일이라 다시 걸어준다(2026-08-14)
  buildLangMenu();  // 목록의 '현재 언어' 표시도 따라가야 한다
  if(typeof syncEditMode==='function')syncEditMode();   // 편집 중이면 담기 버튼 글자(「수정 완료」)를 되살린다 — 위 목록이 덮어썼다
  // 제작 기간 안내 — 제작 화면과 장바구니 고지문이 **같은 문구**다(2026-09-23). TXT 키 없이 함수 한 곳에서 둘 다 채운다.
  // 🔴 `note-lead` 를 위 id 목록에서 뺐다 — 거기 두면 textContent 로 덮여 메일 링크가 사라진다(배지 삭제와 같은 함정).
  ['lead-note','note-lead'].forEach(function(id){
    var el=document.getElementById(id); if(el)el.innerHTML=leadNoteHtml();
  });
  if(typeof syncMobileSum==='function')syncMobileSum();   // 「내역 보기 ▾」 버튼 글자도 언어를 따라간다
}
// HOW TO 탭 문구. 🔴 일반 목록과 따로 두는 이유: 본문에 `<br>` 이 들어 있어
//    `textContent` 로 넣으면 줄바꿈 태그가 글자로 보이거나 사라진다 — 본문만 `innerHTML` 로 넣는다.
function applyHowtoLang(){
  [['ht-title',0],['ht-sub',0],['ht-s1-t',0],['ht-s1-b',1],['ht-s2-t',0],['ht-s2-b',1],['ht-s3-t',0],['ht-s3-b',1],['ht-cta',0]]
    .forEach(function(p){
      var el=document.getElementById(p[0]); if(!el)return;
      if(p[1])el.innerHTML=t(p[0]); else el.textContent=t(p[0]);
    });
}
// 좁은 화면에서는 탭 라벨을 줄인다 — `DIY NOTEBOOK` 은 네 탭을 한 줄에 넣기엔 길어서
// 두 줄로 접히고, 그러면 탭마다 높이가 달라져 줄이 지저분해진다(2026-08-13 대표님 지적).
// 🔴 span 을 넣어 CSS 로 뒷단어만 감추는 방법은 못 쓴다 — applyLang 이 textContent 를
//    통째로 대입하는 구조라 자식 span 이 지워진다(2026-07-10 배지 삭제 버그와 같은 함정).
//    그래서 **라벨 문자열 자체를** 화면 폭에 따라 고른다.
// ⚠️ 경계는 **360px**. 375px(아이폰 미니·SE3 이상)에서는 nowrap 만으로 네 탭이 다 들어가므로
//    굳이 라벨을 줄이지 않는다 — 들어가는 곳에서는 제 이름을 그대로 보여주는 게 낫다.
//    줄이는 건 320px 급(구형 SE)에서만이다. 실측으로 정한 값이다(아래 검증).
var TAB_SHORT_MQ=(window.matchMedia?window.matchMedia('(max-width:360px)'):null);
function tabLabel(id){
  if(id==='vtab-diy'&&TAB_SHORT_MQ&&TAB_SHORT_MQ.matches)return t('vtab-diy-short');
  return t(id);
}
// 🔴 applyLang 은 **언어를 바꿀 때만** 돈다 — 첫 로드에는 마크업의 정적 라벨이 그대로 남는다.
//    그래서 라벨 동기화를 따로 두고 init 에서도 부른다(안 그러면 좁은 화면 첫 화면이 안 줄어든다).
function syncTabLabels(){
  ['vtab-diy','vtab-premade','vtab-acc'].forEach(function(id){
    var el=document.getElementById(id); if(el&&t(id)!==id)el.textContent=tabLabel(id);
  });
}
// 가로/세로 전환처럼 폭이 바뀌면 라벨도 따라가야 한다(경계를 넘을 때만 다시 그린다).
if(TAB_SHORT_MQ&&TAB_SHORT_MQ.addEventListener)TAB_SHORT_MQ.addEventListener('change',syncTabLabels);

// ═══ DATA ════════════════════════════════════════════════════════════
var SIZES=[
  {id:'A',w:182,h:257},{id:'B',w:152,h:202},{id:'C',w:128,h:182},{id:'X',w:null,h:null}
];
var A_AREA=182*257,B_AREA=152*202,C_AREA=128*182;
// 커스텀 면적을 C→B→A 기준값 사이에서 구간별 선형 보간 (프리셋과 금액 일치)
function lerpByArea(tbl){
  var a=S.cw*S.ch;
  if(a<=C_AREA)return tbl.C;
  if(a>=A_AREA)return tbl.A;
  if(a<=B_AREA){var r=(a-C_AREA)/(B_AREA-C_AREA);return Math.round(tbl.C+r*(tbl.B-tbl.C));}
  var r2=(a-B_AREA)/(A_AREA-B_AREA);return Math.round(tbl.B+r2*(tbl.A-tbl.B));
}
var COV_BASE={A:10500,B:9500,C:8000};
// 표지 개별가 사용 시: C 입력값 + 사이즈 가산액(기존 규칙 B +1500, A +2500). 규칙 변경은 여기만 수정.
var COV_SIZE_ADD={C:0,B:1500,A:2500};
var COV_PREMIUMS={solid:0,texture:2000,pattern:4000,limited:7500};
var INN_BLANK={A:1680,B:1380,C:1080};
var INN_PRINTED={A:2600,B:2300,C:2000};

var SC=[
  {id:'s01',n:'Gold',h:'#C8A84B'},{id:'s02',n:'Silver',h:'#A8AAB0'},
  {id:'s03',n:'Bronze',h:'#8B6340'},{id:'s04',n:'Black',h:'#2A2A2A'},
  {id:'s05',n:'White',h:'#ffffff'},{id:'s06',n:'Gray',h:'#888888'},
  {id:'s07',n:'Red',h:'#C43030'},{id:'s08',n:'Green',h:'#3A7A3A'},
  {id:'s09',n:'Navy',h:'#1A2E5A'},{id:'s10',n:'Yellow',h:'#D4B800'},
  {id:'s11',n:'Mustard',h:'#B8840A'},{id:'s12',n:'Brown',h:'#6B4020'}
];
var BC=[
  {id:'b04',n:'Black',h:'#1C1C1C'},
  {id:'b05',n:'Gray',h:'#909090'},{id:'b06',n:'Charcoal',h:'#4A4A4A'},
  {id:'b08',n:'Navy',h:'#1A2E5A'},
  {id:'b09',n:'Dusty Blue',h:'#79a4d3'},{id:'b10',n:'Pink',h:'#ffc0da'},
  {id:'b11',n:'Brown',h:'#7A4828'},{id:'b12',n:'Cloud',h:'#f2efeb'},
  {id:'b13',n:'Deep Green',h:'#2A5A30'},{id:'b14',n:'Green',h:'#53a33d'},
  {id:'b15',n:'Lime',h:'#cfe862'},{id:'b16',n:'Turquoise',h:'#4cd6d2'},
  {id:'b17',n:'Azure Blue',h:'#3683f2'},{id:'b18',n:'Lilac',h:'#A890C8'},
  {id:'b19',n:'Red',h:'#f41919'},{id:'b20',n:'Orange',h:'#f46414'},
  {id:'b21',n:'Lemon',h:'#fff383'}
];
var EYELETS=[
  {id:'e01',n:'Gold',h:'#fdd96c'},{id:'e02',n:'Silver',h:'#c6cacf'},
  {id:'e03',n:'Bronze',h:'#453626'},{id:'e04',n:'Black',h:'#2c2d31'}
];
var BANDS=[
  {id:'none',p:0},{id:'basic',p:1500},{id:'corner',p:2000},{id:'double',p:2000}
];
// 🔴 표지도 내지(INNS)와 **같은 방식으로** 영문 칸을 채운다(2026-08-13).
//    내지는 아래에서 `nEn:x.n, sEn:x.s, dEn:x.d` 로 한글을 영문 칸에 복사해 두는데 표지에는 그 과정이 없어,
//    EN 으로 바꾸면 `cv.matEn`/`cv.dEn` 이 없어서 화면에 그대로 **undefined** 가 찍혔다.
//    여기서 채워두면 이 필드를 읽는 모든 곳이 안전해진다 — 호출부마다 막는 것보다 확실하다.
//    ⚠️ 이건 '깨지지 않게' 하는 것이지 번역이 아니다. 진짜 영문은 메타객체에 영문 필드를 만들어야 한다.
var COVS=(window.PAPERME_COVERS&&window.PAPERME_COVERS.length)
  ? window.PAPERME_COVERS.map(function(x){
      return Object.assign({},x,{matEn:x.matEn||x.mat,dEn:x.dEn||x.desc,nEn:x.nEn||x.n});
    })
  :[
  {id:'v01',n:'cover_c_01_Double Layer_orange/gray',cat:'solid',col:'#F5F3EE',mat:'표면지 200g',matEn:'Cover paper 200g',desc:'깨끗하고 밝은 흰색 표면지.',dEn:'Clean bright white cover paper.'},
  {id:'v02',n:'Fog Gray',cat:'solid',col:'#C8C5BE',mat:'표면지 200g',matEn:'Cover paper 200g',desc:'차분한 미색 그레이.',dEn:'Calm muted gray.'},
  {id:'v03',n:'Ink Black',cat:'solid',col:'#2C2B28',mat:'표면지 200g',matEn:'Cover paper 200g',desc:'깊은 블랙 컬러.',dEn:'Deep black cover.'},
  {id:'v04',n:'Warm Ivory',cat:'solid',col:'#EDE7D5',mat:'표면지 200g',matEn:'Cover paper 200g',desc:'따뜻한 아이보리 톤.',dEn:'Warm ivory tone.'},
  {id:'v05',n:'Sage Green',cat:'solid',col:'#8EAA88',mat:'표면지 200g',matEn:'Cover paper 200g',desc:'차분한 세이지 그린.',dEn:'Calm sage green.'},
  {id:'v06',n:'Dusty Rose',cat:'solid',col:'#D4A5A0',mat:'표면지 200g',matEn:'Cover paper 200g',desc:'부드러운 더스티 로즈.',dEn:'Soft dusty rose.'},
  {id:'v07',n:'Slate Blue',cat:'solid',col:'#6A8098',mat:'표면지 200g',matEn:'Cover paper 200g',desc:'깊은 슬레이트 블루.',dEn:'Deep slate blue.'},
  {id:'v08',n:'Terracotta',cat:'solid',col:'#C4714A',mat:'표면지 200g',matEn:'Cover paper 200g',desc:'따뜻한 테라코타.',dEn:'Warm terracotta.'},
  {id:'v09',n:'Kraft',cat:'texture',col:'#C8A870',mat:'크라프트지 250g',matEn:'Kraft paper 250g',desc:'자연스러운 크라프트 질감.',dEn:'Natural kraft texture.'},
  {id:'v10',n:'Linen',cat:'texture',col:'#D4C9A8',mat:'리넨 텍스처 220g',matEn:'Linen texture 220g',desc:'리넨 패브릭 느낌.',dEn:'Linen fabric feel.'},
  {id:'v11',n:'Bark',cat:'texture',col:'#8B7355',mat:'바크 텍스처 230g',matEn:'Bark texture 230g',desc:'나무껍질을 연상시키는 텍스처.',dEn:'Tree bark-inspired texture.'},
  {id:'v12',n:'Slate Stone',cat:'texture',col:'#7A8085',mat:'스톤 텍스처 220g',matEn:'Stone texture 220g',desc:'돌의 표면을 닮은 매트한 텍스처.',dEn:'Matte stone surface texture.'},
  {id:'v13',n:'Marbled',cat:'pattern',col:'#E8E0D0',mat:'마블 패턴지 200g',matEn:'Marble pattern paper 200g',desc:'대리석 마블링 패턴.',dEn:'Marble pattern.'},
  {id:'v14',n:'Floral Line',cat:'pattern',col:'#F0EDE8',mat:'패턴 인쇄지 200g',matEn:'Pattern print paper 200g',desc:'섬세한 플로럴 라인 패턴.',dEn:'Delicate floral line pattern.'},
  {id:'v15',n:'Owl',cat:'pattern',col:'#D4806A',mat:'패턴 인쇄지 200g',matEn:'Pattern print paper 200g',desc:'귀여운 올빼미 패턴.',dEn:'Cute owl pattern.'},
  {id:'v16',n:'Stripe',cat:'pattern',col:'#E0D8CC',mat:'스트라이프 패턴지 200g',matEn:'Stripe pattern paper 200g',desc:'클래식한 스트라이프 패턴.',dEn:'Classic stripe pattern.'},
  {id:'v17',n:'Indigo Weave',cat:'limited',col:'#3A4E6E',mat:'패브릭 위브 250g',matEn:'Fabric weave 250g',desc:'인디고 컬러의 위브 패브릭. 한정 수량.',dEn:'Indigo woven fabric. Limited edition.'},
  {id:'v18',n:'Sakura Foil',cat:'limited',col:'#E8C4C0',mat:'포일 인쇄지 230g',matEn:'Foil print paper 230g',desc:'벚꽃 패턴에 골드 포일 마감.',dEn:'Cherry blossom with gold foil finish.'},
  {id:'v19',n:'Midnight Velvet',cat:'limited',col:'#1A1A2E',mat:'벨벳 코팅 260g',matEn:'Velvet coating 260g',desc:'딥 네이비 벨벳 코팅. 럭셔리 한정판.',dEn:'Deep navy velvet coating. Luxury edition.'},
  {id:'v20',n:'Desert Gold',cat:'limited',col:'#C8944A',mat:'레더 텍스처 270g',matEn:'Leather texture 270g',desc:'골드 톤 레더 텍스처. 프리미엄 한정판.',dEn:'Gold tone leather texture. Premium edition.'}
];
// 상품 탭: PREMADE(완성노트, 컬렉션 premade) / ACC(액세서리, 컬렉션 acc).
// Liquid 주입(window.PAPERME_PREMADE/ACC) 우선, 없으면 데모 폴백(단독 dev만). 주입 있으면 빈 배열도 그대로(빈 안내).
// ⚠️ priceCents 는 라이브와 같은 **원×100** 이다(2026-09-15 맞춤 — 전엔 원 그대로라 데모와 라이브가 달랐다). 원은 pcKrw().
var PREMADE=window.PAPERME_PREMADE?window.PAPERME_PREMADE:[
  {id:'demo-note-a5',title:'클래식 A5 완성 노트',priceStr:'₩18,000',priceCents:1800000,img:'',imgs:[],desc:'미리 완성해 둔 A5 스프링 노트입니다.',available:true,variants:[{id:1,title:'Ivory',priceCents:1800000,priceStr:'₩18,000',available:true},{id:2,title:'Charcoal',priceCents:1800000,priceStr:'₩18,000',available:true}]}
];
var ACC=window.PAPERME_ACC?window.PAPERME_ACC:[
  {id:'demo-band',title:'가죽 밴드',priceStr:'₩4,500',priceCents:450000,img:'',imgs:[],desc:'노트를 감싸 고정하는 가죽 밴드.',available:true,variants:[]},
  {id:'demo-pen',title:'황동 볼펜',priceStr:'₩12,000',priceCents:1200000,img:'',imgs:[],desc:'묵직한 황동 볼펜.',available:true,variants:[]}
];
var SHOP_SRC={premade:PREMADE, acc:ACC};
var _shopSource='premade';                 // 현재 활성 상품 탭
function curShop(){return SHOP_SRC[_shopSource]||[];}

// 표지 카테고리: 메타객체 category 값(한글) → 탭 표시 라벨(한/영).
// 🔴 예전엔 값을 그대로 찍어서 **EN 에서도 한글 탭이 나왔다**(2026-08-13 대표님 지적).
//    내지(INN_CAT_LABEL)에는 있던 매핑이 표지에만 없었다 — 내지는 값이 영문이라 매핑이 필요했고,
//    표지는 값이 한글이라 "그대로 쓰면 된다"고 넘어간 탓이다. 한국어만 볼 때는 문제가 없었다.
// ⚠️ 여기 없는 값(대표님이 새 카테고리를 추가한 경우)은 **값 그대로** 보여준다 — 빈칸이 되지 않게.
var COV_CAT_LABEL={
  '단색':{ko:'단색',en:'Solid',ja:'単色'},
  '디자인':{ko:'디자인',en:'Designed',ja:'デザイン'},
  '패턴':{ko:'패턴',en:'Pattern',ja:'パターン'},
  '한정판':{ko:'한정판',en:'Limited',ja:'限定版'}
};
function covCatLabel(cid){var m=COV_CAT_LABEL[cid];return m?L(m.ko,m.en,m.ja):cid;}
// 🔴 **카테고리 값은 로케일마다 다르게 온다** (2026-08-16, 대표님 제보로 라이브 실측).
//    Translate & Adapt 가 메타객체의 `category` **값 자체를 번역**해 버린 표지가 둘 있었다:
//      `Dot_ivory`(cover_09)            → 한국어 `패턴`   / 영어 `Pattern`
//      `Cambridge Imprint _ owl`(cover_36) → 한국어 `한정판` / 영어 `Limited`
//    카테고리는 화면 문구가 아니라 **내부 분류키**다. 번역되면 코드는 전혀 다른 카테고리로 읽는다.
//    그 결과 영어에서 `패턴`/`Pattern`, `한정판`/`Limited` 이 **각각 별개 탭**이 되어
//    **한정판 탭이 두 개**가 되고 패턴 표지 하나가 딴 탭으로 빠졌다(일본어는 멀쩡했다 — 그래서 더 늦게 보였다).
// 🔴 **에러가 안 난다.** 탭이 하나 더 생길 뿐이라 코드는 정상 동작한다고 믿는다.
// → 근본 해결은 관리자에서 그 번역을 지우는 것이지만(카테고리는 번역 대상이 아니다),
//   **또 누가 번역하면 같은 사고가 난다.** 그래서 값을 **정규화해서** 어느 언어로 와도 한 카테고리로 합친다.
// ⚠️ 표에 없는 값은 **그대로 둔다** — 대표님이 새 카테고리를 만들었을 때 빈칸이 되지 않게 하려는 기존 방침 유지.
function pmCatNorm(s){return String(s==null?'':s).trim().toLowerCase().replace(/[\s_-]/g,'');}
function pmBuildAlias(pairs){
  var m={};
  pairs.forEach(function(p){p[1].forEach(function(a){m[pmCatNorm(a)]=p[0];});});
  return m;
}
var COV_CAT_ALIAS=pmBuildAlias([
  ['단색',  ['단색','solid','単色']],
  ['디자인',['디자인','designed','design','デザイン']],
  ['패턴',  ['패턴','pattern','パターン']],
  ['한정판',['한정판','limited','limited edition','限定版']]
]);
function covCatKey(v){return COV_CAT_ALIAS[pmCatNorm(v)]||v;}
// 내지 카테고리: 메타객체 category 값(내부값) → 탭 표시 라벨(한/영), 탭 순서 고정
var INN_CAT_ORDER=['blank_writing','lined','grid','planner','blank_drawing','special edition'];
var INN_CAT_LABEL={
  /* 🔴 한국어 라벨은 «플래너» 다 (2026-08-23, 대표님). 예전엔 「스케줄러」였는데
     화면 다른 곳(사이즈 제한 안내·주석·코드)은 전부 이미 「플래너」라 탭만 혼자 달랐다.
     ⚠️ 내부값 `planner` 는 안 바꾼다 — 메타객체에 그 값으로 저장돼 있다(라이브 확인). */
  planner:{ko:'플래너',en:'Planner',ja:'プランナー'},
  lined:{ko:'라인',en:'Lined',ja:'罫線'},
  grid:{ko:'격자',en:'Grid',ja:'方眼'},
  blank_writing:{ko:'무지(필기)',en:'Blank (Writing)',ja:'無地（筆記用）'},
  blank_drawing:{ko:'무지(드로잉)',en:'Blank (Drawing)',ja:'無地（ドローイング）'},
  'special edition':{ko:'한정판',en:'Special Edition',ja:'限定版'}
};
function innCatLabel(cid){var m=INN_CAT_LABEL[cid];return m?L(m.ko,m.en,m.ja):cid;}
// 내지도 같은 방어. 🔴 지금은 멀쩡하다(2026-08-16 라이브 확인: 값이 전부 내부키 그대로).
//    그래도 **구조가 똑같이 노출돼 있다** — 특히 `special edition` 은 사람이 읽는 말이라 번역되기 쉽다.
//    표지에서 당한 뒤에 내지만 안 막아두면, 같은 사고를 한 번 더 겪고 나서야 고치게 된다.
// ⚠️ 별칭에 **화면 라벨(한/영/일)도 넣는다** — 번역기가 만들어 낼 값이 바로 그 라벨이기 때문이다.
var INN_CAT_ALIAS=pmBuildAlias([
  ['blank_writing', ['blank_writing','무지(필기)','blank (writing)','無地（筆記用）']],
  ['lined',         ['lined','라인','罫線']],
  ['grid',          ['grid','격자','方眼']],
  /* ⚠️ 「스케줄러」는 **옛 라벨이지만 별칭에 남겨둔다** — 번역 도구에 그 말로 들어간 값이
     남아 있을 수 있고, 별칭은 있어서 손해 볼 게 없다(없으면 그 탭이 통째로 사라진다). */
  ['planner',       ['planner','플래너','스케줄러','プランナー']],
  ['blank_drawing', ['blank_drawing','무지(드로잉)','blank (drawing)','無地（ドローイング）']],
  ['special edition',['special edition','한정판','限定版']]
]);
function innCatKey(v){return INN_CAT_ALIAS[pmCatNorm(v)]||v;}

// 메타객체(window.PAPERME_INNERS) 우선, 없으면 하드코딩 데모(폴백). 하드코딩도 새 카테고리 체계로.
var INNS=(window.PAPERME_INNERS&&window.PAPERME_INNERS.length)
  ? window.PAPERME_INNERS.map(function(x){
      // 영문 필드가 비어 있으면 한글로 폴백한다(관리자에 name_en/spec_en/explain_en 을 넣으면 그 값이 쓰인다).
      // 🔴 `dJa` 는 **폴백을 걸지 않고 그대로 넘긴다**(2026-08-14). 비어 있어야 pickLang 이 영어 → 한국어로
      //    내려갈 수 있다 — 여기서 한국어를 채워버리면 영어 번역이 있어도 일본어 화면에 한국어가 뜬다.
      //    ⚠️ 이 객체는 필드를 **하나씩 적어 옮기므로**, 새 필드를 추가하면 여기에도 적어야 조용히 사라지지 않는다.
      return {id:x.id,n:x.n,nEn:x.nEn||x.n,no:x.no,unit:x.unit,cat:x.cat,s:x.s,sEn:x.sEn||x.s,d:x.d,dEn:x.dEn||x.d,dJa:x.dJa||'',
              tagline:x.tagline||'',tagEn:x.tagEn||'',tagJa:x.tagJa||'',   // 첫인상 문구(2026-09-22). 🔴 여기 안 적으면 주입돼도 조용히 사라진다 — 위 ⚠️ 그대로 겪었다.
              img:x.img,imgHi:x.imgHi,imgsDetail:x.imgsDetail||[],video:x.video||'',
              gsm:x.gsm||0,
              ori:x.ori,price:x.price,status:x.status,ord:x.ord};
    })
  : [
  {id:'i01',cat:'lined',ori:'vertical',n:'5mm 횡선',nEn:'5mm Ruled',s:'80g · 라인지',sEn:'80g · Ruled',t:'lined',g:5,tp:'printed',d:'5mm 간격의 횡선. 표준 필기용.',dEn:'5mm ruled lines.'},
  {id:'i02',cat:'lined',ori:'vertical',n:'7mm 횡선',nEn:'7mm Ruled',s:'80g · 라인지',sEn:'80g · Ruled',t:'lined',g:7,tp:'printed',d:'여유있는 7mm 간격.',dEn:'Wide 7mm spacing.'},
  {id:'i03',cat:'lined',ori:'horizontal',n:'필기체선',nEn:'Script Lines',s:'90g · 크림지',sEn:'90g · Cream',t:'lined',g:6,tp:'printed',d:'크림색 90g지에 연한 라인.',dEn:'Faint lines on cream paper.'},
  {id:'i04',cat:'grid',ori:'any',n:'5mm 격자',nEn:'5mm Grid',s:'80g · 모눈지',sEn:'80g · Grid',t:'grid',g:5,tp:'printed',d:'5mm 정방형 격자.',dEn:'5mm square grid.'},
  {id:'i05',cat:'grid',ori:'any',n:'5mm 도트',nEn:'5mm Dot',s:'80g · 도트지',sEn:'80g · Dot',t:'dot',g:5,tp:'printed',d:'5mm 도트 격자.',dEn:'5mm dot grid.'},
  {id:'i06',cat:'grid',ori:'vertical',n:'코넬노트',nEn:'Cornell',s:'80g · 라인지',sEn:'80g · Ruled',t:'cornell',g:0,tp:'printed',d:'코넬 포맷.',dEn:'Cornell format.'},
  {id:'i07',cat:'planner',ori:'horizontal',n:'위클리',nEn:'Weekly',s:'90g · 플래너',sEn:'90g · Planner',t:'weekly',g:0,tp:'printed',d:'월~일 위클리 포맷.',dEn:'Weekly layout.'},
  {id:'i08',cat:'planner',ori:'vertical',n:'데일리',nEn:'Daily',s:'90g · 플래너',sEn:'90g · Planner',t:'daily',g:0,tp:'printed',d:'하루 한 페이지.',dEn:'One page per day.'},
  {id:'i09',cat:'planner',ori:'vertical',n:'투두리스트',nEn:'To-Do',s:'80g · 라인지',sEn:'80g · Ruled',t:'todo',g:8,tp:'printed',d:'체크박스 할일 목록.',dEn:'Checkbox to-do list.'},
  {id:'i10',cat:'blank_writing',ori:'any',n:'백지',nEn:'White Blank',s:'100g · 백색',sEn:'100g · White',t:'blank',g:0,tp:'blank',d:'100g 백색 무지.',dEn:'100g white blank.'},
  {id:'i11',cat:'blank_writing',ori:'any',n:'크림 무지',nEn:'Cream Blank',s:'90g · 크림',sEn:'90g · Cream',t:'bcream',g:0,tp:'blank',d:'크림색 90g 무지.',dEn:'Cream 90g blank.'},
  {id:'i12',cat:'blank_drawing',ori:'any',n:'다크 무지',nEn:'Dark Blank',s:'100g · 흑색',sEn:'100g · Black',t:'bdark',g:0,tp:'blank',d:'블랙 100g 무지.',dEn:'Black 100g blank.'},
  {id:'i13',cat:'special edition',ori:'any',n:'트레이싱지',nEn:'Tracing',s:'60g · 반투명',sEn:'60g · Translucent',t:'trace',g:0,tp:'printed',d:'반투명 트레이싱지.',dEn:'Translucent tracing paper.'},
  {id:'i14',cat:'special edition',ori:'any',n:'방안 전용',nEn:'Fine Grid',s:'80g · 2mm',sEn:'80g · 2mm',t:'grid',g:2,tp:'printed',d:'2mm 세밀 격자.',dEn:'2mm fine grid.'},
  {id:'i15',cat:'special edition',ori:'vertical',n:'악보지',nEn:'Music Staff',s:'80g · 5선',sEn:'80g · 5-line',t:'music',g:0,tp:'printed',d:'5선 악보 전용지.',dEn:'Music staff paper.'},
  {id:'i16',cat:'special edition',ori:'vertical',n:'포켓 유선',nEn:'Pocket Ruled',s:'80g · 라인',sEn:'80g · Ruled',t:'pocket',g:6,tp:'printed',d:'하단 포켓 공간 라인 페이지.',dEn:'Ruled page with pocket.'}
];

// ═══ STATE ════════════════════════════════════════════════════════════
var DEFAULT_STATE={
  size:'C',cw:null,ch:null,dir:'portrait',
  sp:'full',springChosen:false,sc:'s04',sc_top:'s04',sc_bot:'s04',
  band:'none',bc:'b04',bc1:'b09',bc2:'b19',bk:'b04',ey:'e04',ey1:'e04',ey2:'e03',
  fc:null,fc_cat:'solid',bcover:null,bc_cat:'solid',
  inns:[],inn_cat:'blank_writing',qty:1,prev:'front',
  // 어느 표지의 추천 조합을 적용한 상태인지(없으면 null). 앞표지를 바꾸면 해제한다.
  // recApplied = 적용 당시 넣은 값들. 지금 값과 비교해 "손대지 않은 항목"만 되돌린다.
  recFrom:null,recApplied:null
};
var S=JSON.parse(JSON.stringify(DEFAULT_STATE));
// ── 언어를 바꿔도 만들던 조합을 잃지 않는다 (2026-09-15, 대표님 지적 "중간에 언어를 바꾸면 다 리셋되네?") ──
// setLang 은 번역된 카탈로그를 받으려고 Shopify 로케일 주소로 **페이지를 통째로 이동**한다.
// 장바구니·위시는 localStorage 라 살아남지만, 지금 고르던 조합(S)은 메모리뿐이라 통째로 사라졌다.
// → 이동 직전에 S 를 sessionStorage 에 두고, 다음 로드의 init 이 되살린 뒤 바로 지운다.
// 🔴 sessionStorage 인 이유: 그 탭에만 묶이고 탭을 닫으면 사라진다 — 며칠 전 조합이 불쑥 되살아나면 안 된다.
//    같은 이유로 10분이 지난 것은 버린다(언어 전환은 몇 초 안에 끝난다).
// 🟢 S 안의 id(표지·내지 핸들)는 언어와 무관하므로 그대로 되살려도 맞는다. 탭·열린 상품(?tab=·?p=)은 주소에 있어 원래 살아남았다.
var PAPERME_DRAFT_SS='paperme_draft_v1';
// 편집 모드(EDIT)도 같이 챙긴다 — 장바구니 항목을 고치다 언어를 바꿨는데 「담기」로 돌아오면 또 두 권이 된다(2026-09-22).
function stashDraft(){ try{ sessionStorage.setItem(PAPERME_DRAFT_SS,JSON.stringify({s:S,e:(typeof EDIT!=='undefined'?EDIT:null),t:Date.now()})); }catch(e){} }
function restoreDraft(){
  var raw=null;
  try{ raw=sessionStorage.getItem(PAPERME_DRAFT_SS); sessionStorage.removeItem(PAPERME_DRAFT_SS); }catch(e){ return false; }
  if(!raw)return false;
  try{
    var o=JSON.parse(raw);
    if(!o||!o.s||typeof o.s!=='object'||(Date.now()-(o.t||0))>10*60*1000)return false;
    // 기본값 위에 덮는다 — 그 사이 DEFAULT_STATE 에 새 키가 생겨도 빈 채로 남지 않게.
    var next=JSON.parse(JSON.stringify(DEFAULT_STATE));
    for(var k in o.s)if(Object.prototype.hasOwnProperty.call(o.s,k))next[k]=o.s[k];
    // 카탈로그에 없는 표지·내지는 걷어낸다(그 사이 단종됐을 수 있다) — 렌더가 undefined 를 만나면 화면이 통째로 멈춘다.
    if(next.fc&&!COVS.some(function(c){return c.id===next.fc;}))next.fc=null;
    if(next.bcover&&!COVS.some(function(c){return c.id===next.bcover;}))next.bcover=null;
    next.inns=(Array.isArray(next.inns)?next.inns:[]).filter(function(id){return INNS.some(function(x){return x.id===id;});});
    S=next;
    if(o.e&&typeof o.e==='object')EDIT=o.e;   // 항목이 아직 있는지는 syncEditMode 가 확인한다(없으면 조용히 일반 모드)
    return true;
  }catch(e){ return false; }
}
var CART=[],WISH=[];
// ── 로컬 카트/위시 유지 (localStorage) — 새로고침·페이지 이동에도 보존 ──
var PAPERME_CART_LS='paperme_cart_v1';
function saveCart(){try{localStorage.setItem(PAPERME_CART_LS,JSON.stringify({c:CART,w:WISH}));}catch(e){}pmCartMirror();}
function loadCart(){try{var raw=localStorage.getItem(PAPERME_CART_LS);if(!raw)return false;var o=JSON.parse(raw);if(o&&Array.isArray(o.c))CART=o.c;if(o&&Array.isArray(o.w))WISH=o.w;return true;}catch(e){}return false;}

// ── 장바구니 사본을 Shopify 카트 속성에도 둔다 (2026-08-16) ──────────────
// 🔴 **왜 필요한가:** 우리 장바구니는 `localStorage` 인데, 그건 **자바스크립트가 저장한 것**이라
//    사파리 ITP 의 **7일 규칙**에 걸린다 — 7일간 사이트에 안 들어오면 지워진다.
//    담아두고 열흘 뒤에 온 아이폰 고객은 빈 장바구니를 본다. (계정 연동은 로그인한 사람만 구제한다 — #29)
// 🟢 **Shopify 카트 쿠키는 서버가 `Set-Cookie` 로 심는다.** ITP 의 7일 제한은 JS 가 심은 것에 걸리므로
//    여기 해당하지 않는다. **로그인 없이도** 다수를 구제한다.
// 🟢 2026-08-16 라이브 카트 API 로 실측한 것(추측 아님):
//    ① 빈 카트에도 속성만 저장된다(`item_count:0` 인데 attributes 유지)
//    ② 한 값에 **67KB** 를 넣어도 완전히 저장·회수된다. 우리 payload 는 1~3KB — 20배 이상 여유
//    ③ `cart` 쿠키 만료 = **91일**(2026-11-15). 2주가 아니라 석 달이다
// 🔴 **키를 `_` 로 시작한다** — Shopify 는 밑줄로 시작하는 속성을 관리자 주문/체크아웃 화면에서 숨긴다.
//    안 그러면 주문마다 JSON 덩어리가 붙어 보인다.
// 🔴 **결제 흐름은 건드리지 않는다.** DIY 결제는 Worker → Draft Order 로 가고 네이티브 카트를 안 쓴다.
//    여기서 카트는 **저장 장치로만** 쓴다. 실패하면 조용히 넘어가고 기존 동작(localStorage)이 그대로 남는다.
// ⚠️ 주소에 로케일 접두어를 붙이지 않는다(`/en/cart.js` ❌) — 카트 경로는 루트 기준이다(앱 프록시와 같은 규칙).
var PM_CART_ATTR='_pm_cart';
var _pmMirrorT=null;
function pmCartMirror(){
  // saveCart 는 조작 한 번에도 여러 번 불린다 → 묶어서 한 번만 보낸다.
  if(_pmMirrorT)clearTimeout(_pmMirrorT);
  _pmMirrorT=setTimeout(function(){
    _pmMirrorT=null;
    if(typeof fetch!=='function')return;
    var body={attributes:{}};
    // 빈 값을 보내면 Shopify 가 속성을 지운다 — 비우는 것도 이 경로로 정확히 반영된다.
    body.attributes[PM_CART_ATTR]=(CART.length||WISH.length)?JSON.stringify({c:CART,w:WISH}):'';
    fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}).catch(function(){});
  },1200);
}
// localStorage 가 비었을 때만 카트 속성에서 되살린다.
// 🔴 **localStorage 를 덮어쓰지 않는다** — 그쪽이 항상 더 최신이다(속성은 1.2초 늦게 따라간다).
//    비었을 때만 본다는 규칙이 "옛 사본이 새 장바구니를 덮는" 사고를 막는다.
function pmCartRestore(){
  if(typeof fetch!=='function')return;
  fetch('/cart.js',{headers:{'Accept':'application/json'}})
    .then(function(r){return r.ok?r.json():null;})
    .then(function(c){
      if(!c||!c.attributes)return;
      var raw=c.attributes[PM_CART_ATTR];
      if(!raw)return;
      var o=JSON.parse(raw);
      var got=false;
      // ⚠️ 장바구니를 통째로 되살리면 번호가 새로 잡히므로 항목별 용도도 비운다(다시 고르게 한다).
      if(o&&Array.isArray(o.c)&&o.c.length&&!CART.length){CART=o.c;_pmItemUse=[];got=true;}
      if(o&&Array.isArray(o.w)&&o.w.length&&!WISH.length){WISH=o.w;got=true;}
      if(!got)return;
      try{localStorage.setItem(PAPERME_CART_LS,JSON.stringify({c:CART,w:WISH}));}catch(e){}
      // 되살렸으면 화면을 다시 그린다 — 배지·서랍 목록이 이미 0으로 그려진 뒤다.
      updBadges();
      try{renderCartList();renderWishList();}catch(e){}
    })
    .catch(function(){});
}

// ── 위시리스트 계정 동기화 (2026-08-15) ──────────────────────────────
// 로그인한 고객이면 위시를 **고객 메타필드**에도 둔다 — 기기를 바꿔도, 사파리가 7일 만에
// 로컬 저장소를 지워도 남는다. 비로그인 고객은 지금까지처럼 localStorage 만 쓴다.
//
// 통로는 앱 프록시다: `/apps/paperme/wishlist` → Shopify 가 서명과 로그인 고객 id 를 붙여 Worker 로 넘긴다.
// 🔴 그래서 **여기서 고객 id 를 보내지 않는다.** 보내봐야 Worker 가 안 믿는다(믿으면 남의 위시를 볼 수 있다).
// ⚠️ 주소에 로케일 접두어(/en, /ja)를 붙이지 않는다 — 프록시 경로는 루트 기준이다.
var PM_PROXY='/apps/paperme';
function wishSyncOn(){ return !!(window.PAPERME_CUSTOMER && window.PAPERME_CUSTOMER.id); }

// 서버에는 **조합 상태(snap)만** 보낸다. 위시 항목은 표지·내지 객체를 통째로 안고 있어
// (이미지 URL·3개 언어 설명까지) 그대로 보내면 메타필드 한 칸(65,535자)을 금방 넘긴다.
// 되살릴 때는 지금 카탈로그로 다시 조립하므로 **표지 이름·가격이 바뀌면 저장해둔 위시도 최신값을 따라간다.**
function wishSlim(it){
  if(it && it.kind==='product') return {kind:'product',id:it.id,variantId:it.variantId||0,qty:it.qty||1};
  return (it && it.snap) ? {snap:it.snap} : null;
}
// S 를 잠깐 그 조합으로 바꿔놓고 buildCfg 를 부른다 — 위시 항목이 원래 그렇게 만들어지므로
// 모양이 정확히 같아진다(가격·표지·내지·사이즈까지). loadCfg 도 S 를 통째로 갈아끼우는 방식이다.
function withFullSnap(snap,fn){ var keep=S; try{ S=JSON.parse(JSON.stringify(snap)); return fn(); } finally{ S=keep; } }
function wishFat(sl){
  if(!sl) return null;
  if(sl.kind==='product'){
    var p=findShopProduct(sl.id); if(!p) return null;        // 없어진 상품은 조용히 버린다
    var vs=p.variants||[], v=vs.find(function(x){return x.id===sl.variantId;})||vs[0]||{};
    var vt=(v.title&&v.title!=='Default Title')?v.title:'';
    return {kind:'product',id:p.id,title:p.title,variantId:v.id||p.variantId||0,variantTitle:vt,
      priceCents:(v.priceCents!=null?v.priceCents:p.priceCents),priceStr:v.priceStr||p.priceStr,
      img:(p.imgs&&p.imgs[0])||p.img||'',qty:sl.qty||1};
  }
  try{ return withFullSnap(sl.snap,buildCfg); }catch(e){ return null; }
}
// replace=false(POST) → 서버가 **합집합**으로 합친다. 폰에 3개, 노트북에 2개면 5개가 된다.
// replace=true(PUT)  → 지금 목록으로 **대체**한다. 삭제는 합집합으로 표현할 수 없어서 이때만 쓴다.
// 🔴 실패하면 아무것도 하지 않는다 — 서버가 죽어도 화면의 위시는 로컬 그대로 살아 있어야 한다.
var _wishSyncQ=Promise.resolve();
function syncWish(replace){
  if(!wishSyncOn()) return;
  _wishSyncQ=_wishSyncQ.then(function(){       // 요청을 줄 세운다 — 겹치면 나중 것이 옛 목록을 쓸 수 있다
    return fetch(PM_PROXY+'/wishlist',{
      method:replace?'PUT':'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:WISH.map(wishSlim).filter(Boolean)})
    }).then(function(r){return r.json();}).then(function(d){
      if(!d||!d.ok||!Array.isArray(d.items))return;
      WISH=d.items.map(wishFat).filter(Boolean);
      updBadges(); renderWishList();           // updBadges 가 saveCart 까지 한다
    });
  }).catch(function(){});
}

// ── 결제 대기 주문 ────────────────────────────────────────────────
// 체크아웃으로 보낼 때 카트를 비우면, 결제를 취소하고 돌아온 고객의 장바구니가
// 사라진다. 그래서 draftOrderId 만 적어두고 카트는 그대로 둔다. 돌아왔을 때
// Worker 에 결제 여부를 물어, 결제됐을 때만 카트를 비운다.
var PAPERME_PENDING_LS='paperme_pending_v1';
var PENDING_MAX_AGE=24*60*60*1000;   // 24시간 지나면 잊는다(방치된 결제창)
// 🔴 결제 대기 주문을 **여러 건** 추적한다.
//    예전엔 하나만 저장해서 **연속으로 두 번 주문하면 첫 번째를 잊었다** —
//    두 번째가 첫 번째를 덮어써서, 첫 주문을 결제해도 확인하지 않아 장바구니가 안 비워졌다
//    (2026-08-10 대표님이 두 건 주문·결제하고 발견).
//    ⚠️ 옛 형식(단일 객체)으로 저장된 값도 읽는다 — 이미 브라우저에 남아 있는 사람들 때문.
function loadPendings(){
  try{
    var raw=localStorage.getItem(PAPERME_PENDING_LS); if(!raw)return [];
    var o=JSON.parse(raw);
    var arr=Array.isArray(o)?o:((o&&o.id)?[o]:[]);
    var now=Date.now();
    return arr.filter(function(x){return x&&x.id&&(now-(x.at||0)<=PENDING_MAX_AGE);});
  }catch(e){return [];}
}
function savePendings(arr){
  try{
    if(arr&&arr.length)localStorage.setItem(PAPERME_PENDING_LS,JSON.stringify(arr));
    else localStorage.removeItem(PAPERME_PENDING_LS);
  }catch(e){}
}
// 🔧 임시 진단 로그 — 결제 확인이 무슨 일을 했는지 **지워지지 않게** 남긴다(2026-08-13).
//    대기 목록은 확인이 끝나면 비워지므로, 나중에 열어보면 이미 증거가 사라진 뒤다.
//    그래서 별도 키에 최근 30줄만 쌓아두고 `?pendingdebug=1` 로 꺼내 본다.
//    🔴 원인 확인되면 이 로그와 호출부(plog)를 전부 지울 것.
var PAPERME_PENDLOG_LS='paperme_pendlog_v1';
function plog(msg){
  try{
    var a=JSON.parse(localStorage.getItem(PAPERME_PENDLOG_LS)||'[]');
    a.push(new Date().toISOString().slice(5,19).replace('T',' ')+' '+msg);
    localStorage.setItem(PAPERME_PENDLOG_LS,JSON.stringify(a.slice(-30)));
  }catch(e){}
}
function savePending(id){
  plog('savePending('+(id||'(빈 값!)')+')');
  if(!id)return;
  _pendRetries=0;                                  // 새 주문이면 재확인 기회를 처음부터 다시 준다
  var arr=loadPendings().filter(function(x){return x.id!==id;});   // 같은 주문 중복 방지
  arr.push({id:id,at:Date.now()});
  if(arr.length>10)arr=arr.slice(-10);                             // 무한정 쌓이지 않게
  savePendings(arr);
}
function clearPending(){savePendings([]);}
// 결제됐으면 카트를 비운다. 확인 실패(오프라인·서버오류)면 카트를 건드리지 않는다
// — 애매할 땐 남기는 쪽이 안전하다(잃는 것보다 중복이 낫다).
// 🔴 결제하고 **뒤로가기로 돌아오면** 브라우저가 페이지를 통째로 복원한다(bfcache).
//    그러면 init() 이 다시 돌지 않아 결제 확인이 아예 실행되지 않고 장바구니가 남는다
//    (2026-08-10 대표님이 결제 후에도 안 비워진다고 하여 발견. 사파리가 특히 적극적으로 복원한다).
//    그래서 로드 때뿐 아니라 **페이지가 복원되거나 탭이 다시 보일 때도** 확인한다.
//    ⚠️ visibilitychange 는 자주 뜨므로 3초 안에 재실행하지 않는다(요청 폭주 방지).
var _pendCheckAt=0, _pendChecking=false;
// 결제 직후엔 초안이 아직 COMPLETED 가 아닐 수 있어, 간격을 늘려가며 다시 확인한다(합계 약 2분).
// 페이지를 새로 열면 0 부터 다시 시작한다 — 돌아온 시점마다 한 번씩 기회를 준다.
var PEND_RETRY_MS=[3000,5000,10000,20000,30000,60000], _pendRetries=0;
function checkPendingOrderSoon(){
  if(_pendChecking||Date.now()-_pendCheckAt<3000)return;
  checkPendingOrder();
}
// 🔴 **장바구니를 열 때는 시간 제한 없이 즉시 확인한다** (2026-08-16 대표님).
//    *"결제 완료하고 돌아오면 장바구니에 아직 담겨 있는 걸로 보이니까 눌러보게 되거든.
//      그때 비워지면서 뜨는 게 맞지 않을까?"* — 고객이 배지를 보고 **일부러 누른 순간**이
//    의심이 생기는 지점이다. 그 자리에서 답이 나와야 한다.
//    (자동 재확인은 3초 제한이 있다 — 사람이 누른 것과 타이머가 도는 것은 다르게 다룬다.)
function checkPendingOrderNow(){ if(_pendChecking)return; checkPendingOrder(); }
if(typeof window!=='undefined'){
  window.addEventListener('pageshow',function(e){ if(e&&e.persisted)checkPendingOrderSoon(); });
  document.addEventListener('visibilitychange',function(){ if(!document.hidden)checkPendingOrderSoon(); });
}
// 대기 중인 주문을 **전부** 확인해, 하나라도 결제됐으면 장바구니를 비운다.
// (결제 전에는 비우지 않는다 — 체크아웃에서 취소하고 돌아왔을 때 장바구니가 사라지면 안 되므로.)
function checkPendingOrder(){
  var list=loadPendings(); if(!list.length||!PAPERME_ORDER_ENDPOINT)return;
  _pendChecking=true; _pendCheckAt=Date.now();
  var left=[], paidAny=false, done=0;
  function finish(){
    if(++done<list.length)return;
    _pendChecking=false;
    if(paidAny){
      CART=[]; _pmItemUse=[]; saveCart(); updBadges(); savePendings([]);
      // 🔴 왜 비었는지 알려준다 — 조용히 사라지면 "어? 왜 비었지" 가 된다. 서랍의 빈 문구를 바꿔 끼운다.
      _pmJustOrdered=true;
      // ⚠️ 서랍이 **열려 있는 채로** 확인되는 경우가 있다(고객이 눌러서 확인이 도는 경우가 그렇다).
      //    updBadges 만으로는 목록이 안 바뀌어 담긴 것이 그대로 보인다 → 여기서 다시 그린다.
      try{ renderCartList(); }catch(e){}
      plog('→ 결제 확인됨. 장바구니 비움');
    }
    else {
      savePendings(left);                          // 아직 결제 안 된 건만 남긴다
      plog('→ 결제 안 됨. '+left.length+'건 남김');
      // 🔴 결제 직후 곧바로 돌아오면 Shopify 가 아직 초안을 COMPLETED 로 바꾸기 전이라
      //    "결제 안 됨"으로 나온다. 예전엔 그걸로 끝이라, 그 페이지에 머무는 동안
      //    **다시 확인할 계기가 없어 장바구니가 그대로 남았다**(2026-08-13).
      //    그래서 한 번 물어보고 마는 대신 간격을 늘려가며 2분 남짓 다시 물어본다.
      //    (돌아오지 않은 사람에게는 대기 건이 없어 이 경로가 아예 안 돈다.)
      if(left.length&&_pendRetries<PEND_RETRY_MS.length){
        var _d=PEND_RETRY_MS[_pendRetries++];
        setTimeout(checkPendingOrder,_d);
        plog('   '+(_d/1000)+'초 뒤 다시 확인');
      }
    }
  }
  list.forEach(function(p){
    fetch(PAPERME_ORDER_ENDPOINT,{
      method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({action:'status',draftOrderId:p.id})
    }).then(function(r){return r.json().then(function(d){plog('status '+r.status+' '+JSON.stringify(d));return d;});}).then(function(d){
      if(d&&d.paid)paidAny=true;
      // 🔴 2026-08-13: found:false 여도 **지우지 않는다.** 전에는 "초안이 삭제됐다"고 보고 잊었는데,
      //    그러면 장바구니는 안 비운 채 기록만 사라져 **다음 방문에 확인할 방법이 없어진다**
      //    (실제로 이 상태가 관측됐다: 장바구니 1건 · 대기 0건 · 원본 비어 있음).
      //    found:false 는 "결제 안 됨"의 증거가 아니라 **판단 불가**다. 애매하면 남긴다 —
      //    어차피 24시간이 지나면 PENDING_MAX_AGE 로 저절로 잊힌다.
      else left.push(p);
      finish();
    }).catch(function(e){ plog('status 요청 실패 '+e); left.push(p); finish(); });   // 통신 실패는 판단 보류(다음에 다시 확인)
  });
}
// 주문 브릿지(Cloudflare Worker) 엔드포인트. 배포 후 build-customizer가 window.PAPERME_ORDER_ENDPOINT로 주입.
var PAPERME_ORDER_ENDPOINT=(typeof window!=='undefined'&&window.PAPERME_ORDER_ENDPOINT)||'';

// ═══ PRICE ════════════════════════════════════════════════════════════
function getSizeKey(){
  if(S.size==='X'){
    if(!S.cw||!S.ch)return 'C';
    var a=S.cw*S.ch;
    if(a<=C_AREA)return 'C';
    if(a>=A_AREA)return 'A';
    return 'B';
  }
  return S.size;
}
function isCustomBig(){return S.size==='X'&&S.cw&&S.ch&&(S.cw>210||S.ch>297||S.cw<50||S.ch<50);}
function covPrice(id){
  if(!id)return 0;
  var cv=COVS.find(function(x){return x.id===id;});
  if(!cv)return 0;
  // 표지 개별가(메타객체 price = C사이즈 기준). A/B는 COV_SIZE_ADD 가산, 커스텀은 면적 보간. 카테고리 추가금 없음.
  if(cv.price!=null&&cv.price!==''&&!isNaN(+cv.price)){
    var base=+cv.price;
    var anchors={C:base+COV_SIZE_ADD.C,B:base+COV_SIZE_ADD.B,A:base+COV_SIZE_ADD.A};
    if(S.size==='X'&&S.cw&&S.ch)return lerpByArea(anchors);
    var szk=getSizeKey();
    return anchors[szk]||anchors.C;
  }
  // 폴백(하드코딩 표지): 기존 카테고리 규칙
  var premium=COV_PREMIUMS[cv.cat]||0;
  if(S.size==='X'&&S.cw&&S.ch){
    return lerpByArea(COV_BASE)+premium;
  }
  var sz=getSizeKey();
  return (COV_BASE[sz]||COV_BASE.C)+premium;
}
// 내지 방향: 메타객체 orientation(vertical/horizontal/any) 또는 한글(세로/가로/공용) → portrait/landscape/any
function innOri(inn){
  var v=((inn&&inn.ori)||'').toString().trim().toLowerCase();
  if(v==='세로'||v==='portrait'||v==='vertical')return 'portrait';
  if(v==='가로'||v==='landscape'||v==='horizontal')return 'landscape';
  return 'any';
}
// 플래너는 펼침(스프레드) — 옵션칸/상세/크게보기를 가로로 넓게 표시
// ⚠️ 카테고리 비교는 **정규화해서** 한다 — 값이 로케일마다 번역돼 올 수 있다(COV_CAT_ALIAS 설명).
//    여기가 틀리면 탭이 어긋나는 정도가 아니라 **플래너가 펼침면으로 안 그려진다.**
function innIsSpread(inn){return !!inn&&innCatKey(inn.cat)==='planner';}
// 현재 노트(방향·사이즈)에 이 내지를 선택할 수 있는지
function innAvail(inn){
  var o=innOri(inn);
  if(o!=='any'){
    var nd=(S.dir==='landscape')?'landscape':'portrait';
    if(o!==nd)return {ok:false,reason:'ori',o:o};
  }
  // 플래너는 표준 사이즈(A/B/C)만 — 커스텀 불가
  if(innCatKey(inn.cat)==='planner'&&S.size==='X')return {ok:false,reason:'custom'};
  return {ok:true};
}
// 담긴 내지 중 현재 노트에 안 맞는 것 제거 (개수 반환)
function pruneInners(){
  var removed=0;
  S.inns=S.inns.filter(function(id){
    var inn=INNS.find(function(x){return x.id===id;});
    if(!inn||!innAvail(inn).ok){removed++;return false;}
    return true;
  });
  return removed;
}
function pruneInnersNotify(){
  var r=pruneInners();
  if(r>0)showInnToast(L('현재 노트에 맞지 않는 내지 '+r+'개를 제외했어요.',r+' incompatible inner(s) removed.','現在のノートに合わない中紙を'+r+'点、外しました。'));
}

// 내지 개별가: 메타객체 price(C사이즈 기준). C기준 B +300 / A +500 자동, 커스텀은 면적 보간. 규칙 변경은 INN_SIZE_ADD만.
var INN_SIZE_ADD={C:0,B:300,A:500};
function innPrice(id){
  if(!id)return 0;
  var inn=INNS.find(function(x){return x.id===id;});
  if(!inn)return 0;
  if(inn.price!=null&&inn.price!==''&&!isNaN(+inn.price)&&+inn.price>0){
    var base=+inn.price;
    var anchors={C:base+INN_SIZE_ADD.C,B:base+INN_SIZE_ADD.B,A:base+INN_SIZE_ADD.A};
    if(S.size==='X'&&S.cw&&S.ch)return lerpByArea(anchors);
    var szk=getSizeKey();
    return anchors[szk]||anchors.C;
  }
  // 폴백(하드코딩 데모): 기존 무지/인쇄 표
  var sz=getSizeKey();
  var tbl=inn.tp==='blank'?INN_BLANK:INN_PRINTED;
  if(S.size==='X'&&S.cw&&S.ch)return lerpByArea(tbl);
  return tbl[sz]||tbl.C;
}
function getBandPrice(){var b=BANDS.find(function(x){return x.id===S.band;});return b?b.p:0;}
function totalPrice(){
  var sp=S.springChosen?1500:0,band=getBandPrice();
  var fcp=covPrice(S.fc),bcp=covPrice(S.bcover);
  var ip=S.inns.reduce(function(a,id){return a+innPrice(id);},0);
  var custom=S.size==='X'?10000:0;
  return{sp:sp,band:band,fc:fcp,bc:bcp,inn:ip,custom:custom,
    total:(sp+band+fcp+bcp+ip+custom)*S.qty};
}

// ═══ PREVIEW — SVG ════════════════════════════════════════════════════
function getPrevDim(maxW,maxH){
  var nw,nh;
  if(S.size==='X'){
    var cw=S.cw||182, ch=S.ch||257;
    // 가로형이면 큰 값이 가로, 작은 값이 세로
    if(S.dir==='landscape'){nw=Math.max(cw,ch);nh=Math.min(cw,ch);}
    else{nw=Math.min(cw,ch);nh=Math.max(cw,ch);}
  } else {
    var sz=SIZES.find(function(x){return x.id===S.size;});nw=sz.w;nh=sz.h;
    if(S.dir==='landscape'){var tmp=nw;nw=nh;nh=tmp;}
  }
  var sc=Math.min(maxW/nw,maxH/nh);
  return{W:Math.round(nw*sc),H:Math.round(nh*sc)};
}

// 프리뷰 무대(stage) — A4(최대 사이즈) 비율로 가용 영역을 꽉 채운다.
function getStageBox(maxW,maxH){
  var pw=S.dir==='landscape'?297:210, ph=S.dir==='landscape'?210:297;
  var ar=pw/ph;
  var W=maxW, H=W/ar;
  if(H>maxH){H=maxH;W=H*ar;}
  return{W:Math.round(W),H:Math.round(H)};
}
// 무대 안에서 실제 노트 크기 — A4 대비 실제 mm 비율로 축소(작은 사이즈는 작게).
function getNoteSize(stage){
  var nw,nh;
  if(S.size==='X'){
    var cw=S.cw||182, ch=S.ch||257;
    if(S.dir==='landscape'){nw=Math.max(cw,ch);nh=Math.min(cw,ch);}
    else{nw=Math.min(cw,ch);nh=Math.max(cw,ch);}
  } else {
    var sz=SIZES.find(function(x){return x.id===S.size;});nw=sz.w;nh=sz.h;
    if(S.dir==='landscape'){var t=nw;nw=nh;nh=t;}
  }
  var aw=S.dir==='landscape'?297:210, ah=S.dir==='landscape'?210:297;
  return{
    W:Math.max(8,Math.round(stage.W*Math.min(1,nw/aw))),
    H:Math.max(8,Math.round(stage.H*Math.min(1,nh/ah)))
  };
}

// fit_full: 표지 이미지를 프리뷰에서 자르지 않고 그대로 채울지(예: C 전용 표지).
// 관리자는 true/false(불리언) 필드 권장이지만, 텍스트로 넣는 경우까지 방어적으로 해석한다.
function isFitFull(cov){
  var v=cov&&cov.fitFull;
  if(v===true)return true;
  if(typeof v==='string'){var s=v.trim().toLowerCase();return s==='true'||s==='1'||s==='o'||s==='y'||s==='yes'||s==='on';}
  return false;
}
function getPreviewOpts(W,H){
  var isBack=S.prev==='back';
  var cov=isBack?COVS.find(function(x){return x.id===S.bcover;}):COVS.find(function(x){return x.id===S.fc;});
  var scH=(SC.find(function(x){return x.id===S.sc;})||{h:'#888'}).h;
  var scTopH=(SC.find(function(x){return x.id===S.sc_top;})||{h:'#888'}).h;
  var scBotH=(SC.find(function(x){return x.id===S.sc_bot;})||{h:'#888'}).h;
  var bcH=(BC.find(function(x){return x.id===S.bc;})||{h:'#1C1C1C'}).h;
  var bc1H=(BC.find(function(x){return x.id===S.bc1;})||{h:'#1C1C1C'}).h;
  var bc2H=(BC.find(function(x){return x.id===S.bc2;})||{h:'#1C1C1C'}).h;
  var eyH=(EYELETS.find(function(x){return x.id===S.ey;})||{h:'#2A2A2A'}).h;
  var ey1H=(EYELETS.find(function(x){return x.id===S.ey1;})||{h:'#2A2A2A'}).h;
  var ey2H=(EYELETS.find(function(x){return x.id===S.ey2;})||{h:'#2A2A2A'}).h;
  var covPat=null;
  if(cov){
    if(cov.id==='v15')covPat='owl';
    else if(cov.id==='v14')covPat='floral';
    else if(cov.id==='v16')covPat='stripe';
    else if(cov.id==='v18')covPat='dots';
    else if(cov.cat==='texture'||cov.id==='v17'||cov.id==='v19'||cov.id==='v20')covPat='hatch';
  }
  return{
    W:W,H:H,
    isBack:isBack,
    isLandscape:S.dir==='landscape',
    coverColor:cov?cov.col:'#F5F3EE',
    coverImage:cov&&cov.img?cov.img:'',
    coverFitFull:!!(cov&&isFitFull(cov)),
    coverCat:cov?cov.cat:'',
    coverPattern:(cov&&cov.img)?'':covPat,
    // 선택된 것만 표시
    showSpring:S.springChosen,
    showBand:S.band!=='none',
    springType:S.sp,
    springColor:scH,
    springTopColor:scTopH,
    springBotColor:scBotH,
    bandType:S.band,
    // double=좌/우, corner=상/하 — 둘 다 2색(밴드1/2, 아일렛1/2) 사용
    bandColor:(S.band==='double'||S.band==='corner')?bc1H:bcH,
    band2Color:bc2H,
    eyeletColor:(S.band==='double'||S.band==='corner')?ey1H:eyH,
    eyelet2Color:(S.band==='double'||S.band==='corner')?ey2H:eyH
  };
}

// 무대 안에 실제 비율의 노트를 가운데 배치해 그린다.
function renderStage(el,stage,note){
  el.style.width=stage.W+'px';
  el.style.height=stage.H+'px';
  el.style.display='flex';
  el.style.alignItems='center';
  el.style.justifyContent='center';
  el.style.overflow='visible';
  el.style.visibility='visible';
  el.innerHTML=buildNotePreviewSVG(getPreviewOpts(note.W,note.H));
  var svg=el.querySelector('svg');
  if(svg){
    svg.setAttribute('width', note.W);
    svg.setAttribute('height', note.H);
    svg.style.width=note.W+'px';
    svg.style.height=note.H+'px';
    svg.style.display='block';
    svg.style.overflow='visible';
    svg.style.visibility='visible';
    svg.style.maxWidth='none';
    svg.style.maxHeight='none';
  }
}
// 표시되는 스프링 색이 아주 밝으면(흰색 등) 미리보기 바닥색을 어둡게 해서 스프링이 보이게 한다.
function springIsLight(){
  var ids=S.sp==='full'?[S.sc]:[S.sc_top,S.sc_bot];
  return ids.some(function(id){
    var h=(SC.find(function(x){return x.id===id;})||{}).h;
    if(!h)return false;
    var n=parseInt(h.slice(1),16),r=(n>>16)&255,g=(n>>8)&255,b=n&255;
    return (0.299*r+0.587*g+0.114*b)>225;
  });
}
function previewBgColor(){return springIsLight()?'#bbbbba':'#ECEAE6';}
function drawPreview(){
  var bg=previewBgColor();
  document.querySelectorAll('.nbk-wrap').forEach(function(w){w.style.background=bg;});
  var el=document.getElementById('nbk-svg');
  if(el){
    var availW=el.parentElement?el.parentElement.clientWidth-24:285;
    var mW=Math.min(285,Math.max(190,availW)),mH=mW;
    // 무대는 방향/사이즈와 무관한 정사각 고정 박스 → A는 채우고, 정사각 노트는 방향 무관 동일 크기
    renderStage(el,{W:mW,H:mH},fitNote(mW,mH));
  }
  var mel=document.getElementById('nbk-svg-mobile');
  if(mel){
    var mmW=Math.min(213,Math.round(window.innerWidth*0.57)),mmH=mmW;
    var mNote=fitNote(mmW,mmH);
    // 고정 박스(A 노트 + 여백 기준)에 노트를 가운데 정렬 — 작은 사이즈도 박스는 그대로.
    renderStage(mel,{W:mmW,H:mmH},mNote);
    mel.style.background=bg;mel.style.borderRadius='8px';
    // 앞/뒤/크게 버튼은 위치 고정 (방향·사이즈에 따라 움직이지 않음)
  }
  if(document.getElementById('zoom-bg')&&document.getElementById('zoom-bg').classList.contains('on'))drawZoom();
}

function setPrevSide(v){
  S.prev=v;
  document.querySelectorAll('.ptab').forEach(function(b){
    if(b.id==='ptab-front'||b.id==='ptab-back')b.className='ptab'+(b.id==='ptab-'+v?' act':'');
  });
  document.querySelectorAll('.mobile-ptab').forEach(function(b){
    if(b.id==='m-ptab-front'||b.id==='m-ptab-back')b.className='mobile-ptab'+(b.id==='m-ptab-'+v?' act':'');
  });
  var zf=document.getElementById('ztab-front'),zb=document.getElementById('ztab-back');
  if(zf)zf.className='ptab'+(v==='front'?' act':'');
  if(zb)zb.className='ptab'+(v==='back'?' act':'');
  drawPreview();
}

// ═══ 크게보기 (ZOOM) ═══════════════════════════════════════════════════
// ⚠️ 빌더에서 여는 '크게보기'는 **지금 만들고 있는 조합**을 봐야 한다 → 미리보기 표시를 반드시 끈다.
//    (장바구니 미리보기를 보고 닫은 뒤 크게보기를 누르면 그 조합이 계속 나오던 사고를 막는다.)
function openZoom(){_pmPreviewSnap=null;_pmPreviewLabel='';document.getElementById('zoom-bg').className='zoom-bg on';drawZoom();}
function closeZoom(){document.getElementById('zoom-bg').className='zoom-bg';_pmPreviewSnap=null;_pmPreviewLabel='';}
// 설명창 이미지(표지/내지)를 크게 보는 라이트박스
// 크게보기에 그릴 표지 면을 고른다. 'detail' 이면 디테일 사진 중 detailIdx 번째.
// ⚠️ 옛 호출부 호환: `imgDetail`(단일 필드 키)로 들어와도 디테일 첫 장으로 받는다.
function _zoomCovFace(item,faceKey,detailIdx){
  if(!faceKey||faceKey==='img')return item;
  if(faceKey==='detail'||faceKey==='imgDetail'){
    var s=covDetailShots(item);
    if(!s.length)return item;
    return Object.assign({},item,{img:s[Math.min(Math.max(detailIdx||0,0),s.length-1)]});
  }
  return Object.assign({},item,{img:item[faceKey]});
}
// 크게보기에 쓸 **고해상도** URL. 없으면 일반 해상도로 떨어지고, 그것도 없으면 ''(→ 캔버스로 그린다).
// 🔴 이게 돋보기 선명도를 좌우한다 — 렌즈는 이 이미지의 naturalWidth 로 원본을 다시 샘플링한다.
//    캔버스로 그리면 백킹(810px)이 상한이라 실효 배율이 1배 아래로 떨어진다(2026-08-16 실측 0.93배).
function _zoomCovSrc(item,faceKey,detailIdx){
  if(!item)return '';
  if(!faceKey||faceKey==='img')return item.imgHi||item.img||'';
  if(faceKey==='imgBack')return item.imgBackHi||item.imgBack||'';
  if(faceKey==='detail'||faceKey==='imgDetail'){
    var hi=((item.imgsDetailHi)||[]).filter(Boolean);
    var lo=covDetailShots(item);
    if(!lo.length)return item.imgHi||item.img||'';
    var i=Math.min(Math.max(detailIdx||0,0),lo.length-1);
    // ⚠️ 고해상도 목록이 저해상도 목록과 **길이가 다를 수 있다**(옛 단일 필드로 폴백한 경우).
    //    번호가 어긋나면 엉뚱한 사진이 뜨므로, 길이가 같을 때만 고해상도를 쓴다.
    if(hi.length===lo.length)return hi[i];
    if(lo.length===1&&item.imgDetailHi)return item.imgDetailHi;
    return lo[i];
  }
  return item[faceKey]||'';
}
// faceKey: 'img' | 'imgBack' | 'detail'(표지 디테일 사진) · detailIdx: 디테일 중 몇 번째 장인지
function openImgZoom(kind,item,faceKey,detailIdx){
  var stage=document.getElementById('imgzoom-stage'),cap=document.getElementById('imgzoom-cap');
  var _box=stage.closest('.imgzoom-box');   // 펼침·가로 노트(가로로 넓은) 이미지는 상자를 넓게
  var _wideZoom=(kind==='inn'&&(innIsSpread(item)||S.dir==='landscape'));
  if(_box)_box.className='imgzoom-box'+(_wideZoom?' wide':'');
  var _oc=stage.querySelector('canvas,img'); if(_oc)_oc.remove();   // 배지(#imgzoom-badge)는 유지
  var _bd=document.getElementById('imgzoom-badge'); if(_bd)_bd.classList.remove('hidden');
  var canvas;
  if(kind==='inn'&&item.img){
    // 실사 내지: <img> 로 크게보기 — 원본(1600px)을 브라우저가 어떤 dpr·상자폭에서도 선명히 렌더.
    // (캔버스는 백킹 고정이라 상자를 넓히면 레티나에서 오히려 흐려졌다. 돋보기 렌즈는
    //  setupImgZoomLens 가 naturalWidth 로 원본을 다시 샘플링 → 캔버스보다 오히려 선명.)
    canvas=document.createElement('img');canvas.className='imgzoom-media';canvas.alt='';canvas.src=item.imgHi||item.img;
    cap.textContent=pickLang(item.n,item.nEn);
  } else if(kind==='inn'){
    // 패턴(데모, img 없음)만 캔버스
    canvas=document.createElement('canvas');
    if(innIsSpread(item)){ canvas.width=1120;canvas.height=680; drawInnThumb(canvas,item,680,1120,{spread:true}); }
    else if(S.dir==='landscape'){ var LW=108,LH=80;canvas.width=1080;canvas.height=800;canvas.getContext('2d').scale(1080/LW,800/LH);drawInnThumb(canvas,item,LH,LW); }
    else { var IW=80,IH=108;canvas.width=800;canvas.height=1080;canvas.getContext('2d').scale(800/IW,1080/IH);drawInnThumb(canvas,item,IH); }
    cap.textContent=pickLang(item.n,item.nEn);
  } else {
    // 🔴 실사 표지는 **`<img>` 로** 크게 본다(2026-08-16). 캔버스는 백킹(810px)이 상한이라
    //    돋보기 렌즈가 줄어든 픽셀을 다시 확대해 실효 배율이 0.93배(= 확대 아님)였다.
    //    `<img>` 면 렌즈가 naturalWidth 로 원본을 직접 샘플링한다.
    // ⚠️ 그때 「내지와 같은 3.0배」라고 적었는데 **틀렸다**(2026-08-22 실측으로 바로잡음).
    //    배율은 «원본 해상도»가 정한다 — 실효배율 = IMGZOOM_MAG × (naturalWidth / 표시폭).
    //      내지 2600px → 436px 표시 → 2.98배 ✅   표지 1200px → 400px 표시 → **1.5배**
    //    표지 원본이 1200px 이라 절반밖에 안 나온다. 배율을 억지로 올리면 소스를 늘려 그려야 해
    //    흐려질 뿐이다 — **표지 사진을 다시 찍어 올리는 것 말고는 방법이 없다.**
    //    이미지가 없는 데모 패턴 표지만 예전처럼 캔버스로 그린다.
    var _cs=_zoomCovSrc(item,faceKey,detailIdx);
    if(_cs){
      canvas=document.createElement('img');canvas.className='imgzoom-media';canvas.alt='';canvas.src=_cs;
    }else{
      canvas=document.createElement('canvas');
      canvas.width=810;canvas.height=1080;
      drawCovThumb(canvas,_zoomCovFace(item,faceKey,detailIdx));
    }
    cap.textContent=item.n;
  }
  stage.appendChild(canvas);
  // 면 전환 버튼(앞/뒤/디테일) — 설명칸과 같은 규칙: 있는 이미지만 버튼을 만든다.
  // 표지에만 해당하고, 면이 하나뿐이면 버튼 자체를 안 띄운다.
  var oldFaces=document.getElementById('imgzoom-faces'); if(oldFaces)oldFaces.remove();
  // 디테일 넘김 장치(화살표·점)는 면 버튼과 별개로 매번 새로 만든다
  var oldNav=document.getElementById('imgzoom-nav'); if(oldNav)oldNav.remove();
  var oldDots=document.getElementById('imgzoom-dots'); if(oldDots)oldDots.remove();
  if(kind==='cov'){
    var shotsZ=covDetailShots(item);
    // 상세 토글(showCovDetail 의 faceDefs)과 **같은 말**을 쓴다 — 한쪽만 바꾸면 크게보기에서 다시 「앞면」이 나온다.
    var fdefs=[{key:'img',ko:'겉면',en:'Outside',ja:'外側'}];
    if(item.imgBack)fdefs.push({key:'imgBack',ko:'안쪽',en:'Inside',ja:'内側'});
    if(shotsZ.length)fdefs.push({key:'detail',ko:'디테일',en:'Details',ja:'ディテール'});
    var zFace=(faceKey==='imgDetail')?'detail':(faceKey||'img');
    var zIdx=Math.min(Math.max(detailIdx||0,0),Math.max(shotsZ.length-1,0));
    // 🔴 **크게보기에는 스와이프를 걸지 않는다.** 여기선 누른 채 이동이 '확대'(렌즈)라 제스처가 싸운다
    //    — setupPreviewSwipe 위 주석에 그 이유가 실측으로 남아 있다. 넘김은 화살표 버튼이 맡는다.
    var nav=document.createElement('div');nav.className='imgzoom-nav';nav.id='imgzoom-nav';
    var dotsZ=document.createElement('div');dotsZ.className='imgzoom-dots';dotsZ.id='imgzoom-dots';
    function paintZ(){
      var many=(zFace==='detail'&&shotsZ.length>1);
      nav.style.display=many?'':'none';
      dotsZ.style.display=many?'flex':'none';
      dotsZ.innerHTML='';
      if(many)shotsZ.forEach(function(_,i){
        var d=document.createElement('span');d.className='cov-dot'+(i===zIdx?' on':'');dotsZ.appendChild(d);
      });
    }
    function drawZ(){
      // ⚠️ 요소가 `<img>`(실사)일 수도 캔버스(데모 패턴)일 수도 있다. 만들 때 정해진 쪽을 그대로 쓴다 —
      //    도중에 요소를 바꾸면 렌즈·레이아웃이 한 번 튄다.
      var s=_zoomCovSrc(item,zFace,zIdx);
      if(canvas.tagName==='IMG'){ if(s)canvas.src=s; }
      else drawCovThumb(canvas,_zoomCovFace(item,zFace,zIdx));
      setupImgZoomLens(canvas);   // 렌즈는 소스 픽셀을 다시 읽으므로 그림을 바꾸면 다시 걸어준다
      paintZ();
    }
    [['prev','‹',-1],['next','›',1]].forEach(function(p){
      var a=document.createElement('button');a.type='button';
      a.className='imgzoom-arrow '+p[0];a.textContent=p[1];
      a.title=p[2]<0?L('이전 사진','Previous','前の写真'):L('다음 사진','Next','次の写真');
      a.onclick=function(e){
        e.stopPropagation();        // 화살표는 확대(렌즈)로 이어지지 않게
        zIdx=(zIdx+p[2]+shotsZ.length)%shotsZ.length;
        drawZ();
      };
      nav.appendChild(a);
    });
    stage.appendChild(nav);stage.appendChild(dotsZ);
    if(fdefs.length>1){
      var fwrap=document.createElement('div');fwrap.className='imgzoom-faces';fwrap.id='imgzoom-faces';
      var fbtns=[];
      var showF=function(i){
        zFace=fdefs[i].key;
        if(zFace==='detail')zIdx=0;   // 디테일로 들어올 땐 늘 첫 장부터
        drawZ();
        fbtns.forEach(function(b,j){b.className='cov-face-btn'+(j===i?' act':'');});
      };
      fdefs.forEach(function(fd,i){
        var b=document.createElement('button');b.type='button';
        b.textContent=L(fd.ko,fd.en,fd.ja);
        b.onclick=function(){showF(i);};
        fwrap.appendChild(b);fbtns.push(b);
      });
      var activeIdx=0;
      fdefs.forEach(function(fd,i){ if(fd.key===zFace)activeIdx=i; });
      stage.parentNode.insertBefore(fwrap,stage.nextSibling);
      fbtns.forEach(function(b,j){b.className='cov-face-btn'+(j===activeIdx?' act':'');});
    }
    paintZ();
  }
  document.getElementById('imgzoom-hint').textContent=t('imgzoom-hint');
  document.getElementById('imgzoom-note').textContent=L(
    '모든 파트는 하나씩 수작업으로 완성되기 때문에 실제와 약간의 차이가 있을 수 있습니다.',
    'Every part is handcrafted one by one, so the actual product may differ slightly.',
    'すべてのパーツを一つずつ手作業で仕上げているため、実物と多少の違いが生じる場合があります。');
  document.getElementById('imgzoom-bg').className='imgzoom-bg on';
  var _zb=document.getElementById('imgzoom-badge');   // 이미지 오른쪽 하단에 맞춤(가운데 정렬 여백 보정)
  if(_zb){var _gap=Math.max(0,(stage.clientWidth-canvas.offsetWidth)/2); _zb.style.right=(_gap+8)+'px';}
  setupImgZoomLens(canvas);
}
// 크게보기 돋보기 렌즈: 원본 캔버스에서 커서(터치) 주변을 다시 확대 샘플링 → 축소로 잃은 디테일 복원
var IMGZOOM_LENS=220, IMGZOOM_MAG=0.5;
// 🔴 렌즈 캔버스는 «백킹»을 화면 픽셀에 맞춰야 한다(2026-08-22).
//    CSS 는 220px 인데 백킹도 220 이면, dpr=2 인 맥에서 브라우저가 440 화면픽셀로 늘려 그린다
//    — 소스를 아무리 선명하게 샘플링해도 «렌즈 자체»가 절반 해상도라 흐려 보였다.
//    소스 영역(sr)은 그대로라 «배율은 안 바뀐다». 같은 배율을 두 배 촘촘하게 그릴 뿐이다.
//    ⚠️ 2 로 상한을 둔다 — dpr 3 까지 올리면 소스(sr=440)를 늘려 그려야 해서 도로 흐려진다.
function _lensDpr(){ return Math.min(window.devicePixelRatio||1, 2); }
function setupImgZoomLens(src){
  var lens=document.getElementById('imgzoom-lens'); if(!lens)return;
  var _lpx=Math.round(IMGZOOM_LENS*_lensDpr());
  lens.width=_lpx; lens.height=_lpx;          // 백킹(화면 픽셀) — CSS 크기는 220px 그대로다
  var lctx=lens.getContext('2d');
  var badge=document.getElementById('imgzoom-badge'), _lensBelow=false;
  function hide(){lens.style.display='none'; if(badge)badge.classList.remove('hidden');}
  function at(clientX,clientY,isTouch){
    var r=src.getBoundingClientRect();
    if(isTouch){                               // 터치: 이미지 밖으로 나가도 숨기지 말고 가장자리로 클램프(하단 튐 방지)
      clientX=Math.max(r.left,Math.min(r.right,clientX));
      clientY=Math.max(r.top,Math.min(r.bottom,clientY));
    }else if(clientX<r.left||clientX>r.right||clientY<r.top||clientY>r.bottom){hide();return;}
    if(badge)badge.classList.add('hidden');   // 확대 중엔 돋보기 아이콘 숨김
    // 소스가 <img>면 자연 해상도(naturalWidth)로 샘플링(캔버스면 backing width). 원본을 직접 확대해 선명.
    var sW=src.naturalWidth||src.width, sH=src.naturalHeight||src.height;
    var sx=sW/r.width, sy=sH/r.height;
    var sr=IMGZOOM_LENS/IMGZOOM_MAG;
    var cx=(clientX-r.left)*sx, cy=(clientY-r.top)*sy;
    cx=Math.max(sr/2,Math.min(sW-sr/2,cx));   // 가장자리에서도 렌즈 꽉 차게
    cy=Math.max(sr/2,Math.min(sH-sr/2,cy));
    lctx.clearRect(0,0,_lpx,_lpx);
    lctx.imageSmoothingEnabled=true; lctx.imageSmoothingQuality='high';
    lctx.drawImage(src, cx-sr/2, cy-sr/2, sr, sr, 0,0, _lpx,_lpx);   // 백킹 전체에 그린다(=화면 픽셀)
    var lx=clientX-IMGZOOM_LENS/2, ly;
    if(isTouch){                       // 터치: 위/아래를 touchstart에서 한 번 정하고 드래그 내내 고정(튐 방지)
      ly=_lensBelow?(clientY+44):(clientY-IMGZOOM_LENS-44);
    }else{                             // 마우스: 커서 위에
      ly=clientY-IMGZOOM_LENS-16; if(ly<6)ly=clientY+24;
    }
    lx=Math.max(6,Math.min(window.innerWidth-IMGZOOM_LENS-6,lx));
    ly=Math.max(6,Math.min(window.innerHeight-IMGZOOM_LENS-6,ly));
    lens.style.left=lx+'px'; lens.style.top=ly+'px'; lens.style.display='block';
  }
  // Pointer Events 로 마우스·터치를 통합한다. (구 touch/mouse 핸들러는 터치에서 렌즈가 안 뜨는
  // 문제가 있었다 — 2026-07-20.) 마우스=hover 로 확대, 터치=누른 채 드래그로 확대.
  // setPointerCapture 로 손가락이 이미지를 벗어나도 move 를 계속 받아 렌즈가 끊기지 않는다.
  // (캔버스 CSS 에 touch-action:none 이 있어야 드래그가 스크롤로 새지 않는다 — 이미 지정됨.)
  var _pDown=false;
  src.onpointerdown=function(e){
    if(e.pointerType!=='mouse'){                     // 터치·펜: 눌러서 시작
      _pDown=true; try{src.setPointerCapture(e.pointerId);}catch(_e){}
      _lensBelow=(e.clientY < IMGZOOM_LENS+60);       // 위/아래를 시작할 때 한 번 정해 드래그 내내 고정
      at(e.clientX,e.clientY,true); e.preventDefault();
    }
  };
  src.onpointermove=function(e){
    if(e.pointerType==='mouse'){ at(e.clientX,e.clientY,false); }  // 마우스: hover 로 확대
    else if(_pDown){ at(e.clientX,e.clientY,true); e.preventDefault(); }
  };
  src.onpointerup=src.onpointercancel=function(e){ if(e.pointerType!=='mouse'){ _pDown=false; hide(); } };
  src.onpointerleave=function(e){ if(e.pointerType==='mouse') hide(); };  // 마우스가 이미지 밖으로
}
function closeImgZoom(){document.getElementById('imgzoom-bg').className='imgzoom-bg';var l=document.getElementById('imgzoom-lens');if(l)l.style.display='none';}
// 내지 상세 영상 팝업 — 유튜브를 16:9 라이트박스로 크게 재생. 닫으면 iframe 을 비워 정지.
function openVidPop(u){
  var url=ytEmbed(u);if(!url)return;
  var f=document.getElementById('vidpop-frame');f.innerHTML='';
  var ifr=document.createElement('iframe');ifr.src=url;ifr.loading='lazy';
  ifr.setAttribute('frameborder','0');
  ifr.setAttribute('allow','autoplay; encrypted-media; picture-in-picture');
  ifr.setAttribute('allowfullscreen','');
  f.appendChild(ifr);
  document.getElementById('vidpop-bg').className='vidpop-bg on';
}
function closeVidPop(){document.getElementById('vidpop-bg').className='vidpop-bg';document.getElementById('vidpop-frame').innerHTML='';}

/* ── SIZE TIP (사이즈 가이드) ──────────────────────────────────────────────
   도해를 <img> 가 아니라 fetch → DOM 인라인으로 넣는다.
   <img> 는 독립 문서라 페이지 폰트가 안 닿아, 원본이 지정한 Pretendard/Myriad Pro 를
   못 찾고 시스템 폴백(아이폰=세리프 Times)으로 떨어진다 — guide-01~03 이 겪었던 문제다.
   인라인하면 페이지 CSS(#sizetip-fig svg text)가 닿아 사이트와 같은 Pretendard 로 렌더된다.  */
// 🔴 도해 안의 글자는 **SVG 파일에 박혀 있어** 언어 토글로 못 바꾼다(2026-08-13 대표님 지적).
//    그래서 영문판 SVG(`size-tip-en.svg`)를 따로 두고 언어에 따라 갈아끼운다.
//    ⚠️ 아직 그 파일이 없어도 안전하다 — 받아오지 못하면 **한글판으로 되돌린다**(loadSizeTipSvg 의 canFallback).
//    파일을 assets 에 올리기만 하면 그때부터 자동으로 영문이 뜬다. 코드는 더 고칠 것이 없다.
var _sizeTipLoadedLang=null,_sizeTipLoading=false;
function sizeTipUrlKo(){
  // 라이브: build 가 asset_url 주입 / 로컬 단독 열람: 같은 폴더의 심볼릭 링크.
  return window.PAPERME_SIZETIP_URL||'size-tip.svg';
}
function sizeTipUrl(){
  // 2026-08-14: 일본어판(`size-tip-ja.svg`)도 같은 방식으로 갈아끼운다. 파일이 없으면 아래 폴백이 받아준다.
  if(LANG==='ja'&&window.PAPERME_SIZETIP_URL_JA)return window.PAPERME_SIZETIP_URL_JA;
  if(LANG==='en'&&window.PAPERME_SIZETIP_URL_EN)return window.PAPERME_SIZETIP_URL_EN;
  return sizeTipUrlKo();
}
/* 원본 SVG 의 viewBox 는 일러스트레이터 아트보드 전체(0 0 460.74 533.33)라 내용이 왼쪽 위에
   몰려 있고 나머지가 빈 여백이다. 좌표를 손으로 박아두면 재export 할 때마다 다시 깨지므로
   (guide-01~03 이 그래서 매번 크롭을 복원해야 한다) 실제 렌더된 내용의 bbox 를 재서 맞춘다. */
function cropSizeTip(svg){
  try{
    var b=svg.getBBox(); if(!b||!b.width||!b.height)return;
    var pad=Math.max(b.width,b.height)*0.02;
    svg.setAttribute('viewBox',(b.x-pad)+' '+(b.y-pad)+' '+(b.width+pad*2)+' '+(b.height+pad*2));
    svg.removeAttribute('width'); svg.removeAttribute('height');
  }catch(e){}
}
function openSizeTip(){
  var bg=document.getElementById('sizetip-bg'),fig=document.getElementById('sizetip-fig');
  document.getElementById('sizetip-ttl').textContent=t('sizetip-ttl');
  document.getElementById('sizetip-note').textContent=t('sizetip-note');
  document.getElementById('sizetip-scrollhint').textContent=t('sizetip-scrollhint');
  bg.className='sizetip-bg on';
  // ⚠️ 언어별로 다른 파일이므로 **언어가 바뀌면 다시 받아야 한다** — 그래서 '받았는지'가 아니라 '어느 언어로 받았는지'를 기억한다.
  if(_sizeTipLoadedLang===LANG||_sizeTipLoading)return;
  _sizeTipLoading=true;
  fig.innerHTML='<div class="sizetip-err">'+t('sizetip-loading')+'</div>';
  // 영문판을 시도하는 경우에만 한글판으로 되돌릴 여지를 준다(한글판까지 실패하면 이미지 폴백).
  loadSizeTipSvg(sizeTipUrl(), sizeTipUrl()!==sizeTipUrlKo());
}
function loadSizeTipSvg(url,canFallback){
  var fig=document.getElementById('sizetip-fig');
  fetch(url).then(function(r){
    if(!r.ok)throw new Error(r.status); return r.text();
  }).then(function(txt){
    fig.innerHTML=txt;
    var svg=fig.querySelector('svg'); if(!svg)throw new Error('no svg');
    svg.setAttribute('role','img');
    svg.setAttribute('aria-label',t('sizetip-ttl'));
    // 글꼴이 바뀌면 글자 폭이 달라져 bbox 도 달라진다 → 폰트 로드가 끝난 뒤에 잰다.
    (document.fonts&&document.fonts.ready?document.fonts.ready:Promise.resolve())
      .then(function(){cropSizeTip(svg);});
    _sizeTipLoadedLang=LANG; _sizeTipLoading=false;
  }).catch(function(){
    // 영문판이 아직 없으면 한글판으로 되돌린다 — 빈 화면보다 낫다.
    if(canFallback){ loadSizeTipSvg(sizeTipUrlKo(),false); return; }
    _sizeTipLoading=false;
    // 못 받아오면 최소한 그림은 보이게 <img> 로 폴백(글꼴은 시스템 폴백이 됨).
    fig.innerHTML='<img src="'+sizeTipUrlKo()+'" alt="" style="width:100%;height:auto;display:block">';
  });
}
function closeSizeTip(){document.getElementById('sizetip-bg').className='sizetip-bg';}
document.addEventListener('keydown',function(e){
  if(e.key!=='Escape')return;
  var vp=document.getElementById('vidpop-bg');
  if(vp&&vp.classList.contains('on')){closeVidPop();return;}
  var st=document.getElementById('sizetip-bg');
  if(st&&st.classList.contains('on')){closeSizeTip();return;}
  var iz=document.getElementById('imgzoom-bg');
  if(iz&&iz.classList.contains('on'))closeImgZoom();
});
// ── 장바구니 미리보기 (2026-08-16 대표님 요청) ────────────────────────────
// "편집으로 다시 안 가도 어떤 노트였는지 확인할 수 있으면 좋겠다."
// 🔴 **크게보기 장치를 그대로 재사용한다** — 새 팝업을 만들면 핀치 확대·배경색·비율 계산을
//    통째로 복사해야 하고, 그 순간부터 둘이 갈린다(#13). 여기서는 **무엇을 그릴지만** 바꾼다.
// 🔴 `S` 는 빌더의 전역 상태다. 잠깐 갈아끼우고 **반드시 finally 로 되돌린다**
//    (withComboState 가 쓰는 것과 같은 수법 — 안 되돌리면 편집 화면이 장바구니 조합으로 바뀐다).
// ⚠️ S 를 갈아끼우는 helper 는 **이미 있다**(`withFullSnap`, 위시 복원이 쓴다). 새로 만들지 않는다(#13).
var _pmPreviewSnap=null, _pmPreviewLabel='';
// 장바구니 항목 미리보기 열기. 편집(loadCfg)과 달리 **화면을 바꾸지 않는다** — 팝업만 띄운다.
function previewCartItem(i,label){
  var it=CART[i]; if(!it)return;
  // SIGNATURE·ACC 는 조합이 아니라 상품이다 → 상품 사진을 이미지 라이트박스로 띄운다(2026-08-16 대표님 지적).
  if(it.kind==='product'){
    if(!it.img)return;
    openImgZoom('cov',{n:it.title,img:it.img});
    return;
  }
  if(!it.snap)return;
  _pmPreviewSnap=it.snap; _pmPreviewLabel=label||'';
  document.getElementById('zoom-bg').className='zoom-bg on';
  drawZoom();
}
// ⚠️ 창 크기가 바뀌면 drawZoom 이 다시 불린다 — 그때도 **미리보기 조합이 유지돼야** 하므로
//    스냅을 여기서(그리는 시점에) 적용한다. 열 때 한 번만 갈아끼우면 리사이즈에서 원래 조합으로 돌아간다.
// 🔴 **`prev`(앞/뒷면)만은 스냅에서 가져오지 않는다.** 그러면 앞면·뒷면 버튼을 눌러도
//    다시 그릴 때 스냅의 값으로 덮여 **아무 반응이 없다**(2026-08-16 대표님 지적 — 실제로 그랬다).
//    `prev` 는 조합이 아니라 **화면 상태**다(위시 중복 판정에서도 같은 이유로 걷어낸다).
function drawZoom(){
  if(_pmPreviewSnap){
    var livePrev=S.prev;
    return withFullSnap(_pmPreviewSnap,function(){ S.prev=livePrev; return drawZoomNow(); });
  }
  return drawZoomNow();
}
function drawZoomNow(){
  var st=document.getElementById('zoom-stage');if(!st)return;
  st.style.background=previewBgColor();
  // 크게보기는 노트를 화면 가득(실제 비율 그대로) 크게 보여준다.
  var maxW=Math.min(440,window.innerWidth-100);
  var maxH=Math.min(Math.round(window.innerHeight*0.6),600);
  var vb=notePreviewVB(),ar=vb.w/vb.h,dW=maxW,dH=dW/ar;
  if(dH>maxH){dH=maxH;dW=dH*ar;}
  var dim={W:Math.round(dW),H:Math.round(dH)};
  st.innerHTML=buildNotePreviewSVG(getPreviewOpts(dim.W,dim.H));
  var svg=st.querySelector('svg');
  if(svg){
    svg.setAttribute('width',dim.W);svg.setAttribute('height',dim.H);
    svg.style.width=dim.W+'px';svg.style.height=dim.H+'px';
    svg.style.display='block';svg.style.overflow='visible';
    svg.style.maxWidth='none';svg.style.maxHeight='none';
  }
  if(svg)setupZoomPan(st,svg);   // 핀치 확대 + 드래그 이동 (다시 그릴 때마다 배율 초기화)
  var zh=document.getElementById('zoom-hint'); if(zh)zh.textContent=t(_zIsMouse()?'zoom-hint-mouse':'zoom-hint');   // 기기에 맞는 조작법
  var sz=SIZES.find(function(x){return x.id===S.size;});
  var dimStr=S.size==='X'?((S.cw||'?')+'×'+(S.ch||'?')+'mm'):(sz.id+L(' 사이즈 · ',' · ',' サイズ · ')+sz.w+'×'+sz.h+'mm');
  var dirStr=S.dir==='landscape'?t('dir-landscape'):t('dir-portrait');
  // 미리보기로 열었으면 어느 항목인지 앞에 붙인다(장바구니에 여러 권일 때 헷갈리지 않게).
  document.getElementById('zoom-cap').textContent=(_pmPreviewLabel?(_pmPreviewLabel+' · '):'')+dimStr+' · '+dirStr;
}

// ── 크게보기 팝업 핀치 확대 + 드래그 이동 ──────────────────────────────────
// 조립 노트 크게보기는 원래 확대 기능이 없어(정적 SVG) 손으로 확대가 안 됐다(2026-07-20 지적).
// 뷰(무대)는 고정, 노트만 transform 으로 키운다. transform-origin:0 0 기준으로
// 배율 _zS, 이동 _zTX/_zTY 를 잡는다. Pointer Events 라 마우스·터치 통합.
var _zStage=null,_zTarget=null,_zBase=null,_zS=1,_zTX=0,_zTY=0;
var _zPtrs=new Map(),_zPinch=null,_zTapT=0,_zTapX=0,_zTapY=0;
function _zApply(){ if(_zTarget)_zTarget.style.transform='translate('+_zTX+'px,'+_zTY+'px) scale('+_zS+')'; }
function _zClamp(){
  if(!_zBase||!_zStage)return;
  var sr=_zStage.getBoundingClientRect(),m=44;
  var w=_zBase.w*_zS,h=_zBase.h*_zS,left=_zBase.left+_zTX,top=_zBase.top+_zTY;
  if(left>sr.right-m)_zTX=(sr.right-m)-_zBase.left;
  if(left+w<sr.left+m)_zTX=(sr.left+m-w)-_zBase.left;
  if(top>sr.bottom-m)_zTY=(sr.bottom-m)-_zBase.top;
  if(top+h<sr.top+m)_zTY=(sr.top+m-h)-_zBase.top;
}
// 커서는 «지금 클릭하면 무엇이 되나»를 말해야 한다(2026-09-15). 1배면 확대(zoom-in), 확대 중이면 축소(zoom-out),
// 끌고 있는 동안만 grabbing. 예전엔 확대 중에 grab 을 띄웠는데, 1배에서 zoom-in 인데 클릭해도 아무 일이 없었다 — 아래 setupZoomPan.
function _zCursor(dragging){ if(!_zStage)return; _zStage.style.cursor=dragging?'grabbing':(_zS>1?'zoom-out':'zoom-in'); }
function _zSettle(){                 // 제스처가 끝났을 때만 경계 정리(핀치 도중엔 안 건드려 매끄럽게)
  if(_zS<=1.001){_zS=1;_zTX=0;_zTY=0;} else _zClamp();
  _zApply(); _zCursor(false);
}
function _zZoomTo(s2,px,py,live){    // px,py = 확대 기준점(뷰포트 좌표). live=true 면 제스처 도중(클램프·리셋 생략)
  s2=Math.max(1,Math.min(5,s2));
  if(!_zBase)return;
  var fx=(px-(_zBase.left+_zTX))/(_zBase.w*_zS);   // 기준점이 노트 안에서 차지하는 비율
  var fy=(py-(_zBase.top+_zTY))/(_zBase.h*_zS);
  _zTX=px-_zBase.left-fx*_zBase.w*s2;              // 그 비율이 배율 후에도 기준점에 오도록 이동 보정
  _zTY=py-_zBase.top-fy*_zBase.h*s2;
  _zS=s2;
  if(live){ _zApply(); }                           // 도중엔 클램프/리셋 없이 손가락만 따라감(튐 방지)
  else _zSettle();
  _zCursor(false);
}
// 마우스(정밀 포인터)인가 — 안내 문구와 클릭 동작을 가른다. 터치 노트북처럼 둘 다 되는 기기는 마우스 쪽으로 본다.
function _zIsMouse(){ try{ return window.matchMedia&&window.matchMedia('(hover:hover) and (pointer:fine)').matches; }catch(e){ return false; } }
function setupZoomPan(st,target){
  _zStage=st; _zTarget=target;
  _zPtrs.clear(); _zPinch=null;
  target.style.transform='none';                  // 기준(1배·이동0) 위치를 잰다
  var r=target.getBoundingClientRect();
  _zBase={left:r.left,top:r.top,w:r.width,h:r.height};
  _zS=1;_zTX=0;_zTY=0; _zApply(); _zCursor(false);
  // 🔴 마우스는 «클릭 한 번»이 확대/축소다(2026-09-15 대표님: "데스크톱에서 돋보기가 안 되는 것 같다").
  //    전엔 더블클릭·휠만 있었고 커서는 zoom-in 이라, 클릭하면 될 것처럼 보이는데 아무 일도 안 났다.
  //    클릭인지 끌기인지는 pointerup 에서 «움직인 거리»로 가른다(4px 이하 = 클릭). 더블탭 판정은 터치에만 남긴다 —
  //    마우스에도 두면 두 번째 클릭이 down(더블탭)과 up(클릭)에서 두 번 토글돼 제자리로 돌아온다.
  var _mDown=null;   // 마우스 누른 자리 {x,y,moved}
  st.onpointerdown=function(e){
    try{st.setPointerCapture(e.pointerId);}catch(_e){}
    _zPtrs.set(e.pointerId,{x:e.clientX,y:e.clientY});
    if(e.pointerType==='mouse'){ _mDown={x:e.clientX,y:e.clientY,moved:false}; if(_zS>1)_zCursor(true); }
    if(_zPtrs.size===2){
      var p=[..._zPtrs.values()];
      _zPinch={d:Math.hypot(p[0].x-p[1].x,p[0].y-p[1].y),s:_zS};
      _zTapT=0;                   // 핀치는 더블탭 후보에서 제외(핀치 직후 오탐 방지)
    }else if(_zPtrs.size===1&&e.pointerType!=='mouse'){    // 더블탭(터치) 감지: 짧은 간격·가까운 위치의 두 번째 탭
      var now=Date.now();
      if(now-_zTapT<300&&Math.abs(e.clientX-_zTapX)<24&&Math.abs(e.clientY-_zTapY)<24){
        _zZoomTo(_zS>1?1:2.5,e.clientX,e.clientY); _zTapT=0;
      }else{_zTapT=now;_zTapX=e.clientX;_zTapY=e.clientY;}
    }
    e.preventDefault();
  };
  st.onpointermove=function(e){
    if(!_zPtrs.has(e.pointerId))return;
    var prev=_zPtrs.get(e.pointerId);
    _zPtrs.set(e.pointerId,{x:e.clientX,y:e.clientY});
    if(_mDown&&e.pointerType==='mouse'&&(Math.abs(e.clientX-_mDown.x)>4||Math.abs(e.clientY-_mDown.y)>4))_mDown.moved=true;
    if(_zPtrs.size>=2&&_zPinch){
      var p=[..._zPtrs.values()];
      var d=Math.hypot(p[0].x-p[1].x,p[0].y-p[1].y);
      _zZoomTo(_zPinch.s*(d/_zPinch.d),(p[0].x+p[1].x)/2,(p[0].y+p[1].y)/2,true); // live
    }else if(_zPtrs.size===1&&_zS>1){
      _zTX+=e.clientX-prev.x; _zTY+=e.clientY-prev.y; _zClamp(); _zApply();
    }
    e.preventDefault();
  };
  function up(e){
    _zPtrs.delete(e.pointerId); if(_zPtrs.size<2)_zPinch=null;
    var click=(e.type==='pointerup'&&e.pointerType==='mouse'&&_mDown&&!_mDown.moved); _mDown=null;
    if(_zPtrs.size===0)_zSettle();
    if(click)_zZoomTo(_zS>1?1:2.5,e.clientX,e.clientY);   // 클릭 = 확대 ↔ 원래대로(누른 자리를 기준으로)
  }
  st.onpointerup=up; st.onpointercancel=up;
  st.onwheel=function(e){ e.preventDefault(); _zZoomTo(_zS*(e.deltaY<0?1.15:1/1.15),e.clientX,e.clientY); };
}

// ═══ SPRING ICONS ═════════════════════════════════════════════════════
function refreshSpIcons(){
  var scH=(SC.find(function(x){return x.id===S.sc;})||{h:'#888'}).h;
  var scTopH=(SC.find(function(x){return x.id===S.sc_top;})||{h:'#888'}).h;
  var scBotH=(SC.find(function(x){return x.id===S.sc_bot;})||{h:'#888'}).h;
  // 외곽 svg viewBox도 방향에 맞춰 갱신(가로형이면 가로 비율)
  var orient=S.dir==='landscape'?'landscape':'portrait';
  var vb=PM_VIEWBOXES[orient];
  var vbStr=fmt(vb.x0)+' '+fmt(vb.y0)+' '+fmt(vb.w)+' '+fmt(vb.h);

  // 풀 스프링 아이콘
  var fullEl=document.getElementById('sp-svg-full');
  if(fullEl){fullEl.setAttribute('viewBox',vbStr);fullEl.innerHTML=buildSpringIconSVG('full',scH,scH);}
  // 분리형 아이콘
  var splitEl=document.getElementById('sp-svg-split');
  if(splitEl){splitEl.setAttribute('viewBox',vbStr);splitEl.innerHTML=buildSpringIconSVG('split',scTopH,scBotH);}
}

function buildSpringIconSVG(type,c1,c2){
  var orient = S.dir === 'landscape' ? 'landscape' : 'portrait';
  var vb = PM_VIEWBOXES[orient];
  var s = '';
  if(type === 'full'){
    s += PM_ICON_PARTS[orient+'-icon-note-full'] || '';
    s += '<g style="color:'+c1+'">'+(PM_ICON_PARTS[orient+'-icon-full']||'')+'</g>';
    s += PM_ICON_PARTS[orient+'-icon-hole-full'] || '';
  } else {
    s += PM_ICON_PARTS[orient+'-icon-note-split'] || '';
    s += '<g style="color:'+c1+'">'+(PM_ICON_PARTS[orient+'-icon-split-top']||'')+'</g>';
    s += '<g style="color:'+c2+'">'+(PM_ICON_PARTS[orient+'-icon-split-bottom']||'')+'</g>';
    s += PM_ICON_PARTS[orient+'-icon-hole-split-top'] || '';
    s += PM_ICON_PARTS[orient+'-icon-hole-split-bottom'] || '';
  }
  return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="'+fmt(vb.x0)+' '+fmt(vb.y0)+' '+fmt(vb.w)+' '+fmt(vb.h)+'" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">'+s+'</svg>';
}

// 스프링이 연결되는 면의 길이 = 항상 높이(H) 기준
// 세로형: 입력한 세로값 / 가로형: 입력한 가로값 (가로형으로 놓으면 가로가 높이가 됨)
function getSpringFaceLen(){
  if(S.size==='X'){
    var cw=S.cw||182, ch=S.ch||257;
    // 가로형: 가로로 눕히므로 짧은 쪽이 높이
    return S.dir==='landscape' ? Math.min(cw,ch) : Math.max(cw,ch);
  } else {
    var sz=SIZES.find(function(x){return x.id===S.size;});
    // 세로형: 높이=sz.h / 가로형: 가로로 눕히므로 sz.w가 높이
    return S.dir==='landscape' ? sz.w : sz.h;
  }
}


function checkSpringFace(){
  var tooShort=getSpringFaceLen()<=75;
  // 안내 문구 표시/숨김
  var notice=document.getElementById('spring-face-notice');
  if(notice){
    notice.style.display=tooShort?'block':'none';
    notice.textContent=L(
      '스프링 제본면의 길이가 75mm 이하일 땐 풀 스프링만 가능합니다.',
      'Full Spring only when the spring binding edge is 75mm or less.',
      'スプリングを通す辺の長さが75mm以下の場合は、フルスプリングのみお選びいただけます。');
  }
  // 양끝 버튼 비활성화
  var splitBtn=document.querySelector('.sp-btn[data-v="split"]');
  if(splitBtn){
    splitBtn.disabled=tooShort;
    splitBtn.style.opacity=tooShort?'0.35':'1';
  }
  // split 선택된 상태면 full로 자동 전환
  if(tooShort && S.sp==='split'){
    S.sp='full';
    document.querySelectorAll('.sp-btn').forEach(function(b){b.className='sp-btn'+(b.dataset.v==='full'?' sel':'');});
    document.getElementById('sc-full').style.display='block';
    document.getElementById('sc-split').style.display='none';
    refreshSpIcons();
  }
}

function setSP(v){
  // 스프링 면 75mm 이하면 split 불가
  if(v==='split' && getSpringFaceLen()<=75){
    toast(L('스프링 연결 면이 75mm 이하일 때는 풀 스프링만 선택할 수 있어요.','Spring face ≤75mm: Full Spring only.','スプリング側が75mm以下の場合はフルスプリングのみ選べます。'));
    return;
  }
  S.sp=v;S.springChosen=true;setPrevSide('front');
  document.querySelectorAll('.sp-btn').forEach(function(b){b.className='sp-btn'+(b.dataset.v===v?' sel':'');});
  document.getElementById('sc-full').style.display=v==='full'?'block':'none';
  document.getElementById('sc-split').style.display=v==='split'?'block':'none';
  refreshSpIcons();render();
}
function renderSC(){
  renderDots('sc-dots','sc-name',SC,S.sc,function(id){S.sc=id;S.springChosen=true;renderSC();refreshSpIcons();setPrevSide('front');updateSum();});
  renderDots('sc-top-dots','sc-top-name',SC,S.sc_top,function(id){S.sc_top=id;S.springChosen=true;renderSC();refreshSpIcons();setPrevSide('front');updateSum();});
  renderDots('sc-bot-dots','sc-bot-name',SC,S.sc_bot,function(id){S.sc_bot=id;S.springChosen=true;renderSC();refreshSpIcons();setPrevSide('front');updateSum();});
}

// ═══ BAND ═════════════════════════════════════════════════════════════
// 코너형 밴드: 채워야 하는 세로 높이가 80mm 이상일 때만 가능
function cornerBandOK(){return curNoteMM().nh>=80;}
function renderBands(){
  var cn=document.getElementById('corner-band-notice');
  if(cn){
    var coOK=cornerBandOK();
    cn.style.display=coOK?'none':'block';
    cn.textContent=L(
      '코너형은 밴드가 채워지는 세로 높이가 80mm 이상일 때만 선택할 수 있습니다.',
      'Corner band is available only when the band height is 80mm or more.',
      'コーナータイプは、バンドのかかる高さが80mm以上の場合のみお選びいただけます。');
  }
  var g=document.getElementById('band-grid');g.innerHTML='';
  BANDS.forEach(function(b){
    var isSel=S.band===b.id;
    var bH=isSel&&(S.band==='double'||S.band==='corner')
      ?(BC.find(function(x){return x.id===S.bc1;})||{h:'#1C1C1C'}).h
      :(BC.find(function(x){return x.id===S.bc;})||{h:'#1C1C1C'}).h;
    var b2H=(BC.find(function(x){return x.id===S.bc2;})||{h:'#1C1C1C'}).h;
    var eyH=(EYELETS.find(function(x){return x.id===S.ey;})||{h:'#2A2A2A'}).h;
    var prStr=b.p?'+'+b.p.toLocaleString()+t('won'):t('free');
    var disabled=(b.id==='corner'&&!cornerBandOK());
    var btn=document.createElement('button');
    btn.className='band-btn'+(isSel?' sel':'');
    if(disabled){btn.disabled=true;btn.style.opacity='0.35';btn.style.cursor='not-allowed';}
    btn.innerHTML='<div class="band-ico">'+bandThumbSVG2(b.id,bH,b2H,eyH,isSel)+'</div>'
      +'<div class="band-lbl">'+t('band-'+b.id)+'</div>'
      +'<div class="band-price">'+prStr+'</div>';
    btn.onclick=function(){
      if(disabled){toast(L('코너형은 세로 높이 80mm 이상일 때만 선택할 수 있어요.','Corner band needs a height of 80mm or more.','コーナータイプは高さ80mm以上でお選びいただけます。'));return;}
      var prev=S.band;
      S.band=b.id;setPrevSide('front');
      if(b.id==='corner'&&prev!=='corner'){S.bc1='b05';S.bc2='b21';} // 코너 기본 = 위 Gray / 아래 Lemon
      if(b.id==='double'&&prev!=='double'){S.bc1='b09';S.bc2='b19';} // 더블 기본 = Dusty Blue / Red
      renderBands();renderBC();updateBandExtra();render();
    };
    g.appendChild(btn);
  });
}
// 사이즈 변경 등으로 코너형이 불가해지면 자동 해제
function checkBandAvail(){
  if(S.band==='corner'&&!cornerBandOK()){S.band='none';updateBandExtra();}
  renderBands();
}

function updateBandExtra(){
  var show=S.band!=='none';
  document.getElementById('band-extra').className='band-extra'+(show?' on':'');
  // 더블(좌/우)·코너(상/하)는 2색 선택, 기본은 1색
  var twoTone=S.band==='double'||S.band==='corner';
  document.getElementById('band-color-single').style.display=twoTone?'none':'block';
  document.getElementById('band-color-double').style.display=twoTone?'block':'none';
  document.getElementById('eyelet-single').style.display=twoTone?'none':'block';
  document.getElementById('eyelet-double').style.display=twoTone?'block':'none';
  if(twoTone){
    var corner=S.band==='corner';
    var st=function(id,v){var el=document.getElementById(id);if(el)el.textContent=v;};
    st('bc1-lbl',corner?L('위쪽 밴드 컬러','Top Band Color','上のバンドカラー'):L('밴드 1 컬러 (왼쪽)','Band 1 (Left)','バンド1カラー（左）'));
    st('bc2-lbl',corner?L('아래쪽 밴드 컬러','Bottom Band Color','下のバンドカラー'):L('밴드 2 컬러 (오른쪽)','Band 2 (Right)','バンド2カラー（右）'));
    st('ey1-lbl',corner?L('위쪽 아일렛','Top Eyelet','上のアイレット'):L('왼쪽 밴드 아일렛','Left Band Eyelet','左バンドのアイレット'));
    st('ey2-lbl',corner?L('아래쪽 아일렛','Bottom Eyelet','下のアイレット'):L('오른쪽 밴드 아일렛','Right Band Eyelet','右バンドのアイレット'));
  }
}

function renderBC(){
  renderDots('bc-dots','bc-name',BC,S.bc,function(id){S.bc=id;renderBC();renderBands();setPrevSide('front');updateSum();});
  renderDots('bc1-dots','bc1-name',BC,S.bc1,function(id){S.bc1=id;renderBC();renderBands();setPrevSide('front');updateSum();});
  renderDots('bc2-dots','bc2-name',BC,S.bc2,function(id){S.bc2=id;renderBC();renderBands();setPrevSide('front');updateSum();});
}
function renderEyelets(){
  renderEyGrid('eyelet-grid','ey-name',S.ey,function(id){S.ey=id;renderEyelets();renderBands();setPrevSide('back');updateSum();});
  renderEyGrid('eyelet-grid-1','ey1-name',S.ey1,function(id){S.ey1=id;renderEyelets();renderBands();setPrevSide('back');updateSum();});
  renderEyGrid('eyelet-grid-2','ey2-name',S.ey2,function(id){S.ey2=id;renderEyelets();renderBands();setPrevSide('back');updateSum();});
}
function renderEyGrid(gid,nid,selId,onPick){
  var g=document.getElementById(gid);if(!g)return;
  var ne=document.getElementById(nid);
  g.innerHTML='';
  EYELETS.forEach(function(e){
    var btn=document.createElement('button');
    btn.className='eyelet-btn'+(selId===e.id?' sel':'');
    var light=parseInt(e.h.slice(1),16)>0xBBBBBB;
    btn.innerHTML='<div class="eyelet-sw" style="background:'+e.h+';'+(light?'border:1px solid rgba(0,0,0,0.15)':'')+'"></div><div class="eyelet-lbl">'+e.n+'</div>';
    btn.onmouseenter=function(){if(ne)ne.textContent=e.n;};
    btn.onmouseleave=function(){var s=EYELETS.find(function(x){return x.id===selId;});if(ne)ne.textContent=s?s.n:'';};
    btn.onclick=function(){onPick(e.id);};
    g.appendChild(btn);
  });
  var s=EYELETS.find(function(x){return x.id===selId;});
  if(ne&&s)ne.textContent=s.n;
}

// ═══ DOTS ═════════════════════════════════════════════════════════════
function renderDots(gid,nid,colors,selId,onPick){
  var g=document.getElementById(gid);if(!g)return;
  var ne=document.getElementById(nid);
  g.innerHTML='';
  colors.forEach(function(c){
    var d=document.createElement('div');
    d.className='cdot'+(selId===c.id?' sel':'');
    d.style.background=c.h;
    if(parseInt(c.h.slice(1),16)>0xAAAAAA)d.style.outline='1px solid rgba(0,0,0,0.14)';
    d.onmouseenter=function(){if(ne)ne.textContent=c.n;};
    d.onmouseleave=function(){if(ne){var s=colors.find(function(x){return x.id===selId;});ne.textContent=s?s.n:'';}};
    d.onclick=function(){onPick(c.id);};
    g.appendChild(d);
  });
  var s=colors.find(function(x){return x.id===selId;});
  if(ne&&s)ne.textContent=s.n;
}

// ═══ SIZES ════════════════════════════════════════════════════════════
function renderSizes(){
  var g=document.getElementById('sg');g.innerHTML='';
  SIZES.forEach(function(sz){
    var nw=sz.w||(S.cw||182),nh=sz.h||(S.ch||257);
    // 실제 크기에 비례해 보이게 (A의 긴 변 257mm=최대 42px 기준). A가 가장 크고 C가 가장 작게.
    var REF=257,MAXPX=42;
    var vH=Math.max(8,Math.min(MAXPX,Math.round(MAXPX*nh/REF)));
    var vW=Math.max(8,Math.min(MAXPX,Math.round(MAXPX*nw/REF)));
    var lbl=sz.id==='X'?L('커스텀','Custom','カスタム'):L(sz.id+' 사이즈','Size '+sz.id,sz.id+' サイズ');
    var dim=sz.w?(sz.w+'×'+sz.h+'mm'):L('직접 입력','Enter size','サイズを入力');
    var btn=document.createElement('button');
    btn.className='size-btn'+(S.size===sz.id?' sel':'');
    btn.innerHTML='<div class="size-vis-wrap"><div class="size-vis" style="width:'+vW+'px;height:'+vH+'px"></div></div>'
      +'<div class="size-nm">'+lbl+'</div><div class="size-d">'+dim+'</div>';
    btn.onclick=function(){S.size=sz.id;setPrevSide('front');resetOnSizeChange();renderSizes();updateCustomUI();renderCovers('fc');renderCovers('bc');renderInnerGrid();render();};
    g.appendChild(btn);
  });
  document.getElementById('cr').className='custom-row'+(S.size==='X'?' on':'');
}
function onCI(){
  S.cw=parseInt(document.getElementById('cw').value)||null;
  S.ch=parseInt(document.getElementById('ch').value)||null;
  // 커스텀 치수 입력: 방향은 사용자가 고른 그대로 유지(자동 회전 없음). 스프링/잠금 등 기존 선택도 유지.
  document.querySelectorAll('.sp-btn').forEach(function(b){b.className='sp-btn'+(S.springChosen&&b.dataset.v===S.sp?' sel':'');});
  document.getElementById('sc-full').style.display=S.sp==='full'?'block':'none';
  document.getElementById('sc-split').style.display=S.sp==='split'?'block':'none';
  renderSizes();renderCovers('fc');renderCovers('bc');renderInnerGrid();
  updateCustomUI();
  document.querySelectorAll('.dir-btn').forEach(function(b){b.className='dir-btn'+(b.dataset.v===S.dir?' sel':'');});
  checkSpringFace();
  checkBandAvail();
  render();
}
function isCustomOutOfRange(){
  if(!S.cw||!S.ch) return false;
  if(S.cw<50||S.ch<50) return true;
  // 가로/세로 어느 방향으로 놓아도 A4 범위 안에 들어오면 OK
  var fitsNormal = S.cw<=210 && S.ch<=297;
  var fitsRotated = S.cw<=297 && S.ch<=210;
  return !(fitsNormal||fitsRotated);
}
function updateCustomUI(){
  var el=document.getElementById('cn');
  if(S.size!=='X'){el.className='custom-note';return;}
  if(!S.cw||!S.ch){el.className='custom-note info';el.textContent=t('custom-info');return;}
  if(S.cw<50||S.ch<50){el.className='custom-note err';el.textContent=t('custom-err-small');return;}
  var fitsN=S.cw<=210&&S.ch<=297, fitsR=S.cw<=297&&S.ch<=210;
  if(!fitsN&&!fitsR){el.className='custom-note err';el.textContent=t('custom-err-big');return;}
  // 자동 회전 없음 — 방향은 사용자가 직접 선택
  el.className='custom-note warn';el.textContent=t('custom-warn')(S.cw,S.ch,false);
}


function resetOnSizeChange(){
  // 사이즈를 바꿔도 기존 선택(방향/스프링/잠금/컬러)은 유지한다.
  // 새 사이즈와 간섭되는 옵션(75mm 이하 양끝스프링, 80mm 미만 코너밴드)만 자동 보정.
  document.querySelectorAll('.dir-btn').forEach(function(b){
    b.className='dir-btn'+(b.dataset.v===S.dir?' sel':'');
  });
  document.querySelectorAll('.sp-btn').forEach(function(b){
    b.className='sp-btn'+(S.springChosen&&b.dataset.v===S.sp?' sel':'');
  });
  document.getElementById('sc-full').style.display=S.sp==='full'?'block':'none';
  document.getElementById('sc-split').style.display=S.sp==='split'?'block':'none';
  refreshSpIcons();
  checkSpringFace();   // 양끝 불가 크기면 여기서 full로 보정
  checkBandAvail();    // 코너 불가 크기면 여기서 해제
  pruneInnersNotify(); // 커스텀 전환 시 플래너 등 안 맞는 내지 제거 (그리드는 호출부에서 renderInnerGrid)
  pruneCoversNotify(); // 사이즈 전용 표지가 담겨있으면 해제 (그리드는 호출부에서 renderCovers)
}

// ═══ DIR ══════════════════════════════════════════════════════════════
function setDir(v){
  S.dir=v;setPrevSide('front');
  document.querySelectorAll('.dir-btn').forEach(function(b){b.className='dir-btn'+(b.dataset.v===v?' sel':'');});
  checkSpringFace();
  checkBandAvail();
  refreshSpIcons();   // 방향 바꾸면 스프링 아이콘도 즉시 가로/세로 전환
  renderBands();      // 잠금(밴드) 썸네일도 방향에 맞게 전환
  pruneInnersNotify();// 방향에 안 맞는 내지 제거
  renderInnerGrid();  // 내지 방향 필터 다시 적용
  render();
}

// ═══ COVERS ════════════════════════════════════════════════════════════
// 표지 허용 사이즈: 메타객체 sizes(예 "C" / "B,C" / 비움=전체 허용). A/B/C/X(커스텀)만 인식.
function covSizes(cv){
  var raw=((cv&&cv.sizes)||'').toString().toUpperCase();
  if(!raw.trim())return null; // 제한 없음 = 모든 사이즈 허용
  var arr=raw.split(/[^ABCX]+/).filter(function(x){return x==='A'||x==='B'||x==='C'||x==='X';});
  return arr.length?arr:null;
}
// 현재 노트 사이즈에 이 표지를 선택할 수 있는지 (내지 innAvail과 동일 패턴)
function covAvail(cv){
  var allow=covSizes(cv);
  if(!allow)return {ok:true};
  if(allow.indexOf(S.size)<0)return {ok:false,reason:'size',allow:allow};
  return {ok:true};
}
// 담긴 앞/뒷표지가 현재 사이즈에 안 맞으면 해제 (해제된 개수 반환)
function pruneCovers(){
  var removed=0;
  ['fc','bcover'].forEach(function(k){
    if(!S[k])return;
    var cv=COVS.find(function(x){return x.id===S[k];});
    if(cv&&!covAvail(cv).ok){S[k]=null;removed++;}
  });
  return removed;
}
function pruneCoversNotify(){
  var r=pruneCovers();
  if(r>0)showCovToast('fc',L(
    '현재 사이즈에서 선택할 수 없는 표지 '+r+'개를 해제했어요.',
    r+' cover(s) not available in this size were removed.',
    '現在のサイズでは選べない表紙を'+r+'点、解除しました。'));
}
function showCovToast(side,msg){
  var el=document.getElementById(side+'-toast');
  if(!el)return;
  // 자동 숨김 없음 — 다른 액션(사이즈 변경·카테고리 탭·표지 선택 등 renderCovers 경유)을 취할 때
  // hideCovToast 로 지운다. 잠깐 떴다 사라지면 놓치기 쉽다는 지적(2026-07-20) 반영.
  el.textContent=msg;el.style.display='block';
}
function hideCovToast(side){
  var el=document.getElementById(side+'-toast');
  if(el){el.textContent='';el.style.display='none';}
}
function renderCovers(side){
  hideCovToast(side); // 다른 액션(사이즈·탭·선택)으로 다시 그릴 때 이전 안내 문구를 지운다
  var catKey=side==='fc'?'fc_cat':'bc_cat';
  var selKey=side==='fc'?'fc':'bcover';
  // 카테고리 탭을 실제 표지 데이터(메타객체)에서 생성 — 필드값 그대로 표시
  // ⚠️ 반드시 **정규화한 키**로 모은다(covCatKey). 값 그대로 모으면 로케일 번역본이
  //    별개 카테고리가 되어 탭이 두 개로 갈린다(위 COV_CAT_ALIAS 설명).
  var cats=[];
  COVS.forEach(function(cv){ var k=covCatKey(cv.cat); if(k&&cats.indexOf(k)<0)cats.push(k); });
  if(!cats.length)cats=t('cover-cats-ids').map(covCatKey);
  // 카테고리 탭 순서 고정 (변경 시 이 배열만 수정)
  var COV_CAT_ORDER=['단색','디자인','패턴','한정판'];
  cats.sort(function(a,b){var ia=COV_CAT_ORDER.indexOf(a),ib=COV_CAT_ORDER.indexOf(b);return (ia<0?99:ia)-(ib<0?99:ib);});
  var cur=S[catKey];
  if(cats.indexOf(cur)<0){cur=cats[0];S[catKey]=cur;}
  var tabEl=document.getElementById(side+'-tabs');tabEl.innerHTML='';
  cats.forEach(function(cid){
    var b=document.createElement('button');
    var isLim=(cid==='한정판');   // cid 는 이미 정규화된 키다(영문·일문 값도 여기로 합쳐진다)
    b.className='tab'+(cur===cid?' act':'')+(isLim?' limited':'');
    b.textContent=covCatLabel(cid);   // 값(한글) 그대로 찍지 않는다 — EN 에서 한글 탭이 나오던 원인
    b.onclick=function(){S[catKey]=cid;renderCovers(side);};
    tabEl.appendChild(b);
  });
  var g=document.getElementById(side+'-grid');g.innerHTML='';
  COVS.filter(function(cv){return covCatKey(cv.cat)===cur;}).forEach(function(cv){
    var av=covAvail(cv);
    var wrap=document.createElement('div');
    wrap.className='cov-item'+(S[selKey]===cv.id?' sel':'')+(covCatKey(cv.cat)==='한정판'?' limited-item':'')+(av.ok?'':' dis');
    var canvas=document.createElement('canvas');
    canvas.className='cov-thumb';canvas.width=240;canvas.height=330;
    // 목록 썸네일은 500px 만 받고(cdnW) **보일 때** 그린다(lazyDrawCov) — 1600px 26장 = 20MB 였다.
    // 상세·크게보기는 그대로 큰 것을 쓴다(누른 사람만 받는다).
    wrap.appendChild(canvas);
    (function(c,cover){ lazyDrawCov(c,function(){ drawCovThumb(c,Object.assign({},cover,{img:cdnW(cover.img,500)}),true); }); })(canvas,cv);  // 리스트: 좌상단 1/4 확대
    // 사이즈 안 맞는 표지: 회색 위에 '전용' 배지를 직접 얹는다(품절처럼 보이지 않도록).
    if(!av.ok&&av.reason==='size'){
      var lbl=av.allow.map(function(s){return s==='X'?L('커스텀','Custom','カスタム'):s;}).join('·');
      var badge=document.createElement('div');badge.className='cov-only-badge';
      badge.textContent=L(lbl+' 전용',lbl+' only',lbl+' 専用');
      wrap.appendChild(badge);
    }
    var pr=covPrice(cv.id);
    var nm=document.createElement('div');nm.className='cov-nm';nm.textContent=cv.n;wrap.appendChild(nm);
    var prEl=document.createElement('div');prEl.className='cov-pr';
    prEl.textContent=pr.toLocaleString()+t('won');wrap.appendChild(prEl);
    if(av.ok){
      wrap.onclick=function(){
        // 앞표지를 다른 것으로 바꾸면 적용해 둔 추천 조합은 걷어낸다 —
        // 그 조합은 이전 표지에 맞춘 것이라 새 표지에 그대로 남아 있으면 안 된다.
        // (뒷표지 변경은 추천을 건드리지 않는다. 추천이 뒷표지를 정해줬더라도
        //  그걸 손으로 바꾸는 건 고객의 선택이다.)
        if(side==='fc'&&S.recFrom&&S.recFrom!==cv.id){
          // 직접 바꿔둔 항목은 남으므로, 실제로 되돌린 게 있을 때만 알린다
          if(clearRecommend()){
            toast(L('표지를 바꿔서 추천 조합을 해제했어요. 직접 고르신 옵션은 그대로 뒀어요.',
                    'Recommended combo cleared — your own picks are kept.',
                    '表紙を変更したため、おすすめの組み合わせを解除しました。ご自身で選ばれた項目はそのままです。'));
          }
        }
        S[selKey]=cv.id;renderCovers(side);showCovDetail(side,cv);setPrevSide(side==='fc'?'front':'back');render();};
    } else {
      wrap.onclick=function(){showCovToast(side,L(
        '이 표지는 '+av.allow.map(function(s){return s==='X'?'커스텀':s;}).join('·')+' 사이즈 전용이에요. 사이즈를 바꿔주세요.',
        'This cover is available only in size '+av.allow.join('/')+'. Change the note size.',
        'この表紙は'+av.allow.map(function(s){return s==='X'?'カスタム':s;}).join('・')+'サイズ専用です。サイズを変更してください。'));};
    }
    g.appendChild(wrap);
  });
  var _selCv=COVS.find(function(x){return x.id===S[selKey];});
  var _det=document.getElementById(side+'-detail');
  if(_selCv&&_det)showCovDetail(side,_selCv);
  else if(_det){_det.className='cov-detail';_det.innerHTML='';}
}
// ═══ 추천 조합 (표지 메타객체 rec_* 필드) ══════════════════════════════
function findByName(list,val){
  if(!val)return null;
  var v=(''+val).trim().toLowerCase();
  if(!v)return null;
  return list.find(function(x){return (x.n&&x.n.toLowerCase()===v)||(x.id&&x.id.toLowerCase()===v);})||null;
}
var BAND_NAME_MAP={'없음':'none','베이직':'basic','기본':'basic','코너':'corner','더블':'double','none':'none','basic':'basic','corner':'corner','double':'double'};
function bandTypeId(val){if(!val)return '';var s=(''+val).trim();return BAND_NAME_MAP[s]||BAND_NAME_MAP[s.toLowerCase()]||'';}
var SPRING_NAME_MAP={'풀':'full','풀스프링':'full','full':'full','양끝':'split','양끝스프링':'split','split':'split'};
function springTypeId(val){if(!val)return '';var s=(''+val).trim();return SPRING_NAME_MAP[s]||SPRING_NAME_MAP[s.toLowerCase()]||'';}
// 뒷표지 추천값(핸들 또는 이름) → COVS 항목 매칭
function findCover(val){
  if(!val)return null;
  var v=(''+val).trim().toLowerCase();
  if(!v)return null;
  return COVS.find(function(x){return (x.id&&x.id.toLowerCase()===v)||(x.n&&x.n.toLowerCase()===v);})||null;
}
// 🔴 관리자 메타객체의 rec_* 는 '값 목록으로 제한'된 선택 필드라, 한번 고른 값을 빈 값으로 되돌릴 수가 없다.
//    그래서 각 필드의 목록에 '없음'(또는 none/-)을 넣어두고 그걸 고르면 "추천 안 함"이 되게 한다.
//    ⚠️ 필드 목록에 넣는 문자열은 반드시 아래 REC_NONE 에 있는 것으로. 새 표기를 쓰려면 여기에 추가할 것.
var REC_NONE=['none','없음','추천없음','추천 없음','해당없음','해당 없음','안함','n/a','na','-','–','—'];
function recVal(v){
  if(v==null)return '';
  var s=(''+v).trim();
  return REC_NONE.indexOf(s.toLowerCase())>=0?'':s;
}
// 🔴 추천 조합 전체 스위치. 표지 메타객체의 **rec_clear**(참/거짓)를 켜면 그 표지의 rec_* 를 하나도 안 읽고
//    '추천 조합 적용' 버튼 자체가 사라진다. 필드를 8개씩 '없음'으로 바꿀 필요 없이 이것 하나면 된다.
//    build 가 rec_clear(정식) 또는 rec_off(구 이름) 중 켜진 쪽을 rec_off 로 주입한다.
//    (불리언이 아니라 선택 목록으로 만들었을 때를 대비해 문자열 표기도 받는다.)
var REC_OFF_YES=['true','1','yes','y','on','해제','추천해제','추천 해제','사용안함','사용 안함','off','끔'];
function recOff(v){
  if(v===true)return true;
  if(v===false||v==null)return false;
  return REC_OFF_YES.indexOf((''+v).trim().toLowerCase())>=0;
}
// 표지의 rec_* 필드를 해석 → 적용 가능한 것이 있으면 객체, 없으면 null
function coverRec(cov){
  if(!cov)return null;
  if(recOff(cov.rec_off))return null;   // 전체 스위치가 켜져 있으면 추천 없음
  var out={any:false,parts:[]};
  // 스프링: 타입(풀/양끝) + 컬러. 양끝은 위=rec_spring_color / 아래=rec_spring_color2 (두 색).
  var spType=springTypeId(recVal(cov.rec_spring_type));
  var sc=findByName(SC,recVal(cov.rec_spring_color));
  var sc2=findByName(SC,recVal(cov.rec_spring_color2));
  if(spType||sc||sc2){
    out.any=true;
    if(spType)out.springType=spType;
    if(sc)out.spring=sc.id;
    if(sc2)out.spring2=sc2.id;
    // 라벨: 타입이 있으면 t('sp-lbl-*')에 이미 "스프링/Spring" 단어 포함 → 중복 방지
    var slbl=spType?t('sp-lbl-'+spType):t('sk-sp');
    if(spType==='split'&&(sc||sc2)){
      var t1=sc||sc2,t2=sc2||sc;   // 위/아래(한쪽만 있으면 동일색)
      slbl+=' '+t1.n+'/'+t2.n;
    } else if(sc){
      slbl+=' '+sc.n;
    }
    out.parts.push(slbl);
  }
  // 잠금(밴드) 타입 + 밴드색 + 아일렛색
  var bt=bandTypeId(recVal(cov.rec_band));
  if(bt&&bt!=='none'){
    out.band=bt;out.any=true;
    var c1=findByName(BC,recVal(cov.rec_band_color)),c2=findByName(BC,recVal(cov.rec_band_color2));
    var e1=findByName(EYELETS,recVal(cov.rec_eyelet)),e2=findByName(EYELETS,recVal(cov.rec_eyelet2));
    if(c1)out.bc1=c1.id; if(c2)out.bc2=c2.id; if(e1)out.ey1=e1.id; if(e2)out.ey2=e2.id;
    out.parts.push(L('잠금 ','Band ','留め方 ')+t('band-'+bt));
  }
  // 뒷표지 (앞표지와 같은 표지를 추천해도 정상 — 같은 디자인 양면)
  var bcov=findCover(recVal(cov.rec_back));
  if(bcov){out.back=bcov.id;out.backCat=bcov.cat;out.any=true;out.parts.push(L('뒷표지 ','Back ','裏表紙 ')+bcov.n);}
  return out.any?out:null;
}
function applyRecommend(cov){
  var r=coverRec(cov);
  if(!r)return;
  if(r.springType){S.sp=r.springType;S.springChosen=true;}
  if(r.spring||r.spring2){
    S.springChosen=true;
    if(r.springType==='split'){
      // 양끝: 위=rec_spring_color / 아래=rec_spring_color2 (한쪽만 있으면 동일색)
      var _top=r.spring||r.spring2, _bot=r.spring2||r.spring;
      S.sc_top=_top; S.sc_bot=_bot; S.sc=_top;
    } else {
      // 풀: 단일색을 상·하 모두에
      var _one=r.spring||r.spring2;
      S.sc=_one; S.sc_top=_one; S.sc_bot=_one;
    }
  }
  if(r.band){
    if(r.band==='corner'&&!cornerBandOK()){
      toast(L('추천 코너 잠금은 현재 사이즈에선 적용할 수 없어 생략했어요.','Recommended corner band skipped for this size.','おすすめのコーナーバンドは現在のサイズでは使えないため、省きました。'));
    } else {
      S.band=r.band;
      if(r.band==='basic'){ if(r.bc1)S.bc=r.bc1; if(r.ey1)S.ey=r.ey1; }
      else { if(r.bc1)S.bc1=r.bc1; if(r.bc2)S.bc2=r.bc2; if(r.ey1)S.ey1=r.ey1; if(r.ey2)S.ey2=r.ey2; }
    }
  }
  if(r.back){S.bcover=r.back;S.bc_cat=r.backCat||S.bc_cat;}
  // 어느 표지의 추천을 적용했는지 + 그때 넣은 값이 무엇이었는지 기억해 둔다.
  // 앞표지를 바꿀 때, **아직 그대로인 값만** 되돌리기 위해 필요하다(clearRecommend).
  S.recFrom=cov.id;
  S.recApplied={};
  REC_KEYS.forEach(function(k){ S.recApplied[k]=S[k]; });
  setPrevSide('front');
  renderAll();
  toast(L('추천 조합을 적용했어요.','Applied recommended combo.','おすすめの組み合わせを適用しました。'));
}
// 추천이 건드리는 항목들. 사이즈·방향·내지는 추천과 무관하므로 제외.
// springChosen 은 파생값이라 따로 다룬다(아래).
var REC_KEYS=['sp','sc','sc_top','sc_bot','band','bc','bc1','bc2','ey','ey1','ey2','bcover','bc_cat'];
var REC_SPRING_KEYS=['sp','sc','sc_top','sc_bot'];
// 적용해 둔 추천 조합을 걷어낸다.
// ⚠️ 전부 되돌리지 않는다 — 추천을 적용한 뒤 고객이 직접 바꾼 항목은 그대로 둔다.
//    "적용 당시의 값과 지금 값이 같다" = 아직 손대지 않았다 → 그것만 기본값으로.
// 되돌린 항목이 하나라도 있으면 true.
function clearRecommend(){
  if(!S.recFrom)return false;
  var applied=S.recApplied||{}, changed=false;
  // 되돌리기 전에 판정해 둔다 — 아래 루프가 값을 바꾸고 나면 "손댔는지"를 알 수 없다.
  // 스프링을 하나도 손대지 않았을 때만 "스프링 미선택" 상태로 되돌린다.
  // 색만 바꿔둔 경우까지 미선택으로 만들면 고른 색이 프리뷰에서 사라진다.
  var springUntouched=REC_SPRING_KEYS.every(function(k){
    return !(k in applied) || S[k]===applied[k];
  });
  REC_KEYS.forEach(function(k){
    if(!(k in applied))return;
    if(S[k]===applied[k]){ S[k]=DEFAULT_STATE[k]; changed=true; }
  });
  if(springUntouched)S.springChosen=DEFAULT_STATE.springChosen;
  S.recFrom=null; S.recApplied=null;
  return changed;
}

// 표지 디테일 사진 목록 (2026-08-16). **새 목록 필드 우선, 없으면 기존 단일 필드**.
// 🔴 폴백이 있어야 대표님이 표지를 하나씩 옮기시는 중간에도 화면이 안 깨진다
//    (내지 이미지·HOW TO 일러스트 때 쓴 것과 같은 방식).
function covDetailShots(cv){
  var list=((cv&&cv.imgsDetail)||[]).filter(Boolean);
  if(!list.length&&cv&&cv.imgDetail)list=[cv.imgDetail];
  return list;
}
function showCovDetail(side,cv){
  var el=document.getElementById(side+'-detail');el.className='cov-detail on';
  var shots=covDetailShots(cv);
  var dIdx=0;                       // 디테일 사진 중 지금 보고 있는 번호
  var curFace='img';                // 'img' | 'imgBack' | 'detail'
  var imgDiv=document.createElement('div');imgDiv.className='cov-detail-img';
  var canvas=document.createElement('canvas');canvas.width=360;canvas.height=480;
  function zoomNow(){openImgZoom('cov',cv,curFace,dIdx);}
  canvas.style.cursor='zoom-in';canvas.onclick=function(){zoomNow();};
  drawCovThumb(canvas,cv);imgDiv.appendChild(canvas);
  var zb=document.createElement('button');zb.className='detail-zoom';zb.type='button';
  zb.title=L('크게보기','Zoom','拡大表示');zb.innerHTML='🔍';
  zb.onclick=function(e){e.stopPropagation();zoomNow();};imgDiv.appendChild(zb);
  // 디테일 사진이 여러 장일 때만: 이미지 위 아래쪽 가운데 점 표시 + 좌우 스와이프
  // ⚠️ 점은 **가운데**에 둔다 — 돋보기가 오른쪽 아래에 있어 겹치지 않게.
  var dots=document.createElement('div');dots.className='cov-dots';imgDiv.appendChild(dots);
  function paintDots(){
    var many=(curFace==='detail'&&shots.length>1);
    dots.style.display=many?'flex':'none';
    if(!many){dots.innerHTML='';return;}
    dots.innerHTML='';
    shots.forEach(function(_,i){
      var d=document.createElement('span');d.className='cov-dot'+(i===dIdx?' on':'');
      dots.appendChild(d);
    });
  }
  function paintFace(){
    if(curFace==='detail')drawCovThumb(canvas,Object.assign({},cv,{img:shots[dIdx]}));
    else drawCovThumb(canvas,curFace==='img'?cv:Object.assign({},cv,{img:cv[curFace]}));
    paintDots();
  }
  function stepDetail(dir){
    if(curFace!=='detail'||shots.length<2)return;
    dIdx=(dIdx+dir+shots.length)%shots.length;   // 끝에서 처음으로 돌아온다
    paintFace();
  }
  // 스와이프: 프리뷰 노트(앞↔뒤)와 같은 방식. 세로 스크롤은 살려둔다(touch-action:pan-y).
  // 🔴 **크게보기 창에는 절대 걸지 말 것** — 거긴 누른 채 이동이 '확대'라 제스처가 싸운다.
  //    (그 이유는 setupPreviewSwipe 위 주석에 실측으로 기록돼 있다. 크게보기는 화살표 버튼으로 넘긴다.)
  imgDiv.style.touchAction='pan-y';
  var _sx=null,_sy=null;
  imgDiv.addEventListener('pointerdown',function(e){_sx=e.clientX;_sy=e.clientY;});
  imgDiv.addEventListener('pointerup',function(e){
    if(_sx==null)return;
    var dx=e.clientX-_sx,dy=e.clientY-_sy;_sx=null;
    if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)*1.2){
      e.preventDefault();          // 스와이프였으면 클릭(크게보기 열기)으로 이어지지 않게
      stepDetail(dx<0?1:-1);       // 왼쪽으로 밀면 다음 장
    }
  });
  imgDiv.addEventListener('pointercancel',function(){_sx=null;});
  var pr=covPrice(cv.id);
  // 🔴 EN 에서 `undefined` 가 찍히던 버그(2026-08-13). `matEn`/`dEn` 은 **데모 폴백 배열에만** 있는 필드다 —
  //    실제 데이터는 메타객체에서 오고 거기엔 한글 `mat`/`desc` 뿐이라, EN 으로 바꾸면 그대로 undefined 가 됐다.
  //    영문 값이 없으면 **한글로 되돌린다**(내지 상세가 이미 그렇게 동작한다 — 두 곳을 같게 맞췄다).
  //    ⚠️ 진짜 번역은 메타객체에 영문 필드를 만들어야 한다. 지금은 '깨지지 않게' 까지가 범위다.
  var mat=pickLang(cv.mat,cv.matEn);
  var desc=pickLang(cv.desc,cv.dEn,cv.dJa);
  var txt=document.createElement('div');txt.className='cov-detail-txt';
  // 🔴 이미지 옆에는 **설명 본문을 뺀** 것만 둔다 — 번호·이름·소재·가격 (대표님 지정 순서, 2026-08-16).
  //    설명은 아래 전체 폭(.cov-detail-desc)으로 내려보낸다. 옆에 두면 칸이 길어지고,
  //    그만큼 이미지 칸까지 늘어나 돋보기·버튼이 이미지에서 떨어진다(내지 상세가 먼저 겪고 고친 문제).
  // 옆 칸 순서(2026-09-22 대표님 지정): 번호 · 이름 · 첫인상 한 줄 · 소재 · 색 조합 · 가격.
  // 🔴 첫인상은 `/` **앞부분만** 쓴다 — 디자인·한정판의 이야기는 40~60자라 이 칸(모바일 133px)에서 3~4줄이 된다.
  //    이야기 전문은 아래 전체 폭(.cov-detail-desc)에 기존 설명과 함께 둔다. 단색은 `/` 가 없어 문장 전체가 한 줄로 들어간다.
  var tagHead=tagHeadOf(covTag(cv));
  var head=document.createElement('div');head.className='cov-detail-txt-head';
  head.innerHTML=(cv.no?'<span class="cov-detail-no">'+cv.no+'</span>':'')+'<strong>'+pickLang(cv.n,cv.nEn)+'</strong>'
    +(tagHead?'<span class="cov-detail-tag">'+shopEsc(tagHead)+'</span>':'')
    +(mat?mat:'')
    +(colorLine(cv.colors)?'<span class="cov-detail-colors">'+shopEsc(colorLine(cv.colors))+'</span>':'');
  var prEl=document.createElement('div');prEl.className='cov-detail-pr';
  prEl.textContent=pr.toLocaleString()+t('won');fxAppend(prEl,pr);
  head.appendChild(prEl);
  txt.appendChild(head);
  // 이미지 하단에 맞춰 붙는 묶음(.cov-detail-foot 의 margin-top:auto 가 내려붙인다)
  var foot=document.createElement('div');foot.className='cov-detail-foot';
  txt.appendChild(foot);
  // 앞표지에 추천 조합(rec_*)이 있으면 적용 버튼 노출
  if(side==='fc'){
    var rec=coverRec(cv);
    if(rec){
      var rb=document.createElement('button');
      rb.className='rec-combo-btn';
      rb.type='button';
      rb.innerHTML='<svg viewBox="0 0 112.59 113.59" width="12" height="12" style="display:inline-block;vertical-align:-2px;margin-right:4px" aria-hidden="true"><path style="fill:var(--brand-red)" d="M60.29,47.33l15.94-9.96-9.96,15.43c9.2.84,18.44,1.76,27.65,2.49,5.53.44,11.49.39,16.95.98.75.08,1.54.11,1.72,1.01l-46.33,3.5,9.96,15.44c-.93.78-14.99-10.47-15.94-9.46l-3.98,46.83-3.5-46.83-1.47.27-14.96,9.7,10.46-15.94L0,57.05l46.83-4.24-10.46-15.94c4.7,2.13,10.13,7.69,14.58,9.57.62.26,1.14.52,1.85.39L56.3,0l3.99,47.33Z"/></svg>'+L('추천 조합 적용','Apply recommended combo','おすすめの組み合わせを適用');
      rb.title=rec.parts.join(' · ');
      rb.onclick=function(){applyRecommend(cv);};
      foot.appendChild(rb);
    }
  }
  // 면 이미지(앞/뒤/디테일): 있는 것만 토글 버튼(카탈로그 표시용). 노트 조립 프리뷰는 안 건드림.
  // 🔴 **디테일은 사진이 몇 장이든 버튼 하나다**(대표님 결정 2026-08-16).
  //    장수만큼 버튼을 만들면 이름을 매번 정해야 하고(디테일2·3…) 좁은 칸에서 줄이 접힌다.
  //    여러 장은 **버튼이 아니라 스와이프(기본 창)·화살표(크게보기)**로 넘긴다.
  // 🔴 「앞면/뒷면」이 아니라 **「겉면/안쪽」**(2026-09-23 대표님: 노트의 앞표지·뒷표지와 헷갈린다는 의견).
  //    같은 화면에 노트 프리뷰의 「앞/뒤」(= 앞표지·뒷표지)가 있어서, 표지 «한 장»의 두 면도 앞/뒤라고 부르면 말이 겹친다.
  //    표지는 겉과 안쪽이 다른 색인 두 겹 구조라 겉면/안쪽이 실제에도 맞는다. 색 조합(colors)도 `겉 … / 안쪽 …` 로 맞췄다.
  var faceDefs=[{key:'img',ko:'겉면',en:'Outside',ja:'外側'}];
  if(cv.imgBack)faceDefs.push({key:'imgBack',ko:'안쪽',en:'Inside',ja:'内側'});
  if(shots.length)faceDefs.push({key:'detail',ko:'디테일',en:'Details',ja:'ディテール'});
  if(faceDefs.length>1){
    var faces=document.createElement('div');faces.className='cov-face-btns';
    var faceBtns=[];
    var showFace=function(idx){
      curFace=faceDefs[idx].key;
      if(curFace==='detail')dIdx=0;    // 디테일로 들어올 땐 늘 첫 장부터
      paintFace();
      faceBtns.forEach(function(b,i){b.className='cov-face-btn'+(i===idx?' act':'');});
    };
    faceDefs.forEach(function(fd,i){
      var b=document.createElement('button');b.type='button';
      b.textContent=L(fd.ko,fd.en,fd.ja);
      b.onclick=function(){showFace(i);};
      faces.appendChild(b);faceBtns.push(b);
    });
    showFace(0);foot.appendChild(faces);
  }
  // 조립: [이미지 | 번호·이름·소재·가격 + 바닥 버튼] 한 줄, 그 아래 전체 폭 설명
  var top=document.createElement('div');top.className='cov-detail-top';
  top.appendChild(imgDiv);top.appendChild(txt);
  el.innerHTML='';el.appendChild(top);
  // 아래 전체 폭: 이야기(첫인상 문구의 `/` 뒷부분) → 기존 설명. 둘은 하는 일이 다르다 —
  // 이야기는 «첫인상», 설명은 «실제 정보»(평량·원단·인증). 대표님: "원래 넣어둔 설명도 보여야 해."
  var story=tagStoryOf(covTag(cv));
  if(story){
    var sEl=document.createElement('div');sEl.className='cov-detail-story';
    sEl.textContent=story;
    el.appendChild(sEl);
  }
  if(desc){
    var dEl=document.createElement('div');dEl.className='cov-detail-desc';
    // ⚠️ innerHTML 은 **원래 동작 그대로**다(예전 코드도 `'<br>'+desc` 로 넣었고, 내지 상세도 innerHTML 이다).
    //    설명에 줄바꿈 태그가 들어간 경우가 있어 textContent 로 바꾸면 한 줄로 붙어버린다.
    dEl.innerHTML=desc;
    el.appendChild(dEl);
  }
}
// ── 첫인상 문구 가르기 (2026-09-22) ─────────────────────────────────────────
// 메타객체 `tagline` 은 두 모양이다:
//   ① 짧은 한 줄            — 단색 표지·내지 ("보랏빛이 깊어지는 저녁")
//   ② `한글이름 / 이야기`    — 디자인·패턴·한정판 ("첫 빛 / 아직 잠든 숲의 가장자리에…")
// 옆 칸(좁다, 모바일 133px)에는 ①이면 전체, ②면 `/` 앞만. 이야기는 상세 아래로 내려 온전히 읽게 한다.
// 🔴 `/` 는 «처음 나오는 것»만 가른다 — 이야기 안에도 `/` 가 들어갈 수 있다.
// ── 색 조합 한 줄 (2026-09-23) ──────────────────────────────────────────────
// 메타객체 `colors` 에는 **색만** 둔다(`purple / black`). 「겉/안쪽」은 여기서 언어에 맞춰 붙인다 —
// 데이터에 한국어를 넣으면 표지를 하나 추가할 때마다 번역이 따라붙는다(대표님 질문: "번역본은 따로 줘야 해?").
// 🔴 손으로 입력하는 칸이라 띄어쓰기를 믿지 않는다 — `/` 로 갈라 trim 한다(`purple/black` 도 받는다).
// 색이 아닌 자유 텍스트(한국어 원단 설명 등)가 들어오면 그대로 내보낸다 — 갈라 붙이면 말이 안 된다.
// 첫인상 문구의 언어 고르기 — 설명(pickLang)과 같은 규칙: 영문이 없으면 한국어, 일본어가 없으면 영어 → 한국어.
// 🔴 `L()` 이 아니라 `pickLang()` 이다 — 빈 칸의 뜻이 «아직 입력 안 함»이라 폴백해야 한다(#32 의 두 함수).
function covTag(cv){ return pickLang(cv&&cv.tagline, cv&&cv.tagEn, cv&&cv.tagJa); }
function innTag(inn){ return pickLang(inn&&inn.tagline, inn&&inn.tagEn, inn&&inn.tagJa); }
function colorLine(colors){
  var s=String(colors||'').trim(); if(!s)return '';
  if(/[가-힣]/.test(s))return s;                 // 한국어가 섞였으면 자유 텍스트로 본다
  var p=s.split('/').map(function(x){return x.trim();}).filter(Boolean);
  if(p.length!==2)return s;
  // 🔴 영어만 «색 → 위치» 순이다(2026-09-23 대표님) — 한국어·일본어는 수식이 앞에 오지만
  //    영어는 `purple outside` 가 자연스럽다. 언어마다 어순이 다르니 한 틀로 찍어내지 않는다.
  return L('겉 '+p[0]+' / 안쪽 '+p[1], p[0]+' outside / '+p[1]+' inside', '外側 '+p[0]+' / 内側 '+p[1]);
}
// 평량 단위를 언어에 맞춰 붙인다 (2026-09-23 대표님).
// 사양 칸(`s`)에는 `81.4g, light ivory, smooth, 15 sheets` 처럼 **숫자+g** 로 적혀 있는데,
// 그냥 `g` 는 «한 장의 무게»로 읽힐 수 있어 단위를 분명히 한다 — 한국어·일본어는 `g/㎡`, 영어는 `gsm`.
// 🔴 데이터는 안 건드린다(#55 ①) — 단위 표기는 «말»이라 화면이 붙인다. 관리자는 계속 `81.4g` 로만 적으면 된다.
// 🟢 이미 `gsm`·`g/㎡` 로 적혀 온 값은 안 건드린다 — `g` 뒤에 글자가 이어지면 \b 가 안 걸린다.
function gsmLine(spec){
  var s=String(spec||''); if(!s)return '';
  // 🔴 숫자와 단위는 **한 칸 띄운다**(2026-09-23 대표님) — 붙여 쓰면 덩어리로 읽힌다.
  //    「約 ¥2,983」에서 約 뒤를 띄운 것과 같은 판단이고, SI 표기 관행과도 맞다. 세 언어 모두 같다.
  return s.replace(/(\d)\s*g\b/g, function(_,d){ return d+L(' g/㎡',' gsm',' g/㎡'); });
}
function tagHeadOf(tag){
  var s=String(tag||'').trim(); if(!s)return '';
  var i=s.indexOf(' / ');
  return i<0?s:s.slice(0,i).trim();
}
function tagStoryOf(tag){
  var s=String(tag||'').trim(); if(!s)return '';
  var i=s.indexOf(' / ');
  return i<0?'':s.slice(i+3).trim();
}
// zoomTL(옵션 리스트 전용): 이미지 좌상단 1/4만 잘라 2배 확대해 보여준다.
// 작은 썸네일에서 텍스처·패턴이 안 보인다는 지적(2026-07-20) → 리스트에서만 확대.
// 상세뷰·프리뷰는 zoomTL 미전달이라 전체(커버 핏) 그대로.
// ── CDN 이미지 폭 바꾸기 (2026-09-22) ───────────────────────────────────────
// 빌드가 주입하는 URL 은 `...&width=1600`(목록·설명칸 기준)이다. **작은 썸네일까지 그 크기를 받고 있었다** —
// 표지 한 장이 1600px = 784KB 인데 화면에는 68×94 로 그린다. 표지 26장이면 **20MB**(실측, 2026-09-22 대표님 "어떨 땐 느리다").
// 🔴 Shopify 는 요청한 폭으로 줄여서 준다 — 500px = 158KB. **원본 크기와 무관하다**(원본이 커져도 여기선 안 느려진다).
// ⚠️ 폭을 줄일 때는 «그 캔버스가 실제로 필요한 픽셀»을 먼저 센다:
//    표지 격자는 백킹 240px + zoomTL 이 소스의 **절반만** 잘라 쓰므로 소스는 480px 이상이어야 한다 → 500.
//    내지 목록은 <img> 93×109 CSS × dpr2 = 218px → 500 이면 여유가 있다.
// URL 에 width 가 없으면(데모 데이터·외부 URL) 그대로 둔다.
function cdnW(u,w){ return String(u||'').replace(/([?&]width=)\d+/,'$1'+w); }
// 표지 격자는 «보일 때» 그린다(2026-09-22). 앞·뒤 두 격자가 처음부터 26장을 한꺼번에 받고 있었는데,
// 뒷표지 격자는 한참 아래에 있어 대부분 안 본 채로 받는다. 내지 목록은 <img loading=lazy> 라 이미 이렇게 돈다.
// 🔴 캔버스에는 loading=lazy 가 없어서 IntersectionObserver 로 대신한다. 지원 안 하면 바로 그린다(옛 브라우저 안전).
// rootMargin 300px — 스크롤해 닿기 «전에» 받아둬서 빈 칸이 보이지 않는다.
var _pmCovIO=(typeof IntersectionObserver!=='undefined')?new IntersectionObserver(function(es){
  es.forEach(function(e){ if(e.isIntersecting){ var f=e.target._pmDraw; if(f){e.target._pmDraw=null;f();} _pmCovIO.unobserve(e.target); } });
},{rootMargin:'300px'}):null;
function lazyDrawCov(canvas,fn){ if(!_pmCovIO){fn();return;} canvas._pmDraw=fn; _pmCovIO.observe(canvas); }
function drawCovThumb(canvas,cv,zoomTL){
  var ctx=canvas.getContext('2d');
  var w=canvas.width,h=canvas.height;
  ctx.fillStyle=cv.col||'#EDEAE3';ctx.fillRect(0,0,w,h);
  if(cv.img){
    // crossOrigin 미지정: 캔버스는 표시용(픽셀 미독출)이라 불필요하고, CORS 캐시 이슈로 미표시되는 걸 방지
    var _im=new Image();
    _im.onload=function(){ctx.imageSmoothingEnabled=true;ctx.imageSmoothingQuality='high';var ir=_im.width/_im.height,cr=w/h,sx,sy,sw,sh;if(ir>cr){sh=_im.height;sw=sh*cr;sx=0;sy=0;}else{sw=_im.width;sh=sw/cr;sx=0;sy=(_im.height-sh)/2;}if(zoomTL){sw/=2;sh/=2;sx=0;sy=0;}ctx.drawImage(_im,sx,sy,sw,sh,0,0,w,h);};
    _im.src=cv.img;return;
  }
  if(cv.cat==='texture'||cv.id==='v17'||cv.id==='v19'||cv.id==='v20'){
    ctx.strokeStyle='rgba(0,0,0,0.06)';ctx.lineWidth=0.5;
    for(var i=0;i<300;i+=5){ctx.beginPath();ctx.moveTo(i,0);ctx.lineTo(0,i);ctx.stroke();}
  }
  if(cv.id==='v15'){ctx.fillStyle='rgba(255,255,255,0.25)';for(var y=8;y<h;y+=18) for(var x=4;x<w;x+=18){ctx.beginPath();ctx.ellipse(x,y,3,7,0.3,0,Math.PI*2);ctx.fill();}}
  if(cv.id==='v14'){ctx.strokeStyle='rgba(80,80,120,0.2)';ctx.lineWidth=0.5;for(var y=6;y<h;y+=10) for(var x=6;x<w;x+=12){ctx.beginPath();ctx.arc(x,y,4,0,Math.PI*2);ctx.stroke();}}
  if(cv.id==='v16'){ctx.strokeStyle='rgba(100,90,70,0.18)';ctx.lineWidth=2.5;for(var x=0;x<w;x+=10){ctx.beginPath();ctx.moveTo(x,0);ctx.lineTo(x,h);ctx.stroke();}}
  if(cv.id==='v18'){ctx.fillStyle='rgba(255,200,160,0.3)';for(var y=8;y<h;y+=12) for(var x=6;x<w;x+=12){ctx.beginPath();ctx.arc(x,y,3,0,Math.PI*2);ctx.fill();}}
}

// ═══ INNERS ════════════════════════════════════════════════════════════
function renderInnerTabs(cats){
  var el=document.getElementById('in-tabs');el.innerHTML='';
  cats.forEach(function(cid){
    var b=document.createElement('button');
    var isLim=(cid==='special edition');
    b.className='tab'+(S.inn_cat===cid?' act':'')+(isLim?' limited':'');
    b.textContent=innCatLabel(cid);
    b.onclick=function(){S.inn_cat=cid;renderInnerGrid();};
    el.appendChild(b);
  });
}
function renderInnerGrid(){
  var g=document.getElementById('in-grid');g.innerHTML='';
  // 카테고리 탭을 실제 내지 데이터에서 생성 → 고정 순서(INN_CAT_ORDER)
  var cats=[];
  INNS.forEach(function(i){var k=innCatKey(i.cat); if(k&&cats.indexOf(k)<0)cats.push(k);});
  cats.sort(function(a,b){var ia=INN_CAT_ORDER.indexOf(a),ib=INN_CAT_ORDER.indexOf(b);return (ia<0?99:ia)-(ib<0?99:ib);});
  if(cats.indexOf(S.inn_cat)<0)S.inn_cat=cats[0];
  renderInnerTabs(cats);
  g.className='inner-grid';
  var planner=(S.inn_cat==='planner'); // 플래너는 옵션칸에선 오른쪽 페이지만 작게(단면처럼)
  var _pending=[]; // 캔버스는 먼저 붙이고, 레이아웃 확정 뒤 실제 표시크기×dpr 로 백킹을 잡아 그린다(선명도)
  INNS.filter(function(i){return innCatKey(i.cat)===S.inn_cat;}).forEach(function(inn){
    var cnt=S.inns.filter(function(x){return x===inn.id;}).length;
    var av=innAvail(inn);
    var wrap=document.createElement('div');
    wrap.className='inn-item'+(cnt>0?' sel':'')+(av.ok?'':' dis');
    // 실사 이미지는 <img object-fit:cover> — 브라우저가 어떤 dpr·확대에서도 1600px 원본을 최적 리샘플링(캔버스 축소 흐림 방지).
    // 패턴(데모, img 없음)만 캔버스로 그린다.
    var thumb;
    if(inn.img){
      thumb=document.createElement('img');thumb.className='inn-thumb';thumb.alt='';thumb.decoding='async';thumb.loading='lazy';
      if(planner)thumb.style.objectPosition='100% 50%'; // 플래너 스프레드: 오른쪽 페이지 위주로 크롭
      thumb.src=cdnW(inn.img,500);   // 목록 썸네일은 500px(표지 격자와 같은 이유 — cdnW 주석)
    } else {
      thumb=document.createElement('canvas');thumb.className='inn-thumb';
      _pending.push({canvas:thumb,inn:inn});
    }
    wrap.appendChild(thumb);
    // 안 맞는 내지: 회색 위에 '전용' 배지를 직접 얹는다(표지 'C 전용'과 동일 방식, 품절처럼 보이지 않게).
    if(!av.ok){
      var blbl;
      if(av.reason==='ori')blbl=L((av.o==='portrait'?'세로':'가로')+' 전용',(av.o==='portrait'?'Portrait':'Landscape')+' only',(av.o==='portrait'?'縦':'横')+'専用');
      else if(av.reason==='custom')blbl=L('A·B·C 전용','A·B·C only','A・B・C専用');
      if(blbl){var ibadge=document.createElement('div');ibadge.className='inn-only-badge';ibadge.textContent=blbl;wrap.appendChild(ibadge);}
    }
    var nm=document.createElement('div');nm.className='inn-nm';nm.textContent=pickLang(inn.n,inn.nEn);wrap.appendChild(nm);
    var sub=document.createElement('div');sub.className='inn-sub';sub.textContent=gsmLine(pickLang(inn.s,inn.sEn));wrap.appendChild(sub);
    if(cnt>0){var nb=document.createElement('div');nb.className='inn-num';nb.textContent=cnt+'×';wrap.appendChild(nb);}
    if(av.ok){
      // 클릭 = 구경(상세 열기). 담기는 상세창 오른쪽 위 버튼에서만 — 예전엔 클릭이 곧 담기라
      // 여러 내지를 둘러보려면 담은 걸 비워야 했다(최대 5세트 제한 때문).
      // 담기 전 '구경'에서도 모바일 상단 프리뷰를 접는다 — 안 접으면 상세창이 화면 밖으로 밀린다.
      wrap.onclick=function(){showInnDetail(inn);collapseMobilePreview();};
    } else {
      wrap.onclick=function(){
        showInnToast(av.reason==='custom'
          ?L('플래너는 표준 사이즈(A/B/C)에서만 선택할 수 있어요.','Planner is available only in standard sizes (A/B/C).','プランナーは標準サイズ（A/B/C）のみお選びいただけます。')
          :L((av.o==='portrait'?'세로':'가로')+' 방향 전용 내지예요. 노트 방향을 바꿔주세요.',
             'This inner is for '+(av.o==='portrait'?'vertical':'horizontal')+' notes. Change the note orientation.',
             (av.o==='portrait'?'縦':'横')+'向き専用の中紙です。ノートの向きを変更してください。'));
      };
    }
    g.appendChild(wrap);
  });
  // 레이아웃 확정 후 백킹 해상도 = 표시폭 × dpr (레티나·풀폭에서도 선명). aspect .85 유지, 상한 520px.
  var _dpr=Math.min(window.devicePixelRatio||1,3);
  _pending.forEach(function(p){
    var cw=p.canvas.clientWidth, bw=cw>0?Math.min(Math.round(cw*_dpr),520):340;
    p.canvas.width=bw;p.canvas.height=Math.round(bw/0.85);
    drawInnThumb(p.canvas,p.inn,p.canvas.height,p.canvas.width,{half:(planner?'right':null)});
  });
  renderInnCart();
  // 열려있는 내지 상세가 있으면 다시 그려 가격(사이즈 반영)·설명을 갱신
  var ind=document.getElementById('in-detail');
  if(_lastInn&&ind&&ind.className.indexOf('on')>=0)showInnDetail(_lastInn);
}
function drawInnThumb(canvas,inn,H,W,opts){
  H=H||68; W=W||80; var f=H/68;         // 그리드 썸네일=68, 상세=더 큰 H. 플래너 스프레드는 넓은 W
  opts=opts||{};
  var ctx=canvas.getContext('2d');
  // 실사 이미지(메타객체)가 있으면 이미지로 채움.
  //  - opts.spread: contain(펼침 전체, 상세·크게보기)
  //  - opts.half==='right': 소스의 오른쪽 절반만 사용(플래너 옵션칸을 단면처럼 작게)
  //  - 그 외: cover 크롭
  if(inn.img){
    ctx.fillStyle='#FAFAF5';ctx.fillRect(0,0,W,H);
    var _im=new Image(); // crossOrigin 미지정(표시용, CORS 캐시 이슈 방지)
    _im.onload=function(){
      ctx.imageSmoothingEnabled=true;ctx.imageSmoothingQuality='high'; // 축소 화질 개선(흐림 방지)
      var iw=_im.width, ih=_im.height, srcX=0, srcW=iw;
      if(opts.half==='right'){ srcX=iw/2; srcW=iw/2; }   // 오른쪽 페이지만
      var ir=srcW/ih, cr=W/H;
      if(opts.spread){ // contain: 잘리지 않게 전체 표시(레터박스)
        var dw=W,dh=H,dx=0,dy=0;
        if(ir>cr){dw=W;dh=W/ir;dy=(H-dh)/2;}else{dh=H;dw=H*ir;dx=(W-dw)/2;}
        ctx.drawImage(_im,srcX,0,srcW,ih,dx,dy,dw,dh);
      } else {    // cover: 채우고 넘치는 부분 크롭(선택 영역 srcX~srcW 안에서)
        var sx,sy,sw,sh;
        if(ir>cr){sh=ih;sw=sh*cr;sx=srcX+(srcW-sw)/2;sy=0;}else{sw=srcW;sh=sw/cr;sx=srcX;sy=(ih-sh)/2;}
        ctx.drawImage(_im,sx,sy,sw,sh,0,0,W,H);
      }
    };
    _im.src=inn.img;return;
  }
  var bg=inn.t==='bdark'?'#2A2A2A':inn.t==='bcream'?'#FAF6EC':'#FAFAF5';
  ctx.fillStyle=bg;ctx.fillRect(0,0,W,H);
  var lc=inn.t==='bdark'?'rgba(255,255,255,0.15)':'rgba(175,185,205,0.75)';
  ctx.strokeStyle=lc;ctx.lineWidth=0.6;
  var tt=inn.t,gg=inn.g||6;
  if(tt==='lined'||tt==='pocket'){for(var y=gg;y<H;y+=gg){ctx.beginPath();ctx.moveTo(3,y);ctx.lineTo(W-3,y);ctx.stroke();}}
  else if(tt==='grid'){for(var y=gg;y<H;y+=gg){ctx.beginPath();ctx.moveTo(0,y);ctx.lineTo(W,y);ctx.stroke();}for(var x=gg;x<W;x+=gg){ctx.beginPath();ctx.moveTo(x,0);ctx.lineTo(x,H);ctx.stroke();}}
  else if(tt==='dot'){ctx.fillStyle=lc;for(var y=gg;y<H;y+=gg) for(var x=gg;x<W;x+=gg){ctx.beginPath();ctx.arc(x,y,0.85,0,Math.PI*2);ctx.fill();}}
  else if(tt==='cornell'){var cd=52*f;ctx.beginPath();ctx.moveTo(22,0);ctx.lineTo(22,cd);ctx.stroke();ctx.beginPath();ctx.moveTo(0,cd);ctx.lineTo(W,cd);ctx.stroke();for(var y=8;y<cd-1;y+=7){ctx.beginPath();ctx.moveTo(24,y);ctx.lineTo(W-4,y);ctx.stroke();}}
  else if(tt==='weekly'){var wt=12*f;ctx.beginPath();ctx.moveTo(0,wt);ctx.lineTo(W,wt);ctx.stroke();for(var x=11;x<W;x+=11){ctx.beginPath();ctx.moveTo(x,wt);ctx.lineTo(x,H);ctx.stroke();}}
  else if(tt==='daily'){for(var y=10*f;y<H;y+=7){ctx.beginPath();ctx.moveTo(0,y);ctx.lineTo(W,y);ctx.stroke();}ctx.strokeStyle='rgba(175,185,205,0.35)';ctx.beginPath();ctx.moveTo(18,10*f);ctx.lineTo(18,H);ctx.stroke();}
  else if(tt==='todo'){for(var y=10*f;y<H;y+=9){ctx.strokeRect(3,y-3,5,5);ctx.beginPath();ctx.moveTo(11,y);ctx.lineTo(W-4,y);ctx.stroke();}}
  else if(tt==='music'){for(var base=12*f;base<H;base+=14) for(var l=0;l<5;l++){ctx.beginPath();ctx.moveTo(4,base+l*2.2);ctx.lineTo(W-4,base+l*2.2);ctx.stroke();}}
  else if(tt==='trace'){ctx.strokeStyle='rgba(100,160,100,0.18)';for(var y=5;y<H;y+=5){ctx.beginPath();ctx.moveTo(0,y);ctx.lineTo(W,y);ctx.stroke();}for(var x=5;x<W;x+=5){ctx.beginPath();ctx.moveTo(x,0);ctx.lineTo(x,H);ctx.stroke();}}
}
function addInn(id,inn){
  if(S.inns.length>=5){
    // 내지 선택 섹션 근처에 토스트 표시
    showInnToast(t('toast-max'));
    return;
  }
  S.inns.push(id);setPrevSide('front');showInnDetail(inn);renderInnerGrid();render();
  collapseMobilePreview();   // 내지를 선택하는 순간 상단 프리뷰를 접어 선택란이 보이게
}
// 모바일 상단 프리뷰 즉시 접기 (모바일에서만)
// 🔴 접을 때마다 «펼치기» 띠에 신호를 다시 준다(2026-09-23 대표님: "존재감을 좀 보여줄 수 있나").
//    애니메이션은 클래스를 다시 붙인다고 다시 돌지 않는다 — 떼고, **레이아웃을 한 번 읽어** 브라우저가
//    «없어졌다»고 인정하게 한 뒤 붙여야 처음부터 다시 돈다(offsetWidth 읽기가 그 역할).
function collapseMobilePreview(){
  var prev=document.getElementById('mobile-preview');
  if(!prev||getComputedStyle(prev).display==='none')return;
  prev.classList.add('mini');
  var btn=document.getElementById('mobile-prev-reopen');
  prev.classList.remove('nudge');
  if(btn)void btn.offsetWidth;
  prev.classList.add('nudge');
}
// 모바일 상단 프리뷰 다시 펼치기 (내지 모두 비웠을 때)
function expandMobilePreview(){
  var prev=document.getElementById('mobile-preview');
  if(prev)prev.classList.remove('mini','nudge');   // 펼쳤으면 신호도 끝이다
  // 접혀 있는 동안은 내역 높이를 못 쟀다(fitMobileSum 이 건너뛴다) → 펼치는 지금 다시 잰다.
  // 두 번 부르는 이유: max-height 전환이 .35s 라 바로 재면 아직 그림이 제 높이가 아니다.
  if(typeof fitMobileSum==='function'){ fitMobileSum(); setTimeout(fitMobileSum,400); }
}
function showInnToast(msg){
  var el=document.getElementById('inn-toast');
  if(!el)return;
  el.textContent=msg;el.style.display='block';
  setTimeout(function(){el.textContent='';el.style.display='none';},2800);
}
var _lastInn=null;
// 유튜브 URL(watch?v=·youtu.be·shorts·embed·순수 11자 ID)을 음소거 자동재생 루프 임베드로.
// loop 는 유튜브 규격상 playlist=같은ID 를 줘야 먹는다. 인식 실패(빈 문자열)면 영상 안 뜸.
function ytId(u){
  if(!u)return '';
  u=(''+u).trim();
  var m=u.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/))([A-Za-z0-9_-]{11})/);
  return m?m[1]:(/^[A-Za-z0-9_-]{11}$/.test(u)?u:'');
}
function ytEmbed(u){
  var id=ytId(u);
  if(!id)return '';
  return 'https://www.youtube.com/embed/'+id+'?autoplay=1&mute=1&loop=1&playlist='+id+'&controls=1&modestbranding=1&rel=0&playsinline=1';
}
function showInnDetail(inn){
  _lastInn=inn;
  var el=document.getElementById('in-detail');
  var spread=innIsSpread(inn);
  var land=S.dir==='landscape';           // 가로 노트면 단면 내지도 가로로 긴 이미지로
  // 가로로 긴 이미지(플래너 펼침 또는 가로 노트)는 상단 이미지·하단 설명(stack).
  // 세로로 긴 이미지(세로 노트 단면)는 좌측 이미지·우측 설명(기본 좌우 배치).
  var wide=spread||land;
  el.className='inn-detail on'+(wide?' stack':'');
  var pr=innPrice(inn.id);
  var imgDiv=document.createElement('div');imgDiv.className='inn-detail-img'+(spread?' spread':(land?' land':''));
  var media;
  if(inn.img){
    // 실사 이미지: 상세는 전체 보기 — <img> 자연 비율(캔버스 축소 흐림 없이 원본 그대로 선명).
    media=document.createElement('img');media.className='inn-detail-media';media.src=inn.imgHi||inn.img;media.alt='';media.decoding='async';
    media.onclick=function(){openImgZoom('inn',inn);};
  } else {
    // 패턴(데모, img 없음)만 캔버스로.
    media=document.createElement('canvas');
    media.style.cursor='zoom-in';media.onclick=function(){openImgZoom('inn',inn);};
    if(spread){ media.width=680;media.height=420; drawInnThumb(media,inn,420,680,{spread:true}); }
    else if(land){ var LW=108,LH=80;media.width=648;media.height=480;media.getContext('2d').scale(648/LW,480/LH);drawInnThumb(media,inn,LH,LW); }
    else { var IW=80,IH=108;media.width=480;media.height=648;media.getContext('2d').scale(480/IW,648/IH);drawInnThumb(media,inn,IH); }
  }
  imgDiv.appendChild(media);
  var zbi=document.createElement('button');zbi.className='detail-zoom';zbi.type='button';
  zbi.title=L('크게보기','Zoom','拡大表示');zbi.innerHTML='🔍';
  zbi.onclick=function(e){e.stopPropagation();openImgZoom('inn',inn);};imgDiv.appendChild(zbi);
  var nm=pickLang(inn.n,inn.nEn),sub=gsmLine(pickLang(inn.s,inn.sEn)),desc=pickLang(inn.d,inn.dEn,inn.dJa);
  var txt=document.createElement('div');txt.className='inn-detail-txt';
  // 이름·스펙은 위(head), 썸네일 줄은 head 아래로 밀어 기본 이미지 하단 라인에 맞춘다.
  // 표지와 같은 순서(2026-09-22): 번호 · 이름 · 첫인상 한 줄 · 사양. 가격은 아래 설명 밑에 이미 있다(대표님).
  var innTagTxt=tagHeadOf(innTag(inn));
  var head=document.createElement('div');head.className='inn-detail-txt-head';
  head.innerHTML=(inn.no?'<span class="inn-detail-no">'+inn.no+'</span>':'')+'<strong>'+nm+'</strong>'
    +(innTagTxt?'<span class="inn-detail-tag">'+shopEsc(innTagTxt)+'</span>':'')+sub;
  txt.appendChild(head);
  // 추가 상세 이미지(image_detail) + 영상: 기본 이미지 하단 라인에 맞춘 가로 썸네일 줄.
  // 첫 칸=기본 이미지(복귀·활성). 이미지 썸네일 클릭=왼쪽 큰 이미지 교체,
  // 영상 썸네일(▶ 표시로 구분) 클릭=그 자리에서 재생. 실사 메인 이미지 있을 때만(패턴 데모는 아래 폴백).
  var shots=(inn.imgsDetail||[]).filter(Boolean);
  var vid=inn.img?ytId(inn.video):'';
  if((shots.length||vid)&&inn.img){
    el.classList.add('has-shots');
    var allShots=[inn.imgHi||inn.img].concat(shots);
    var curShot=allShots[0];
    var thumbs=document.createElement('div');thumbs.className='inn-detail-thumbs';
    function clearAct(){thumbs.querySelectorAll('.inn-detail-thumb').forEach(function(x){x.classList.remove('act');});}
    // 이미지 썸네일: 왼쪽 큰 이미지 교체(활성 이동).
    allShots.forEach(function(u,i){
      var t=document.createElement('img');t.className='inn-detail-thumb'+(i===0?' act':'');
      t.src=u;t.alt='';t.loading='lazy';t.decoding='async';
      t.onclick=function(){clearAct();t.classList.add('act');curShot=u;media.src=u;};
      thumbs.appendChild(t);
    });
    // 영상 썸네일(▶): 세로 이미지 자리에서 재생하면 너무 작아 → 팝업(라이트박스)으로 크게 재생.
    // 큰 이미지는 안 바꾸므로 활성 표시도 옮기지 않는다.
    if(vid){
      var vt=document.createElement('button');vt.type='button';vt.className='inn-detail-thumb vid';
      vt.style.backgroundImage="url('https://img.youtube.com/vi/"+vid+"/hqdefault.jpg')";
      vt.setAttribute('aria-label',L('영상 재생','Play video','動画を再生'));
      vt.innerHTML='<span class="pv-play">▶</span>';
      vt.onclick=function(){openVidPop(inn.video);};
      thumbs.appendChild(vt);
    }
    txt.appendChild(thumbs);
    // 돋보기·큰 이미지 클릭은 '지금 보이는' 사진으로 크게보기
    media.onclick=function(){openImgZoom('inn',Object.assign({},inn,{img:curShot,imgHi:curShot}));};
    zbi.onclick=function(e){e.stopPropagation();openImgZoom('inn',Object.assign({},inn,{img:curShot,imgHi:curShot}));};
  }
  var top=document.createElement('div');top.className='inn-detail-top';
  top.appendChild(imgDiv);top.appendChild(txt);
  var dsc=document.createElement('div');dsc.className='inn-detail-desc';
  dsc.innerHTML=desc||'';
  // 폴백: 실사 메인 이미지가 없는(패턴 데모) 경우에만 옛 방식(설명 아래 갤러리).
  if(shots.length&&!inn.img){
    var gal=document.createElement('div');gal.className='inn-detail-gallery';
    shots.forEach(function(u){
      var g=document.createElement('img');g.className='inn-detail-shot';g.src=u;g.alt='';g.loading='lazy';g.decoding='async';
      g.onclick=function(){openImgZoom('inn',Object.assign({},inn,{img:u,imgHi:u}));};
      gal.appendChild(g);
    });
    if(gal.children.length)dsc.appendChild(gal);
  }
  // 영상(detail_video): 실사 이미지가 있으면 썸네일로 재생하므로, 여기(설명 아래)는
  // 실사 메인 이미지가 없는 패턴 데모에서만 폴백으로 띄운다.
  if(inn.video&&!inn.img){
    var vurl=ytEmbed(inn.video);
    if(vurl){
      var vw=document.createElement('div');vw.className='inn-detail-video';
      var ifr=document.createElement('iframe');
      ifr.src=vurl;ifr.title=L(nm+' 영상',nm+' video',nm+' の動画');ifr.loading='lazy';
      ifr.setAttribute('frameborder','0');
      ifr.setAttribute('allow','autoplay; encrypted-media; picture-in-picture');
      ifr.setAttribute('allowfullscreen','');
      vw.appendChild(ifr);dsc.appendChild(vw);
    }
  }
  var prEl=document.createElement('div');prEl.className='inn-detail-pr';
  prEl.textContent=pr.toLocaleString()+(inn.unit?L('원 / '+inn.unit+'장 1세트',' KRW / 1 set of '+inn.unit+' sheets',' KRW / '+inn.unit+'枚1セット'):t('per-set'));
  fxAppend(prEl,pr);
  dsc.appendChild(prEl);
  el.innerHTML='';el.appendChild(top);el.appendChild(dsc);
  // 오른쪽 위 담기 버튼 (격자 클릭은 상세 열기만 하므로 실제 담기는 여기서).
  // float:right 라 번호·이름 줄 오른쪽에 끼어든다 → 이름칸 head 의 맨 앞에 넣어야 한다
  // (txt 는 이제 flex 컬럼이라 float 이 안 먹으니 반드시 블록인 head 안에).
  var acnt=S.inns.filter(function(x){return x===inn.id;}).length;
  var aav=innAvail(inn), afull=(S.inns.length>=5);
  var ab=document.createElement('button');ab.className='inn-add-btn';ab.type='button';
  if(!aav.ok){
    ab.disabled=true;
    ab.textContent=aav.reason==='custom'?L('A·B·C 전용','A·B·C only','A・B・C専用')
      :L((aav.o==='portrait'?'세로':'가로')+' 전용',(aav.o==='portrait'?'Portrait':'Landscape')+' only',(aav.o==='portrait'?'縦':'横')+'専用');
  } else if(afull){
    ab.disabled=true;ab.textContent=L('최대 5세트','Max 5 sets','最大5セット');
  } else {
    ab.textContent=L('+ 담기','+ Add','+ 追加')+(acnt>0?' ('+acnt+')':'');
    ab.onclick=function(e){e.stopPropagation();addInn(inn.id,inn);};
  }
  head.insertBefore(ab,head.firstChild);
}
function removeInn(idx){S.inns.splice(idx,1);if(!S.inns.length)expandMobilePreview();renderInnerGrid();render();}
function renderInnCart(){
  var el=document.getElementById('in-list');
  if(!S.inns.length){
    el.innerHTML='<div style="font-size:11px;color:var(--t3);padding:7px 0">'+L('내지를 클릭해서 추가하세요.','Click to add inner pages.','中紙をクリックして追加してください。')+'</div>';
    document.getElementById('in-hint').textContent='';return;
  }
  el.innerHTML='';
  var dragEl=null,dragInn=null,moved=false;
  function rowAfter(y){
    var rows=[].slice.call(el.querySelectorAll('.inn-row:not(.dragging)'));
    for(var k=0;k<rows.length;k++){var b=rows[k].getBoundingClientRect();if(y<b.top+b.height/2)return rows[k];}
    return null;
  }
  function renumber(){ // 현재 DOM 순서대로 번호 다시 매김 (드래그 중에도 즉시 반영)
    [].slice.call(el.querySelectorAll('.inn-row .inn-row-n')).forEach(function(s,k){s.textContent=k+1;});
  }
  function endDrag(){
    if(!dragEl)return;
    dragEl.classList.remove('dragging');
    var inn=dragInn,wasMoved=moved;dragEl=null;dragInn=null;
    if(wasMoved){
      // 새로 쌓인 DOM 순서대로 S.inns 재정렬 (renderInnerGrid가 renderInnCart도 호출 → 번호 재부여)
      S.inns=[].slice.call(el.querySelectorAll('.inn-row')).map(function(r){return r.dataset.id;});
      renderInnerGrid();render();
    } else if(inn){
      showInnDetail(inn);   // 끌지 않고 클릭만 했으면 해당 내지 설명 표시
    }
  }
  S.inns.forEach(function(id,i){
    var inn=INNS.find(function(x){return x.id===id;});
    var pr=innPrice(id);
    var nm=pickLang(inn.n,inn.nEn);
    var row=document.createElement('div');row.className='inn-row';row.dataset.id=id;
    row.title=L('클릭=설명 보기 · 드래그=순서 변경','Click for details · drag to reorder','クリックで詳細 · ドラッグで並べ替え');
    row.innerHTML='<span class="inn-row-grip">⠿</span>'
      +'<span class="inn-row-n">'+(i+1)+'</span><span class="inn-row-nm">'+nm+'</span>'
      +'<span class="inn-row-pr">'+pr.toLocaleString()+'</span>'
      +'<button class="inn-row-rm" onclick="removeInn('+i+')">×</button>';
    // 행 전체: 클릭=설명, 드래그=순서 변경 (× 삭제 버튼만 제외)
    // 이동/놓기는 document 레벨에서 듣는다 → 포인터를 행 바깥에서 놓아도 endDrag가 확실히 호출됨
    row.addEventListener('pointerdown',function(e){
      if(e.target.closest('.inn-row-rm'))return;
      e.preventDefault();dragEl=row;dragInn=inn;moved=false;row.classList.add('dragging');
      function onMove(ev){
        if(!dragEl)return;
        var after=rowAfter(ev.clientY);
        if(after==null){if(el.lastElementChild!==dragEl){el.appendChild(dragEl);moved=true;}}
        else if(after!==dragEl){el.insertBefore(dragEl,after);moved=true;}
        if(moved)renumber();
      }
      function onUp(){
        document.removeEventListener('pointermove',onMove);
        document.removeEventListener('pointerup',onUp);
        document.removeEventListener('pointercancel',onUp);
        endDrag();
      }
      document.addEventListener('pointermove',onMove);
      document.addEventListener('pointerup',onUp);
      document.addEventListener('pointercancel',onUp);
    });
    el.appendChild(row);
  });
  var left=5-S.inns.length;
  document.getElementById('in-hint').textContent=
    S.inns.length<2?t('hint-more')(2-S.inns.length):left>0?t('hint-add')(left):t('hint-done');
}

// ═══ SUMMARY ══════════════════════════════════════════════════════════
function updateSum(){
  var sz=SIZES.find(function(x){return x.id===S.size;});
  var bnd=BANDS.find(function(x){return x.id===S.band;});
  var fcc=COVS.find(function(x){return x.id===S.fc;});
  var bcc=COVS.find(function(x){return x.id===S.bcover;});
  var scName=S.sp==='full'
    ?(SC.find(function(x){return x.id===S.sc;})||{n:''}).n
    :L('위 ','Top ','上 ')+(SC.find(function(x){return x.id===S.sc_top;})||{n:''}).n
      +L(' / 아래 ',' / Bot ',' / 下 ')+(SC.find(function(x){return x.id===S.sc_bot;})||{n:''}).n;
  var szStr=S.size==='X'
    ?(S.cw&&S.ch?'Custom '+S.cw+'×'+S.ch+'mm':'Custom')
    :L(sz.id+' 사이즈 ',sz.id+' ',sz.id+' サイズ ')+sz.w+'×'+sz.h+'mm';
  var bandStr=t('band-'+S.band);
  if(S.band==='double'||S.band==='corner'){
    var b1n=(BC.find(function(x){return x.id===S.bc1;})||{n:''}).n;
    var b2n=(BC.find(function(x){return x.id===S.bc2;})||{n:''}).n;
    if(b1n)bandStr+=' · '+b1n+(b1n!==b2n?' / '+b2n:'');
  } else if(S.band!=='none'){
    var bcn=(BC.find(function(x){return x.id===S.bc;})||{n:''}).n;
    if(bcn)bandStr+=' · '+bcn;
  }
  function setText(id,v){var el=document.getElementById(id);if(el)el.textContent=v;}
  setText('sv-size',szStr);
  setText('sv-dir',S.dir==='portrait'?t('dir-portrait'):t('dir-landscape'));
  if(S.springChosen){setText('sv-sp',spTypeName()+' · '+scName);setText('svp-sp','+1,500');}
  else{setText('sv-sp',L('선택 안 함','Not selected','選択なし'));setText('svp-sp','');}
  setText('sv-band',bandStr);
  setText('svp-band',bnd.p?'+'+bnd.p.toLocaleString():'');
  setText('sv-fc',fcc?fcc.n:'—');
  setText('svp-fc',fcc?'+'+covPrice(S.fc).toLocaleString():'');
  setText('sv-bc',bcc?bcc.n:'—');
  setText('svp-bc',bcc?'+'+covPrice(S.bcover).toLocaleString():'');
  var inEl=document.getElementById('sv-inn');
  if(!S.inns.length){inEl.textContent='—';}
  else{
    var pInnSum=0;
    var pInnHtml=S.inns.map(function(id,i){
      var inn=INNS.find(function(x){return x.id===id;});
      var nm=pickLang(inn.n,inn.nEn);
      pInnSum+=(inn&&inn.unit)?(parseInt(inn.unit,10)||0):0;
      var uStr=inn.unit?L(' ('+inn.unit+')장',' ('+inn.unit+')',' ('+inn.unit+')枚'):'';
      return '<span>'+(i+1)+'. '+nm+uStr+' <span style="font-family:var(--m);font-size:9px;color:var(--t3)">+'+innPrice(id).toLocaleString()+'</span></span>';
    }).join('<br>');
    if(pInnSum)pInnHtml+='<br><span style="font-weight:500">'+L('총 '+pInnSum+'장','Total '+pInnSum,'合計 '+pInnSum+'枚')+'</span>';
    inEl.innerHTML=pInnHtml;
  }
  var big=isCustomOutOfRange();
  var customOk=S.size!=='X'||(S.cw&&S.ch&&!big);
  // 🔴 스프링은 **필수**다(2026-09-22 대표님: "스프링을 선택하지 않아도 결제로 넘어간다. 스프링 방식은 필수조건인데").
  //    "선택 전 미표시"(DECISIONS — 표지를 깨끗이 보고 나서 얹는 UX)가 "안 골라도 됨"으로 굳어 있었다.
  //    담기·위시 버튼, 장바구니 주문 버튼(cartSpringMissing), Worker(price.mjs 'spring required') 세 곳이 같은 조건이다.
  var ready=S.springChosen&&S.fc&&S.bcover&&S.inns.length>=2&&customOk;
  var wonStr=t('won');
  if(big){
    // 커스텀 사이즈가 범위를 벗어남 — 가격 산정 불가
    setText('p-total','—');
    setText('p-bk',L('A 초과 — 별도 문의','Exceeds max — contact us','Aサイズ超 — お問い合わせください'));
    setText('mobile-price','—');
    setText('mobile-bottom-price','—');
    setText('mobile-sum',L('사이즈가 범위를 초과했습니다.','Size exceeds range.','サイズが範囲を超えています。'));
  } else {
    // 선택한 항목만으로 실시간 누계 표시 (표지·내지 미선택이어도 스프링/잠금/커스텀 등은 바로 합산)
    var p=totalPrice();
    setPrice('p-total',p.total.toLocaleString()+wonStr,p.total);
    var lines=[
      S.springChosen?(L('스프링','Spring','スプリング')+' +1,500'):'',
      bnd.p?L('잠금','Closure','留め方')+' +'+bnd.p.toLocaleString():'',
      p.custom?L('커스텀','Custom','カスタム')+' +'+p.custom.toLocaleString():'',
      fcc?L('앞표지','Front','表紙')+' +'+p.fc.toLocaleString():'',
      bcc?L('뒷표지','Back','裏表紙')+' +'+p.bc.toLocaleString():'',
      S.inns.length?L('내지','Inner','中紙')+' +'+p.inn.toLocaleString():'',
      S.qty>1?'× '+S.qty+L('개','','点'):'',
    ].filter(Boolean);
    if(!ready)lines.push('<span style="color:var(--t3)">※ '+L('스프링 + 표지 앞뒤 + 내지 2세트 이상 선택 시 주문 가능','Add spring + covers + 2 inner sets to order','スプリング・表紙（表・裏）・中紙2セット以上でご注文いただけます')+'</span>');
    // 배송비 규칙 — 합계 바로 아래(2026-09-22). 합계에 더하지 않고 규칙만 보인다(주소를 알아야 정해지므로).
    lines.push('<span class="p-ship">'+shipNoteHtml()+'</span>');
    // 환산 각주 — 합계 아래 한 번. 매 가격마다 붙이면 시끄럽고, 결제로 이어지는 자리에 있어야 뜻이 있다.
    if(fxNote())lines.push('<span style="color:var(--t3)">'+fxNote()+'</span>');
    document.getElementById('p-bk').innerHTML=lines.join('<br>');
    setPrice('mobile-price',p.total.toLocaleString()+wonStr,p.total);
    setPrice('mobile-bottom-price',p.total.toLocaleString()+wonStr,p.total);
    var spName=spTypeName();
    var bandName=S.band==='none'?'':t('band-'+S.band);
    var bcName=(S.band==='double'||S.band==='corner')
      ?(BC.find(function(x){return x.id===S.bc1;})||{n:''}).n+' / '+(BC.find(function(x){return x.id===S.bc2;})||{n:''}).n
      :(BC.find(function(x){return x.id===S.bc;})||{n:''}).n;
    // 내지는 바꾼 순서 그대로 번호를 붙여 표시
    var innOrdered=S.inns.map(function(id,i){var inn=INNS.find(function(x){return x.id===id;});var nm=inn?pickLang(inn.n,inn.nEn):'?';return (i+1)+'. '+nm;});
    var dirStr=S.dir==='portrait'?t('dir-portrait'):t('dir-landscape');
    function msEsc(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}
    var msRows=[
      {k:L('사이즈','Size','サイズ'), v:szStr},
      {k:L('방향','Orientation','向き'), v:dirStr}
    ];
    if(S.springChosen)msRows.push({k:L('스프링','Spring','スプリング'), v:spName+(scName?' · '+scName:'')+' +1,500'+wonStr});
    if(bandName)msRows.push({k:L('잠금','Lock','留め方'), v:bandName+(bcName?' · '+bcName:'')+(bnd.p?' +'+bnd.p.toLocaleString()+wonStr:'')});
    if(p.custom)msRows.push({k:L('커스텀','Custom','カスタム'), v:'+'+p.custom.toLocaleString()+wonStr});
    if(fcc)msRows.push({k:L('앞표지','Front','表紙'), v:fcc.n+' +'+p.fc.toLocaleString()+wonStr});
    if(bcc)msRows.push({k:L('뒤표지','Back','裏表紙'), v:bcc.n+' +'+p.bc.toLocaleString()+wonStr});
    if(S.inns.length)msRows.push({k:L('내지','Inner','中紙'), v:innOrdered.join(' / ')+' ('+S.inns.length+L('세트)',' sets)','セット)')+' +'+p.inn.toLocaleString()+wonStr});
    var msHtml=msRows.map(function(r){return '<div class="ms-row"><span class="ms-k">'+msEsc(r.k)+'</span> '+msEsc(r.v)+'</div>';}).join('');
    document.getElementById('mobile-sum').innerHTML=msHtml;
    // 🔴 아래 세 줄은 **접어도 보이는 칸**(#mobile-hint)에 둔다 — 지금 담을 수 있는지·배송비·환산은
    //    내역을 접은 채로도 알아야 하는 값이다(2026-09-22 요약 접기와 한 쌍).
    var hintEl=document.getElementById('mobile-hint');
    if(hintEl){
      var hints=[];
      if(!ready)hints.push(L('※ 스프링 + 표지 앞뒤 + 내지 2세트 이상 선택 시 주문 가능','※ Add spring + covers + 2 inner sets to order','※ スプリング・表紙（表・裏）・中紙2セット以上を選ぶとご注文いただけます'));
      hints.push(shipNoteParts()[0]);   // 모바일 칸은 좁다 — 기본 규칙 한 줄만(제주·해외는 장바구니에)
      if(fxNote())hints.push(fxNote());
      hintEl.innerHTML=hints.map(msEsc).join('<br>');
    }
    syncMobileSum();
  }
  document.getElementById('btn-add').disabled=!ready;
  document.getElementById('btn-wish').disabled=!ready;
  ['mobile-add-btn','mobile-wish-btn','mobile-bottom-add','mobile-bottom-wish'].forEach(function(id){
    var el=document.getElementById(id);if(el)el.disabled=!ready;
  });
  document.getElementById('qty-n').textContent=S.qty;
}

// ── 모바일 미리보기 «내역» 접기 (2026-09-22, 대표님 제안) ───────────────────
// 그림은 그대로 두고 오른쪽 내역만 접는다 — 블록 높이를 키우는 게 내역이라 옵션 영역이 그만큼 돌아온다(실측 +140px).
// 기본은 접힘. 한 번 펼치면 그 선택을 기억한다(고르는 내내 펼쳐 두고 싶은 사람도 있다).
var PM_SUMOPEN_LS='paperme_sumopen_v1';
var _pmSumOpen=(function(){try{return localStorage.getItem(PM_SUMOPEN_LS)==='1';}catch(e){return false;}})();
// 접힌 내역의 높이를 **왼쪽 그림에 맞춰** 잰다 (2026-09-22 대표님: "초기화 버튼이 왼쪽 이미지 크기를 벗어나지 않는 선까지
// 내역이 쌓이는 게 보이고, 그다음 그라데이션으로 사라지면 좋겠다").
// 🔴 고정값(3.2em 등)으로 둘 수 없다 — 가격·안내 줄 수와 버튼 높이가 언어·선택 상태에 따라 달라지므로 그때그때 재야 한다.
// 순서: 내역을 잠깐 제한 없이 펴서 «지금 자리»를 잰 뒤, 그림 아래끝에서 버튼 몫을 뺀 만큼만 남긴다.
function fitMobileSum(){
  var wrap=document.getElementById('mobile-preview');
  if(!wrap||getComputedStyle(wrap).display==='none')return;      // 데스크톱에서는 이 블록이 없다
  // 🔴 «접힌 미리보기(.mini)» 동안에는 재지 않는다 — 내지를 담으면 프리뷰가 통째로 접히는데(collapseMobilePreview),
  //    그때 자식이 display:none 이라 그림 높이가 0 이다. 0 을 기준으로 재면 내역이 최소값(28px)에 갇히고
  //    손잡이까지 사라져, 다시 펼쳤을 때 «상태가 이상»해진다(2026-09-22 대표님 발견). 펼칠 때 다시 잰다.
  if(wrap.classList.contains('mini'))return;
  var sum=document.getElementById('mobile-sum'), btn=document.getElementById('mps-toggle'),
      btns=wrap.querySelector('.mobile-prev-btns'), img=document.getElementById('nbk-svg-mobile');
  if(!sum||!btn||!btns||!img)return;
  if(img.getBoundingClientRect().height<10)return;                // 그림이 아직 안 그려졌으면 다음 기회에
  if(_pmSumOpen){ sum.style.maxHeight=''; sum.classList.remove('mps-more'); btn.style.display=''; return; }   // 펼친 상태는 제한 없음
  sum.style.maxHeight='none';                                     // 잴 때는 제한을 풀고
  var mt=function(el){return parseFloat(getComputedStyle(el).marginTop)||0;};
  var imgBottom=img.getBoundingClientRect().bottom;               // 왼쪽 그림의 아래끝 = 넘지 말아야 할 선
  var below=btn.offsetHeight+mt(btn)+btns.offsetHeight+mt(btns);  // 내역 아래에 놓이는 것들(버튼 줄 둘)
  var avail=imgBottom-sum.getBoundingClientRect().top-below;
  sum.style.maxHeight=Math.max(28,Math.round(avail))+'px';        // 최소 두 줄은 남긴다(그림이 아주 작을 때 대비)
  // 가려진 내용이 있을 때만 그라데이션 + 「내역 보기」 손잡이. 다 보이면 둘 다 군더더기다.
  var more=sum.scrollHeight>sum.clientHeight+2;
  sum.classList.toggle('mps-more',more);
  btn.style.display=more?'':'none';
}
function syncMobileSum(){
  var el=document.getElementById('mobile-sum'), btn=document.getElementById('mps-toggle');
  if(!el||!btn)return;
  el.classList.toggle('mps-collapsed',!_pmSumOpen);
  btn.textContent=_pmSumOpen?L('내역 접기 ▴','Hide details ▴','内訳をとじる ▴'):L('내역 보기 ▾','Details ▾','内訳をみる ▾');
  fitMobileSum();
}
// 화면을 돌리거나 폭이 바뀌면 그림 높이도 바뀐다 — 다시 잰다.
window.addEventListener('resize',function(){ if(typeof syncMobileSum==='function')fitMobileSum(); });
function toggleMobileSum(){
  _pmSumOpen=!_pmSumOpen;
  try{localStorage.setItem(PM_SUMOPEN_LS,_pmSumOpen?'1':'0');}catch(e){}
  syncMobileSum();
}
function render(){drawPreview();updateSum();}

// ═══ RESET ════════════════════════════════════════════════════════════
function resetAll(){
  S=JSON.parse(JSON.stringify(DEFAULT_STATE));
  if(EDIT){EDIT=null;syncEditMode();}   // 「처음부터」는 새 노트다 — 장바구니 항목을 덮어쓰는 편집을 여기서 푼다
  // 커스텀 입력 필드도 초기화
  var cw=document.getElementById('cw'); if(cw) cw.value='';
  var ch=document.getElementById('ch'); if(ch) ch.value='';
  expandMobilePreview();   // 초기화하면 내지도 비워지므로 상단 프리뷰 다시 펼침
  renderAll();
  toast(L('선택이 초기화됐어요.','Selections reset.','選択をリセットしました。'));
}

// ═══ QTY / CART / WISH ════════════════════════════════════════════════
function setQty(d){S.qty=Math.max(1,Math.min(99,S.qty+d));render();}
function buildCfg(){
  return{id:Date.now(),snap:JSON.parse(JSON.stringify(S)),price:totalPrice(),
    fc:COVS.find(function(x){return x.id===S.fc;}),
    bcover:COVS.find(function(x){return x.id===S.bcover;}),
    inns:S.inns.map(function(id){return INNS.find(function(x){return x.id===id;});}),
    size:SIZES.find(function(x){return x.id===S.size;})};
}
// 장바구니에 담긴 항목의 **자기 사이즈**로 S 를 잠깐 맞춰 fn 을 실행하고 되돌린다.
// 🔴 covPrice()/innPrice() 가 전역 S.size·S.cw·S.ch 를 보기 때문에 필요하다.
//    그냥 부르면 "빌더에서 지금 선택된 사이즈" 기준 가격이 나온다 — 고객이 A 노트를 담아둔 뒤
//    빌더에서 C 로 바꾸면 **담아둔 A 노트의 주문서에 C 가격이 찍힌다.**
//    (결제 금액 자체는 서버가 다시 계산하므로 정확하다. 틀어지는 건 주문서에 적히는 항목별 금액 —
//     대표님이 제작할 때 보는 문서라 숫자가 어긋나면 안 된다.)
// comboSpecHtml 이 쓰는 withComboState 와 같은 수법이다. 반드시 finally 로 되돌릴 것 — S 는 빌더의 전역 상태다.
function withSnapState(snap,fn){
  var _s=S.size,_w=S.cw,_h=S.ch,_d=S.dir;
  if(snap){
    if(snap.size)S.size=snap.size;
    if(snap.cw)S.cw=snap.cw;
    if(snap.ch)S.ch=snap.ch;
    if(snap.dir)S.dir=snap.dir;
  }
  try{ return fn(); }
  finally{ S.size=_s;S.cw=_w;S.ch=_h;S.dir=_d; }
}
// ═══ 배송 무게 ═════════════════════════════════════════════════════════
// 주문 시 Draft Order 의 line item 에 실어 보낸다 → Shopify 가 무게 기준 배송료를 계산한다.
// 🔴 값의 근거는 전부 대표님 실측(2026-08-11). 바꿀 일이 있으면 **여기만** 고치면 된다.
//    검증: C 세로·플래너(100g/13장) 3세트 = 155.4g, 4세트 = 185.7g
//          → 대표님이 실제로 잰 "C 사이즈 160~190g" 과 일치.
var WEIGHT = {
  // 표지 평량. 실측을 면적으로 나눠보니 A·B·C 모두 890~1,290 g/m² 범위에 들어왔고 평균이 이 값이다.
  // 그래서 상수 하나로 커스텀 사이즈까지 커버된다. 오차는 표지 2장 기준 C 에서 ±9g 정도.
  // ⚠️ 더 정확히 하려면 표지 메타객체에도 weight_gsm 을 넣으면 되지만, 내지와 달리
  //    구매 스펙으로 알 수 없어 23종을 전부 저울에 올려야 한다. 지금은 상수로 간다.
  coverGsm: 1065,
  // 풀 스프링: C 세로(제본면 182mm) 12.3g → 길이 비례
  springFullPerMm: 12.3 / 182,
  // 양끝 스프링: 코일 4개 2.4g → 코일 1개 0.6g. 코일 수는 프리뷰와 같은 규칙을 쓴다.
  springCoilG: 0.6,
  // 밴드: C 세로 1g → 길이 비례 (총량에서 차지하는 비중은 미미)
  bandPerMm: 1 / 182,
  eyeletG: 0.2,                 // 구멍 1개. 기본형 2개 / 더블 4개 / 코너 2개
  innerGsmDefault: 100,         // 내지에 weight_gsm 이 안 들어간 경우
  // 매수(unit)가 비어 있을 때 쓸 값. 🔴 0 으로 두면 그 내지가 **무게 0** 으로 잡혀 배송비를
  // 실제보다 싸게 받는다(조용히 손해). 그래서 넉넉한 쪽으로 가정한다.
  innerSheetsDefault: 15,
  // 🔴 포장 일체(봉투·간지·스티커). **종이봉투 최대 75g + 부자재** 기준.
  //    ⚠️ 박스로 보내면 300g 안팎이 된다 — 그 경우 이 값을 바꿔야 한다.
  //    박스 실측이 아직 없다(2026-08-11). 정해지면 이 숫자만 고칠 것.
  packG: 100
};
// 양끝 스프링 한쪽 끝의 코일 개수. buildNotePreviewSVG 의 규칙과 같아야 한다 — 한쪽만 고치면 어긋난다.
function springEndCoils(faceLenMm){
  var aRef=(SIZES.find(function(x){return x.id==='A';})||{}).h||257;
  return faceLenMm<=85?3:(faceLenMm>=aRef?5:4);
}
// cfg(장바구니 항목) 하나의 무게(g). 포장까지 포함한 발송 무게다.
function calcWeightG(cfg){
  if(!cfg)return 0;
  var s=cfg.snap||{};
  var land=s.dir==='landscape';
  var w,h;
  if(s.size==='X'){ var cw=s.cw||182, ch=s.ch||257; w=Math.min(cw,ch); h=Math.max(cw,ch); }
  else { var sz=SIZES.find(function(x){return x.id===s.size;})||{w:128,h:182}; w=sz.w; h=sz.h; }
  var areaM2=(w*h)/1000000;               // 내지 1장 면적. 사이즈 표기는 내지 기준이다.
  var faceLen=land?w:h;                   // 스프링이 물리는 모서리 길이
  var g=0;
  g+=WEIGHT.coverGsm*areaM2*2;            // 앞뒤 표지
  (cfg.inns||[]).forEach(function(x){
    if(!x)return;
    var gsm=(+x.gsm)||WEIGHT.innerGsmDefault;
    // 매수. 표기가 '15' · '15 sheets' · '15sheet' 로 제각각이라 parseInt 로 앞 숫자만 뽑는다.
    var sheets=parseInt(x.unit,10)||WEIGHT.innerSheetsDefault;
    g+=gsm*areaM2*sheets;
  });
  if(s.springChosen){
    g+= s.sp==='full' ? WEIGHT.springFullPerMm*faceLen
                      : WEIGHT.springCoilG*springEndCoils(faceLen)*2;   // 위·아래 양끝
  }
  var band=s.band||'none';
  if(band!=='none'){
    g+=WEIGHT.bandPerMm*faceLen;
    g+=WEIGHT.eyeletG*(band==='double'?4:2);
  }
  g+=WEIGHT.packG;
  return Math.round(g);
}
function cfgDesc(cfg){
  return withSnapState(cfg&&cfg.snap,function(){return _cfgDescRows(cfg);});
}
function _cfgDescRows(cfg){
  var sz=cfg.size||{id:'X'};
  var szStr=cfg.snap.size==='X'?(cfg.snap.cw+'×'+cfg.snap.ch+'mm'):(sz.id+' '+sz.w+'×'+sz.h);
  var snap=cfg.snap;
  // 스프링 (선택 시 +1,500)
  var spP=snap.springChosen?1500:0;
  // 🔴 이 함수의 라벨은 전부 한글로 박혀 있었다 — 장바구니 스펙만 EN 에서 한글로 남던 원인(2026-08-13).
  //    라벨은 이미 있는 TXT 키(sk-*, dir-*, sp-lbl-*)를 재사용한다. 표지·내지 **이름**은 고유명사라 그대로 둔다.
  // 스프링은 필수(2026-09-22) — 없으면 빨갛게 표시해 어느 항목을 고칠지 보이게 한다.
  var spStr=snap.springChosen?t('sp-lbl-'+(snap.sp==='full'?'full':'split'))
    :('<span style="color:var(--brand-red)">'+L('선택 안 함 (필수)','Not selected (required)','未選択（必須）')+'</span>');
  // 스프링 색 · 아일렛 색 (2026-11-03) — 전엔 주문서에 없었다(cfgPaperColors 주석). 색 이름은 팔레트 그대로(영어).
  var cName=function(list,id){return (list.find(function(x){return x.id===id;})||{n:''}).n;};
  if(snap.springChosen){
    var s1n=cName(SC,snap.sp==='full'?snap.sc:snap.sc_top), s2n=snap.sp==='full'?s1n:cName(SC,snap.sc_bot);
    if(s1n)spStr+=' · '+s1n+(s2n&&s2n!==s1n?' / '+s2n:'');
  }
  // 잠금(밴드): 타입 + 색 (프리뷰 bandStr 과 동일 계산) + 가격
  var bandId=snap.band||'none';
  var bandStr=t('band-'+bandId);
  if(bandId==='double'||bandId==='corner'){
    var b1n=(BC.find(function(x){return x.id===snap.bc1;})||{n:''}).n;
    var b2n=(BC.find(function(x){return x.id===snap.bc2;})||{n:''}).n;
    if(b1n)bandStr+=' · '+b1n+(b1n!==b2n?' / '+b2n:'');
  }else if(bandId!=='none'){
    var bcn=(BC.find(function(x){return x.id===snap.bc;})||{n:''}).n;
    if(bcn)bandStr+=' · '+bcn;
  }
  if(bandId!=='none'){
    var two=(bandId==='double'||bandId==='corner');
    var e1n=cName(EYELETS,two?snap.ey1:snap.ey), e2n=two?cName(EYELETS,snap.ey2):e1n;
    if(e1n)bandStr+=' · '+L('아일렛 ','Eyelet ','アイレット ')+e1n+(e2n&&e2n!==e1n?' / '+e2n:'');
  }
  var bandP=(BANDS.find(function(x){return x.id===bandId;})||{}).p||0;
  var unitSum=cfg.inns.reduce(function(a,x){return a+((x&&x.unit)?(parseInt(x.unit,10)||0):0);},0);
  function cdRow(k,v){return '<span class="cd-k">'+k+'</span> <span class="cd-v">'+v+'</span>';}
  function cdPr(p){return p?' <span class="cd-p">+'+p.toLocaleString()+'</span>':'';}
  var shN=function(n){return L('('+n+')장',' ('+n+' sheets)',' ('+n+'枚)');};
  var innsHtml=cfg.inns.map(function(x,i){
    var pr=x?innPrice(x.id):0;
    return '<span class="cd-in">'+(i+1)+'. '+(x?pickLang(x.n,x.nEn):'?')+((x&&x.unit)?(' '+shN(x.unit)):'')+cdPr(pr)+'</span>';
  }).join('<br>');
  return cdRow(t('sk-size'),szStr)+'<br>'
    +cdRow(t('sk-dir'),t('dir-'+(cfg.snap.dir==='portrait'?'portrait':'landscape')))+'<br>'
    +cdRow(t('sk-sp'),spStr)+cdPr(spP)+'<br>'
    +cdRow(t('sk-band'),bandStr)+cdPr(bandP)+'<br>'
    +cdRow(t('sk-fc'),cfg.fc?pickLang(cfg.fc.n,cfg.fc.nEn):'—')+(cfg.fc?cdPr(covPrice(cfg.fc.id)):'')+'<br>'
    +cdRow(t('sk-bc'),cfg.bcover?pickLang(cfg.bcover.n,cfg.bcover.nEn):'—')+(cfg.bcover?cdPr(covPrice(cfg.bcover.id)):'')+'<br>'
    +'<span class="cd-k">'+t('sk-inn')+'</span><br>'
    +innsHtml
    +(unitSum?('<br><span class="cd-in cd-tot">'+L('총 '+unitSum+'장','Total '+unitSum+' sheets','合計 '+unitSum+'枚')+'</span>'):'');
}
function addCart(){
  var cfg=buildCfg();
  // 편집 모드면 새로 담지 않고 **그 자리를 교체**한다(id 유지 · 용도 유지). 팝업 대신 장바구니를 열어 바뀐 항목을 바로 보여준다.
  var eIdx=editIndex();
  if(EDIT&&eIdx>=0){
    cfg.id=CART[eIdx].id!=null?CART[eIdx].id:cfg.id;
    CART[eIdx]=cfg; EDIT=null;
    updBadges(); syncEditMode();
    toast(L('Note #'+cartNoteNo(eIdx)+' 을 수정했어요.','Note #'+cartNoteNo(eIdx)+' updated.','Note #'+cartNoteNo(eIdx)+' を更新しました。'));
    openDrawer('cart');
    return;
  }
  CART.push(cfg);updBadges();
  var p=totalPrice(),wonStr=t('won');
  // `nEn` 도 데모 폴백에만 있는 필드다 — EN 에서 내지 이름이 undefined 로 찍히던 것(2026-08-13).
  var innLines=cfg.inns.map(function(x,i){return L('내지 ','Inner ','中紙 ')+(i+1)+' : '+(x?pickLang(x.n,x.nEn):'—');}).join('<br>');
  document.getElementById('pop-d').innerHTML=L('앞표지 : ','Front : ','表紙 : ')+(cfg.fc?cfg.fc.n:'—')+'<br>'
    +L('뒷표지 : ','Back : ','裏表紙 : ')+(cfg.bcover?cfg.bcover.n:'—')+'<br>'
    +innLines+'<br><strong>'+p.total.toLocaleString()+wonStr+'</strong>'+fxHtml(p.total);
  document.getElementById('pop-bg').className='pop-bg on';renderCartList();
}
function addWish(){WISH.push(buildCfg());updBadges();toast(L('위시리스트에 저장됐어요.','Saved!','ウィッシュリストに保存しました。'));renderWishList();syncWish();}
function updBadges(){
  var cb=document.getElementById('cbadge'),wb=document.getElementById('wbadge');
  cb.textContent=CART.length;cb.className='badge'+(CART.length?' on':'');
  wb.textContent=WISH.length;wb.className='badge'+(WISH.length?' on':'');
  saveCart();
  syncEditMode();   // 편집 중이던 항목이 지워졌으면(삭제·주문 확인 후 비움) 편집 표시도 내린다
}
// 조합을 주문 브릿지가 기대하는 payload로 변환 (id·사이즈·수량 + 참고 라벨)
function cfgToOrderItem(cfg){
  var s=cfg.snap;
  return {
    size:s.size, cw:s.cw, ch:s.ch, dir:s.dir,
    springChosen:s.springChosen, sp:s.sp, band:s.band,
    fc:s.fc, bcover:s.bcover, inns:s.inns.slice(), qty:s.qty,
    // 1권당 발송 무게(g, 포장 포함). Worker 가 Draft Order line item 의 weight 로 넣는다
    // → Shopify 가 무게 기준 배송료를 계산한다. ⚠️ 서버는 이 값을 신뢰하지 않고 참고만 해도 되지만,
    //    가격과 달리 위변조해도 얻는 게 배송비 몇 천원이라 클라이언트 계산으로 둔다.
    weightG:calcWeightG(cfg),
    paper:cfgPaperColors(s),
    label:cfgDesc(cfg).replace(/<br>/g,' · ').replace(/<[^>]+>/g,''),
    // 🔴 **주문서(제작지시서)용 한글 판**(2026-08-14 대표님 지적: 일본어 주문서가 온통 일본어라 읽기 힘들다).
    //    예전엔 Worker 가 한글 줄을 직접 조립했는데 **색상·매수·합계가 빠지고** `잠금 basic` 처럼
    //    내부 id 가 그대로 나왔다. 화면에 쓰는 cfgDesc 를 **언어만 한국어로 바꿔 한 벌 더** 만들면
    //    한국어 주문서와 **글자 하나까지 같은** 줄이 나온다 — 따로 조립하면 또 어긋난다.
    labelKo:_withLangKo(function(){return cfgDesc(cfg).replace(/<br>/g,' · ').replace(/<[^>]+>/g,'');})
  };
}
// LANG 을 잠깐 한국어로 두고 fn 을 돌린다. 예외가 나도 반드시 되돌린다(안 되돌리면 화면이 한국어로 굳는다).
function _withLangKo(fn){
  var prev=LANG; LANG='ko';
  try{ return fn(); } finally { LANG=prev; }
}
// 색 이름을 매장 종이 주문서 표기(`01_GOLD`)로. 번호 = 팔레트 id 의 숫자(s01→01, b19→19).
function paperColor(list,id){
  var x=list.find(function(c){return c.id===id;});
  return x?(String(x.id).replace(/\D/g,'')+'_'+String(x.n).toUpperCase()):'';
}
// 🔴 스프링 색·아일렛 색은 **주문에 실린 적이 없었다**(2026-11-03, 출력용 주문서를 만들다 발견).
//    cfgDesc 는 스프링 «타입»과 밴드 색까지만 적었다 — 손님이 고른 스프링 색은 화면에만 있고 주문서엔 없었다.
//    Worker 가 이 값을 `_주문서` 줄에 그대로 옮긴다(가격 무관 · 표시용). 형식은 Worker 가 `^[0-9A-Z_ ]+$` 로만 받는다.
function cfgPaperColors(s){
  var two=(s.band==='double'||s.band==='corner');
  var split=s.sp==='split';
  return {
    sc1:s.springChosen?paperColor(SC,split?s.sc_top:s.sc):'',
    sc2:(s.springChosen&&split)?paperColor(SC,s.sc_bot):'',
    bc1:s.band==='none'?'':paperColor(BC,two?s.bc1:s.bc),
    bc2:two?paperColor(BC,s.bc2):'',
    ey1:s.band==='none'?'':paperColor(EYELETS,two?s.ey1:s.ey),
    ey2:two?paperColor(EYELETS,s.ey2):''
  };
}
// 카트 항목 → 주문 payload. 노트=cfgToOrderItem, 기성품=variantId+수량(서버가 Shopify 실가격 검증).
function cartItemToOrder(it){
  if(it&&it.kind==='product'){
    var o={kind:'product',variantId:it.variantId,qty:it.qty||1};
    var sh=cartSigSheet(it);   // SIGNATURE 면 출력용 주문서 사양(없으면 null — ACC 등)
    if(sh)o.sheet=sh;
    return o;
  }
  return cfgToOrderItem(it);
}
// 이 항목이 "주문을 받고 나서 만드는 것"인가.
// 🔴 2026-08-13 정정: PREMADE 를 기성 재고품으로 취급하고 있었는데 사실이 아니다.
//    PREMADE 는 페이퍼미가 조합만 미리 정해둔 "추천 구성"이고 실제 제작은 주문 후에 한다.
//    전자상거래법의 기준은 조합을 누가 골랐느냐가 아니라 주문 후에 만드느냐이므로,
//    PREMADE 도 DIY 노트와 똑같이 제작 고지 + 동의를 받아야 청약철회를 제한할 수 있다.
//    ACC(스티커·봉투 등)만 진짜 재고품이라 일반 청약철회(7일) 대상 → 동의를 받지 않는다.
function cartItemIsMade(it){
  if(!it)return true;
  if(it.kind!=='product')return true;                     // DIY 노트
  if(typeof it.made==='boolean')return it.made;
  return PREMADE.some(function(x){return x.id===it.id;});  // made 없는 옛 카트 대비
}
function cartHasCustom(){ return CART.some(cartItemIsMade); }
// 제작 고지 + 동의 줄의 표시 여부를 카트 내용에 맞춘다.
function updateCartNotices(){
  var custom=cartHasCustom();
  var lead=document.getElementById('note-lead'), row=document.getElementById('agree-row');
  if(lead)lead.style.display=custom?'':'none';
  if(row)row.style.display=custom?'':'none';
  // 용도 선택은 **주문 전체에 하나**다. 동봉 주문서는 커스텀 노트에 딸려 가므로 조건도 동의 줄과 같게 맞춘다.
  var use=document.getElementById('use-row');
  if(use)use.style.display=custom?'':'none';
}
// 고른 용도 — 'self' | 'gift' | ''(아직 안 고름)
// ⚠️ 일부러 저장하지 않는다. 주문마다 다시 고르게 하는 게 맞다 —
//    지난 주문의 '선물용'이 남아 있다가 조용히 따라가면 가격이 빠진 종이가 잘못 나간다.
function cartUseChoice(){
  var el=document.querySelector('input[name="pm-use"]:checked');
  return el?el.value:'';
}
// 동의 체크 상태 → 주문 버튼 활성/비활성. 실패 후 재활성화도 이걸 거쳐야 한다
// (그냥 disabled=false 하면 체크 안 한 상태로 버튼이 살아남).
// 주문제작이 없는 카트(기성품만)는 동의가 필요 없으므로 항상 활성.
// "섞여있어요"를 골랐으면 **선물 품목을 최소 하나는** 체크해야 넘어간다.
// 🔴 체크박스라 안 고른 것은 자동으로 '본인 사용'이 된다 — 즉 "전부 안 고름"은 곧 "전부 본인"이고,
//    그건 `섞여있어요` 와 앞뒤가 안 맞는다. 그대로 두면 **선물인데 가격이 찍힌 종이가 나간다.**
//    (버튼 두 개였을 때는 "아직 안 고름" 상태가 따로 있어 전부 골랐는지를 봤다. 체크박스에는 그 상태가 없다.)
function itemUsesReady(){
  if(cartUseChoice()!=='mixed')return true;
  for(var i=0;i<CART.length;i++){ if(_pmItemUse[i]==='gift')return true; }
  return false;
}
// 스프링이 빠진 DIY 노트의 장바구니 번호(Note #n) 목록. 비어 있으면 정상.
// 🔴 담기 버튼이 스프링을 요구해도 **이 고침 전에 담아둔 항목**(localStorage·카트 속성 복원)은 스프링이 없을 수 있다.
//    그 항목이 그대로 결제로 가면 안 되므로 주문 버튼도 같은 조건을 본다(2026-09-22).
function cartSpringMissing(){
  var out=[],n=0;
  CART.forEach(function(it){
    if(!it||it.kind==='product')return;
    n++;
    if(!(it.snap&&it.snap.springChosen))out.push(n);
  });
  return out;
}
function syncCheckoutBtn(){
  var cb=document.getElementById('agree-custom'), btn=document.getElementById('btn-checkout');
  if(!btn)return;
  // 주문제작이 든 카트는 **동의 + 용도 선택(+ 섞였으면 항목별 전부)** 이 있어야 넘어간다.
  btn.disabled=cartHasCustom()?!((cb&&cb.checked)&&cartUseChoice()&&itemUsesReady()):false;
  // 스프링 없는 노트가 있으면 이유를 적고 막는다 — 버튼만 꺼 두면 왜 안 되는지 모른다.
  // 해결되면 **우리가 적은 문구만** 지운다(다른 오류 문구는 건드리지 않는다).
  var miss=cartSpringMissing();
  var msg=document.getElementById('checkout-msg');
  if(miss.length){
    btn.disabled=true;
    if(msg){msg.textContent=springMissingMsg(miss);_pmSpringMsg=msg.textContent;}
  }else if(msg&&_pmSpringMsg&&msg.textContent===_pmSpringMsg){
    msg.textContent='';_pmSpringMsg='';
  }
}
var _pmSpringMsg='';
function springMissingMsg(miss){
  var list=miss.map(function(n){return 'Note #'+n;}).join(', ');
  return L(list+' 에 스프링이 없어요. 「편집」에서 스프링을 골라 다시 담아주세요.',
           list+': spring not selected. Tap Edit, choose a spring and add it again.',
           list+' のスプリングが未選択です。「編集」でスプリングを選んで、もう一度カートに入れてください。');
}
// 항목 i 가 선물용인가 — 주문 전송과 화면이 **같은 함수**를 본다(둘이 갈리면 표기가 어긋난다).
function itemIsGift(i){
  var c=cartUseChoice();
  if(c==='gift')return true;
  if(c==='mixed')return _pmItemUse[i]==='gift';
  return false;
}
// 🔴 결제창(체크아웃) 언어(2026-08-13 대표님 지적: 영어로 주문했는데 결제창이 한글).
//    체크아웃 주소는 Worker 가 만든 **Draft Order 청구서 링크**라 우리 사이트의 언어를 모른다.
//    그래서 주소에 `locale` 을 실어 보낸다. 한국어일 때는 아무것도 붙이지 않는다(기본값 그대로).
//    ⚠️ 스토어에 그 언어가 **게시돼 있어야** 먹는다. 안 먹으면 파라미터가 무시될 뿐 결제는 정상 진행된다.
function withCheckoutLocale(url){
  try{
    if(LANG==='ko'||!url)return url;
    if(/[?&]locale=/.test(url))return url;
    return url+(url.indexOf('?')>=0?'&':'?')+'locale='+encodeURIComponent(LANG);
  }catch(e){return url;}
}
function submitOrder(){
  if(!CART.length)return;
  var msg=document.getElementById('checkout-msg');
  var btn=document.getElementById('btn-checkout');
  var cb=document.getElementById('agree-custom');
  if(cartHasCustom()&&!(cb&&cb.checked)){   // 버튼 비활성이라 정상 경로론 안 오지만, 방어
    msg.textContent=t('agree-warn');
    return;
  }
  var miss=cartSpringMissing();             // 스프링 필수 — 위와 같은 방어(Worker 도 'spring required' 로 거절한다)
  if(miss.length){ msg.textContent=springMissingMsg(miss); return; }
  if(!PAPERME_ORDER_ENDPOINT){
    msg.textContent=L('주문 서버가 아직 연결되지 않았어요. (관리자 설정 대기)','Order service not connected yet.','注文サーバーにまだ接続されていません。');
    return;
  }
  btn.disabled=true; msg.textContent=L('주문서를 준비 중이에요…','Preparing your order…','ご注文内容を準備しています…');
  fetch(PAPERME_ORDER_ENDPOINT,{
    method:'POST', headers:{'Content-Type':'application/json'},
    // lang 을 같이 보낸다 — Worker 가 결제창에 보일 품목 이름·항목을 이 언어로 만든다(2026-08-13).
    // 용도는 **항목마다** 보낸다(섞여 있을 수 있다). Worker 가 각 line item 의 `_용도` 와
    // 주문 note 요약("전부 선물용" / "일부만 선물용 N건")으로 옮긴다 →
    // 대표님이 **동봉 종이 주문서에서 그 항목의 금액을 뺀다**.
    // (관리자 주문 화면·결제창·주문 확인 메일의 가격은 그대로 둔다.)
    body:JSON.stringify({lang:LANG,items:CART.map(function(c,i){
      var o=cartItemToOrder(c); if(o)o.gift=itemIsGift(i); return o;
    })})
  }).then(function(r){return r.json().then(function(d){return {status:r.status,d:d};});})
    .then(function(res){
      plog('주문 응답 '+res.status+' draftOrderId='+(res.d&&res.d.draftOrderId||'(없음)')+' checkoutUrl='+(res.d&&res.d.checkoutUrl?'있음':'(없음)'));
      if(res.status===200&&res.d.checkoutUrl){
        // ★ 여기서 카트를 비우면 결제를 취소하고 돌아왔을 때 장바구니가 사라진다.
        // 대신 draftOrderId 를 적어두고, 돌아왔을 때 결제됐는지 확인해서 비운다(checkPendingOrder).
        savePending(res.d.draftOrderId);
        window.location.href=withCheckoutLocale(res.d.checkoutUrl); return;
      }
      syncCheckoutBtn();
      msg.textContent=L('주문 준비 실패: ','Order failed: ','ご注文の準備に失敗しました: ')+(res.d.error||res.status)+(res.d.reasons?(' ('+res.d.reasons.join(', ')+')'):'');
    }).catch(function(e){
      syncCheckoutBtn();
      msg.textContent=L('네트워크 오류로 주문을 열지 못했어요.','Network error.','通信エラーのためご注文を開けませんでした。');
    });
}
// 위시로 옮기기 버튼(하트) — 🔴 **함수로 뽑아 둔다.**
// 2026-08-16 에 여기서 데었다: 같은 버튼이 커스텀 노트 줄과 SIGNATURE·ACC 줄 **두 곳**에 복사돼 있었는데,
// 앞부분이 미묘하게 달라(`<div class="dr-item-acts">` 가 붙어 있음) 한쪽만 바뀌었다.
// 치환은 "전부 바꿨다"고 답했고 나도 그렇게 보고했는데, **대표님이 화면에서 잡으셨다.**
// → 두 줄이 **같은 함수**를 부르게 해서 다시는 갈리지 않게 한다(#13: 같은 것이 두 곳이면 하나가 뒤처진다).
// 선물용 품목 고르기 — "섞여있어요"를 골랐을 때 안내 문구 **아래에 목록**으로 뜬다(대표님 설계 2026-08-16).
// 🔴 처음엔 장바구니 항목마다 `내가 쓸 것 | 선물` 버튼을 넣었는데 **눌러도 안 바뀌는 것처럼 보였다** —
//    값만 바꾸고 다시 그리지 않아 버튼 모양이 그대로였다(내 검증이 값만 보고 화면을 안 봤다).
//    체크박스 목록으로 바꾸니 **브라우저가 상태를 스스로 그려** 그 문제 자체가 사라진다. 더 짧고 훑기도 쉽다.
// ⚠️ 값은 `_pmItemUse` 배열에 담는다 — CART 객체에 넣지 않는다.
//    CART 는 localStorage·카트 속성으로 저장되는데, **용도는 주문마다 다시 고르게 해야** 하기 때문이다
//    (지난 주문의 '선물용'이 남아 따라가면 가격 빠진 종이가 잘못 나간다).
var _pmItemUse=[];
function pmSetItemUse(i,v){ _pmItemUse[i]=v; syncCheckoutBtn(); }
// 목록에 쓸 이름 — 장바구니에 보이는 것과 **같은 이름**이어야 한다(Note #1 / 상품명).
function cartItemLabel(it,noteN){
  return (it.kind==='product')
    ? shopEsc(it.title)+(it.variantTitle?(' · '+shopEsc(it.variantTitle)):'')
    : 'Note #'+noteN;
}
function renderGiftPicker(){
  var box=document.getElementById('use-gift-list'); if(!box)return;
  var on=(cartUseChoice()==='mixed');
  box.style.display=on?'':'none';
  if(!on){box.innerHTML='';return;}
  var noteN=0, html='';
  CART.forEach(function(it,i){
    if(it.kind!=='product')noteN++;
    html+='<label class="cart-gift-item"><input type="checkbox" onchange="pmSetItemUse('+i+',this.checked?\'gift\':\'self\')"'
      +(_pmItemUse[i]==='gift'?' checked':'')+'><span>'+cartItemLabel(it,noteN)+'</span></label>';
  });
  box.innerHTML=html;
}
// 미리보기(눈) 버튼 — 주문한 노트가 어떤 모양이었는지 편집으로 안 들어가고 확인한다.
// ⚠️ 하트와 같은 규칙: 아이콘만 남기므로 `title`·`aria-label` 로 뜻을 남긴다.
function drEyeBtn(i,label){
  var lbl=L('미리보기','Preview','プレビュー');
  return '<button class="dr-act-eye" onclick="previewCartItem('+i+',\''+label+'\')" title="'+lbl+'" aria-label="'+lbl+'">'
    +'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M1.8 12S5.6 5.5 12 5.5 22.2 12 22.2 12 18.4 18.5 12 18.5 1.8 12 1.8 12z"/><circle cx="12" cy="12" r="3.1"/></svg></button>';
}
function drWishBtn(i){
  var lbl=L('위시리스트로','To wishlist','ウィッシュリストへ');
  return '<button class="dr-act-wish" onclick="toWish('+i+')" title="'+lbl+'" aria-label="'+lbl+'">'
    +'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20s-7-4.6-7-9.4A3.9 3.9 0 0 1 12 8a3.9 3.9 0 0 1 7 2.6C19 15.4 12 20 12 20z"/></svg></button>';
}
// 용도 선택을 바꾸면 항목별 칸을 펼치거나 접어야 해서 목록을 다시 그린다.
// 🔴 그때 **동의 체크를 풀면 안 된다** — 용도를 고를 때마다 동의가 풀리면 주문을 못 한다.
//    그래서 `keep=true` 로 부른다.
function pmUseChanged(){ renderCartList(true); syncCheckoutBtn(); }
// keep: true 면 동의 체크·안내 메시지를 건드리지 않는다(용도 선택 변경 등 화면만 다시 그릴 때).
function renderCartList(keep){
  var el=document.getElementById('cart-list');
  var foot=document.getElementById('cart-foot'); if(foot)foot.style.display=CART.length?'block':'none';
  // 동의는 매 주문마다 새로 받는다(저장하지 않음). 카트가 바뀔 때도 초기화.
  if(!keep){
    var cb=document.getElementById('agree-custom'); if(cb)cb.checked=false;
    var cmsg=document.getElementById('checkout-msg'); if(cmsg)cmsg.textContent='';
  }
  // 「섞여 있어요」는 **2개 이상일 때만** 고를 수 있다. 1개로 줄면 그 선택도 함께 푼다
  // (안 그러면 선택지가 사라진 채 'mixed' 가 남아 주문 버튼이 영영 안 열린다).
  var mixRow=document.getElementById('use-mixed-row');
  if(mixRow){
    mixRow.style.display=(CART.length>1)?'':'none';
    if(CART.length<=1){
      var mr=document.querySelector('input[name="pm-use"][value="mixed"]');
      if(mr&&mr.checked)mr.checked=false;
    }
  }
  // 안내문·선물 품목 목록은 "섞여있어요"를 고른 동안만
  var hint=document.getElementById('use-mixed-hint');
  if(hint)hint.style.display=(cartUseChoice()==='mixed')?'':'none';
  renderGiftPicker();
  updateCartNotices(); syncCheckoutBtn();
  renderCartSummary();
  var fxn=document.getElementById('fx-note');
  if(fxn){var fxs=fxNote();fxn.textContent=fxs;fxn.style.display=fxs?'':'none';}
  // 방금 주문이 확인돼 비운 것이면 **왜 비었는지**를 그 자리에 답한다(평소엔 기본 문구).
  if(!CART.length){el.innerHTML='<div class="dr-empty">'+t(_pmJustOrdered?'cart-ordered':'cart-empty')+'</div>';return;}
  el.innerHTML='';
  var noteN=0;
  CART.forEach(function(it,i){
    var wonStr=t('won');
    if(it.kind==='product'){
      el.innerHTML+='<div class="dr-item"><div class="dr-item-nm">'+shopEsc(it.title)+(it.variantTitle?(' · '+shopEsc(it.variantTitle)):'')+'</div>'
        +'<div class="dr-item-p">'+shopEsc(it.priceStr||'')+fxHtml(pcKrw(it.priceCents))+' × '+(it.qty||1)+'</div>'
        +'<div class="dr-item-acts">'+(it.img?drEyeBtn(i,''):'')+drWishBtn(i)
        +'<button onclick="rmItem('+i+',\'cart\')" style="color:var(--brand-red)">'+L('삭제','Remove','削除')+'</button></div></div>';
    }else{
      noteN++;
      el.innerHTML+='<div class="dr-item"><div class="dr-item-nm">Note #'+noteN+'</div>'
        +'<div class="dr-item-d">'+cfgDesc(it)+'</div>'
        +'<div class="dr-item-p">'+it.price.total.toLocaleString()+wonStr+fxHtml(it.price.total)+' × '+it.snap.qty+'</div>'
        +'<div class="dr-item-acts"><button onclick="loadCfg('+i+',\'cart\')">'+L('편집','Edit','編集')+'</button>'
        +drEyeBtn(i,'Note #'+noteN)
        +drWishBtn(i)
        +'<button onclick="rmItem('+i+',\'cart\')" style="color:var(--brand-red)">'+L('삭제','Remove','削除')+'</button></div></div>';
    }
  });
}
// 장바구니 요약 칸(2026-09-22). 상품 합계 · 배송비 규칙(+무료배송까지 남은 금액) · 제작+배송 기간.
// 제작 기간은 동의 문구(note-lead)에도 있지만 거기선 «고지»이고 여기선 «언제 받나»다 — 배송 기간까지 이어서 한 줄로.
function renderCartSummary(){
  var el=document.getElementById('cart-sum'); if(!el)return;
  if(!CART.length){el.innerHTML='';return;}
  var sub=cartSubtotal();
  function esc(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}
  var h='<div class="cart-sum-row"><span>'+L('상품 합계','Subtotal','商品合計')+'</span><span class="cs-v" data-cs-sub>'+sub.toLocaleString()+t('won')+'</span></div>';
  h+='<p class="cart-sum-note">'+esc(shipNote())+'</p>';
  var nudge=freeShipNudge(sub);
  if(nudge)h+='<p class="cart-sum-note cs-nudge">'+esc(nudge)+'</p>';
  // 🔴 제작 기간(5–7일·넉넉히 10일)은 **바로 아래 고지문(note-lead)에 이미 있다** — 여기선 빼고 «배송 소요»만 말한다.
  //    (2026-09-22 대표님: "위에 제작일은 빼도 될 것 같다." 같은 숫자가 두 번 나오면 읽는 사람이 다른 값인가 하고 다시 본다.)
  h+='<p class="cart-sum-note">'+esc(L('제작이 끝나면 국내 배송 1–3일(제주 3–5일) · 해외는 매주 금요일 일괄 발송.',
                                        'After production, delivery takes 1–3 business days in Korea. Overseas orders ship every Friday.',
                                        '制作完了後、国内配送は1〜3営業日。海外発送は毎週金曜日にまとめて発送します。'))+'</p>';
  el.innerHTML=h;
  var sv=el.querySelector('[data-cs-sub]'); if(sv)fxAppend(sv,sub);   // 영어·일본어면 합계 옆에 환산
}
function renderWishList(){
  var el=document.getElementById('wish-list');
  if(!WISH.length){el.innerHTML='<div class="dr-empty">'+t('wish-empty')+'</div>';return;}
  el.innerHTML='';
  WISH.forEach(function(it,i){
    var wonStr=t('won');
    if(it.kind==='product'){
      el.innerHTML+='<div class="dr-item"><div class="dr-item-nm">'+shopEsc(it.title)+(it.variantTitle?(' · '+shopEsc(it.variantTitle)):'')+'</div>'
        +'<div class="dr-item-p">'+shopEsc(it.priceStr||'')+fxHtml(pcKrw(it.priceCents))+((it.qty>1)?(' × '+it.qty):'')+'</div>'
        +'<div class="dr-item-acts"><button onclick="toCart('+i+')">'+L('장바구니로','To cart','カートへ')+'</button>'
        +'<button onclick="rmItem('+i+',\'wish\')" style="color:var(--brand-red)">'+L('삭제','Remove','削除')+'</button></div></div>';
    }else{
      el.innerHTML+='<div class="dr-item"><div class="dr-item-nm">Wish #'+(i+1)+'</div>'
        +'<div class="dr-item-d">'+cfgDesc(it)+'</div>'
        +'<div class="dr-item-p">'+it.price.total.toLocaleString()+wonStr+fxHtml(it.price.total)+'</div>'
        +'<div class="dr-item-acts"><button onclick="loadCfg('+i+',\'wish\')">'+L('불러오기','Load','読み込む')+'</button>'
        +'<button onclick="toCart('+i+')">'+L('장바구니로','To cart','カートへ')+'</button>'
        +'<button onclick="rmItem('+i+',\'wish\')" style="color:var(--brand-red)">'+L('삭제','Remove','削除')+'</button></div></div>';
    }
  });
}
// ── 장바구니 항목 편집 모드 (2026-09-22, 대표님 지적) ─────────────────────────
// 전에는 「편집」이 조합을 빌더에 **복사만** 했다 — 서랍이 닫히고 그 자리(ACC 탭이면 ACC)에 그대로 남았고,
// 고친 뒤 「장바구니에 담기」를 누르면 **원래 항목은 남고 새 항목이 하나 더** 생겼다(19,000 + 20,500 두 권).
// 대표님 제안 그대로: 편집 → 그 노트의 제작 화면(DIY 탭)으로 이동 → 「수정 완료」 → **기존 항목 교체**.
// 🔴 항목은 index 가 아니라 **id 로** 찾는다 — 편집 중에 서랍을 열어 다른 항목을 지우면 번호가 밀린다.
//    id 가 없는 옛 항목(카트 속성 복원분)은 index 로 떨어진다.
// 🔴 교체할 때 `_pmItemUse[idx]`(항목별 용도)는 그대로 둔다 — 같은 자리라 번호가 안 밀린다.
// 편집이 끝나는 길은 셋: 수정 완료 · 취소 버튼 · 선택 초기화(「처음부터」는 새 노트라는 뜻이라 편집을 푼다).
var EDIT=null;   // {id, idx} | null
function editIndex(){
  if(!EDIT)return -1;
  if(EDIT.id!=null){ for(var i=0;i<CART.length;i++){ if(CART[i]&&CART[i].id===EDIT.id)return i; } return -1; }
  return (EDIT.idx<CART.length&&CART[EDIT.idx]&&CART[EDIT.idx].kind!=='product')?EDIT.idx:-1;
}
// 장바구니 안의 노트 번호(Note #n) — 상품(kind:'product')은 세지 않는다. renderCartList 와 같은 규칙.
function cartNoteNo(idx){ var n=0; for(var i=0;i<=idx&&i<CART.length;i++){ if(CART[i]&&CART[i].kind!=='product')n++; } return n; }
function syncEditMode(){
  var idx=editIndex();
  if(EDIT&&idx<0)EDIT=null;                       // 편집하던 항목이 그 사이 지워졌다 → 조용히 일반 모드로
  document.body.classList.toggle('editing',!!EDIT);
  var txt=document.getElementById('edit-bar-txt'), cancel=document.getElementById('edit-bar-cancel');
  if(EDIT){
    var no='Note #'+cartNoteNo(idx);
    if(txt)txt.textContent=L('장바구니의 '+no+' 을 수정하고 있어요. 「수정 완료」를 누르면 그 항목이 바뀝니다.',
                             'Editing '+no+' from your cart. Tap “Save changes” to replace it.',
                             'カートの '+no+' を編集中です。「変更を保存」を押すとその項目が置き換わります。');
    if(cancel)cancel.textContent=L('취소','Cancel','キャンセル');
  }
  // 담기 버튼 셋의 글자. applyLang 이 textContent 를 통째로 덮으므로 언어가 바뀐 뒤에도 다시 불러야 한다.
  var lbl=EDIT?L('수정 완료','Save changes','変更を保存'):null;
  [['btn-add','btn-add'],['mobile-add-btn','mobile-add-btn'],['mobile-bottom-add','mobile-bottom-add']].forEach(function(p){
    var el=document.getElementById(p[0]); if(!el)return;
    el.textContent=lbl||t(p[1]);
  });
}
function cancelEdit(){
  if(!EDIT)return;
  EDIT=null; syncEditMode();
  toast(L('수정을 취소했어요. 장바구니 항목은 그대로예요.','Edit cancelled — your cart item is unchanged.','編集をキャンセルしました。カートの項目はそのままです。'));
}
function loadCfg(i,from){
  var it=(from==='cart'?CART[i]:WISH[i]); if(!it||!it.snap)return;
  S=JSON.parse(JSON.stringify(it.snap));
  EDIT=(from==='cart')?{id:(it.id!=null?it.id:null),idx:i}:null;   // 위시 「불러오기」는 편집이 아니다(새 조합의 출발점)
  closeDrawer();
  switchTab('diy');                                 // 🔴 ACC·SIGNATURE 탭에서 눌렀어도 제작 화면으로 데려간다
  renderAll(); syncEditMode();
  var left=document.querySelector('.left'); if(left)left.scrollTo({top:0,behavior:'smooth'});
  if(EDIT)toast(L('Note #'+cartNoteNo(editIndex())+' 을 수정하고 있어요.','Editing Note #'+cartNoteNo(editIndex())+'.','Note #'+cartNoteNo(editIndex())+' を編集中です。'));
  else toast(L('조합을 불러왔어요.','Config loaded.','組み合わせを読み込みました。'));
}
// 🔴 위시에서 뺄 때는 syncWish(true) — 합집합(POST)으로 보내면 방금 지운 게 서버에서 되살아난다.
// 🔴 장바구니에서 지우면 **번호가 밀린다** — 항목별 용도 배열(`_pmItemUse`)도 같이 밀어야 한다.
//    안 밀면 2번의 '선물' 표시가 1번에 붙는다. 화면은 멀쩡해 보이는데 **주문서에 엉뚱한 항목이 선물로 찍힌다.**
//    (2026-08-16 정적 점검에서 발견. 실제로 겪었으면 찾기 어려웠을 종류다.)
function rmItem(i,from){if(from==='cart'){CART.splice(i,1);_pmItemUse.splice(i,1);renderCartList();}else{WISH.splice(i,1);renderWishList();syncWish(true);}updBadges();}
function toCart(i){CART.push(Object.assign({},WISH[i]));WISH.splice(i,1);renderWishList();renderCartList();updBadges();syncWish(true);}
// 장바구니 → 위시리스트 (2026-08-13 대표님 요청).
// 전에는 장바구니에 담고 나면 위시로 옮길 방법이 없어, 편집으로 되돌아가 다시 담아야 했다.
// 🔴 toCart 와 달리 **장바구니에서 빼지 않는다.** 위시는 '나중에 볼 것'이지 '주문 취소'가 아니라서,
//    옮기면서 장바구니를 비우면 사려던 걸 잃는다. 빼는 건 삭제 버튼이 따로 한다.
function toWish(i){
  var it=CART[i]; if(!it)return;
  WISH.push(Object.assign({},it));
  renderWishList(); updBadges(); syncWish();
  toast(L('위시리스트에 저장됐어요.','Saved to wishlist.','ウィッシュリストに保存しました。'));
}
/* `shareConfig()` 는 2026-08-23 에 지웠다 — 이유는 위 `.act-area` 의 주석에 있다. */
// ⚠️ 여는 쪽에서 `closeDrawer()` 를 먼저 부르므로, **잠금은 닫기 뒤에** 걸어야 한다(먼저 걸면 바로 풀린다).
// 방금 주문이 확인돼 장바구니를 비웠는가(그 세션에서 한 번 알려주려는 표시).
// ⚠️ 저장하지 않는다 — 다음에 들어왔을 때도 "주문이 접수됐어요"가 떠 있으면 이상하다.
var _pmJustOrdered=false;
function openDrawer(tp){
  closeDrawer();
  document.getElementById(tp+'-drawer').className='drawer on';
  document.getElementById('overlay').className='overlay on';
  document.body.classList.add('drawer-open');
  if(tp==='cart'){ renderCartList(); checkPendingOrderNow(); }   // 누른 그 순간 결제 확인
  else renderWishList();
  if(PM_WDEBUG)setTimeout(function(){pmOverflowReport('장바구니/'+tp);},600);   // 서랍을 열었을 때만 넘치는 경우를 잡는다
}
// 서랍을 닫으면 안내 표시도 내린다 — 한 번 보여주면 할 일을 다 한 문구다.
function closeDrawer(){document.querySelectorAll('.drawer').forEach(function(d){d.className='drawer';});document.getElementById('overlay').className='overlay';document.body.classList.remove('drawer-open');_pmJustOrdered=false;}
function closePop(){document.getElementById('pop-bg').className='pop-bg';}
function toast(msg){var el=document.getElementById('toast');el.textContent=msg;setTimeout(function(){el.textContent='';},2800);}

// ── "로그인 화면으로 이동 중…" (2026-08-16) ───────────────────────────
// 계정을 누르면 Shopify 가 호스팅하는 **다른 도메인**으로 이동해 1~2초 흰 화면이 뜬다
// (대표님: "마치 에러가 난 것 같은 느낌"). 속도는 더 못 줄이므로 **체감**을 고친다.
// 🔴 링크를 하나씩 찾아 걸지 않는다 — 계정 입구가 네 곳이라 하나씩 걸면 반드시 하나를 빠뜨린다.
//    `/account` 로 가는 **모든 링크**에 위임 방식으로 건다.
// 🔴 안 사라지는 게 제일 나쁘다: ①뒤로가기(`pageshow`)로 지움 ②10초 뒤 자동 소멸
//    ③새 탭으로 여는 클릭(⌘·Ctrl·가운데)에는 안 띄움.
// ⚠️ 테마 `layout/theme.liquid` 에 **같은 코드가 있다**(이 페이지는 layout none 이라 그게 안 닿는다).
//    한쪽만 고치지 말 것. 문구는 이 페이지에서 보고 있는 언어를 따른다(t 키 `navwait`).
(function(){
  var box=null,timer=null;
  function hide(){
    if(!box)return;
    var b=box; box=null; clearTimeout(timer);
    b.classList.remove('on');
    setTimeout(function(){ if(b.parentNode)b.parentNode.removeChild(b); },220);
  }
  function show(){
    if(box)return;
    box=document.createElement('div');
    box.className='pm-navwait';
    box.setAttribute('role','status');
    var inner=document.createElement('div'); inner.className='pm-navwait__box';
    var sp=document.createElement('span'); sp.className='pm-navwait__spin'; sp.setAttribute('aria-hidden','true');
    inner.appendChild(sp); inner.appendChild(document.createTextNode(t('navwait')));
    box.appendChild(inner);
    document.body.appendChild(box);
    var el=box; requestAnimationFrame(function(){ if(el===box)el.classList.add('on'); });
    timer=setTimeout(hide,10000);
  }
  document.addEventListener('click',function(e){
    if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
    var a=e.target&&e.target.closest?e.target.closest('a[href]'):null;
    if(!a||a.target==='_blank')return;
    // 🔴 `/account` 만 보면 안 된다 — 새 고객 계정은 `/customer_authentication/redirect?...` 로 간다
    //    (테마 쪽이 그 형태다. 이 페이지는 `/account` 를 손으로 박아 써서 걸렸을 뿐이다. 2026-08-16)
    if(!/(\/account(\/|\?|$)|customer_authentication)/.test(a.getAttribute('href')||''))return;
    show();
  });
  window.addEventListener('pageshow',hide);
  window.addEventListener('popstate',hide);
})();

// ═══ RENDER ALL ════════════════════════════════════════════════════════
function renderAll(){
  renderSizes();updateCustomUI();
  // 방향 버튼
  document.querySelectorAll('.dir-btn').forEach(function(b){b.className='dir-btn'+(b.dataset.v===S.dir?' sel':'');});
  // 스프링 버튼
  document.querySelectorAll('.sp-btn').forEach(function(b){b.className='sp-btn'+(S.springChosen&&b.dataset.v===S.sp?' sel':'');});
  document.getElementById('sc-full').style.display=S.sp==='full'?'block':'none';
  document.getElementById('sc-split').style.display=S.sp==='split'?'block':'none';
  refreshSpIcons();renderSC();
  checkSpringFace();
  renderBands();updateBandExtra();renderBC();renderEyelets();
  renderCovers('fc');renderCovers('bc');
  renderInnerGrid();render();
}

// ═══ INIT ══════════════════════════════════════════════════════════════
// 모바일 상단 프리뷰: 스크롤로는 접지 않는다. 내지를 선택하는 순간 접히고(addInn→collapseMobilePreview),
// 내지를 모두 비우면 다시 펼친다(removeInn→expandMobilePreview). 여기선 초기 상태만 보장.
function setupInnerCollapse(){
  var prev=document.getElementById('mobile-preview');
  if(prev)prev.classList.remove('mini');

  // 잠금 방식 선택(#st-band)이 화면에 들어오면 프리뷰를 다시 펼치고,
  // 그 위를 지나 아래로 내려가면(= 내지를 고르는 중) 다시 접는다.
  //
  // 왜 이 방식인가: 스크롤 "방향" 기반은 조금만 움직여도 튀어서 예전에 걷어냈다.
  // 이건 방향이 아니라 특정 지점의 위치를 보므로 같은 자리에선 항상 같은 결과다.
  // 내지가 하나도 없으면 접지 않는다 — 접는 이유가 '내지 고르는 중 화면 확보'라서.
  var band=document.getElementById('st-band');
  if(!band||!window.IntersectionObserver||band._prevObs)return;
  band._prevObs=true;
  new IntersectionObserver(function(entries){
    var e=entries[0];
    if(e.isIntersecting){ expandMobilePreview(); }
    else if(e.boundingClientRect.top<0 && S.inns.length){ collapseMobilePreview(); }
  },{threshold:0}).observe(band);
}
// 프리뷰 노트를 좌우로 스와이프하면 앞/뒤 전환 (왼쪽=뒤, 오른쪽=앞)
// ⚠️ zoom-stage(크게보기)는 제외 — 거긴 핀치 확대/드래그를 쓴다(setupZoomPan). 스와이프를 걸면
//    ①인라인 touch-action:pan-y 가 CSS none 을 덮어 브라우저 기본 핀치줌이 끼고(확대가 이중으로 싸움)
//    ②pointerup 스와이프 감지가 팬/핀치와 충돌해 옆으로 밀면 면이 멋대로 전환된다. 면 전환은 앞/뒤 탭으로.
function setupPreviewSwipe(){
  ['nbk-svg','nbk-svg-mobile'].forEach(function(id){
    var el=document.getElementById(id);
    if(!el||el._swipeBound)return; el._swipeBound=true;
    el.style.touchAction='pan-y';   // 세로 스크롤은 허용, 가로는 스와이프로
    el.style.cursor='grab';
    var x0=null,y0=null;
    el.addEventListener('pointerdown',function(e){x0=e.clientX;y0=e.clientY;});
    el.addEventListener('pointerup',function(e){
      if(x0==null)return;
      var dx=e.clientX-x0, dy=e.clientY-y0; x0=null;
      if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)*1.2){
        // 어느 방향으로 밀어도 반대 면으로 토글 (앞↔뒤)
        setPrevSide(S.prev==='front'?'back':'front');
      }
    });
    el.addEventListener('pointercancel',function(){x0=null;});
  });
}
// ═══ 기성품(SHOP) 탭 ═══════════════════════════════════════════════════
function shopEsc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
var _shopRendered=false;
function renderShop(){
  var el=document.getElementById('shop-grid'); if(!el)return;
  // 헤더 타이틀/설명을 활성 탭(premade/acc)에 맞게 갱신
  var h1=document.getElementById('shop-h1'),sub=document.getElementById('shop-sub');
  if(h1)h1.textContent=t('vtab-'+_shopSource);
  if(sub)sub.textContent=t('shop-sub-'+_shopSource);
  // 제작 안내는 SIGNATURE 에만. ACC 는 진짜 재고품이라 해당 없다(DECISIONS #18).
  var note=document.getElementById('shop-note');
  // 목록은 훑어보는 자리라 **짧은 한 줄**만. 전체 안내는 상품 상세에 둔다(대표님 2026-08-13).
  if(note){ note.textContent=t('sig-note-short'); note.style.display=(_shopSource==='premade')?'block':'none'; }
  var fxn=document.getElementById('shop-fx-note');
  if(fxn){ var fxs=fxNote(); fxn.textContent=fxs; fxn.style.display=fxs?'block':'none'; }
  var list=curShop();
  var emp=document.getElementById('shop-empty');
  _shopRendered=true;
  if(!list.length){el.innerHTML='';if(emp){emp.style.display='block';emp.textContent=t('shop-coming');}return;}
  if(emp)emp.style.display='none';
  el.innerHTML=list.map(function(p){
    var so=!p.available;
    var img=p.img?(' style="background-image:url('+shopEsc(p.img)+')"'):'';
    return '<div class="shop-card'+(so?' so':'')+'"'+(so?'':' onclick="openProduct(\''+shopEsc(p.id)+'\')"')+'>'
      +'<div class="shop-card-img"'+img+'>'
        +(isOnlyOne(p)?'<div class="shop-only1"><span>'+onlyOneShort()+'</span></div>':'')
        +(so?'<div class="shop-card-so">'+t('shop-soldout')+'</div>':'')+'</div>'
      +'<div class="shop-card-b"><div class="shop-card-nm">'+shopEsc(p.title)+'</div>'
      +'<div class="shop-card-pr">'+shopEsc(p.priceStr||'')+fxHtml(pcKrw(p.priceCents))+'</div></div></div>';
  }).join('');
}
// ── 1점 한정(ONLY ONE) 표시 ──────────────────────────────────────────
// 판정 기준은 **상품 태그**(대표님 결정 2026-07-30). 관리자 상품 화면 '태그' 칸에 `only-one` 을 넣으면
// 목록 카드와 상세에 배지가 뜬다. 재고 수나 combo 내용으로 추측하지 않는다 —
// 재고를 채우면 사라지거나 combo 오타가 "1점 한정"으로 보이는 사고를 막으려는 것.
// 표기 흔들림 허용: only-one / only one / onlyone / ONLY-ONE / 1점한정 / 1점 한정 모두 인식.
function isOnlyOne(p){
  var tg=(p&&p.tags)||[];
  if(typeof tg==='string')tg=tg.split(',');
  return tg.some(function(s){
    var k=(''+s).toLowerCase().replace(/[\s_-]/g,'');
    return k==='onlyone'||k==='1점한정'||k==='한정1점';
  });
}
// 한글에서도 영문 그대로 (대표님 결정 2026-07-30) — 브랜드 표기를 언어와 무관하게 통일.
// 자리에 따라 길이를 다르게 쓴다(대표님 결정):
//   목록 카드의 코너 리본 = 'ONLY 1'  — 리본을 작게 유지하려면 짧아야 한다.
//   상품 상세의 알약      = 'ONLY ONE' — 자리가 넉넉하고 문구가 또렷한 게 낫다.
// ⚠️ 리본 문구를 길게 바꾸면 리본(.shop-only1)도 같이 키워야 대각선에 안 들어간다.
function onlyOneShort(){return 'ONLY 1';}
function onlyOneLbl(){return 'ONLY ONE';}
// ── 상품 상세 뷰 + 담기 ── (활성 탭 우선, 없으면 전체에서 탐색)
function findShopProduct(id){return curShop().find(function(p){return p.id===id;})||PREMADE.concat(ACC).find(function(p){return p.id===id;})||null;}
var _sdProd=null,_sdVar=null,_sdQty=1,_sdImg=0;
function openProduct(id){
  var p=findShopProduct(id); if(!p)return;
  _sdProd=p; _sdQty=1; _sdImg=0;
  var vs=(p.variants||[]).filter(function(v){return v;});
  _sdVar=vs.filter(function(v){return v.available;})[0]||vs[0]||null;
  renderShopDetail();
  document.getElementById('shop-list').style.display='none';
  document.getElementById('shop-detail').style.display='block';
  // 어느 탭(premade/acc)의 상품인지도 같이 남긴다 — 뒤로가기로 이 화면을 되살릴 때 필요.
  if(!(history.state&&history.state.shopDetail===id))history.pushState({shopDetail:id,shopSource:_shopSource},'');
  setTabUrl(_shopSource,id);        // 새로고침하면 이 상품 상세로 다시 열리게
  window.scrollTo({top:0,behavior:'auto'});
}
function sdImg(i){_sdImg=i;renderShopDetail();}
function renderShopDetail(){
  var p=_sdProd; if(!p)return;
  var d=document.getElementById('shop-detail');
  // 이미지 전부 사용: 대표(현재 선택) + 여러 장이면 아래 썸네일 줄
  var imgs=(p.imgs&&p.imgs.length)?p.imgs:(p.img?[p.img]:[]);
  var vs=(p.variants||[]).filter(function(v){return v;});
  var multi=vs.length>1;
  var curV=_sdVar||vs[0]||null;
  // 슬라이드 = [그린 프리뷰(있으면)] + 사진들. 프리뷰가 있으면 0번이라 처음엔 프리뷰가 보이고, 사진은 썸네일로.
  var pvSvg=productPreviewSVG(p,curV,'front');
  // 그린 프리뷰가 있으면 사진은 안 보인다(대표님 2026-09-22: "원래 상품 사진은 필요가 없는 것 같다"). 사진은 목록 카드에만 쓰인다.
  var slides=pvSvg?[{svg:pvSvg,back:productPreviewSVG(p,curV,'back')}]:imgs.map(function(u){return {src:u};});
  if(_sdImg>=slides.length)_sdImg=0;
  var cur=slides[_sdImg]||null;
  var pvLbl=function(s){return '<span class="sd-media-pv-lbl">'+s+'</span>';};
  var mediaHtml=cur?(cur.svg
      ?'<div class="sd-media-pv"><div class="sd-media-pv-side">'+cur.svg+pvLbl(L('앞','Front','表'))+'</div><div class="sd-media-pv-side">'+cur.back+pvLbl(L('뒤','Back','裏'))+'</div></div>'
      :'<img src="'+shopEsc(cur.src)+'" alt="'+shopEsc(p.title)+'">'):'';
  var thumbsHtml='';
  if(slides.length>1){
    thumbsHtml='<div class="sd-thumbs">'+slides.map(function(s,i){
      var act=(i===_sdImg)?' act':'';
      if(s.svg)return '<button type="button" class="sd-thumb sd-thumb-pv'+act+'" onclick="sdImg('+i+')" aria-label="'+L('고른 색 미리보기','Preview of your colors','選んだ色のプレビュー')+'">'+s.svg+'</button>';
      return '<img class="sd-thumb'+act+'" src="'+shopEsc(s.src)+'" alt="" loading="lazy" onclick="sdImg('+i+')">';
    }).join('')+'</div>';
  }
  var priceStr=(curV&&curV.priceStr)||p.priceStr||'';
  var priceKrw=pcKrw((curV&&curV.priceCents!=null)?curV.priceCents:p.priceCents);
  var soldout=!p.available;
  var varHtml='';
  if(multi){
    varHtml='<div class="sd-block"><div class="sd-lbl">'+t('shop-opt')+'</div><div class="sd-vars">'
      +vs.map(function(v){
        var act=(_sdVar&&v.id===_sdVar.id);
        return '<button class="sd-var'+(act?' act':'')+'"'+(v.available?'':' disabled')+' onclick="selectVar('+v.id+')">'+shopEsc(v.title)+'</button>';
      }).join('')+'</div></div>';
  }
  // 재고 표시: 재고관리(tracked)되는 변형만 남은 수량 노출. 임박(≤5)이면 강조. 미관리=미표시.
  var stockHtml='';
  if(curV&&curV.tracked&&curV.qty>0){
    var low=curV.qty<=5;
    stockHtml='<div class="sd-stock'+(low?' low':'')+'">'+L('남은 수량 '+curV.qty+'개',curV.qty+' left in stock','残り'+curV.qty+'点')+'</div>';
  }
  // 옵션이 둘 이상(밴드 컬러 × 아일렛 컬러 = 68 변형)이면 제목 알약 68개 대신 **옵션별 한 줄씩** — 색 이름이면 DIY 와 같은 색점.
  var rows=multi?shopOptionRows(p,vs):null;
  if(rows)varHtml=rows;
  var canAdd=!soldout&&(!multi||(_sdVar&&_sdVar.available));
  d.innerHTML=''
    +'<button class="shop-back" onclick="closeProduct()">'+t('shop-back')+'</button>'
    +'<div class="shop-detail-in">'
      +'<div class="sd-media-col"><div class="sd-media">'+mediaHtml+'</div>'+thumbsHtml+'</div>'
      +'<div class="sd-info">'
        +(isOnlyOne(p)?'<div class="sd-only1">'+onlyOneLbl()+'</div>':'')
        +'<h2>'+shopEsc(p.title)+'</h2>'
        +'<div class="sd-price">'+shopEsc(priceStr)+fxHtml(priceKrw)+'</div>'
        +(fxNote()?'<div class="sd-fx-note">'+shopEsc(fxNote())+'</div>':'')   // 환산 각주 — 영어·일본어에서만
        +stockHtml
        +varHtml
        +'<div class="sd-block"><div class="sd-lbl">'+t('shop-qty')+'</div>'
          +'<div class="sd-qty"><button onclick="sdQty(-1)" aria-label="−">−</button><span id="sd-qty-v">'+_sdQty+'</span><button onclick="sdQty(1)" aria-label="+">+</button></div></div>'
        +'<button class="sd-add" id="sd-add"'+(canAdd?'':' disabled')+' onclick="addProductCart()">'+(soldout?t('shop-soldout'):t('shop-add'))+'</button>'
        +'<button class="sd-wish" id="sd-wish" onclick="addProductWish()">'+L('♡ 위시리스트에 저장','♡ Save to Wishlist','♡ ウィッシュリストに保存')+'</button>'
        // ONLY 1 안내 — 배지가 스스로 만드는 오해를 여기서 막는다.
        // `ONLY 1` 만 있으면 "재고가 하나 남았다"로 읽히는데, 실제로는 **표지를 하나씩
        // 즉흥적으로 디자인해 만든 것**이라 같은 디자인을 다시 만들지 않는다는 뜻이다(대표님 설명).
        // 못 하는 게 아니라 안 하는 것이므로 면책이 아니라 팔릴 이유로 쓴다.
        +(isOnlyOne(p)?'<p class="sd-note-only1">'+shopEsc(t('only1-note'))+'</p>':'')
        // 제작 안내 — SIGNATURE 상품에만(ACC 는 재고품이라 해당 없다).
        // 목록에도 같은 안내가 있지만, 링크로 상세에 바로 들어온 고객은 목록을 못 본다.
        +(PREMADE.some(function(x){return x.id===p.id;})?'<p class="sd-note">'+shopEsc(t('sig-note'))+'</p>':'')
        +(comboCanMake(p)?'<button class="sd-make" onclick="applyProductCombo(_sdProd)">'+L('이 조합으로 커스텀하기 →','Customize this combination →','この組み合わせをカスタマイズする →')+'</button>':'')
        +comboSpecHtml(p)
      +'</div>'
    +'</div>'
    // 상품 상세설명도 영문이 있으면 그걸, 없으면 한글로(메타필드 custom.description_en).
    +((function(){var d=pickLang(p.desc,p.descEn,p.descJa);return d?('<div class="sd-desc sd-desc-full">'+d+'</div>'):'';})());
}
function selectVar(id){
  var v=(_sdProd&&_sdProd.variants||[]).find(function(x){return x.id===id;});
  if(v&&v.available){_sdVar=v;renderShopDetail();}
}
// ── 옵션별 고르기 (2026-09-22, 대표님 지적 "밴드컬러/아일렛컬러 조합이 일렬로 늘어져 고르기 어렵다") ──
// 빌드가 상품에 `options`(옵션 이름들)와 변형마다 `opts`(값들)를 넣어 준다. 옵션이 둘 이상이면 옵션마다 한 줄:
// 값이 전부 팔레트 색 이름(BC·EYELETS·SC)이면 DIY 와 같은 색점(cdot), 아니면 글자 알약.
// 🔴 판정은 «다른 옵션의 현재 선택을 유지한 채» 그 값으로 바꿀 수 있는가 — 안 되면 흐리게(dim). 아예 어떤 조합으로도 안 되면 disabled.
// 옵션이 하나뿐이거나 옛 데이터(opts 없음)면 예전 제목 알약 그대로(호출부가 null 을 받으면 그대로 둔다).
function optColor(name){
  var n=String(name||'').trim().toLowerCase(); if(!n)return null;
  var all=[].concat(BC,EYELETS,SC);
  var hit=all.find(function(c){return String(c.n).toLowerCase()===n;});
  return hit?hit.h:null;
}
function shopOptionRows(p,vs){
  var names=(p.options||[]).filter(Boolean);
  if(names.length<2||!vs.some(function(v){return v&&v.opts;}))return null;
  var cur=_sdVar||vs[0];
  var html='';
  names.forEach(function(name,i){
    var values=[];
    vs.forEach(function(v){var val=v.opts&&v.opts[i];if(val!=null&&val!==''&&values.indexOf(val)<0)values.push(val);});
    if(!values.length)return;
    var selVal=(cur&&cur.opts)?cur.opts[i]:null;
    var allColor=values.every(function(val){return !!optColor(val);});
    html+='<div class="sd-block"><div class="sd-lbl">'+shopEsc(name)+(selVal?' <span class="sd-opt-sel">'+shopEsc(selVal)+'</span>':'')+'</div>'
        +'<div class="'+(allColor?'sd-opt-dots':'sd-vars')+'">';
    values.forEach(function(val){
      var ok=vs.some(function(v){
        if(!v.available||!v.opts||v.opts[i]!==val)return false;
        return names.every(function(_,j){return j===i||!cur||!cur.opts||v.opts[j]===cur.opts[j];});
      });
      var anyOk=vs.some(function(v){return v.available&&v.opts&&v.opts[i]===val;});
      var act=(selVal===val);
      var attrs=' data-oi="'+i+'" data-ov="'+shopEsc(val)+'" onclick="selectOptEl(this)"'+(anyOk?'':' disabled');
      if(allColor){
        var h=optColor(val);
        html+='<button type="button" class="cdot sd-opt-dot'+(act?' sel':'')+(ok?'':' dim')+'" style="background:'+h
            +(parseInt(h.slice(1),16)>0xAAAAAA?';outline:1px solid rgba(0,0,0,0.14)':'')+'" title="'+shopEsc(val)+'" aria-label="'+shopEsc(val)+'"'+attrs+'></button>';
      }else{
        html+='<button type="button" class="sd-var'+(act?' act':'')+(ok?'':' dim')+'"'+attrs+'>'+shopEsc(val)+'</button>';
      }
    });
    html+='</div></div>';
  });
  return html||null;
}
// ── 고른 색을 상품 이미지에도 반영 (2026-09-22, 대표님: "위에 이미지에도 반영되게") ──
// 변형 사진이 68장 있을 리 없으니(실측: 사진 1장 · 변형 이미지 0) DIY 프리뷰 엔진(buildNotePreviewSVG)으로 **그린다** —
// 밝은 표지(Cloud)에 고른 밴드·아일렛 색을 얹은 노트. 옵션 이름에 「밴드/band」가 있어야 그린다(아일렛은 있으면 반영, 없으면 검정).
// 밴드 종류는 상품 제목에서(corner / double / 그 외 basic). 사진은 썸네일로 남아 언제든 되돌아갈 수 있다.
function productPreviewSpec(p){
  var names=(p&&p.options)||[];
  var bi=-1,ei=-1;
  names.forEach(function(n,i){ if(bi<0&&/밴드|band/i.test(n))bi=i; if(ei<0&&/아일렛|eyelet/i.test(n))ei=i; });
  if(bi<0)return null;
  var t=/corner/i.test(p.title||'')?'corner':(/double/i.test(p.title||'')?'double':'basic');
  return {bandType:t,bi:bi,ei:ei};
}
// 🔴 아일렛은 프리뷰 엔진이 **뒷면에만** 그린다(실물이 그렇다 — 밴드가 뒷표지에 아일렛으로 고정). 그래서 앞·뒤를 나란히 그린다:
//    앞면 = 밴드 색이 한눈에, 뒷면 = 아일렛 색. 썸네일은 앞면만.
function productPreviewSVG(p,v,side){
  var spec=productPreviewSpec(p); if(!spec||!v||!v.opts)return '';
  var bh=optColor(v.opts[spec.bi]); if(!bh)return '';
  var eh=(spec.ei>=0&&optColor(v.opts[spec.ei]))||'#2c2d31';
  var svg=buildNotePreviewSVG({W:256,H:364,isBack:(side==='back'),isLandscape:false,      // C 비율(128×182)
    coverColor:'#F2EFEB',coverImage:'',coverFitFull:false,coverCat:'',coverPattern:null,
    showSpring:false,showBand:true,springType:'full',springColor:'#B0ADA8',springTopColor:'#B0ADA8',springBotColor:'#B0ADA8',
    bandType:spec.bandType,bandColor:bh,band2Color:bh,eyeletColor:eh,eyelet2Color:eh});
  // 🔴 width/height 속성을 뗀다 — 엔진의 viewBox(노트+여백, 약 0.76 비율)와 W:H(0.70)가 달라 svg 상자 위아래에 빈 띠가 생겼다
  //    (실측: 상자 126×240 에 그림 0.76 → 위아래 30px 씩 빔 → "여백이 크고 앞/뒤 글씨와 떨어진다", 대표님 2026-09-22).
  //    속성이 없으면 CSS height 만 주고 width:auto 로 두어 viewBox 비율 그대로 꽉 찬다.
  return svg.replace(/ width="[^"]*" height="[^"]*"/,'');
}
function selectOptEl(el){ selectOpt(parseInt(el.getAttribute('data-oi'),10), el.getAttribute('data-ov')); }
function selectOpt(i,val){
  var p=_sdProd; if(!p)return;
  var vs=(p.variants||[]).filter(function(v){return v;});
  var cur=_sdVar||vs[0]; var names=p.options||[];
  var keep=function(v){return names.every(function(_,j){return j===i||!cur||!cur.opts||v.opts[j]===cur.opts[j];});};
  // 1) 다른 옵션 유지 + 이 값 → 2) 이 값을 가진 아무 구매 가능 변형(다른 옵션이 바뀐다) → 3) 이 값을 가진 아무 변형(품절 표시용)
  var m=vs.find(function(v){return v.available&&v.opts&&v.opts[i]===val&&keep(v);})
       ||vs.find(function(v){return v.available&&v.opts&&v.opts[i]===val;})
       ||vs.find(function(v){return v.opts&&v.opts[i]===val;});
  if(m){_sdVar=m;if(productPreviewSpec(p))_sdImg=0;renderShopDetail();}   // 색을 고르면 그린 프리뷰(0번)로 돌아와 바로 보인다
}
function sdQty(d){_sdQty=Math.max(1,Math.min(99,_sdQty+d));var el=document.getElementById('sd-qty-v');if(el)el.textContent=_sdQty;}
function addProductCart(){
  var p=_sdProd; if(!p)return;
  var v=_sdVar||{};
  var vt=(v.title&&v.title!=='Default Title')?v.title:'';
  // made = 주문 후 제작인가. PREMADE(추천 조합)는 true, ACC(재고품)는 false → 제작 동의 여부가 갈린다.
  CART.push({kind:'product',id:p.id,title:p.title,made:PREMADE.some(function(x){return x.id===p.id;}),
    variantId:v.id||p.variantId||0,variantTitle:vt,
    priceCents:(v.priceCents!=null?v.priceCents:p.priceCents),priceStr:v.priceStr||p.priceStr,
    img:(p.imgs&&p.imgs[0])||p.img||'',qty:_sdQty});
  updBadges();
  document.getElementById('pop-t').textContent=t('shop-added');
  document.getElementById('pop-d').innerHTML=shopEsc(p.title)+(vt?(' ('+shopEsc(vt)+')'):'')
    +'<br><strong>'+shopEsc(v.priceStr||p.priceStr||'')+'</strong>'+fxHtml(pcKrw(v.priceCents!=null?v.priceCents:p.priceCents))+' × '+_sdQty;
  document.getElementById('pop-bg').className='pop-bg on'; renderCartList();
}
function addProductWish(){
  var p=_sdProd; if(!p)return;
  var v=_sdVar||{};
  var vt=(v.title&&v.title!=='Default Title')?v.title:'';
  WISH.push({kind:'product',id:p.id,title:p.title,variantId:v.id||p.variantId||0,variantTitle:vt,
    priceCents:(v.priceCents!=null?v.priceCents:p.priceCents),priceStr:v.priceStr||p.priceStr,
    img:(p.imgs&&p.imgs[0])||p.img||'',qty:_sdQty});
  updBadges();
  toast(L('위시리스트에 저장됐어요.','Saved to wishlist!','ウィッシュリストに保存しました。'));
  renderWishList(); syncWish();
}
// ── 기성품 combo → "이 조합으로 직접 만들기" ─────────────────────────
// 상품 메타필드 custom.combo(여러 줄 텍스트)를 해석해 DIY 상태로 로드한다.
// 줄 형식(모르는 줄·값은 건너뜀, 색·타입 이름 매칭은 rec_* 와 동일 헬퍼 재사용):
//   size: C / dir: 세로|가로 / front: cover_22 / back: cover_27
//   inners: paper_06 x2, paper_08   (순서 유지, xN=같은 내지 반복)
//   spring: 풀 / Black  (양끝이면 색 2개: 양끝 / Black / Gray)
//   band: 기본형 / Brown / Silver  (코너·더블형: 타입 / 색1 / 색2 / 아일렛1 / 아일렛2)
function comboFindCover(v){
  if(!v)return null;
  var s=(''+v).trim().toLowerCase();
  if(!s)return null;
  return COVS.find(function(x){return (x.no&&(''+x.no).toLowerCase()===s)||(x.id&&(''+x.id).toLowerCase()===s)||(x.n&&x.n.toLowerCase()===s);})||null;
}
// 옵션 목록에 없는 1점짜리(only one) 표지·내지용: `이름 | 가격` 으로 값 뒤에 가격을 직접 적을 수 있다.
// 예) front: 한정 마블 커버 | 6000     inners: 특별 내지 x2 | 3000   ← 가격은 반드시 맨 뒤
// 가격을 안 적으면 이름만 나오고 가격칸은 빈다. 목록에 있는 표지에 적으면 그 값이 자동 계산보다 우선한다.
// 옵션 목록에 없는 1점짜리(only one) 항목은 기성 가격이 없어 대표님이 값 뒤에 가격을 같이 적는다.
// 적는 방식이 사람마다 다르므로 아래 세 가지를 모두 같은 뜻으로 읽는다 — 어떻게 적어도
// 이름은 이름칸, 가격은 **기성 옵션과 똑같이 줄 오른쪽 가격칸**에 들어간다.
//   ① `한정 마블 커버 | 6,000`      (정식 표기)
//   ② `한정 마블 커버 (6,000원)`     (괄호)
//   ③ `한정 마블 커버 6,000원`       (그냥 뒤에)
// 🔴 ③ 은 **통화 표시(원·₩·KRW)가 있을 때만** 가격으로 뗀다 — `cover_28`·`5mm 횡선` 처럼
//    이름이 숫자로 끝나는 경우를 가격으로 잘못 떼면 이름이 망가진다.
// ⚠️ 숫자에서 `.` 도 버린다(`6.000원` 을 6 으로 읽던 문제). 원화는 소수점을 쓰지 않는다.
function comboSplitPrice(v){
  var s=(v==null?'':''+v);
  var i=s.search(/[|｜]/);
  if(i>=0){
    var pr=s.slice(i+1).replace(/[^0-9]/g,'');
    return {text:s.slice(0,i).trim(), price:(pr===''?null:+pr)};
  }
  var m=s.match(/^(.*?)\s*[(（]\s*₩?\s*([\d.,]+)\s*(?:원|KRW|won)?\s*[)）]\s*$/i);
  if(!m)m=s.match(/^(.*?)\s*(?:₩\s*([\d.,]+)|([\d.,]+)\s*(?:원|KRW|won))\s*$/i);
  // ④ `한정 커버 11,000` — 통화 표시가 없어도 **천단위 쉼표로 묶인 숫자**면 가격으로 본다.
  //    쉼표를 요구하는 게 안전장치다: `cover_28`·`Flowers_blue 2024` 처럼 이름이 그냥 숫자로
  //    끝나는 경우와 구분된다(그런 이름에 천단위 쉼표가 들어갈 일은 없다).
  if(!m)m=s.match(/^(.*?)\s+(\d{1,3}(?:,\d{3})+)\s*$/);
  if(m){
    var num=(m[2]||m[3]||'').replace(/[^0-9]/g,'');
    if(num!=='')return {text:m[1].trim(), price:+num};
  }
  return {text:s.trim(),price:null};
}
// `inners:`·`acc:` 는 쉼표로 여러 항목을 나누는데, **가격의 천단위 쉼표까지 잘려버렸다**
// (`손염색 내지 x3 | 1,200` → `…| 1` 과 `200` 두 항목이 되어, `200` 이 이름 없는 줄로 그냥 찍혔다).
// 그래서 쪼갠 뒤, **앞 토큰이 숫자로 끝나고** 지금 토큰이 **세 자리 숫자 덩어리뿐이면**
// 같은 가격의 뒷부분으로 보고 되붙인다(`11` + `000` → `11,000`).
// ⚠️ 지금 토큰에 숫자·통화표시·닫는괄호 말고 다른 글자가 섞이면 붙이지 않는다 —
//    `inners: paper_01, 100장` 처럼 진짜 별개 항목을 삼키지 않게 하는 안전장치다.
function comboSplitList(v){
  var out=[];
  (''+v).split(',').forEach(function(s){
    s=s.trim(); if(!s)return;
    var prev=out.length?out[out.length-1]:'';
    if(prev&&/\d$/.test(prev)&&/^\d{3}(?:,\d{3})*\s*(?:원|₩|KRW|won)?\s*[)）]?\s*$/i.test(s)){
      out[out.length-1]=prev+','+s; return;
    }
    out.push(s);
  });
  return out;
}
function comboFindInner(v){
  if(!v)return null;
  var s=(''+v).trim().toLowerCase();
  if(!s)return null;
  return INNS.find(function(x){return (x.no&&(''+x.no).toLowerCase()===s)||(x.id&&(''+x.id).toLowerCase()===s)||(x.n&&x.n.toLowerCase()===s);})||null;
}
// 액세서리 안내 문구 — 구성 스펙 아래와 '직접 만들기' 토스트에서 같이 쓴다(한 곳만 고치면 둘 다 바뀜).
function ACC_NOTE(){
  return L('기본 노트 구성 외 품목은 ACC 탭에서 따로 담아주세요 (예: 펜 홀더).',
           'Items beyond the base notebook are sold separately — add them from the ACC tab (e.g. pen holder).',
           'ノート本体以外の品目は別売りです。ACC タブから追加してください（例：ペンホルダー）。');
}
// ACC 컬렉션에서 액세서리 찾기(핸들 또는 상품명). 가격은 상품에서 살아있는 값을 쓴다.
function comboFindAcc(v){
  if(!v)return null;
  var s=(''+v).trim().toLowerCase();
  if(!s)return null;
  return ACC.find(function(x){return (x.id&&(''+x.id).toLowerCase()===s)||(x.title&&x.title.toLowerCase()===s);})||null;
}
function parseCombo(txt){
  if(!txt)return null;
  var out={},any=false;
  (''+txt).split(/\r?\n/).forEach(function(line){
    var m=line.match(/^\s*([A-Za-z_]+)\s*[:=]\s*(.+?)\s*$/);
    if(!m)return;
    var k=m[1].toLowerCase(),v=m[2];
    if(k==='size'){out.size=v.trim().toUpperCase();any=true;}
    else if(k==='dir'||k==='direction'){out.dir=v.trim();any=true;}
    else if(k==='front'){out.front=v.trim();any=true;}
    else if(k==='back'){out.back=v.trim();any=true;}
    // ⚠️ 쉼표로 나누되 가격의 천단위 쉼표는 살린다(comboSplitList) — 그냥 split(',') 하면 `1,200` 이 두 항목이 된다.
    else if(k==='inners'||k==='inner'){out.inners=comboSplitList(v);any=true;}
    // acc: 노트에 붙은 액세서리(펜 홀더 등). ACC 컬렉션 상품 핸들이나 이름, `xN`·가격 표기 모두 내지와 같은 규칙.
    else if(k==='acc'||k==='accs'||k==='accessory'){out.acc=comboSplitList(v);any=true;}
    else if(k==='spring'){out.spring=v.split(/[\/,]/).map(function(s){return s.trim();}).filter(Boolean);any=true;}
    else if(k==='band'){out.band=v.split(/[\/,]/).map(function(s){return s.trim();}).filter(Boolean);any=true;}
  });
  return any?out:null;
}
// combo 메타필드 → 고객이 읽을 수 있는 구성 스펙 HTML.
// 관리자에 cover_34·paper_06 같은 코드로 적혀 있어도 화면엔 실제 이름으로 나온다
// (손으로 스펙을 다시 쓸 필요가 없고, 표지/내지 이름을 고쳐도 자동으로 따라온다).
// 각 줄 오른쪽에 그 항목의 가격도 함께 보여준다.
// ⚠️ 표지·내지 값은 사이즈에 따라 달라지고 covPrice/innPrice 는 전역 S.size 를 본다.
//    그래서 이 함수 동안만 S.size 를 combo 에 적힌 사이즈로 바꿔 계산하고 원래대로 되돌린다
//    (안 그러면 빌더에서 마지막으로 고른 사이즈 기준 가격이 나온다 — cfgDesc 에 남아 있는 것과 같은 함정).
var COMBO_DIR={'세로':'portrait','세로형':'portrait','portrait':'portrait','vertical':'portrait',
               '가로':'landscape','가로형':'landscape','landscape':'landscape','horizontal':'landscape'};
// combo 를 판단·계산하는 동안만 S 를 그 조합의 사이즈·방향으로 맞춘다(가격도 내지 가용성도 여기에 딸려 있음).
// 🔴 combo 에 없는 항목은 빌더의 현재 값이 아니라 DEFAULT_STATE 로 둔다 — applyProductCombo 가
//    S 를 기본값으로 초기화한 뒤 조합을 얹는 것과 같은 기준이어야 한다. 안 그러면 고객이 빌더에서
//    마지막에 고른 방향·사이즈가 판정에 새어들어, 같은 상품인데 버튼이 보였다 안 보였다 한다.
// 반드시 finally 로 되돌린다 — S 는 빌더가 쓰는 전역 상태다.
function withComboState(c,fn){
  var _s=S.size,_w=S.cw,_h=S.ch,_d=S.dir;
  S.size=DEFAULT_STATE.size;S.cw=DEFAULT_STATE.cw;S.ch=DEFAULT_STATE.ch;S.dir=DEFAULT_STATE.dir;
  if(c.size&&['A','B','C'].indexOf(c.size)>=0)S.size=c.size;
  var dv=c.dir?COMBO_DIR[(''+c.dir).trim().toLowerCase()]:null;
  if(dv)S.dir=dv;
  try{ return fn(); }
  finally{ S.size=_s;S.cw=_w;S.ch=_h;S.dir=_d; }
}
// 이 조합을 DIY 로 그대로 재현할 수 있는가 — 못 만드는 표지·내지 이름을 모아 돌려준다.
// 비어 있지 않으면 '이 조합으로 직접 만들기' 버튼을 아예 띄우지 않는다(눌러봐야 반쪽만 실리므로).
// 스프링·잠금 색은 못 찾아도 기본값으로 떨어질 뿐이라 판단에서 뺀다.
function comboMissing(c){
  if(!c)return [];
  return withComboState(c,function(){
    var miss=[];
    [c.front,c.back].forEach(function(raw){
      var txt=comboSplitPrice(raw).text;
      if(txt&&!comboFindCover(txt))miss.push(txt);
    });
    (c.inners||[]).forEach(function(tok){
      var m=comboSplitPrice(tok).text.match(/^(.*?)(?:\s*[x×]\s*(\d+))?$/i);
      var nm=(m&&m[1])||'';
      if(!nm)return;
      var inn=comboFindInner(nm);
      if(!inn||!innAvail(inn).ok)miss.push(nm);   // 목록에 없거나, 이 사이즈·방향엔 못 쓰는 내지
    });
    return miss;
  });
}
// 🔴 **구성 스펙은 장식이다 — 여기서 터져도 상품 상세는 열려야 한다**(2026-08-14).
//    실제로 그 반대가 났다: 3언어 개편에서 `_comboSpecRows` 안의 `ko` 변수를 지우며 두 곳을 빠뜨렸고,
//    `ReferenceError: ko is not defined` 가 renderShopDetail 을 타고 openProduct 까지 올라가
//    **SIGNATURE 상품을 눌러도 아무 반응이 없었다**(대표님 발견). 화면엔 에러도 안 보인다.
//    스펙 한 덩어리 때문에 상품을 못 여는 건 손해가 너무 크다 — 실패하면 스펙만 빠지고 나머지는 뜨게 한다.
//    ⚠️ 조용히 삼키지는 않는다. 콘솔에 남겨야 다음에 원인을 1분에 찾는다.
function comboSpecHtml(p){
  try{
    var c=p?parseCombo(p.combo):null;
    if(!c)return '';
    return withComboState(c,function(){return _comboSpecRows(c);});
  }catch(e){
    console.error('comboSpecHtml 실패 — 구성 스펙만 생략하고 상세는 그대로 엽니다:',e);
    return '';
  }
}
// '이 조합으로 직접 만들기' 버튼을 띄울지 — combo 가 있고, 전부 기성 옵션으로 재현될 때만.
// 1점짜리 표지·내지가 하나라도 섞이면 버튼 자체가 안 나온다(스펙은 그대로 다 보인다).
function comboCanMake(p){
  var c=(p&&p.combo&&(''+p.combo).trim())?parseCombo(p.combo):null;
  return !!c&&comboMissing(c).length===0;
}
function _comboSpecRows(c){
  var rows=[];
  var won=function(v){return v.toLocaleString()+t('won');};
  function add(k,v,pr){
    if(!v)return;
    rows.push('<div class="sd-spec-r"><span class="sd-spec-k">'+k+'</span><span class="sd-spec-v">'+v+'</span>'
      +(pr?'<span class="sd-spec-p">'+pr+'</span>':'')+'</div>');
  }
  if(c.size){
    var sz=SIZES.find(function(x){return x.id===c.size;});
    add(t('sk-size'), sz&&sz.w?(c.size+L(' 사이즈 ',' ',' サイズ ')+sz.w+'×'+sz.h+'mm'):c.size);
  }
  if(c.dir){
    var isLand=/가로|landscape|horizontal/i.test(c.dir);
    add(t('sk-dir'), isLand?t('dir-landscape'):t('dir-portrait'));
  }
  // 번호(cover_no/inner_no) → 이름 순. 내지는 이름이 서로 비슷해 번호가 있어야 구분된다.
  function specNm(o){
    var n=shopEsc(pickLang(o.n,o.nEn));
    return o.no?('<span class="sd-spec-no">'+shopEsc(o.no)+'</span> '+n):n;
  }
  // 목록에 있으면 실제 이름+자동 가격, 없으면(1점짜리 표지 등) 적어준 글자를 그대로 보여준다.
  // 예전엔 못 찾으면 줄 자체가 사라져서 스펙이 비어 보였다.
  function coverRow(lbl,raw){
    var sp=comboSplitPrice(raw);
    if(!sp.text)return;
    var cv=comboFindCover(sp.text);
    add(lbl, cv?specNm(cv):shopEsc(sp.text),
        sp.price!=null?won(sp.price):(cv?won(covPrice(cv.id)):''));
  }
  coverRow(t('sk-fc'), c.front);
  coverRow(t('sk-bc'), c.back);
  var innNames=[];
  (c.inners||[]).forEach(function(tok){
    var sp=comboSplitPrice(tok);
    var m=sp.text.match(/^(.*?)(?:\s*[x×]\s*(\d+))?$/i);
    var nmRaw=(m&&m[1])||sp.text;
    if(!nmRaw)return;
    var inn=comboFindInner(nmRaw);
    var n=(m&&m[2])?parseInt(m[2],10):1;
    var unit=(sp.price!=null)?sp.price:(inn?innPrice(inn.id):null);
    // 내지는 여러 줄이라 줄마다 가격을 오른쪽에 붙인다(×N 이면 그 개수만큼 곱한 값)
    // 이름은 한 덩어리로 감싼다 — 안 그러면 번호 span 과 이름 텍스트가 각각 flex 항목이 되어 사이가 벌어진다
    innNames.push('<span class="sd-spec-il"><span>'+(inn?specNm(inn):shopEsc(nmRaw))+(n>1?(' ×'+n):'')+'</span>'
      +(unit!=null?('<span class="sd-spec-p">'+won(unit*n)+'</span>'):'')+'</span>');
  });
  if(innNames.length)add(t('sk-inn'), innNames.join(''));
  if(c.spring&&c.spring.length){
    var st=springTypeId(c.spring[0]);
    var s1=findByName(SC,c.spring[1]),s2=findByName(SC,c.spring[2]);
    var lbl=st?t('sp-lbl-'+st):t('sk-sp');
    if(st==='split'&&(s1||s2)){var a=s1||s2,b=s2||s1;lbl+=' · '+a.n+'/'+b.n;}
    else if(s1||s2){lbl+=' · '+(s1||s2).n;}
    add(t('sk-sp'), lbl, won(1500));   // 스프링 색을 고르면 붙는 값(빌더와 동일)
  }
  if(c.band&&c.band.length){
    var bt=bandTypeId(c.band[0])||bandTypeId((''+c.band[0]).replace(/형$/,''));
    if(bt&&bt!=='none'){
      var parts=[t('band-'+bt)];
      var cols=c.band.slice(1).map(function(v){var x=findByName(BC,v)||findByName(EYELETS,v);return x?x.n:null;}).filter(Boolean);
      if(cols.length)parts.push(cols.join('/'));
      var bp=(BANDS.find(function(x){return x.id===bt;})||{}).p||0;
      add(t('sk-band'), parts.join(' · '), bp?won(bp):'');
    }
  }
  // 액세서리(펜 홀더 등) — DIY 빌더엔 없는 항목이라 스펙에만 표시하고, 아래에 '별도 상품' 안내를 붙인다.
  var accNames=[];
  (c.acc||[]).forEach(function(tok){
    var sp=comboSplitPrice(tok);
    var m=sp.text.match(/^(.*?)(?:\s*[x×]\s*(\d+))?$/i);
    var nmRaw=(m&&m[1])||sp.text;
    if(!nmRaw)return;
    var a=comboFindAcc(nmRaw);
    var n=(m&&m[2])?parseInt(m[2],10):1;
    // ⚠️ priceCents 는 원×100 — 그대로 쓰면 ₩4,500 이 450,000원으로 찍힌다(2026-09-15 pcKrw 로 고침).
    var unit=(sp.price!=null)?sp.price:(a&&a.priceCents!=null?pcKrw(a.priceCents):null);
    accNames.push('<span class="sd-spec-il"><span>'+shopEsc(a?a.title:nmRaw)+(n>1?(' ×'+n):'')+'</span>'
      +(unit!=null?('<span class="sd-spec-p">'+won(unit*n)+'</span>'):'')+'</span>');
  });
  if(accNames.length)add(L('액세서리','Accessory','アクセサリー'), accNames.join(''));
  if(!rows.length)return '';
  // 🔴 '가격은 이 구성을 직접 만들 때의 항목별 금액입니다' 안내는 뺐다(대표님 2026-08-13).
  //    줄별 가격이 '직접 만들 때' 값이라 판매가와 합이 다를 수 있다는 걸 밝히려던 문장인데,
  //    상세를 이미 안내 문구가 여럿 차지하고 있어 덜어냈다. 되살리려면 이 자리에 한 줄 넣으면 된다.
  // 액세서리 안내는 남긴다 — DIY 빌더에 없는 항목이라 직접 만들 땐 ACC 탭에서 따로 담아야 한다.
  // 문구는 대표님이 정한 것(2026-07-30). 이름을 나열하지 않아 조사 문제도 없다. 토스트도 같은 문장을 쓴다.
  var note=accNames.length?('<div class="sd-spec-note">'+ACC_NOTE()+'</div>'):'';
  return '<div class="sd-spec"><div class="sd-spec-t">'+L('구성 스펙','Specification','構成スペック')+'</div>'+rows.join('')+note+'</div>';
}
// combo → 빌더 상태 한 벌(S 와 같은 모양). applyProductCombo(직접 만들기)와 cartSigSheet(출력용 주문서)가 같이 쓴다 —
// 두 곳이 combo 를 따로 해석하면 «상품 상세에 보이는 구성»과 «주문서에 찍히는 구성»이 어긋난다(DECISIONS #13).
// ⚠️ innAvail·cornerBandOK 가 전역 S 의 사이즈·방향을 보므로 반드시 withComboState 안에서 부를 것.
// 반환: { st, skipped, sheet } — sheet 는 주문서용(1점짜리 표지·내지도 이름 그대로 남긴다).
function comboState(c){
  var skipped=[], st=JSON.parse(JSON.stringify(DEFAULT_STATE));
  var sheet={fc:'',bcover:'',inns:[]};
  // 사이즈·방향 먼저 — 내지 가용성(innAvail) 판정의 기준이 된다.
  if(c.size&&['A','B','C'].indexOf(c.size)>=0)st.size=c.size;
  if(c.dir&&COMBO_DIR[(''+c.dir).trim().toLowerCase()])st.dir=COMBO_DIR[(''+c.dir).trim().toLowerCase()];
  // `| 가격` 이 붙어 있어도 이름만 떼어 찾는다(1점짜리 표지 표기법 — comboSplitPrice 주석 참고).
  // 목록에 없는 1점짜리는 DIY 로 재현할 수 없어 skipped 로 빠지고 토스트에 이름이 뜬다.
  var fcRaw=comboSplitPrice(c.front).text, bkRaw=comboSplitPrice(c.back).text;
  var fc=comboFindCover(fcRaw);
  if(fc){st.fc=fc.id;st.fc_cat=fc.cat||st.fc_cat;} else if(fcRaw)skipped.push(fcRaw);
  sheet.fc=fc?fc.id:fcRaw;
  var bk=comboFindCover(bkRaw);
  if(bk){st.bcover=bk.id;st.bc_cat=bk.cat||st.bc_cat;} else if(bkRaw)skipped.push(bkRaw);
  sheet.bcover=bk?bk.id:bkRaw;
  (c.inners||[]).forEach(function(tok){
    var m=comboSplitPrice(tok).text.match(/^(.*?)(?:\s*[x×]\s*(\d+))?$/i);
    var inn=comboFindInner(m&&m[1]);
    var n=(m&&m[2])?parseInt(m[2],10):1;
    // 주문서에는 «실제로 들어가는 종이»를 다 적는다 — 직접 만들기에서 빠지는 1점짜리·방향 불가 내지도.
    for(var k=0;k<n&&sheet.inns.length<5;k++)sheet.inns.push(inn?inn.id:((m&&m[1])||tok));
    if(!inn){skipped.push((m&&m[1])||tok);return;}
    var av=innAvail(inn);
    if(!av.ok){skipped.push(inn.n);return;}
    for(var i=0;i<n&&st.inns.length<5;i++)st.inns.push(inn.id);
  });
  if(c.spring&&c.spring.length){
    var spt=springTypeId(c.spring[0]);
    if(spt){st.sp=spt;st.springChosen=true;}
    var s1=findByName(SC,c.spring[1]),s2=findByName(SC,c.spring[2]);
    if(s1||s2){
      st.springChosen=true;
      if(spt==='split'){var _t=(s1||s2).id,_b=(s2||s1).id;st.sc_top=_t;st.sc_bot=_b;st.sc=_t;}
      else{var _o=(s1||s2).id;st.sc=_o;st.sc_top=_o;st.sc_bot=_o;}
    }
  }
  if(c.band&&c.band.length){
    var bt=bandTypeId(c.band[0])||bandTypeId((''+c.band[0]).replace(/형$/,''));
    if(bt&&bt!=='none'){
      if(bt==='corner'&&!cornerBandOK()){skipped.push(L('코너 잠금','corner band','コーナーバンド'));}
      else{
        st.band=bt;
        if(bt==='basic'){
          var b1=findByName(BC,c.band[1]),e1=findByName(EYELETS,c.band[2]);
          if(b1)st.bc=b1.id; if(e1)st.ey=e1.id;
        } else {
          var c1=findByName(BC,c.band[1]),c2=findByName(BC,c.band[2]),
              e1b=findByName(EYELETS,c.band[3]),e2b=findByName(EYELETS,c.band[4]);
          if(c1)st.bc1=c1.id; if(c2)st.bc2=c2.id; if(e1b)st.ey1=e1b.id; if(e2b)st.ey2=e2b.id;
        }
      }
    }
  }
  st.recFrom=null;st.recApplied=null;
  return {st:st,skipped:skipped,sheet:sheet};
}
// SIGNATURE 한 항목 → 출력용 주문서 사양(2026-11-03 대표님: «시그니처도 일반 노트처럼 사양을 다 써 달라»).
// Worker 가 `_주문서` 줄로 옮긴다(가격은 안 싣는다 — 판매가는 상품 가격이고, 부품별 값을 더해도 그 값이 아니다).
function cartSigSheet(it){
  try{
    var p=PREMADE.find(function(x){return x.id===it.id;});
    var c=p?parseCombo(p.combo):null;
    if(!c)return null;
    var r=withComboState(c,function(){return comboState(c);});
    var st=r.st;
    return {size:st.size,dir:st.dir,sp:st.sp,springChosen:!!st.springChosen,band:st.band||'none',
      fc:r.sheet.fc,bcover:r.sheet.bcover,inns:r.sheet.inns,paper:cfgPaperColors(st)};
  }catch(e){
    // 주문서 사양 때문에 주문이 막히면 안 된다 — 빠지면 종이에 SIGNATURE 이름만 나간다.
    console.error('cartSigSheet 실패 — 주문은 그대로 진행:',e);
    return null;
  }
}
function applyProductCombo(p){
  var c=p?parseCombo(p.combo):null;
  if(!c){toast(L('조합 정보를 읽지 못했어요.','Could not read this combo.','組み合わせ情報を読み込めませんでした。'));return;}
  // 조합 기준으로 새로 시작(기존 선택 대체)
  var r=withComboState(c,function(){return comboState(c);});
  S=r.st;
  var skipped=r.skipped;
  // DIY 를 새 히스토리 항목으로 쌓는 일은 switchTab 이 한다(2026-07-31부터) → 뒤로가기가 그 상품으로 돌아간다.
  // ⚠️ 예전엔 여기서 직접 pushState({diy:1}) 했는데, 이제 switchTab 도 쌓으므로 **두 번 쌓여**
  //    뒤로가기를 두 번 눌러야 상세로 돌아가게 된다. 그래서 뺐다.
  // (?combo= 주소로 바로 들어온 경우엔 주소에 tab·p 가 없어 주소가 안 바뀌므로 항목도 안 쌓인다.)
  switchTab('diy');
  renderAll();
  var msg=L('조합을 불러왔어요. 자유롭게 바꿔보세요!','Combo loaded — customize away!','組み合わせを読み込みました。自由に変えてみてください！');
  if(skipped.length)msg+=L(' (제외: ',' (skipped: ',' （除外：')+skipped.join(', ')+L(')',')','）');
  // 액세서리는 빌더에 없는 항목이라 노트만 실린다 — 어디서 담는지 알려준다(그냥 빠뜨리면 고객이 눈치채지 못한다).
  // 어떤 액세서리인지는 방금 보던 상세의 구성 스펙에 이름·가격이 다 나와 있어 여기서 다시 나열하지 않는다.
  if((c.acc||[]).length)msg+=' '+ACC_NOTE();
  toast(msg);
}
// 표지 하나로 시작하기(?cover=cover_01) — 새로 시작 → 그 표지 → 추천 조합 → 내지 선택으로 스크롤.
// 🔴 적용한 뒤 주소에서 cover 를 지운다 — 언어 전환은 주소의 쿼리를 그대로 들고 다시 로드하므로(pmLocalizeHref),
//    남겨 두면 언어를 바꿀 때마다 고객이 그 사이 고른 내지·옵션을 이 표지 기본값으로 덮어쓴다(지뢰 20 과 같은 뿌리).
// 🔴 기본 사이즈(C)를 못 만드는 표지면 그 표지가 되는 첫 사이즈로 바꾼다 — 안 그러면 표지가 «선택 불가»로 남는다.
function applyCoverLink(cv,size){
  S=JSON.parse(JSON.stringify(DEFAULT_STATE));
  if(size&&['A','B','C'].indexOf(size)>=0)S.size=size;
  var allow=covSizes(cv);
  if(allow&&allow.indexOf(S.size)<0){var _s=allow.filter(function(x){return x!=='X';})[0];if(_s)S.size=_s;}
  S.fc=cv.id;S.fc_cat=cv.cat||S.fc_cat;
  switchTab('diy');
  if(coverRec(cv))applyRecommend(cv); else renderAll();
  // 안내를 화면 가운데에 잠깐 띄웠다가 내지 선택으로 내려간다(대표님 2026-10-01: "내지를 2세트 이상 골라주세요. 라는 문구가 한번 뜨고 넘어가게").
  // 기존 toast 는 11px 한 줄이라 이 자리엔 약하다 — 새로 들어온 손님에게 «다음에 할 일» 하나만 크게.
  var _ntc=document.createElement('div');
  _ntc.setAttribute('role','status');
  // ⚠️ left:50% 로 띄우면 상자 폭이 «화면의 오른쪽 절반»으로 묶여 「골라 / 주세요」처럼 접힌다 → width:max-content 로 글자만큼.
  _ntc.style.cssText='position:fixed;left:50%;top:42%;transform:translate(-50%,-50%);z-index:9999;width:max-content;max-width:86vw;word-break:keep-all;'
    +'background:rgba(28,27,24,.92);color:#fff;border-radius:14px;padding:16px 22px;text-align:center;'
    +'box-shadow:0 10px 30px rgba(0,0,0,.18);transition:opacity .8s ease;opacity:0;pointer-events:none';
  _ntc.innerHTML='<div style="font-size:11.5px;opacity:.72;margin-bottom:5px">'+shopEsc(L(cv.n+' · 추천 조합을 담았어요',cv.n+' · recommended combo added',cv.n+'・おすすめの組み合わせを選びました'))+'</div>'
    +'<div style="font-size:15.5px;font-weight:600">'+shopEsc(L('내지를 2세트 이상 골라주세요.','Choose at least 2 paper sets.','中紙を2セット以上お選びください。'))+'</div>';
  document.body.appendChild(_ntc);
  requestAnimationFrame(function(){_ntc.style.opacity='1';});
  var _shown=Date.now();
  try{ history.replaceState(history.state,'',location.pathname+location.search.replace(/([?&])cover=[^&]*(&|$)/,function(_m,a,b){return b?a:'';}).replace(/([?&])size=[^&]*(&|$)/,function(_m,a,b){return b?a:'';}).replace(/[?&]$/,'')+location.hash); }catch(e){}
  // 🔴 한 번만 내려가면 안 된다 — 페이지 로드(load)가 끝날 때 브라우저가 스크롤을 맨 위로 되돌리고,
  //    그 사이 사진이 들어오며 높이도 바뀐다(실측: 350ms 에 내려갔다가 load 뒤 0 으로). 지금 한 번, load 뒤 한 번.
  function _goInn(){
    var el=document.getElementById('step-inn'); if(!el)return;
    // 위에 붙어 있는 것(헤더+탭, 모바일은 미리보기 띠까지)의 실제 높이만큼 덜 내려간다 — 짐작값을 쓰면 제목이 그 밑에 숨는다.
    var off=8, mp=document.querySelector('.mobile-preview'), rt=document.querySelector('.right');
    if(mp&&getComputedStyle(mp).display!=='none')off+=parseFloat(getComputedStyle(mp).top)||0, off+=mp.offsetHeight;
    else if(rt)off+=parseFloat(getComputedStyle(rt).top)||0;
    var top=el.getBoundingClientRect().top+window.pageYOffset-off;
    window.scrollTo({top:Math.max(0,top),behavior:'auto'});
  }
  // 안내가 2.6초 보인 뒤 + 페이지 로드가 끝난 뒤에 내려가며 0.8초에 걸쳐 흐려진다(load 때 브라우저가 스크롤을 맨 위로 되돌리므로 그 뒤여야 한다).
  // 처음엔 1.4초 + 0.35초였는데 대표님: "너무 순식간에 지나간다" → 읽고 넘어갈 시간을 준다.
  // 로드가 늦어도 5초면 일단 내려가고, 로드 뒤 한 번 더 맞춘다.
  var _done=false;
  function _finish(){
    if(_done){_goInn();return;}
    _done=true; _ntc.style.opacity='0'; setTimeout(function(){if(_ntc.parentNode)_ntc.parentNode.removeChild(_ntc);},900);
    _goInn();
  }
  function _after(ms){setTimeout(_finish,Math.max(0,ms-(Date.now()-_shown)));}
  if(document.readyState==='complete')_after(2600);
  else{ window.addEventListener('load',function(){_after(2600);}); setTimeout(function(){if(!_done)_finish();},5000); }
}
function _closeProductView(){
  document.getElementById('shop-detail').style.display='none';
  document.getElementById('shop-list').style.display='';
  _sdProd=null;
}
function closeProduct(){
  if(history.state&&history.state.shopDetail){history.back();}
  // 히스토리 항목이 없는 경우(예: ?p= 주소로 바로 들어온 뒤 새로고침) — 목록으로 닫고 주소에서 p 만 지운다
  else{_closeProductView();setTabUrl(_shopSource,null);}
}
window.addEventListener('popstate',function(){
  var st=history.state||{};
  if(st.shopDetail){
    // 뒤로가기로 상품 상세 항목에 돌아옴 — 그 탭으로 되돌리고 상세를 다시 연다.
    // (DIY 로 넘어갔다 돌아오는 경우가 여기. switchTab 이 리스트로 리셋하므로 openProduct 를 뒤에.)
    switchTab(st.shopSource||_shopSource||'premade',true);
    openProduct(st.shopDetail);
    return;
  }
  // 상세가 아닌 항목 = 탭 상태. 브라우저가 이미 되돌린 **주소에서** 탭을 읽어 그 탭으로 돌아간다.
  // 🔴 state 가 아니라 주소를 보는 이유: 맨 처음 항목은 state 가 null 이라(우리가 안 만들었다)
  //    state 만 보면 DIY 로 못 돌아온다. 주소에 tab 이 없으면 곧 DIY 다.
  var tb=(location.search.match(/[?&]tab=([^&]+)/)||[])[1];
  tb=tb?tabFromUrl(decodeURIComponent(tb)):'diy';
  if(['howto','diy','premade','acc'].indexOf(tb)<0)tb='diy';
  switchTab(tb,true);   // 열려 있던 상세는 switchTab 이 알아서 닫는다(_closeProductView)
  // ?p= 로 바로 들어온 뒤 뒤로가기를 하면 브라우저가 되돌린 주소에 p 가 그대로 남아,
  // 화면은 목록인데 새로고침하면 상세가 다시 열렸다 → 그때만 주소에서 p 를 지운다.
  if(/[?&]p=/.test(location.search))setTabUrl(tb,null);
});
// 화면에 보이는 이름이 SIGNATURE 라 주소에도 `?tab=signature` 로 적는다(2026-08-13 대표님 지적).
// 🔴 **내부 id 는 'premade' 그대로 둔다.** 컬렉션 핸들·Liquid 주입 변수(PAPERME_PREMADE)·
//    TXT 키·엘리먼트 id 가 전부 그 값이라, 다 바꾸면 수십 군데를 건드리는데 얻는 건 없다.
//    **주소를 읽고 쓰는 지점에서만** 갈아끼운다 — 바뀌는 건 고객에게 보이는 주소뿐이다.
// ⚠️ 옛 주소(`?tab=premade`)도 계속 읽는다 — 이미 나간 링크·북마크·관리자 메뉴가 안 깨지게.
function tabToUrl(tp){ return tp==='premade'?'signature':tp; }
function tabFromUrl(s){ return s==='signature'?'premade':s; }
// 지금 탭·열린 상품을 주소에 적어둔다 — 새로고침해도 그 자리로 돌아오게(대표님 요청 2026-07-30).
// DIY 는 기본 탭이라 파라미터를 붙이지 않는다(주소가 깔끔하고 기존 링크와 그대로 호환).
// push=true 면 새 히스토리 항목을 쌓는다(탭 전환) — 아니면 지금 항목의 주소만 고쳐 쓴다.
function setTabUrl(tp,pid,push){
  if(!window.history||!history.replaceState)return;
  try{
    var u=new URL(location.href);
    if(tp&&tp!=='diy')u.searchParams.set('tab',tabToUrl(tp)); else u.searchParams.delete('tab');
    if(pid)u.searchParams.set('p',pid); else u.searchParams.delete('p');
    var nu=u.pathname+(u.search||'')+u.hash;
    // ⚠️ 주소가 그대로면(같은 탭을 다시 누름) 쌓지 않는다 — 안 그러면 뒤로가기를 여러 번 눌러야 한 칸 움직인다.
    if(push&&history.pushState&&nu!==location.pathname+location.search+location.hash)history.pushState({tab:tp||'diy'},'',nu);
    else history.replaceState(history.state,'',nu);
  }catch(e){}
}
// fromHistory=true 면 주소를 건드리지 않는다 — 뒤로가기로 불릴 때 주소는 브라우저가 이미 되돌렸다.
function switchTab(tp,fromHistory){
  var isDiy=(tp==='diy'), isHow=(tp==='howto');
  // 뷰는 셋 중 하나: howto / diy(.wrap) / shop(premade·acc). body 클래스로 가른다.
  document.body.classList.toggle('tab-howto',isHow);
  document.body.classList.toggle('tab-shop',!isDiy&&!isHow);
  ['howto','diy','premade','acc'].forEach(function(k){var b=document.getElementById('vtab-'+k);if(b)b.classList.toggle('act',k===tp);});
  syncNavMenu(tp);                                      // 헤더 메뉴의 현재 위치 표시도 같이(탭 줄과 어긋나면 안 된다)
  _closeProductView();                                  // 탭 이동 시 상세는 리스트로 리셋
  if(!isDiy&&!isHow){ _shopSource=tp; renderShop(); }   // 활성 소스 바꾸고 그리드 재렌더
  // 탭을 옮기면 열려 있던 상품(p)은 주소에서 지우고, 새 히스토리 항목을 쌓아 뒤로가기로 이전 탭에 돌아가게 한다.
  // 🔴 2026-07-31 이전엔 replaceState 라 항목이 안 쌓였다 — DIY→PREMADE 후 뒤로가기를 누르면
  //    이전 탭이 아니라 **사이트 밖으로** 나갔고, 게다가 원래 주소까지 덮여 앞으로가기도 DIY 로 안 돌아왔다.
  if(!fromHistory)setTabUrl(tp,null,true);
  window.scrollTo({top:0,behavior:'auto'});
}
// HOW TO 탭 일러스트. Shopify에선 build가 window.PAPERME_GUIDE_URLS(에셋 URL 3개)를 주입한다.
// 주입이 없으면(원본 html 단독 열람) 그림 자리를 비워 레이아웃만 유지 — 깨진 이미지 아이콘을 띄우지 않는다.
// 🔴 일러스트 안에 글자가 들어가므로 **언어별 파일을 갈아끼운다**(2026-08-14). SIZE TIP 과 같은 방식이다.
//    build 가 `PAPERME_GUIDE_URLS_EN` / `_JA`(각 3개)를 함께 주입한다.
//    ⚠️ **파일이 아직 없어도 안전하다** — 못 받아오면 `onerror` 로 한국어판으로 되돌린다.
//    (SIZE TIP 은 fetch 라 상태코드를 보지만 여기는 <img> 라 onerror 가 같은 역할을 한다.)
//    그래서 대표님이 guide-01-ja.svg 부터 하나씩 올리셔도 중간 상태가 깨지지 않는다.
function guideUrls(){
  var ko=window.PAPERME_GUIDE_URLS||[];
  var alt=(LANG==='ja'?window.PAPERME_GUIDE_URLS_JA:(LANG==='en'?window.PAPERME_GUIDE_URLS_EN:null))||[];
  return {ko:ko,alt:alt};
}
function setupHowto(){
  var u=guideUrls();
  for(var i=0;i<3;i++){
    var img=document.getElementById('howto-img-'+(i+1));
    if(!img)continue;
    var koUrl=u.ko[i], altUrl=u.alt[i];
    if(!koUrl&&!altUrl){img.remove();continue;}
    if(altUrl&&altUrl!==koUrl){
      // 언어판을 먼저 시도하고, 없으면(404) 한국어판으로. 한국어판까지 실패하면 더 시도하지 않는다(무한 루프 방지).
      (function(el,fallback){
        el.onerror=function(){el.onerror=null; if(fallback)el.src=fallback; else el.remove();};
      })(img,koUrl);
      img.src=altUrl;
    }else{
      img.onerror=null; img.src=koUrl;
    }
  }
}
// Shopify에선 build가 window.PAPERME_LOGO_URL(에셋 URL)을 주입 → 로고 이미지로 교체.
// 없으면(단독 열람 dev) 텍스트 "PAPER ME" 그대로 둔다.
function setupLogo(){
  var u=window.PAPERME_LOGO_URL||'', img=document.getElementById('nav-logo'), txt=document.getElementById('nav-logo-txt');
  if(!u||!img||!txt)return;
  img.src=u; img.hidden=false; txt.hidden=true;
}
// ── 가로 스크롤 진단 (2026-09-22) ─────────────────────────────────────────
// 대표님이 폰(일본어)에서 가로 스크롤을 보셨는데 데스크톱 375·320px 에뮬레이션으로는 재현되지 않았다.
// 폰에서만 나는 문제는 **폰에서 값을 찍는 게 제일 빠르다** — `?herodebug=1`·`?customerdebug=1` 과 같은 계열.
// 쓰는 법: 주소 끝에 `?wdebug=1` (이미 ? 가 있으면 `&wdebug=1`) → 화면 폭·문서 폭·넘친 요소가 알림으로 뜬다.
// 장바구니를 열 때도 다시 잰다(서랍을 열었을 때만 넘치는 경우가 있다).
function pmOverflowReport(where){
  try{
    var W=window.innerWidth, doc=document.documentElement;
    var over=Math.max(doc.scrollWidth-W, document.body.scrollWidth-W);
    var list=[].slice.call(document.querySelectorAll('body *')).filter(function(e){
      var cs=getComputedStyle(e); if(cs.position==='fixed'||cs.display==='none')return false;
      // 서랍·팝업은 화면에 «떠 있는» 층이라 페이지 가로 스크롤을 못 만든다.
      //   - 닫혀 있으면 아예 화면 밖에 세워 둔 것이라 뺀다(안 빼면 알림이 그것들로 가득 찬다).
      //   - 열려 있으면 «그 서랍의 오른쪽 끝»을 기준으로 잰다 — 서랍 안에서 넘치는 것도 잡아야 하므로.
      var d=e.closest('.drawer,.pop-bg,.zoom-bg');
      if(d&&!d.classList.contains('on'))return false;
      var limit=d?d.getBoundingClientRect().right:W;
      var b=e.getBoundingClientRect(); return b.width>0&&b.right>limit+1;
    }).map(function(e){
      var b=e.getBoundingClientRect();
      return (e.tagName.toLowerCase())+(e.id?('#'+e.id):'')+(e.className?('.'+String(e.className).trim().split(/\s+/)[0]):'')
        +' →'+Math.round(b.right)+' w'+Math.round(b.width)+' "'+(e.textContent||'').trim().slice(0,16)+'"';
    });
    // 열린 서랍은 자체 스크롤이 생길 수 있어 따로 잰다.
    var op=document.querySelector('.drawer.on'), dov=op?(op.scrollWidth-op.clientWidth):0;
    alert('['+where+'] 화면 '+W+'px · 문서 '+doc.scrollWidth+'px · 넘침 '+over+'px'
      +(op?(' · 서랍 넘침 '+dov+'px'):'')+'\nlang='+LANG+' dpr='+(window.devicePixelRatio||1)
      +'\n\n넘친 요소 '+list.length+'개\n'+(list.slice(0,8).join('\n')||'(없음)'));
  }catch(e){ alert('진단 실패: '+e); }
}
var PM_WDEBUG=/[?&]wdebug=1(&|$)/.test(location.search);
function init(){setupLogo();setupHowto();
  // 첫 화면은 DIY(주문 화면). HOW TO 는 탭 순서상 첫 번째지만 기본 선택은 아니다 —
  // 재구매 고객이 매번 설명을 지나치지 않도록. 첫 상태는 마크업(body 클래스 없음 +
  // vtab-diy.act)에 박혀 있어 JS 없이도 DIY 가 먼저 그려진다(깜빡임 없음).
  pmLocalizeLinks();   // 내부 링크에 로케일 접두어를 붙인다(영어로 보다가 나가도 언어가 안 풀리게)
  // 영어 로케일로 들어왔으면 화면 문구를 먼저 영문으로 맞춘다.
  // ⚠️ applyLang 은 원래 '언어 버튼을 눌렀을 때'만 돌았다 — 그대로 두면 주소는 /en 인데 UI 만 한글로 남는다.
  applyLangAttrs();  // 🔴 조건 밖에 둔다 — 한국어 첫 로드에도 body 클래스·<html lang> 이 맞아야 한다
  if(LANG!=='ko')applyLang();
  buildLangMenu();   // 게시된 언어가 하나뿐이면 버튼을 비활성으로 둔다(applyLang 이 안 도는 한국어 첫 로드용)
  syncTabLabels();   // 좁은 화면이면 탭 라벨을 줄여둔다(첫 로드에는 applyLang 이 안 돈다)
  loadCart();
  // 🔴 localStorage 가 **비어 있을 때만** Shopify 카트 속성에서 되살린다(사파리가 7일 만에 지운 경우).
  //    비어 있지 않으면 건드리지 않는다 — 로컬 쪽이 항상 더 최신이다.
  if(!CART.length&&!WISH.length)pmCartRestore();
  // 🔧 임시 진단 — `?pendingdebug=1` 로 열면 대기 주문과 **지금까지의 결제 확인 기록**을 띄운다.
  //    결제 후 장바구니가 안 비워지는 문제가 2026-08-13 에 재발해 다시 넣었다.
  //    🔴 **반드시 checkPendingOrder() 앞에 있어야 한다.** 처음엔 뒤에 뒀다가, 확인이 끝나
  //       이미 비워진 상태만 보고 아무것도 못 갈랐다(대기 0건 · 원본 비어 있음).
  //    **원인 확인되면 이 블록과 plog 호출부를 전부 지울 것.**
  if(/[?&]pendingdebug=1/.test(location.search)){
    var _pl=loadPendings();
    var _lg=[]; try{_lg=JSON.parse(localStorage.getItem(PAPERME_PENDLOG_LS)||'[]');}catch(e){}
    var _head='장바구니 '+CART.length+'건 · 대기 '+_pl.length+'건\n원본: '+(localStorage.getItem(PAPERME_PENDING_LS)||'(비어 있음)')
      +'\n\n─ 기록 ─\n'+(_lg.length?_lg.join('\n'):'(없음 — 이 코드를 넣은 뒤로 주문한 적이 없습니다)');
    if(!_pl.length){ alert(_head+'\n\n→ 지금 대기 중인 주문은 없습니다.'); }
    else Promise.all(_pl.map(function(p){
      return fetch(PAPERME_ORDER_ENDPOINT,{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({action:'status',draftOrderId:p.id})})
        .then(function(r){return r.json().then(function(d){return p.id+'\n → HTTP '+r.status+' '+JSON.stringify(d);});})
        .catch(function(e){return p.id+'\n → 요청 실패: '+e;});
    })).then(function(lines){ alert(_head+'\n\n─ 지금 조회 ─\n'+lines.join('\n\n')); });
  }
  restoreDraft();   // 언어를 바꾸며 넘어온 조합이 있으면 여기서 S 에 되살린다(renderAll 앞이어야 화면에 나온다)
  checkPendingOrder();updBadges();renderAll();setupInnerCollapse();setupPreviewSwipe();
  // 로그인 상태면 계정에 저장된 위시와 **합친다**(합집합). 카탈로그(COVS·INNS·PREMADE)가
  // 이미 주입돼 있어야 되살릴 수 있으므로 init 안에서 부른다. 비로그인이면 아무 일도 안 한다.
  syncWish();
  // ?tab=premade|acc|howto 로 들어오면 그 탭으로(+ ?p=<상품핸들> 이면 그 상세까지) 되살린다.
  // 🔴 새로고침하면 DIY 로 튀던 문제 해결(2026-07-30) — 탭 상태가 주소에 없어서 항상 기본 탭으로 돌아갔다.
  // fromHistory=true 로 불러 주소를 다시 쓰지 않는다(이미 주소에서 읽은 값이다).
  var _tb=(location.search.match(/[?&]tab=([^&]+)/)||[])[1];
  if(_tb)_tb=tabFromUrl(decodeURIComponent(_tb));   // ?tab=signature → 내부 id 'premade'
  if(['howto','premade','acc'].indexOf(_tb)>=0){
    switchTab(_tb,true);
    var _pm=(location.search.match(/[?&]p=([^&]+)/)||[])[1];
    if(_pm&&_tb!=='howto'){
      try{ openProduct(decodeURIComponent(_pm)); }catch(e){}
      // 상품이 없어졌거나(품절 삭제 등) 못 찾으면 openProduct 가 조용히 빠진다 → 주소의 p 를 정리
      if(!_sdProd)setTabUrl(_tb,null);
      else if(/[?&]tab=premade(&|$)/.test(location.search))setTabUrl(_tb,_sdProd.id);   // 옛 주소 정리(상세 유지)
    }
    // 옛 주소(`?tab=premade`)로 들어왔으면 주소만 새 형식으로 바꿔둔다 — 화면은 그대로,
    // 히스토리도 안 쌓인다(replaceState). 공유·북마크가 새 주소로 정리된다.
    else if(/[?&]tab=premade(&|$)/.test(location.search))setTabUrl(_tb,null);
  }
  // 다른 페이지의 헤더 카트에서 ?cart=1로 들어오면 통합 카트 드로어 열기
  if(/[?&]cart=1(&|$)/.test(location.search))openDrawer('cart');
  // 헤더 좌표 진단(2026-08-15). `?hdrdebug=1` — 테마(layout/theme.liquid)에 같은 것이 있어
  // 두 페이지 값을 나란히 비교한다. 테마 헤더는 로컬에서 못 띄우므로 라이브에서 재는 수밖에 없다.
  if(/[?&]hdrdebug=1(&|$)/.test(location.search)){
    window.addEventListener('load',function(){
      function R(el){ if(!el)return null; var r=el.getBoundingClientRect();
        return {l:+r.left.toFixed(1), r:+r.right.toFixed(1), w:+r.width.toFixed(1), h:+r.height.toFixed(1)}; }
      function INK(el){ if(!el)return null; var s=el.querySelector('svg'); if(!s)return null;
        var b=s.getBBox(), r=s.getBoundingClientRect(), vb=s.viewBox.baseVal, k=r.width/((vb&&vb.width)||24);
        return {l:+(r.left+b.x*k).toFixed(1), r:+(r.left+(b.x+b.width)*k).toFixed(1)}; }
      var o={ where:'CUSTOMIZER', vw:window.innerWidth,
        header:R(document.querySelector('nav')),
        bundle:R(document.querySelector('.nav-btns')),
        lang:R(document.getElementById('lang-btn')),
        wishInk:INK(document.getElementById('nav-wish')),
        cartInk:INK(document.getElementById('nav-cart')) };
      alert(JSON.stringify(o,null,1));
    });
  }
  // 헤더 위시 아이콘(?wish=1)도 같은 방식 — 2026-08-15에 테마 헤더에 위시를 넣으며 추가.
  // 전에는 위시 입구가 이 페이지 안에만 있어서 홈·ABOUT·NOTICE 에서는 볼 방법이 없었다(대표님 지적).
  if(/[?&]wish=1(&|$)/.test(location.search))openDrawer('wish');
  // ?combo=<상품핸들> 로 들어오면 그 기성품의 조합을 바로 로드 (Dawn 상품 페이지·공유 링크용)
  var _cm=location.search.match(/[?&]combo=([^&]+)/);
  if(_cm){
    try{
      var _cp=PREMADE.concat(ACC).find(function(x){return x.id===decodeURIComponent(_cm[1]);});
      if(_cp&&_cp.combo)applyProductCombo(_cp);
    }catch(e){}
  }
  // ?cover=cover_01 로 들어오면 그 표지 + 추천 조합을 적용하고 «내지 선택» 단계로 내려간다(2026-10-01).
  // 입구: 매장 카드 QR 설명 페이지(page.note-info.liquid)의 「온라인 주문」 — 대표님: "추천 조합이 선택된 상태에서 내지 선택 단계가 보이게".
  var _cvq=location.search.match(/[?&]cover=([^&]+)/);
  if(_cvq){
    // &size=A|B|C — 설명 페이지 가격표의 줄마다 붙은 「주문」 링크가 그 사이즈를 넘긴다(QR 은 사이즈 없이 하나).
    var _szq=(location.search.match(/[?&]size=([abcABC])(&|$)/)||[])[1];
    try{ var _cvo=COVS.find(function(x){return (x.no||'').toLowerCase()===decodeURIComponent(_cvq[1]).toLowerCase();}); if(_cvo)applyCoverLink(_cvo,_szq&&_szq.toUpperCase()); }catch(e){}
  }
}
init();
// 첫 화면 진단(?wdebug=1). 이미지·폰트가 자리를 잡은 뒤에 재야 정확하다.
if(PM_WDEBUG)setTimeout(function(){pmOverflowReport('제작 화면');},1500);
var _rzT;
window.addEventListener('resize',function(){clearTimeout(_rzT);_rzT=setTimeout(drawPreview,150);});

